import EsgImg from "assets/images/images/sustainEsbBlack (1).svg";
export const GRI_FORM_CONFIG = {
  title: "Download GRI Customized form",
  subtitle: "Download GRI Customized Form Preview",
  formTitle: "GRI Customized Reporting Form",
  downloadFileName: "GRI_Customized_Reporting_Form",
  downloadFileExtension: "png",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "Section 1: Organization Overview",
      fields: [
        { label: "Company Name", type: "text", required: true },
        {
          label:
            "Business Sector & Industry (E.g., Food Manufacturing, Renewable Energy)",
          type: "text",
        },
        {
          label: "Country(ies) of Operation (List all relevant countries)",
          type: "text",
        },
        {
          label:
            "Reporting Period (Start and end dates – e.g., Jan 2024 to Dec 2024)",
          type: "text",
        },
        {
          label:
            "Total Workforce (Employees & Contractors – include regional breakdown if possible)",
          type: "text",
        },
        { label: "Website (Company’s official site URL)", type: "url" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (For follow-up if needed)", type: "text" },
      ],
    },

    {
      title: "Section 2: Scope & Boundaries",
      fields: [
        {
          label: "Scope of Report",
          type: "checkbox",
          options: [
            "Full Organization",
            "Specific Business Unit(s) (list)",
            "Site/Location(s) (list)",
          ],
        },
        {
          label: "Coverage Area (Domestic, Regional – list regions, or Global)",
          type: "text",
        },
        {
          label:
            "Impact Boundaries (e.g., Internal Operations, Supply Chain, Customers)",
          type: "text",
        },
        { label: "Exclusions (if any – list and explain)", type: "text" },
        {
          label: "Upload: Coverage Map / Entity List (if available)",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3: Material Topics & Performance Data",
      fields: [
        {
          label: "Topic Name (Auto-filled by ESG Vision)",
          type: "text",
          disabled: true,
        },
        {
          label: "Do you have specific policies or procedures in place?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        { label: "Upload Policies/Procedures", type: "file" },

        {
          label: "Do you collect performance data for this topic?",
          type: "radio",
          options: ["Yes (Upload dataset or summary)", "No"],
        },
        { label: "Upload Performance Data", type: "file" },

        {
          label: "Do you have third-party audits or verification?",
          type: "radio",
          options: ["Yes (Upload reports)", "No"],
        },
        { label: "Upload Audit/Verification Reports", type: "file" },

        {
          label: "Optional: Add any comments or explanations",
          type: "textarea",
        },
      ],
    },

    {
      title: "Section 4: Stakeholder Engagement",
      fields: [
        {
          label: "List any additional key stakeholders not already covered",
          type: "textarea",
        },
        {
          label: "Describe how you typically engage with stakeholders",
          type: "checkbox",
          options: [
            "Surveys",
            "Workshops/Meetings",
            "Public Consultations",
            "Digital Platforms",
            "Other",
          ],
        },
        {
          label: "Engagement Frequency (e.g., quarterly, annually)",
          type: "text",
        },
        {
          label: "Main concerns raised & company responses (if available)",
          type: "textarea",
        },
        { label: "Upload Stakeholder Map/Matrix", type: "file" },
        { label: "Upload Meeting Minutes/Grievance Logs", type: "file" },
      ],
    },

    {
      title: "Section 5: Governance & ESG Controls",
      fields: [
        {
          label: "Do you have a formal ESG management structure?",
          type: "radio",
          options: ["Yes (Describe below & upload documentation)", "No"],
        },
        { label: "Description", type: "textarea" },
        {
          label: "How are ESG risks managed? (Brief summary)",
          type: "textarea",
        },
        { label: "Upload Governance Policies", type: "file" },
        { label: "Upload Board/Committee Charters", type: "file" },
        { label: "Upload Risk Assessments/Audit Reports", type: "file" },
      ],
    },

    {
      title: "Section 6: Evidence & Benchmarking",
      fields: [
        {
          label: "Please confirm which supporting documents you are uploading",
          type: "checkbox",
          options: [
            "Full ESG/GRI Report (if available)",
            "KPI & Metrics Sheets",
            "Gap Analysis",
            "Audit/Verification Reports",
            "Any Other Relevant Evidence",
          ],
        },
        {
          label: "Do you want:",
          type: "checkbox",
          options: [
            "Industry Benchmarking",
            "Risk/Opportunity Heatmap",
            "Gap Analysis & Action Plan",
          ],
        },
      ],
    },

    {
      title: "Section 7: Declaration & Submission",
      fields: [
        { label: "Name & Position", type: "text" },
        { label: "Date", type: "date" },
        { label: "Signature", type: "text" },
        { label: "Upload Completed Form", type: "file" },
        { label: "Upload All Supporting Evidence/Reports", type: "file" },
      ],
    },
  ],
};
export const MATERIAL_BY_ESG_TOPICS_FORM = {
  title: "Material by ESG Topics form",
  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name", type: "text" },
        {
          label:
            "Business Sector & Industry (E.g., Food Manufacturing, Renewable Energy)",
          type: "text",
        },
        {
          label: "Reporting Period (e.g., Jan 2024 to Dec 2024)",
          type: "text",
        },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone", type: "text" },
      ],
    },
    {
      title: "🌿 Environmental Topics – Supporting Data",
      description: `✅ Your selected Environmental topics are auto-filled based on your earlier choices.\nPlease complete the following for each topic selected.\nExample Topic: Biodiversity`,
      fields: [
        {
          label:
            "1️⃣ Do you have specific policies, programs, or initiatives for this topic?",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload)", value: "yes_upload" },
            { label: "No", value: "no" },
          ],
        },
        {
          label:
            "2️⃣ Do you track performance metrics/data? (e.g., protected areas, restoration efforts)",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload data)", value: "yes_upload_data" },
            { label: "No", value: "no" },
          ],
        },
        {
          label: "3️⃣ Is there third-party verification/audit?",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload)", value: "yes_upload" },
            { label: "No", value: "no" },
          ],
        },
        {
          label: "4️⃣ Optional: Add comments (e.g., risks, improvement plans)",
          type: "textarea",
        },
        {
          label:
            "📎 Upload (per topic):\n• Policies & Procedures\n• Performance Data\n• Audit/Verification Reports",
          type: "file",
        },
        {
          label:
            "➡️ Repeat this format for each of your selected Environmental topics, such as:\n• Energy Efficiency\n• Climate Change Mitigation\n• Circular Economy\n• Emissions (GHG Scope 1, 2, 3)\n• Waste\n• Renewable Energy\n• Spill Prevention, etc.",
          type: "label",
        },
      ],
    },
    {
      title: "👥 Social Topics – Supporting Data",
      description: `✅ Your selected Social topics are auto-filled. Please complete the following for each selected topic.\nExample Topic: Occupational Health & Safety`,
      fields: [
        {
          label:
            "1️⃣ Do you have specific policies, programs, or certifications for this topic?",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload)", value: "yes_upload" },
            { label: "No", value: "no" },
          ],
        },
        {
          label:
            "2️⃣ Do you track performance metrics/data? (e.g., injury rates, training hours)",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload data)", value: "yes_upload_data" },
            { label: "No", value: "no" },
          ],
        },
        {
          label: "3️⃣ Is there third-party verification/audit?",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload)", value: "yes_upload" },
            { label: "No", value: "no" },
          ],
        },
        {
          label:
            "4️⃣ Optional: Add comments (e.g., main challenges, community concerns)",
          type: "textarea",
        },
        {
          label:
            "📎 Upload (per topic):\n• Policies & Procedures\n• Performance Data\n• Audit/Verification Reports",
          type: "file",
        },
        {
          label:
            "➡️ Repeat this format for each selected Social topic, such as:\n• Child Labor\n• Gender Equality\n• Diversity & Inclusion\n• Freedom of Association\n• Grievance Mechanisms\n• Community Development\n• Human Rights Due Diligence, etc.",
          type: "label",
        },
      ],
    },
    {
      title: "🏛️ Governance Topics – Supporting Data",
      description: `✅ Your selected Governance topics are auto-filled. Please complete the following for each selected topic.\nExample Topic: Anti-Corruption`,
      fields: [
        {
          label:
            "1️⃣ Do you have specific policies, controls, or certifications?",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload)", value: "yes_upload" },
            { label: "No", value: "no" },
          ],
        },
        {
          label:
            "2️⃣ Do you track performance data? (e.g., training sessions, investigations)",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload data)", value: "yes_upload_data" },
            { label: "No", value: "no" },
          ],
        },
        {
          label: "3️⃣ Is there third-party verification/audit?",
          type: "checkbox-group",
          options: [
            { label: "Yes (Upload)", value: "yes_upload" },
            { label: "No", value: "no" },
          ],
        },
        {
          label:
            "4️⃣ Optional: Add comments (e.g., governance challenges, progress)",
          type: "textarea",
        },
        {
          label:
            "📎 Upload (per topic):\n• Governance Policies\n• Performance Data\n• Audit/Verification Reports",
          type: "file",
        },
        {
          label:
            "➡️ Repeat this format for each selected Governance topic, such as:\n• Board Diversity\n• Supply Chain Ethics\n• Whistleblower Protection\n• ESG Risk Management\n• Stakeholder Engagement\n• Lobbying & Political Contributions, etc.",
          type: "label",
        },
      ],
    },
    {
      title: "🔎 Cross-Cutting Notes (Optional)",
      fields: [
        {
          label:
            "Do you have any general remarks, lessons learned, or company-wide ESG context you'd like to share?",
          type: "textarea",
        },
        {
          label:
            "📎 Upload (if applicable):\n• Company-wide ESG Strategy\n• Integrated Reports",
          type: "file",
        },
      ],
    },
    {
      title: "📝 Declaration & Submission",
      fields: [
        { label: "Name & Position", type: "text" },
        { label: "Date", type: "date" },
        { label: "Signature", type: "text" },
      ],
    },
  ],
};
export const AI_DRIVEN_FORM_DATA = {
  title: "AI-Driven GRI Reporting Form",
  formTitle: "AI-Powered ESG Data Submission",
  downloadFileName: "AI_Driven_GRI_Reporting_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        {
          label:
            "Business Sector & Industry: (E.g., Food Manufacturing, Renewable Energy)",
          type: "text",
        },
        {
          label: "Country(ies) of Operation: (List all relevant countries)",
          type: "text",
        },
        {
          label:
            "Reporting Period: (Start and end dates – e.g., Jan 2024 to Dec 2024)",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone:", type: "text" },
        {
          label:
            "Optional: List any existing frameworks you align with (e.g., SDGs, SASB, TCFD):",
          type: "textarea",
        },
      ],
    },

    {
      title: "🔹 Section 2: Upload Core Reports & Data",
      fields: [
        {
          label:
            "Select all main ESG-related reports you will upload for AI processing:",
          type: "checkbox",
          options: [
            "Full ESG/Sustainability Report (if available)",
            "Corporate Social Responsibility (CSR) Report",
            "Environmental Reports (e.g., EIA, Biodiversity Assessments)",
            "Occupational Health & Safety Reports",
            "Governance Reports / Policies",
            "Any Audits / Third-Party Verifications",
            "Stakeholder Engagement Records",
            "Risk Assessments",
            "Other Relevant Reports (Specify: ______________________)",
          ],
        },
        {
          label: "Upload your main ESG-related files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
      ],
    },

    {
      title:
        "🔹 Section 3: Upload Supporting Evidence (Optional but Recommended)",
      fields: [
        {
          label: "Select supporting data files you will upload:",
          type: "checkbox",
          options: [
            "KPIs & Metrics Sheets (e.g., energy, water, emissions, labor data)",
            "Policies & Procedures",
            "Training Records",
            "Board/Committee Documents",
            "Supply Chain Documents",
            "Compliance Certifications",
          ],
        },
        {
          label: "Upload your supporting evidence files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
      ],
    },

    {
      title: "🔹 Section 4: Auto-Detection Preferences (Optional)",
      fields: [
        {
          label:
            "Do you want AI to prioritize any specific focus area? (Tick if applicable)",
          type: "checkbox",
          options: [
            "Environmental Performance",
            "Social Impact & Labor",
            "Corporate Governance",
            "Supply Chain Compliance",
            "Human Rights",
            "Climate-Related Risks",
            "Other (Specify): _______________________",
          ],
        },
        {
          label: "Any additional notes to guide the AI engine? (Optional)",
          type: "textarea",
        },
      ],
    },

    {
      title: "🔹 Section 5: Output Preferences (Select What You Need)",
      fields: [
        {
          label: "Select desired outputs:",
          type: "checkbox",
          options: [
            "Full GRI Mapping Report (Auto-Detected GRI Standards & Disclosures)",
            "Gap Analysis & Action Plan (Highlights missing/weak areas)",
            "ESG Performance Benchmark (Compare against industry standards)",
            "Risk & Opportunity Heatmap",
            "GRI Standards Cross-Reference Table",
            "Full ESG Progress Report (Auto-generated for review)",
          ],
        },
      ],
    },

    {
      title: "🔹 Section 6: Declaration & Submission",
      fields: [
        {
          label:
            "I confirm that all data and evidence submitted are accurate to the best of my knowledge and authorize ESG Vision to process and analyze the uploaded files using AI-driven tools.",
          type: "staticText",
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📎 Upload Checklist:",
          type: "staticText",
          value: [
            "✔ Completed AI-Driven Form",
            "✔ Core Reports",
            "✔ Supporting Evidence (if applicable)",
            "✅ Tip: The more complete your uploads, the richer and more precise your AI-driven ESG report will be!",
          ],
        },
        {
          label: "🌟 Notes:",
          type: "staticText",
          value: [
            "✔ This form bypasses manual GRI standards/topic selections — our AI engine will automatically identify the relevant disclosures, topics, and materiality areas.",
          ],
        },
        {
          label: "✅ Download Form: AI-Driven GRI Reporting Form",
          type: "downloadLink",
          fileName: "AI_Driven_GRI_Reporting_Form.pdf",
        },
        {
          label: "📤 *Upload Completed Form & All Evidence",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const INDUSTRY_SPECIFIC_SASB_DISCLOSURE_FORM = {
  title: "Industry specific disclosures",
  subtitle: "Download Industry-Specific SASB Disclosures form",
  formTitle: "Industry-Specific SASB Disclosure Form",
  downloadFileName: "Industry_Specific_SASB_Disclosures_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        {
          label:
            "Business Sector & Industry: (Auto-filled based on your selected industry)",
          type: "text",
        },
        { label: "Country(ies) of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 to Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone:", type: "text" },
      ],
    },

    {
      title: "🔹 Section 2: Upload Core Reports & Data",
      fields: [
        {
          label:
            "📎 Please upload your main ESG and financial performance files:",
          type: "checkbox",
          options: [
            "Full ESG/Sustainability Report",
            "Annual Report / Financial Statements",
            "SASB/CSR Report (if available)",
            "Environmental Reports (GHG emissions, energy use, waste, etc.)",
            "Social Reports (OHS, labor data, community engagement)",
            "Governance Reports (board oversight, ethics policies)",
            "Third-Party Audits/Verification Reports",
            "Risk Assessments",
            "Any Other Relevant Reports (Specify: ______________________)",
          ],
        },
        {
          label: "Upload your core ESG & financial files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
      ],
    },

    {
      title:
        "🔹 Section 3: Upload Supporting Evidence (Optional but Recommended)",
      fields: [
        {
          label: "📎 Upload any topic-specific supporting data:",
          type: "checkbox",
          options: [
            "KPIs & Metrics Sheets (aligned to your industry SASB disclosures)",
            "Policies & Procedures",
            "Stakeholder Engagement Records",
            "Materiality Assessment Reports",
            "Climate-Related Risk Analysis",
            "Industry Certification Documents",
          ],
        },
        {
          label: "Upload your supporting evidence files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
      ],
    },

    {
      title: "🔹 Section 4: Optional – Focus Areas & Notes",
      fields: [
        {
          label:
            "Do you want to emphasize any specific areas in your SASB analysis? (Tick if applicable)",
          type: "checkbox",
          options: [
            "Environmental Performance",
            "Social & Labor Practices",
            "Governance & Ethics",
            "Supply Chain Management",
            "Climate Change & Emissions",
            "Financial Sustainability Risks",
            "Other (Specify): ________________________",
          ],
        },
        {
          label: "Additional notes for context (optional):",
          type: "textarea",
        },
      ],
    },

    {
      title: "🔹 Section 5: Reports & Analysis Requested (Tick All That Apply)",
      fields: [
        {
          label: "Select desired outputs:",
          type: "checkbox",
          options: [
            "Analysis against Performance on SASB Standards Progress",
            "Gap Analysis and Action Report (Table)",
            "SASB Standards Cross-References",
            "Industry Benchmark Score",
            "Materiality Assessment (Risk Assessment)",
            "SASB Materiality Map Report",
            "Risk & Opportunity Matrix",
            "ISSB Alignment Preview (especially IFRS S1/S2 alignment)",
            "Industrial ESG Matrix Sheet",
            "GHG Emissions & Climate Change Overview",
            "Sustainability-Related Risks & Opportunities Report",
            "Sector Peer Benchmark Report",
            "Sustainability-Related Financial Disclosures Report",
            "Full SASB Progress Report",
          ],
        },
      ],
    },

    {
      title: "🔹 Section 6: Declaration & Submission",
      fields: [
        {
          label:
            "I confirm that all data and evidence provided are accurate to the best of my knowledge and authorize ESG Vision to process the uploaded files using AI-driven tools aligned with SASB standards.",
          type: "staticText",
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📎 Upload Checklist:",
          type: "staticText",
          value: [
            "✔ Completed Industry-Specific SASB Disclosures Form",
            "✔ Core Reports",
            "✔ Supporting Evidence Files",
          ],
        },
        {
          label: "✅ Download Form: Industry-Specific SASB Disclosures Form",
          type: "downloadLink",
          fileName: "Industry_Specific_SASB_Disclosures_Form.pdf",
        },
        {
          label: "📤 *Upload Completed Form & All Evidence",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const SASB_DISCLOSURE_FORM_CATEGORY = {
  title: "SASB Disclosures by categories",
  subtitle: "Download SASB Disclosures by Category form",
  formTitle: "Industry-Specific SASB Disclosure Form",
  downloadFileName: "Industry_Specific_SASB_Disclosures_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Business Sector & Industry:", type: "text" },
        { label: "Country(ies) of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 to Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone:", type: "text" },
      ],
    },

    {
      title: "🔹 Section 2: Upload Core Reports & Data",
      fields: [
        {
          label: "📎 Please upload your main ESG-related documents:",
          type: "checkbox",
          options: [
            "ESG/Sustainability Report",
            "Annual Report / Financial Statements",
            "CSR Reports",
            "Environmental & Social Impact Assessments",
            "Governance Reports",
            "Third-Party Audit/Verification Reports",
            "Risk Assessments",
            "Other (Specify: ______________________)",
          ],
        },
        {
          label: "Upload your core ESG & financial files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
      ],
    },

    {
      title: "🔹 Section 3: Category-Specific Supporting Data",
      fields: [
        {
          label:
            "✅ Your selected categories are pre-loaded from your previous dashboard selection. Please provide details for each category.",
          type: "staticText",
        },
        {
          label: "🌱 Environment",
          type: "sectionHeader",
        },
        {
          label: "Example Category: GHG Emissions",
          type: "categoryHeader",
        },
        {
          label:
            "1️⃣ Do you have specific policies, procedures, or controls in place?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Do you track and report performance data? (e.g., CO₂ emissions, energy consumption)",
          type: "radio",
          options: ["Yes (Upload data)", "No"],
        },
        {
          label: "3️⃣ Is there third-party verification or certification?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "4️⃣ Optional: Add any comments (challenges, targets, improvements):",
          type: "textarea",
        },
        {
          label:
            "📎 Upload (per category): Policies/Procedures, Performance Data, Verification/Audit Reports",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "➡️ Repeat for each Environment category selected (e.g., Air Quality, Noise Quality, Waste Management, Ecological Impacts).",
          type: "staticText",
        },
        {
          label: "👥 Social Capital",
          type: "sectionHeader",
        },
        {
          label: "Example Category: Customer Privacy",
          type: "categoryHeader",
        },
        {
          label: "1️⃣ Do you have policies/procedures for this category?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Are performance metrics available? (e.g., data breaches, compliance checks)",
          type: "radio",
          options: ["Yes (Upload data)", "No"],
        },
        {
          label: "3️⃣ Third-party audits/verifications?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label: "4️⃣ Optional notes:",
          type: "textarea",
        },
        {
          label: "📎 Upload (per category): Policies, Metrics, Audits",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "➡️ Repeat for each Social Capital category selected (e.g., Human Rights, Product Quality & Safety, Data Security).",
          type: "staticText",
        },
        {
          label: "👷 Human Capital",
          type: "sectionHeader",
        },
        {
          label: "Example Category: Employee Health & Safety",
          type: "categoryHeader",
        },
        {
          label: "1️⃣ Policies/procedures in place?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Performance data? (e.g., incident rates, safety training hours)",
          type: "radio",
          options: ["Yes (Upload data)", "No"],
        },
        {
          label: "3️⃣ Audits/verification?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label: "4️⃣ Optional notes:",
          type: "textarea",
        },
        {
          label:
            "📎 Upload: Policies & Procedures, KPIs & Metrics, Audits/Certifications",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "➡️ Repeat for each Human Capital category selected (e.g., Labor Practices, Diversity & Inclusion).",
          type: "staticText",
        },
        {
          label: "💼 Business Model & Innovation",
          type: "sectionHeader",
        },
        {
          label: "Example Category: Supply Chain Management",
          type: "categoryHeader",
        },
        {
          label: "1️⃣ Policies/programs?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Performance data? (e.g., supplier audits, compliance rates)",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label: "3️⃣ Third-party audits/verifications?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label: "4️⃣ Optional notes:",
          type: "textarea",
        },
        {
          label:
            "📎 Upload: Supply Chain Policies, Supplier Audits, Performance Data",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "➡️ Repeat for other categories selected (e.g., Business Model Resilience, Product Lifecycle Management).",
          type: "staticText",
        },
        {
          label: "🏛️ Leadership & Governance",
          type: "sectionHeader",
        },
        {
          label: "Example Category: Business Ethics",
          type: "categoryHeader",
        },
        {
          label: "1️⃣ Policies/programs?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Performance data? (e.g., training records, compliance cases)",
          type: "radio",
          options: ["Yes (Upload data)", "No"],
        },
        {
          label: "3️⃣ Audits/verifications?",
          type: "radio",
          options: ["Yes (Upload)", "No"],
        },
        {
          label: "4️⃣ Optional notes:",
          type: "textarea",
        },
        {
          label: "📎 Upload: Ethics Policies, Performance Data, Audit Reports",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "➡️ Repeat for each selected Governance category (e.g., Critical Incident Risk, Competitive Behavior, Systemic Risk).",
          type: "staticText",
        },
        {
          label: "🛠️ Other Categories (if applicable)",
          type: "sectionHeader",
        },
        {
          label: "Other Category (specify):",
          type: "text",
        },
        {
          label: "Upload supporting documents as above.",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
      ],
    },

    {
      title: "🔹 Section 4: Reports & Analysis Requested (Tick All That Apply)",
      fields: [
        {
          label: "Select desired outputs:",
          type: "checkbox",
          options: [
            "Analysis against Performance on SASB Standards Progress",
            "Gap Analysis and Action Report (Table)",
            "SASB Standards Cross-References",
            "Industry Benchmark Score",
            "Materiality Assessment (Risk Assessment)",
            "SASB Materiality Map Report",
            "Risk & Opportunity Matrix",
            "ISSB Alignment Preview (IFRS S1/S2)",
            "Industrial ESG Matrix Sheet",
            "GHG Emissions & Climate Change Report",
            "Sustainability-Related Risks & Opportunities Report",
            "Sector Peer Benchmark Report",
            "Sustainability-Related Financial Disclosures Report",
            "Full SASB Progress Report",
          ],
        },
      ],
    },

    {
      title: "🔹 Section 5: Declaration & Submission",
      fields: [
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📎 Upload Checklist:",
          type: "staticText",
          value: [
            "✔ Completed SASB Disclosures by Category Form",
            "✔ Core Reports",
            "✔ Supporting Evidence for Each Category",
          ],
        },
        {
          label:
            "✅ Tip: The dashboard will auto-map your uploads to the relevant SASB standards and generate comprehensive reports based on your selected categories.",
          type: "staticText",
        },
        {
          label: "✅ Download Form: Industry-Specific SASB Disclosures Form",
          type: "downloadLink",
          fileName: "Industry_Specific_SASB_Disclosures_Form.pdf",
        },
        {
          label: "📤 Upload Completed Form & All Evidence",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const AI_DRIVEN_SASB_FORM = {
  title: "AI-Driven SASB Reporting Form",
  // subtitle: "Upload your ESG and financial data for streamlined AI-powered SASB analysis",
  formTitle: "Industry-Specific SASB Disclosure Form",
  downloadFileName: "Industry_Specific_SASB_Disclosures_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Business Sector & Industry:", type: "text" },
        { label: "Country(ies) of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 to Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone:", type: "text" },
        {
          label:
            "Optional: List any existing ESG frameworks your organization aligns with (e.g., TCFD, SDGs, GRI):",
          type: "text",
        },
      ],
    },

    {
      title: "🔹 Section 2: Upload Core Reports & Evidence",
      fields: [
        {
          label: "📎 Please upload your key ESG and financial reports:",
          type: "checkbox",
          options: [
            "ESG/Sustainability Report",
            "Annual Report / Financial Statements",
            "CSR Report",
            "Environmental & Social Impact Assessments",
            "Governance/Compliance Reports",
            "Third-Party Audits/Verifications",
            "Risk Assessments",
            "Any Other Relevant Reports (Specify: _______________________)",
          ],
        },
        {
          label: "Upload your core ESG & financial files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
      ],
    },

    {
      title: "🔹 Section 3: Upload Supporting Data (Optional but Recommended)",
      fields: [
        {
          label: "📎 Upload specific supporting files to enhance AI accuracy:",
          type: "checkbox",
          options: [
            "KPIs & Metrics Sheets (e.g., GHG emissions, labor data)",
            "Policies & Procedures",
            "Stakeholder Engagement Logs",
            "Board & Governance Documents",
            "Climate Risk Assessments",
            "Supply Chain Data",
            "Certifications & Compliance Records",
          ],
        },
        {
          label: "Upload your supporting evidence files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
      ],
    },

    {
      title: "🔹 Section 4: Optional – Focus Areas & Notes",
      fields: [
        {
          label:
            "Do you want to emphasize any specific focus area(s) in your SASB analysis? (Tick if applicable)",
          type: "checkbox",
          options: [
            "Environmental Performance",
            "Social Practices & Labor",
            "Corporate Governance",
            "Climate Change & GHG Emissions",
            "Supply Chain Management",
            "Financial Risks & Opportunities",
            "Other (Specify): ___________________________",
          ],
        },
        {
          label: "Additional notes to guide the AI (optional):",
          type: "textarea",
        },
      ],
    },

    {
      title: "🔹 Section 5: Reports & Analysis Requested (Tick All That Apply)",
      fields: [
        {
          label: "Select desired outputs:",
          type: "checkbox",
          options: [
            "SASB Standards Progress Analysis",
            "Gap Analysis and Action Report (Table)",
            "SASB Standards Cross-References",
            "Industry Benchmark Score",
            "Materiality Assessment (Risk Assessment)",
            "SASB Materiality Map Report",
            "Risk & Opportunity Matrix",
            "ISSB Alignment Preview (IFRS S1/S2 Compliance)",
            "Industrial ESG Matrix Sheet",
            "GHG Emissions & Climate Change Report",
            "Sustainability-Related Risks & Opportunities Report",
            "Sector Peer Benchmark Report",
            "Sustainability-Related Financial Disclosures Report",
            "Full SASB Progress Report",
          ],
        },
      ],
    },

    {
      title: "🔹 Section 6: Declaration & Submission",
      fields: [
        {
          label:
            "I confirm that all data and evidence provided are accurate to the best of my knowledge and authorize ESG Vision to process and analyze the uploaded files using AI-driven tools aligned with SASB standards.",
          type: "staticText",
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📎 Upload Checklist:",
          type: "staticText",
          value: [
            "✔ Completed AI-Driven SASB Form",
            "✔ Core Reports",
            "✔ Supporting Data (if applicable)",
          ],
        },
        {
          label:
            "✅ Tip: The more detailed your uploads, the more precise and complete your SASB-aligned reports will be!",
          type: "staticText",
        },
        {
          label: "📤 *Upload Completed Form & All Evidence",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const Climate_Related_Financial_Disclosure_Form = {
  title: "Climate-Related Financial Disclosure Form (TCFD-Aligned)",
  subtitle:
    "Submit climate risk governance, strategy, and performance insights per TCFD standards",
  formTitle: "TCFD-Aligned Climate Disclosure Form",
  downloadFileName: "Climate_Related_Financial_Disclosures_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Business Sector & Industry:", type: "text" },
        { label: "Country(ies) of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 to Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone:", type: "text" },
      ],
    },
    {
      title: "🔹 Section 2: TCFD Pillar – Governance",
      fields: [
        {
          label:
            "✅ Please provide evidence and commentary on your climate-related governance structure.",
          type: "staticText",
        },
        {
          label:
            "1️⃣ Do you have board-level oversight of climate-related issues?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label: "2️⃣ Is there a management-level role for climate governance?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "3️⃣ Are sustainability committees established at board/management levels?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "4️⃣ Is climate integrated into executive compensation and performance reviews?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "5️⃣ Optional notes (explain reporting lines, governance processes, accountability):",
          type: "textarea",
        },
        {
          label: "📎 Upload:",
          type: "staticText",
          value: [
            "• Climate Governance Structure",
            "• Board & Committee Charters",
            "• Compensation Policies",
          ],
        },
      ],
    },
    {
      title: "🔹 Section 3: TCFD Pillar – Strategy",
      fields: [
        {
          label:
            "✅ Provide details on how climate-related risks and opportunities are integrated into your business strategy.",
          type: "staticText",
        },
        {
          label:
            "1️⃣ Have you identified climate-related risks and opportunities across short, medium, and long-term horizons?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Do you use scenario analysis (e.g., 2°C or Net Zero scenarios)?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "3️⃣ Have you mapped transition risks, physical risks, and opportunities?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "4️⃣ Have you assessed financial planning and resilience under different climate scenarios?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "5️⃣ Optional notes (explain strategic decisions, sector/geography exposure):",
          type: "textarea",
        },
        {
          label: "📎 Upload:",
          type: "staticText",
          value: [
            "• Climate Risk & Opportunity Assessments",
            "• Scenario Analysis Reports",
            "• Strategic Resilience Plans",
          ],
        },
      ],
    },
    {
      title: "🔹 Section 4: TCFD Pillar – Risk Management",
      fields: [
        {
          label:
            "✅ Submit data on your climate risk identification, assessment, and management processes.",
          type: "staticText",
        },
        {
          label:
            "1️⃣ Do you have formal processes for identifying and assessing climate-related risks?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "2️⃣ Are climate risks integrated into your Enterprise Risk Management (ERM) framework?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "3️⃣ Do you conduct stress testing, risk heat mapping, or risk categorization?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "4️⃣ Optional notes (explain monitoring, response mechanisms, insurance coverage):",
          type: "textarea",
        },
        {
          label: "📎 Upload:",
          type: "staticText",
          value: [
            "• Climate Risk Register",
            "• ERM Integration Documents",
            "• Stress Test & Heatmap Reports",
          ],
        },
        {
          label: "Climate-Related Risks – Physical & Transition",
          type: "staticText",
        },
        {
          label:
            "Physical Risks: (Acute & Chronic) – Indicate which apply and upload evidence.",
          type: "checkbox",
          options: [
            "Hurricanes/Cyclones/Floods",
            "Wildfires/Extreme Heatwaves",
            "Rising Sea Levels/Droughts/Desertification",
            "Water Stress/Glacier Melt",
          ],
        },
        {
          label:
            "Transition Risks: (Policy, Technology, Market, Reputation) – Indicate and upload evidence.",
          type: "checkbox",
          options: [
            "Carbon Pricing/Regulatory Compliance",
            "Technological Disruption",
            "Market Demand Shifts",
            "Reputation/Stakeholder Pressure",
          ],
        },
        {
          label: "📎 Upload:",
          type: "staticText",
          value: [
            "• Physical Risk Assessments",
            "• Transition Risk Reports",
            "• Legal/Policy Monitoring",
          ],
        },
      ],
    },
    {
      title: "🔹 Section 5: TCFD Pillar – Metrics & Targets",
      fields: [
        {
          label:
            "✅ Provide your metrics, targets, and climate performance tracking details.",
          type: "staticText",
        },
        {
          label: "1️⃣ Do you disclose GHG emissions (Scopes 1, 2, 3)?",
          type: "checkbox",
          options: ["Yes (Upload data)", "No"],
        },
        {
          label:
            "2️⃣ Have you set climate-related targets (e.g., Net Zero, GHG reductions)?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "3️⃣ Do you use internal carbon pricing, decarbonization roadmaps, or KPIs?",
          type: "checkbox",
          options: ["Yes (Upload)", "No"],
        },
        {
          label:
            "4️⃣ Optional notes (explain progress tracking, assurance, alignment with standards):",
          type: "textarea",
        },
        {
          label: "📎 Upload:",
          type: "staticText",
          value: [
            "• GHG Inventory & Metrics",
            "• Climate Targets & Roadmaps",
            "• Assurance Reports",
          ],
        },
      ],
    },
    {
      title: "🔹 Section 6: Reports & Analysis Requested (Tick All That Apply)",
      fields: [
        {
          label: "Select desired outputs:",
          type: "checkbox",
          options: [
            "Scenario Analysis",
            "TCFD Gap Analysis & Readiness Report",
            "Climate Scenario Impact Assessment",
            "Climate Risk & Opportunity Matrix",
            "Materiality Scoring",
            "Climate Metrics & Targets Tracker",
            "Performance Tracking Against TCFD",
            "Decarbonization Roadmap",
            "Audit-Ready Disclosure Package",
            "TCFD Cross-References Table",
            "Board Climate Governance Report",
            "TCFD Full Climate Disclosure Report",
          ],
        },
      ],
    },
    {
      title: "🔹 Section 7: Declaration & Submission",
      fields: [
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📎 Upload Checklist:",
          type: "staticText",
          value: [
            "✔ Completed Climate-Related Financial Disclosure Form",
            "✔ Core Reports & Evidence (for all relevant TCFD pillars)",
          ],
        },
        {
          label:
            "✅ Tip: The more complete your uploads, the more precise your TCFD-aligned disclosure and automated reports will be!",
          type: "staticText",
        },
        {
          label: "📤 Upload Completed Form & All Evidence",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const AI_DRIVEN_TCFD_FORM = {
  title: "AI-Driven TCFD Reporting Form",
  subtitle:
    "Upload climate-related and financial data for AI-powered TCFD disclosure readiness",
  formTitle: "TCFD Climate Disclosure Input Form",
  downloadFileName: "TCFD_Climate_Disclosures_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Business Sector & Industry:", type: "text" },
        { label: "Country(ies) of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 to Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone:", type: "text" },
        {
          label:
            "Optional: List any current climate-related disclosure frameworks your organization aligns with (e.g., CDP, GRI, SASB):",
          type: "text",
        },
      ],
    },
    {
      title: "🔹 Section 2: Upload Core Reports & Evidence",
      fields: [
        {
          label: "📎 Upload your main climate-related and financial reports:",
          type: "checkbox",
          options: [
            "ESG/Sustainability Report",
            "Annual Report / Financial Statements",
            "Climate Strategy or Transition Plans",
            "Risk Assessments (ERM, Climate Risk Registers)",
            "Governance Reports / Board Charters",
            "Environmental Impact Assessments",
            "Third-Party Audit/Verification Reports",
            "Any Other Relevant Reports (Specify: ________________________)",
          ],
        },
        {
          label: "Upload your core climate-related and financial files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
      ],
    },
    {
      title: "🔹 Section 3: Upload Supporting Data (Optional but Recommended)",
      fields: [
        {
          label:
            "📎 Upload any specific supporting data to improve AI accuracy:",
          type: "checkbox",
          options: [
            "GHG Emissions Inventory (Scopes 1, 2, 3)",
            "Climate Targets / Roadmaps",
            "Climate Risk & Opportunity Mapping",
            "Scenario Analysis Reports",
            "Internal Carbon Pricing / KPIs",
            "Climate-Related Performance Data",
            "Stakeholder Engagement Records",
            "Assurance / Certification Documents",
          ],
        },
        {
          label: "Upload your supporting data files:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
      ],
    },
    {
      title: "🔹 Section 4: Optional – Focus Areas & Notes",
      fields: [
        {
          label:
            "Do you want AI to prioritize any focus areas in your disclosure? (Tick if applicable)",
          type: "checkbox",
          options: [
            "Governance & Oversight",
            "Climate Strategy & Resilience",
            "Risk Management & ERM Integration",
            "Climate Metrics & Performance",
            "Climate Scenario Analysis",
            "Net Zero / Decarbonization Planning",
            "Other (Specify): ________________________",
          ],
        },
        {
          label: "Additional notes for the AI engine (optional):",
          type: "textarea",
        },
      ],
    },
    {
      title: "🔹 Section 5: Reports & Analysis Requested (Tick All That Apply)",
      fields: [
        {
          label: "Select desired outputs:",
          type: "checkbox",
          options: [
            "Scenario Analysis",
            "TCFD Gap Analysis & Readiness Report",
            "Climate Scenario Impact Assessment",
            "Climate Risk & Opportunity Matrix",
            "Materiality Scoring",
            "Climate Metrics & Targets Tracker",
            "Performance Tracking Against TCFD",
            "Decarbonization Roadmap",
            "Audit-Ready Disclosure Package",
            "TCFD Cross-References Table",
            "Board Climate Governance Report",
            "TCFD Full Climate Disclosure Report",
          ],
        },
      ],
    },
    {
      title: "🔹 Section 6: Declaration & Submission",
      fields: [
        {
          label:
            "I confirm that the data and evidence provided are accurate to the best of my knowledge and authorize ESG Vision to process and analyze the uploaded files using AI-driven tools aligned with TCFD recommendations.",
          type: "staticText",
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📎 Upload Checklist:",
          type: "staticText",
          value: [
            "✔ Completed AI-Driven TCFD Form",
            "✔ Core Reports & Supporting Data (if applicable)",
          ],
        },
        {
          label:
            "✅ Tip: The more comprehensive your uploads, the richer and more precise your TCFD-aligned reporting will be!",
          type: "staticText",
        },
        {
          label: "📤 *Upload Completed Form & All Evidence",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const IFRS_S1_SUSTAINABILITY_RELATED_FINANCIAL_DISCLOSURE_FORM = {
  title: "AI-Driven IFRS S1 Sustainability Disclosure Form",
  subtitle:
    "Upload climate and financial data to generate IFRS S1-aligned sustainability reports with AI assistance",
  formTitle: "IFRS S1 Sustainability Input Form",
  downloadFileName: "IFRS_S1_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Details",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Industry / Sector:", type: "text" },
        { label: "Headquarters / Countries of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 – Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone (for follow-up):", type: "text" },
        {
          label:
            "✅ This helps tailor reports, benchmark against sector norms, and label outputs correctly.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 2: Upload Core Reports",
      fields: [
        {
          label: "📎 Tick all core reports your organization already prepares:",
          type: "checkbox",
          options: [
            "Sustainability or ESG Report",
            "Annual Report / Financial Statements",
            "Sustainability Risk Register or Risk Assessments",
            "Corporate Strategy or Business Plan",
            "Board Oversight or Governance Reports",
            "Sustainability Transition or Action Plans",
            "Stakeholder Engagement Summaries or Grievance Logs",
            "Investor Presentations / External Disclosures",
            "Green Finance or Sustainability-Linked Financing Reports",
            "Other Core Reports (please specify): _____________________________",
          ],
        },
        {
          label: "⬆ Upload these core reports here:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
        {
          label:
            "✅ These reports allow AI to extract disclosures on strategy, risk, governance, and metrics.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 3: Upload Supporting Data",
      fields: [
        {
          label: "📎 Tick any supporting data files you can provide:",
          type: "checkbox",
          options: [
            "Risk & Opportunity Summaries (short, medium, long term)",
            "Scenario Analysis Reports (business resilience, stress testing)",
            "Metrics & KPIs Sheets (industry-specific or custom-developed)",
            "Sustainability Targets & Progress Reports",
            "Investment, Funding, or Capital Allocation Data",
            "Materiality Assessments or Prioritization Maps",
            "Board Governance Policies or Committee Charters",
            "Third-Party Assurance, Audit, or Certification Reports",
            "Policies & Procedures (Environmental, Social, Governance)",
            "Supply Chain or Partner Sustainability Assessments",
            "Other Supporting Files (please specify): _____________________________",
          ],
        },
        {
          label: "⬆ Upload these supporting files here:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "✅ These help enrich your disclosure outputs under IFRS S1. Even drafts are helpful!",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 4: Optional Notes or Focus Areas",
      fields: [
        {
          label:
            "Write your focus areas or notes for the AI engine (optional):",
          type: "textarea",
          placeholder:
            "E.g., 'Focus on governance structure and accountability' or 'Emphasize ERM alignment.'",
        },
        {
          label:
            "✅ Let us know what matters most so the AI can prioritize your themes.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 5: Reports You Want (Tick All That Apply)",
      fields: [
        {
          label: "Select IFRS S1-specific outputs to generate:",
          type: "checkbox",
          options: [
            "Full IFRS S1-Aligned Sustainability Disclosure Report",
            "Performance Tracking Report (against IFRS S1 pillars)",
            "Sustainability Risk and Opportunity Register",
            "Scenario Impact & Strategic Resilience Assessment",
            "Metrics & Targets Dashboard",
            "Materiality Heat Map & Prioritization Report",
            "Gap Analysis & Readiness Report",
            "Board Governance & Oversight Summary",
            "Framework Cross-Reference Report (IFRS S1 vs. ISSB, SASB, GRI)",
            "Audit-Ready Disclosure Package",
          ],
        },
        {
          label:
            "✅ You can request more reports later too – this is just the starting suite.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 6: User Declaration",
      fields: [
        {
          label: "I confirm that:",
          type: "staticText",
          value: [
            "✅ All uploaded documents and data are accurate to the best of my knowledge.",
            "✅ I authorize ESG Vision to process, analyze, and generate sustainability disclosure outputs using IFRS S1-aligned tools.",
            "✅ I understand the system will generate reports, highlight gaps, and provide actionable insights.",
          ],
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📤 Upload Final Form & Documents:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const IFRS_S2_Climate_RELATED_DISCLOSURE_FORM = {
  title: "AI-Driven IFRS S2 Climate Disclosure Form",
  subtitle:
    "Upload climate and financial data to generate IFRS S2-aligned climate reports with AI assistance",
  formTitle: "IFRS S2 Climate Disclosure Input Form",
  downloadFileName: "IFRS_S2_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Details",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Industry / Sector:", type: "text" },
        { label: "Headquarters / Countries of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 – Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone (for follow-up):", type: "text" },
        {
          label:
            "✅ This ensures your disclosure outputs are tailored and sector-aligned.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 2: Upload Core Reports",
      fields: [
        {
          label: "📎 Tick all reports you can provide (more is better):",
          type: "checkbox",
          options: [
            "Climate-Related Disclosures (e.g., TCFD Reports, CDP Reports)",
            "Sustainability or ESG Reports",
            "Annual Reports / Financial Statements",
            "Climate Transition Plans or Net Zero Roadmaps",
            "Risk Registers (Climate-Related Physical and Transition Risks)",
            "Board Governance or Oversight Reports",
            "Strategic Planning Documents",
            "Climate Finance or Capital Allocation Reports",
            "Investor Presentations or External Climate Disclosures",
            "Sector-Specific Climate Disclosures (e.g., Oil & Gas, Financial Services, Utilities)",
            "Other Core Reports (please specify): _____________________________",
          ],
        },
        {
          label: "⬆ Upload these files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
        {
          label:
            "✅ Provide the main reports your organization already prepares. These will allow the AI to extract climate-related disclosures across governance, strategy, risk management, metrics, and scenario analysis.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 3: Upload Supporting Data",
      fields: [
        {
          label: "📎 Tick what you can provide (optional but valuable):",
          type: "checkbox",
          options: [
            "Climate-Related Risk and Opportunity Summaries (short, medium, long term)",
            "Scenario Analysis or Climate Resilience Assessments",
            "Scope 1, Scope 2, Scope 3 Emissions Inventories",
            "Internal Carbon Pricing Documentation",
            "Climate-Related KPIs, Metrics, and Performance Sheets",
            "Climate Targets & Progress Reports (absolute, intensity-based)",
            "Climate Finance / Green Investment Data",
            "Capital Deployment or Financed Emissions Data",
            "Adaptation and Mitigation Strategies",
            "Board and Management Oversight Policies",
            "Third-Party Assurance, Audit, or Verification Reports",
            "Climate-Aligned Product or Service Portfolio Reports",
            "Policy Integration Documents (climate into corporate strategy)",
            "Other Supporting Files (please specify): _____________________________",
          ],
        },
        {
          label: "⬆ Upload these files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label:
            "✅ Upload supporting files to strengthen the completeness and quality of your disclosure outputs. Partial data is okay — the system will flag any missing areas.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 4: Optional Notes or Focus Areas",
      fields: [
        {
          label: "Write your priorities or notes here (optional):",
          type: "textarea",
          placeholder:
            "E.g., 'Emphasize climate scenario analysis and resilience assessment.' or 'Highlight Scope 3 emissions and financed emissions data.'",
        },
        {
          label:
            "✅ Help tailor your outputs by highlighting areas you want the AI to emphasize (optional).",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 5: Reports You Want (Tick All That Apply)",
      fields: [
        {
          label:
            "Select which IFRS S2-specific outputs you want the system to generate:",
          type: "checkbox",
          options: [
            "Full IFRS S2-Aligned Climate Disclosure Report",
            "Climate Risk & Opportunity Register (AI-generated summary)",
            "Performance Tracking Report (against IFRS S2 pillars)",
            "Climate Scenario Impact & Resilience Analysis",
            "Emissions Profile & Reduction Progress Report (Scopes 1, 2, 3)",
            "Capital Deployment and Climate Finance Report",
            "Metrics & Targets Dashboard (including carbon pricing, KPIs, progress)",
            "Materiality Assessment & Heat Map",
            "Gap Analysis & Readiness Report (highlighting disclosure gaps)",
            "Board Governance & Oversight Summary",
            "Audit-Ready Climate Disclosure Package",
            "Cross-Reference Report (IFRS S2 vs. ISSB, TCFD, SASB, GRI)",
          ],
        },
        {
          label:
            "✅ You can start with a few outputs and request more later as needed.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 6: User Declaration",
      fields: [
        {
          label: "I confirm that:",
          type: "staticText",
          value: [
            "✅ The uploaded documents and data are accurate to the best of my knowledge.",
            "✅ I authorize ESG Vision to process, analyze, and generate climate disclosure outputs using IFRS S2-aligned tools.",
            "✅ I understand the system will generate reports, highlight gaps, and provide actionable recommendations.",
          ],
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📤 Upload Final Form & Documents:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const AI_DRIVEN_IFRS_S1_DISCLOSURE_FORM = {
  title: "AI-Driven IFRS S1 Sustainability Disclosure Form",
  subtitle:
    "Upload sustainability, governance, risk, and financial data for AI-powered IFRS S1-aligned reporting",
  formTitle: "IFRS S1 Sustainability Disclosure Input Form",
  downloadFileName: "IFRS_S1_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Industry / Sector:", type: "text" },
        { label: "Countries / Regions of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 – Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone (for system updates):", type: "text" },
        {
          label:
            "✅ This basic info helps the dashboard label and benchmark your results.",
          type: "staticText",
        },
      ],
    },
    {
      title:
        "🔹 Section 2: Upload All Available Files (AI Will Auto-Select Content)",
      fields: [
        {
          label: "📎 Types of files to upload (tick all that apply):",
          type: "checkbox",
          options: [
            "Sustainability or ESG Reports",
            "Annual Reports / Financial Statements",
            "Risk Registers or ERM Frameworks",
            "Board Oversight or Governance Documents",
            "Business Strategy, Transition, or Investment Plans",
            "Stakeholder Engagement Reports",
            "KPIs, Metrics, and Performance Sheets",
            "Targets, Milestones, and Progress Reports",
            "Materiality Assessments or Prioritization Documents",
            "Policy Documents (Environmental, Social, Governance, etc.)",
            "Third-Party Audit, Assurance, or Certification Reports",
            "Supply Chain or Partner Sustainability Reports",
            "Other Relevant Files (please specify): _____________________________",
          ],
        },
        {
          label: "⬆ Upload all selected files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
        {
          label:
            "✅ Reminder: No need to manually organize these files. The AI will detect what content aligns with each disclosure area.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 3: Optional Focus Area (if any)",
      fields: [
        {
          label: "Write here (optional):",
          type: "textarea",
          placeholder:
            "E.g., 'Prioritize governance and board-level oversight.' or 'Emphasize sustainability risk integration.'",
        },
        {
          label:
            "✅ (Optional) Let the AI know if you want to prioritize or highlight any specific focus.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 4: Reports You Want (Tick All That Apply)",
      fields: [
        {
          label:
            "✅ Select the automated outputs you want the system to generate:",
          type: "checkbox",
          options: [
            "Full IFRS S1-Aligned Sustainability Disclosure Report",
            "AI-Generated Risk & Opportunity Register",
            "Performance Tracking Report (vs. IFRS S1 pillars)",
            "Strategic Resilience and Scenario Summary",
            "Metrics, KPIs, and Targets Dashboard",
            "Materiality Heat Map & Prioritization Report",
            "Gap Analysis & Readiness Report",
            "Board Governance & Oversight Summary",
            "Framework Cross-Reference Report (IFRS, ISSB, SASB, GRI)",
            "Audit-Ready Disclosure Package",
          ],
        },
        {
          label: "✅ You can select multiple or start small and expand later.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 5: Declaration & Submission",
      fields: [
        {
          label: "I confirm that:",
          type: "staticText",
          value: [
            "✅ All uploaded data and documents are accurate to the best of my knowledge.",
            "✅ I authorize ESG Vision to analyze, process, and generate disclosure outputs using AI-driven IFRS S1 tools.",
            "✅ I understand that system-generated reports will highlight gaps, benchmark performance, and provide actionable insights.",
          ],
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📤 Upload Final Form & Documents:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const AI_DRIVEN_IFRS_S2_DISCLOSURE_FORM = {
  title: "AI-Driven IFRS S2 Climate Disclosure Form",
  subtitle:
    "Upload climate risk, governance, and emissions data for AI-powered IFRS S2-aligned reporting",
  formTitle: "IFRS S2 Climate Disclosure Input Form",
  downloadFileName: "IFRS_S2_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "🔹 Section 1: Organization Overview",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Industry / Sector:", type: "text" },
        { label: "Countries / Regions of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 – Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        {
          label: "Email & Phone (for dashboard updates / report delivery):",
          type: "text",
        },
        {
          label:
            "✅ This helps the system label, benchmark, and tailor your outputs correctly.",
          type: "staticText",
        },
      ],
    },
    {
      title:
        "🔹 Section 2: Upload All Available Climate-Related Files (AI Will Auto-Select)",
      fields: [
        {
          label: "📎 Types of files to upload (tick all that apply):",
          type: "checkbox",
          options: [
            "Climate-Related Disclosure Reports (e.g., TCFD, CDP)",
            "Climate Transition or Net Zero Roadmaps",
            "Climate Risk Registers (physical and transition risks)",
            "Board Governance or Oversight Documents (climate-focused)",
            "Strategic Business Plans with Climate Components",
            "Capital Allocation or Climate Finance Reports",
            "Scope 1, Scope 2, Scope 3 Emissions Inventories",
            "Internal Carbon Pricing Documentation",
            "Climate-Related KPIs, Metrics, and Targets Sheets",
            "Scenario Analysis or Climate Resilience Reports",
            "Adaptation and Mitigation Plans",
            "Green Finance or Financed Emissions Data (for financial institutions)",
            "Climate-Aligned Products or Services Reports",
            "Third-Party Assurance, Verification, or Audit Reports",
            "Supplier and Value Chain Climate Risk Assessments",
            "Other Relevant Climate Files (please specify): _____________________________",
          ],
        },
        {
          label: "⬆ Upload all selected files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
        {
          label:
            "✅ Reminder: You do not need to pre-organize or pre-map the files — the AI will do that for you.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 3: Optional Focus Area (if any)",
      fields: [
        {
          label: "Write here (optional):",
          type: "textarea",
          placeholder:
            "E.g., 'Prioritize Scope 3 emissions mapping and financed emissions.' or 'Highlight scenario analysis and climate resilience assessments.'",
        },
        {
          label:
            "✅ (Optional) Let the AI know if you want to prioritize any specific climate disclosure focus.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 4: Reports You Want (Tick All That Apply)",
      fields: [
        {
          label:
            "✅ Select which automated outputs you want the system to generate:",
          type: "checkbox",
          options: [
            "Full IFRS S2-Aligned Climate Disclosure Report",
            "AI-Generated Climate Risk & Opportunity Register",
            "Performance Tracking Report (vs. IFRS S2 pillars)",
            "Climate Scenario Impact & Resilience Summary",
            "Scope 1, 2, 3 Emissions Profile & Reduction Progress Report",
            "Capital Deployment and Climate Finance Report",
            "Metrics, KPIs, and Targets Dashboard",
            "Materiality Assessment & Heat Map",
            "Gap Analysis & Readiness Report (highlighting missing or weak disclosures)",
            "Board Governance & Oversight Summary",
            "Audit-Ready Climate Disclosure Package",
            "Framework Cross-Reference Report (IFRS S2 vs. ISSB, TCFD, SASB, GRI)",
          ],
        },
        {
          label:
            "✅ Start with a few outputs or select all for a full package.",
          type: "staticText",
        },
      ],
    },
    {
      title: "🔹 Section 5: Declaration & Submission",
      fields: [
        {
          label: "I confirm that:",
          type: "staticText",
          value: [
            "✅ All uploaded documents and data are accurate to the best of my knowledge.",
            "✅ I authorize ESG Vision to analyze, process, and generate climate disclosure outputs using AI-driven IFRS S2 tools.",
            "✅ I understand the system will provide reports, highlight gaps, and offer actionable recommendations.",
          ],
        },
        { label: "Name & Position:", type: "text", required: true },
        { label: "Date:", type: "date", required: true },
        { label: "Signature:", type: "text", required: true },
        {
          label: "📤 Upload Final Form & Documents:",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar",
          required: true,
        },
      ],
    },
  ],
};
export const CSRD_SUSTAINABILITY_DISCLOSURE_FORM = {
  title: "CSRD Sustainability Disclosure Form",
  subtitle:
    "Upload ESG data across climate, governance, emissions, energy, biodiversity, workforce, and value chain to enable AI-powered CSRD–ESRS reporting",
  downloadFileName: "IFRS_S2_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name:", type: "text", required: true },
        { label: "Industry / Sector:", type: "text" },
        { label: "Headquarters / Countries of Operation:", type: "text" },
        {
          label: "Reporting Period (e.g., Jan 2024 – Dec 2024):",
          type: "text",
        },
        { label: "Contact Person (Name & Title):", type: "text" },
        { label: "Email & Phone (for follow-up):", type: "text" },
        {
          label:
            "✅ This ensures your disclosures are sector- and region-appropriate.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 2: Upload Core Reports",
      fields: [
        {
          label:
            "✅ Please tick all main reports your organization already prepares (tick even partial or draft versions):",
          type: "checkbox",
          options: [
            "Climate-Related Disclosures (e.g., TCFD, CDP)",
            "Sustainability or ESG Reports",
            "Annual Reports / Financial Statements",
            "Climate Transition Plans or Net Zero Roadmaps",
            "Climate Risk Registers (Physical & Transition Risks)",
            "Board Governance or Oversight Reports",
            "Strategic or Business Planning Documents",
            "Climate Finance or Investment Reports",
            "Investor Presentations or External Disclosures",
            "Sector-Specific Climate Reports (e.g., Energy, Finance, Manufacturing)",
            "Other Reports (please specify):",
          ],
        },
        {
          label: "⬆ Upload these files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: true,
        },
      ],
    },
    {
      title: "Section 3: Upload Supporting Data",
      fields: [
        {
          label:
            "✅ Please tick and upload any additional files that support your disclosures (optional but valuable):",
          type: "checkbox",
          options: [
            "Climate Risk & Opportunity Summaries (short, medium, long term)",
            "Scenario Analyses or Resilience Assessments",
            "Scope 1, 2, 3 Emissions Inventories",
            "Internal Carbon Pricing Documentation",
            "Climate-Related KPIs & Performance Data",
            "Climate Targets & Progress Tracking",
            "Green Finance or Climate Investment Data",
            "Financed Emissions / Capital Deployment Data",
            "Adaptation & Mitigation Strategy Documents",
            "Governance & Oversight Policies",
            "Third-Party Assurance or Audit Reports",
            "Climate-Aligned Products or Services Reports",
            "Policy Integration Files (linking climate & corporate strategy)",
            "Other Supporting Files (please specify):",
          ],
        },
        {
          label: "⬆ Upload these files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: false,
        },
      ],
    },
    {
      title: "Section 4: Notes or Focus Areas (Optional)",
      fields: [
        {
          label: `✅ Please let us know if there are special priorities or areas you want us to emphasize:\nExamples:\n• “Focus on climate resilience and adaptation.”\n• “Highlight Scope 3 emissions.”\n• “Emphasize board governance and leadership accountability.”\nWrite your focus notes here (optional):`,
          type: "textarea",
          placeholder: "",
        },
      ],
    },
    {
      title: "Section 5: Reports You Want Generated (Tick All That Apply)",
      fields: [
        {
          label: "✅ Please select which reports you want from us:",
          type: "checkbox",
          options: [
            "Full CSRD-Aligned Sustainability Report",
            "Double Materiality Assessment Summary",
            "Materiality Matrix & Analysis",
            "Stakeholder Engagement Report",
            "Value Chain Impact Report",
            "Sustainability Action Plan",
            "Climate Transition & GHG Tracker (E1)",
            "Pollution & Emissions Impact Report (E2)",
            "Water & Marine Risk Report (E3)",
            "Biodiversity & Ecosystem Risk Report (E4)",
            "Circular Economy & Resource Use Tracker (E5)",
            "Workforce Social Metrics Report (S1)",
            "Supply Chain Labor Risk Assessment (S2)",
            "Community Impact Report (S3)",
            "Product Safety & Consumer Impact Report (S4)",
            "Business Conduct & Governance Summary (G1)",
            "Disclosure Gap & Completeness Analysis",
            "Crosswalk Mapping Report (e.g., ESRS ↔ GRI / TCFD / ISSB)",
            "Integrated Management Report for CSRD Submission",
            "Sector-Specific Disclosure Tracker",
            "Sustainability Performance Target Tracker",
          ],
        },
        {
          label: "✅ We will tailor the outputs to match your selections.",
          type: "staticText",
        },
      ],
    },
  ],
};
export const AI_DRIVEN_CSRD_DISCLOSURE_FORM = {
  title: "CSRD Sustainability Disclosure Form",
  subtitle:
    "Upload ESG data across climate, governance, emissions, energy, biodiversity, workforce, and value chain to enable AI-powered CSRD–ESRS reporting.",
  downloadFileName: "IFRS_S2_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        {
          label: "✅ Please fill in your basic organization details:",
          type: "staticText",
        },
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan–Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This allows the AI system to align disclosures to your sector, geography, and regulatory scope.",
          type: "staticText",
        },
      ],
    },

    {
      title: "Section 2: Upload Core Business Reports",
      fields: [
        {
          label:
            "✅ Upload any major reports your organization already prepares (even partial or draft versions):",
          type: "checkbox",
          options: [
            "Sustainability / ESG Reports",
            "Annual Reports or Financial Statements",
            "Climate Disclosures (e.g., TCFD, CDP)",
            "Climate Transition Plans or Net Zero Roadmaps",
            "Climate Risk Registers (Physical or Transition Risks)",
            "Governance or Oversight Reports",
            "Strategic / Business Plans",
            "Climate Finance or Investment Reports",
            "Investor Presentations or External Disclosures",
            "Sector-Specific Climate Reports (e.g., Energy, Finance, Manufacturing)",
            "Other Reports (please specify):",
          ],
        },
        {
          label: "⬆ Upload these files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: false,
        },
      ],
    },

    {
      title: "Section 3: Upload Supporting Data (Optional but Recommended)",
      fields: [
        {
          label:
            "✅ Add any additional files to help the system strengthen completeness and accuracy:",
          type: "checkbox",
          options: [
            "Scope 1, 2, 3 Emissions Inventories",
            "Climate KPIs or Performance Data",
            "Climate Targets and Progress Tracking",
            "Climate Risk and Opportunity Summaries",
            "Scenario Analyses / Climate Resilience Assessments",
            "Internal Carbon Pricing Documentation",
            "Green Finance or Climate Investment Data",
            "Financed Emissions or Capital Deployment Data",
            "Adaptation or Mitigation Strategy Files",
            "Board and Management Policies",
            "Third-Party Assurance or Audit Reports",
            "Climate-Aligned Product or Service Reports",
            "Policy Integration Files (linking climate and corporate strategy)",
            "Other Supporting Files (please specify):",
          ],
        },
        {
          label: "⬆ Upload these files here",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          required: false,
        },
      ],
    },

    {
      title: "Section 4: AI Processing Notes (Optional)",
      fields: [
        {
          label:
            "✅ Provide any special instructions or areas of emphasis (optional):\nExamples:\n• “Focus on climate risk management and resilience.”\n• “Emphasize emissions reductions and Scope 3 data.”\n• “Prioritize board-level governance and accountability sections.”",
          type: "textarea",
          placeholder: "Write your focus notes here (optional)...",
        },
      ],
    },

    {
      title: "Section 5: Select Outputs You Want Generated",
      fields: [
        {
          label:
            "✅ Please tick the AI-generated reports and outputs you want:",
          type: "checkbox",
          options: [
            "Full CSRD-Aligned Sustainability Disclosure Report",
            "AI-Generated Double Materiality Assessment",
            "AI-Generated Materiality Matrix",
            "Stakeholder Engagement Summary",
            "Value Chain Impact Overview",
            "Sustainability Action Plan",
            "Climate Transition & GHG Emissions Tracker (aligned to E1)",
            "Pollution & Emissions Impact Summary (aligned to E2)",
            "Water & Marine Risk Report (aligned to E3)",
            "Biodiversity & Ecosystem Risk Summary (aligned to E4)",
            "Circular Economy & Resource Use Summary (aligned to E5)",
            "Workforce Social Metrics Overview (aligned to S1)",
            "Supply Chain Labor Risk Overview (aligned to S2)",
            "Community Impact & Mitigation Report (aligned to S3)",
            "Product Safety & Consumer Impact Report (aligned to S4)",
            "Business Conduct & Governance Summary (aligned to G1)",
            "Disclosure Gap and Completeness Analysis",
            "Crosswalk Mapping (AI auto-mapping to GRI / TCFD / ISSB frameworks)",
            "Integrated Management Report for CSRD Submission",
            "Sector-Specific Disclosure Tracker",
            "Sustainability Performance Target Tracker",
          ],
        },
        {
          label:
            "✅ The AI system will analyze your uploads, extract key disclosures, and automatically generate aligned outputs without requiring you to map ESRS standards manually.",
          type: "staticText",
        },
      ],
    },
  ],
};
export const UNGC_DISCLOSURE_FORM = {
  title: "UNGC Compliance & Sustainability Disclosure Form",
  // subtitle: "Upload policies and reports aligned with UNGC principles for AI-powered compliance outputs",
  downloadFileName: "UNGC_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg }, // Replace with actual image import if needed

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan–Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone", type: "text" },
        {
          label:
            "✅ This ensures the compliance review is tailored to your sector and geographic operations.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 2: Upload Specific Supporting Documents",
      fields: [
        {
          label: "✅ Please upload documents relevant to each area:",
          type: "staticText",
        },
        {
          label: "• Human Rights (P1–P2)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload human rights policies, employee codes of conduct, grievance procedures, or supplier codes.",
        },
        {
          label: "• Labour (P3–P6)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload collective bargaining agreements, labor policies, workforce equality reports, or child labor policies.",
        },
        {
          label: "• Environment (P7–P9)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload environmental policies, EMS certificates, sustainability or climate action plans, or innovation project reports.",
        },
        {
          label: "• Anti-Corruption (P10)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload anti-corruption policies, ethics manuals, whistleblower frameworks, compliance training records, or audit summaries.",
        },
      ],
    },
    {
      title: "Section 3: Select Reports to Generate",
      fields: [
        {
          label:
            "✅ Please select the compliance outputs you want the system to generate:",
          type: "checkbox",
          options: [
            "Full UNGC Compliance Report",
            "Human Rights & Labour Risk Summary",
            "Environmental Responsibility Performance Summary",
            "Anti-Corruption Practices Overview",
            "UNGC–SDG Alignment Summary",
            "UNGC Principles Gap Analysis",
            "UNGC Implementation Timeline Tracker",
            "Custom UNGC Dashboard Summary",
          ],
        },
        {
          label:
            "✅ We will tailor the outputs to your selections and the documents provided.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 4: Notes or Priorities (Optional)",
      fields: [
        {
          label:
            "Please describe any areas you want us to emphasize or focus on:",
          type: "textarea",
          placeholder: "Write any notes or areas of focus here...",
        },
      ],
    },
    {
      title: "⚡ Important Notes",
      fields: [
        {
          label:
            "✔ The system will synthesize all submitted materials into clear, actionable reports aligned with UNGC principles.",
          type: "staticText",
        },
      ],
    },
  ],
};
export const AI_DRIVEN_UNGC_COMPLIANCE_FORM = {
  title: "UNGC Compliance & Sustainability Disclosure Form",
  downloadFileName: "UNGC_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg }, // Replace with actual image import if needed

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan–Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone", type: "text" },
        {
          label:
            "✅ Ensures AI aligns outputs to your sector, size, and operational footprint.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 2: Upload Required Supporting Documents",
      fields: [
        {
          label:
            "To enable full automation, upload basic policy or governance documents (no technical formatting required):",
          type: "staticText",
        },
        {
          label: "• Human Rights & Labor Area (P1–P6)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload: Company HR policies, employee handbook, supplier codes, grievance or ethics policies.",
        },
        {
          label: "• Environmental Area (P7–P9)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload: Environmental commitment letters, sustainability policies, EMS documentation, innovation or energy project summaries.",
        },
        {
          label: "• Anti-Corruption Area (P10)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: true,
          helperText:
            "⬆ Upload: Anti-corruption policies, ethics guidelines, whistleblower protections, audit reports.",
        },
        {
          label:
            "✅ The AI will scan and extract necessary compliance information.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 3: Automated Reports You Want",
      fields: [
        {
          label:
            "✅ Select which outputs you want the system to generate automatically:",
          type: "checkbox",
          options: [
            "Full UNGC Compliance Report",
            "Human Rights & Labour Risk Assessment",
            "Environmental Performance Summary",
            "Anti-Corruption Controls Overview",
            "NGC Principles Gap Analysis",
            "UNGC–SDG Alignment Report",
            "UNGC Implementation Timeline Tracker",
            "Custom Executive Dashboard Summary",
          ],
        },
        {
          label:
            "✅ You can choose one or multiple — AI will tailor outputs to your inputs.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 4: Notes or Priorities (Optional)",
      fields: [
        {
          label:
            "If you want the AI to focus on any specific area or issue, please describe it here:",
          type: "textarea",
          placeholder: "Write any notes or areas of focus here...",
        },
      ],
    },
  ],
};
export const SDG_COMPLIANCE_FORM = {
  title: "SDG Compliance Submission Form",
  downloadFileName: "UNGC_Disclosure_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your SDG compliance outputs are tailored to your organization’s profile.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 2: General Supporting Documents Upload",
      fields: [
        {
          label:
            "✅ Please upload general documents that reflect your SDG-related activities, policies, or practices. These do not need to be highly technical — the system will analyze and match them against the selected SDG compliance topics.",
          type: "staticText",
        },
        {
          label: "☐ Company Sustainability Policy Document",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label: "☐ Internal ESG or Sustainability Reports (if available)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label: "☐ Codes of Conduct / Ethics Policies",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label: "☐ Health, Safety, or Environmental Guidelines",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label: "☐ Human Rights or Labor Rights Policies",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
        {
          label: "☐ Any Other Supporting Company Documents",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
        },
      ],
    },
    {
      title: "🌍 Section 3: Confirmed SDG Topics for Compliance Alignment",
      fields: [
        {
          label:
            "✅ Please upload any supporting documents (even if partial, simple, or draft) under each selected SDG topic. The system will automatically compile and generate your compliance reports and progress trackers.",
          type: "staticText",
        },
        ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map(
          (goal, index) => ({
            label: `☐ ${goal}. ${[
              "No Poverty",
              "Zero Hunger",
              "Good Health and Well-being",
              "Quality Education",
              "Gender Equality",
              "Clean Water and Sanitation",
              "Affordable and Clean Energy",
              "Decent Work and Economic Growth",
              "Industry, Innovation and Infrastructure",
              "Reduced Inequalities",
              "Sustainable Cities and Communities",
              "Responsible Consumption and Production",
              "Climate Action",
              "Life Below Water",
              "Life on Land",
              "Peace, Justice, and Strong Institutions",
              "Partnerships for the Goals",
            ][index]
              }`,
            type: "file",
            accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
            helperText: `⬆ Upload File: [ ___________ ]`,
          })
        ),
      ],
    },
    {
      title: "Section 4: Requested AI-Generated Compliance Outputs",
      fields: [
        {
          label:
            "✅ Please tick the reports or outputs you would like the system to generate:",
          type: "checkbox",
          options: [
            "Vulnerable Group Impact Assessment",
            "SDG Gap Report",
            "SDG Materiality Assessment",
            "Health & Safety Metrics Report",
            "SDG Impact Monitoring Report",
            "SDG Progress Report",
            "Training & Capacity Building Tracker",
            "Stakeholder SDG Summary Report",
            "Gender Equity Analysis",
            "SDG KPI Report (Gender Indicators)",
            "Water Risk Assessment",
            "Labor Rights Compliance Report",
            "Alternative Energy Alignment with SDG",
            "ESG–SDG Crosswalk Analysis",
            "Equity & Inclusion Report",
            "Risk Mapping (Including Climate Resilience)",
            "Circular Economy Alignment Report",
            "Resource Efficiency Report",
            "GHG Inventory Report (SDG 13 Tracker)",
            "Climate Risk Heatmap",
            "Marine Impact Report",
            "Water Pollution Assessment",
            "Biodiversity Risk Analysis",
            "Deforestation-Free Supply Chain Report",
            "Governance Compliance Report",
            "Anti-Corruption and Compliance Report",
            "Stakeholder Engagement Report",
            "Public–Private SDG Cooperation Report",
            "Full SDG Alignment Report",
          ],
        },
        {
          label:
            "✅ All requested reports will be generated automatically by matching your provided documents and pre-selected SDG topics.",
          type: "staticText",
        },
      ],
    },
  ],
};
export const AI_DRIVEN_SDG_COMPLIANCE_FORM = {
  title: "AI-Driven SDG Compliance Form (Enhanced Version)",
  downloadFileName: "AI_Driven_SDG_Compliance_Form",
  downloadFileExtension: "pdf",
  formImageUrl: { EsgImg }, // Replace with actual image import if needed

  sections: [
    {
      title: "Section 1: Organization Profile (Auto-Populated or User-Entered)",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Countries of Operation", type: "text" },
        { label: "Reporting Period", type: "text" },
        { label: "Contact Person (Name & Role)", type: "text" },
        { label: "Email & Phone", type: "text" },
        {
          label:
            "✅ System ensures correct sector and region tagging for SDG alignment.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 2: Targeted Evidence Upload — Smart Documents Request",
      fields: [
        {
          label:
            "✅ Please upload specific documents related to your sustainability, ESG, or SDG actions. The AI system will automatically scan, tag, and map them to the SDG goals and targets selected below.",
          type: "staticText",
        },
        {
          label: "Poverty and Social Protection Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., social welfare records, community development programs",
        },
        {
          label: "Food Security and Agriculture Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., food program reports, agricultural sustainability plans",
        },
        {
          label: "Health and Safety Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., health access policies, occupational safety records, wellness audits",
        },
        {
          label: "Education and Skills Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., training programs, literacy initiatives, education funding reports",
        },
        {
          label: "Gender Equality and Inclusion Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., gender policies, equal pay reviews, anti-discrimination audits",
        },
        {
          label: "Water and Sanitation Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., water resource management, sanitation system audits, WASH initiatives",
        },
        {
          label: "Energy and Climate Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., renewable energy project records, GHG inventories, climate adaptation plans",
        },
        {
          label: "Economic Growth and Decent Work Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., labor policies, employment statistics, worker safety programs",
        },
        {
          label: "Innovation and Infrastructure Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., innovation strategies, R&D reports, smart infrastructure plans",
        },
        {
          label: "Inequality Reduction Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., inclusion policies, marginalized group programs, social equity strategies",
        },
        {
          label: "Urban and Community Resilience Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., urban planning documents, housing strategies, green city plans",
        },
        {
          label: "Sustainable Consumption Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., waste management plans, circular economy audits, resource tracking",
        },
        {
          label: "Marine and Biodiversity Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., ocean conservation plans, biodiversity monitoring, deforestation tracking",
        },
        {
          label: "Governance and Anti-Corruption Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., ethics policies, anti-corruption programs, governance reports",
        },
        {
          label: "Partnership and Collaboration Files",
          type: "file",
          multiple: true,
          helperText:
            "e.g., partnership agreements, joint project records, cooperation reports",
        },
        {
          label:
            "✅ AI will match all uploads to the SDG goals selected below, ensuring evidence-backed alignment.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 3: SDG Goals and Targets Selection (Automated Mapping)",
      fields: [
        {
          label:
            "✅ Please tick the SDG Goals and Targets your organization is addressing.",
          type: "staticText",
        },
        {
          label: "Select SDG Goals",
          type: "checkbox",
          options: [
            "SDG Goal 1: No Poverty",
            "SDG Goal 2: Zero Hunger",
            "SDG Goal 3: Good Health and Well-being",
            "SDG Goal 4: Quality Education",
            "SDG Goal 5: Gender Equality",
            "SDG Goal 6: Clean Water and Sanitation",
            "SDG Goal 7: Affordable and Clean Energy",
            "SDG Goal 8: Decent Work and Economic Growth",
            "SDG Goal 9: Industry, Innovation and Infrastructure",
            "SDG Goal 10: Reduced Inequalities",
            "SDG Goal 11: Sustainable Cities and Communities",
            "SDG Goal 12: Responsible Consumption and Production",
            "SDG Goal 13: Climate Action",
            "SDG Goal 14: Life Below Water",
            "SDG Goal 15: Life on Land",
            "SDG Goal 16: Peace, Justice, and Strong Institutions",
            "SDG Goal 17: Partnerships for the Goals",
          ],
        },
      ],
    },
    {
      title: "Section 4: Requested AI-Generated Outputs",
      fields: [
        {
          label:
            "✅ Please tick the outputs you would like the system to generate:",
          type: "checkbox",
          options: [
            "SDG Compliance Assessment",
            "SDG Gap Analysis",
            "Impact and Progress Tracker",
            "Climate and Energy Risk Report",
            "Health and Well-being Metrics",
            "Gender Equality and Inclusion Scorecard",
            "Circular Economy Performance Report",
            "Marine and Biodiversity Impact Summary",
            "Governance and Anti-Corruption Compliance",
            "Partnership and Stakeholder Engagement Report",
            "Full SDG Alignment Report and Disclosure Package",
          ],
        },
        {
          label:
            "✅ AI will process all your uploaded documents and selected goals to automatically produce the requested reports.",
          type: "staticText",
        },
      ],
    },
  ],
};
export const SDG_COMPLIANCE_TARGET_FORM = {
  title: "SDG Compliance Topics Form",
  downloadFileName: "SDG_Compliance_Topics_Form",
  downloadFileExtension: "pdf",
  // formImageUrl can be added here if needed, like: formImageUrl: { SomeImg }

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This section ensures the compliance outputs are tailored to your company’s profile.",
          type: "staticText",
        },
      ],
    },
    {
      title: "Section 2: General Supporting Documents Upload",
      fields: [
        {
          label:
            "✅ Please upload general documents that reflect your company’s SDG-related work, activities, or practices (these can be simple, non-technical files — the system will process and align them).",
          type: "staticText",
        },
        {
          label: "Company Sustainability or ESG Policies",
          type: "file",
        },
        {
          label: "Codes of Conduct or Ethics Statements",
          type: "file",
        },
        {
          label: "Health, Safety, Environmental, or Community Guidelines",
          type: "file",
        },
        {
          label: "Human Rights, Labor, or Equity Policies",
          type: "file",
        },
        {
          label: "Community Outreach or Social Responsibility Reports",
          type: "file",
        },
        {
          label: "Any Additional Supporting Documents",
          type: "file",
        },
      ],
    },
    {
      title: "Section 3: Confirmed SDG Goals and Targets for Alignment",
      fields: [
        {
          label:
            "✅ For each SDG goal and related targets you have selected, please upload any relevant supporting documents. Even if documents are draft or basic, they will help generate the automated compliance and alignment reports.",
          type: "staticText",
        },
        // Now looping through each SDG goal with target info & upload
        {
          label: "SDG Goal 1: No Poverty",
          type: "checkbox",
          options: ["Relevant Targets (1.1 to 1.b)"],
        },
        {
          label:
            "Upload Files (e.g., Social Protection Plans, Poverty Eradication Programs)",
          type: "file",
        },
        {
          label: "SDG Goal 2: Zero Hunger",
          type: "checkbox",
          options: ["Relevant Targets (2.1 to 2.c)"],
        },
        {
          label:
            "Upload Files (e.g., Food Security Initiatives, Sustainable Agriculture Reports)",
          type: "file",
        },
        {
          label: "SDG Goal 3: Good Health and Well-being",
          type: "checkbox",
          options: ["Relevant Targets (3.1 to 3.d)"],
        },
        {
          label:
            "Upload Files (e.g., Health and Safety Policies, Wellness Programs, Disease Prevention Measures)",
          type: "file",
        },
        {
          label: "SDG Goal 4: Quality Education",
          type: "checkbox",
          options: ["Relevant Targets (4.1 to 4.c)"],
        },
        {
          label:
            "Upload Files (e.g., Training Programs, Literacy Projects, Educational Partnerships)",
          type: "file",
        },
        {
          label: "SDG Goal 5: Gender Equality",
          type: "checkbox",
          options: ["Relevant Targets (5.1 to 5.c)"],
        },
        {
          label:
            "Upload Files (e.g., Gender Equality Policies, Anti-Discrimination Programs, Women’s Leadership Reports)",
          type: "file",
        },
        {
          label: "SDG Goal 6: Clean Water and Sanitation",
          type: "checkbox",
          options: ["Relevant Targets (6.1 to 6.b)"],
        },
        {
          label:
            "Upload Files (e.g., Water Resource Management Plans, Sanitation Infrastructure Reports)",
          type: "file",
        },
        {
          label: "SDG Goal 7: Affordable and Clean Energy",
          type: "checkbox",
          options: ["Relevant Targets (7.1 to 7.b)"],
        },
        {
          label:
            "Upload Files (e.g., Renewable Energy Projects, Energy Efficiency Plans)",
          type: "file",
        },
        {
          label: "SDG Goal 8: Decent Work and Economic Growth",
          type: "checkbox",
          options: ["Relevant Targets (8.1 to 8.b)"],
        },
        {
          label:
            "Upload Files (e.g., Labor Rights Documentation, Employment Reports, Youth Programs)",
          type: "file",
        },
        {
          label: "SDG Goal 9: Industry, Innovation, and Infrastructure",
          type: "checkbox",
          options: ["Relevant Targets (9.1 to 9.c)"],
        },
        {
          label:
            "Upload Files (e.g., Innovation Strategies, Infrastructure Development Plans)",
          type: "file",
        },
        {
          label: "SDG Goal 10: Reduced Inequalities",
          type: "checkbox",
          options: ["Relevant Targets (10.1 to 10.c)"],
        },
        {
          label:
            "Upload Files (e.g., Social Inclusion Reports, Migration and Mobility Policies)",
          type: "file",
        },
        {
          label: "SDG Goal 11: Sustainable Cities and Communities",
          type: "checkbox",
          options: ["Relevant Targets (11.1 to 11.c)"],
        },
        {
          label:
            "Upload Files (e.g., Urban Planning Reports, Disaster Resilience Strategies)",
          type: "file",
        },
        {
          label: "SDG Goal 12: Responsible Consumption and Production",
          type: "checkbox",
          options: ["Relevant Targets (12.1 to 12.c)"],
        },
        {
          label:
            "Upload Files (e.g., Circular Economy Plans, Waste Reduction Programs)",
          type: "file",
        },
        {
          label: "SDG Goal 13: Climate Action",
          type: "checkbox",
          options: ["Relevant Targets (13.1 to 13.b)"],
        },
        {
          label:
            "Upload Files (e.g., Climate Risk Reports, Emissions Inventories, Carbon Reduction Plans)",
          type: "file",
        },
        {
          label: "SDG Goal 14: Life Below Water",
          type: "checkbox",
          options: ["Relevant Targets (14.1 to 14.c)"],
        },
        {
          label:
            "Upload Files (e.g., Marine Conservation Documents, Sustainable Fishing Practices)",
          type: "file",
        },
        {
          label: "SDG Goal 15: Life on Land",
          type: "checkbox",
          options: ["Relevant Targets (15.1 to 15.c)"],
        },
        {
          label:
            "Upload Files (e.g., Biodiversity Protection Plans, Ecosystem Restoration Reports)",
          type: "file",
        },
        {
          label: "SDG Goal 16: Peace, Justice, and Strong Institutions",
          type: "checkbox",
          options: ["Relevant Targets (16.1 to 16.b)"],
        },
        {
          label:
            "Upload Files (e.g., Governance Policies, Anti-Corruption Reports, Human Rights Documentation)",
          type: "file",
        },
        {
          label: "SDG Goal 17: Partnerships for the Goals",
          type: "checkbox",
          options: ["Relevant Targets (17.1 to 17.19)"],
        },
        {
          label:
            "Upload Files (e.g., Partnership Agreements, International Collaboration Reports)",
          type: "file",
        },
      ],
    },
    {
      title: "Section 4: Select Reports to Be Generated",
      fields: [
        {
          label:
            "✅ Please tick the outputs you want generated from your submissions:",
          type: "staticText",
        },
        {
          label: "SDG Gap Analysis Report",
          type: "checkbox",
        },
        {
          label: "SDG Materiality Assessment",
          type: "checkbox",
        },
        {
          label: "SDG Impact and Progress Report",
          type: "checkbox",
        },
        {
          label: "Health & Safety Metrics Report",
          type: "checkbox",
        },
        {
          label: "Gender Equity and Inclusion Report",
          type: "checkbox",
        },
        {
          label: "Water and Energy Risk Assessments",
          type: "checkbox",
        },
        {
          label: "Climate Action and Emissions Tracker",
          type: "checkbox",
        },
        {
          label: "Circular Economy and Resource Efficiency Report",
          type: "checkbox",
        },
        {
          label: "Biodiversity and Marine Impact Report",
          type: "checkbox",
        },
        {
          label: "Governance and Anti-Corruption Compliance Report",
          type: "checkbox",
        },
        {
          label: "Stakeholder Engagement Summary",
          type: "checkbox",
        },
        {
          label: "Public–Private SDG Cooperation Tracker",
          type: "checkbox",
        },
        {
          label: "Full SDG Alignment and Compliance Report",
          type: "checkbox",
        },
        {
          label:
            "✅ These reports will be automatically generated by aligning your provided documents and selected SDG goals and targets.",
          type: "staticText",
        },
      ],
    },
  ],
};
export const CDP_COMPLIANCE_FORM = {
  title: "Download CDP Customized form",
  subtitle: "Download CDP Customized Form Preview",
  formTitle: "CDP Customized Reporting Form",
  downloadFileName: "CDP_Customized_Reporting_Form",
  downloadFileExtension: "png",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          required: true,
        },
        {
          label: "Industry / Sector",
          type: "text",
        },
        {
          label: "Countries of Operation",
          type: "text",
        },
        {
          label: "Reporting Period (e.g., Jan 2024 – Dec 2024)",
          type: "text",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
        },
        {
          label: "Email & Phone (for follow-up)",
          type: "text",
        },
      ],
    },
    {
      title: "Section 2: General Supporting Documents Upload",
      fields: [
        {
          label: "Corporate Sustainability Policy Document",
          type: "file",
        },
        {
          label: "Climate or Environmental Strategy Document",
          type: "file",
        },
        {
          label: "ESG / Sustainability Report (if available)",
          type: "file",
        },
        {
          label: "GHG Emissions Inventory or Energy Use Data",
          type: "file",
        },
        {
          label: "Water Use, Wastewater, or Resource Management Reports",
          type: "file",
        },
        {
          label: "Forests / Sourcing or Supplier Policies",
          type: "file",
        },
        {
          label: "Any Other Relevant Company Policies or Statements",
          type: "file",
        },
      ],
    },
    {
      title: "Section 3A: CDP Climate Change Documentation",
      fields: [
        {
          label: "Climate Change Strategy Documents",
          type: "file",
        },
        {
          label: "Board-Level Oversight Evidence (Meeting Minutes, Policies)",
          type: "file",
        },
        {
          label: "GHG Emissions Inventories (Scope 1, 2, 3)",
          type: "file",
        },
        {
          label: "Emission Reduction Targets & Initiatives",
          type: "file",
        },
        {
          label: "Internal Carbon Pricing Documentation",
          type: "file",
        },
        {
          label: "Climate Risk & Opportunity Assessments",
          type: "file",
        },
        {
          label: "Climate Scenario Analysis (IEA, IPCC, etc.)",
          type: "file",
        },
        {
          label: "Science-Based Targets (SBTi) Evidence",
          type: "file",
        },
        {
          label: "Net-Zero Commitments or Pathway Documentation",
          type: "file",
        },
        {
          label: "Climate Financial Planning or Impact Assessments",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3B: CDP Water Security Documentation",
      fields: [
        {
          label: "Water Withdrawal, Use, and Recycling Data",
          type: "file",
        },
        {
          label: "Water Risk Mapping or Basin-Level Assessments",
          type: "file",
        },
        {
          label: "Water Risk Response Plans or Mitigation Strategies",
          type: "file",
        },
        {
          label: "Wastewater Treatment Policies or Compliance Reports",
          type: "file",
        },
        {
          label: "Supply Chain Water Risk Identification",
          type: "file",
        },
        {
          label: "Ecosystem Impact or Water Stewardship Evidence",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3C: CDP Forests Documentation",
      fields: [
        {
          label:
            "Forest-Risk Commodity Sourcing Reports (Palm Oil, Soy, Timber, Cattle)",
          type: "file",
        },
        {
          label: "Traceability and Source Origin Data",
          type: "file",
        },
        {
          label: "Deforestation-Free Commitments",
          type: "file",
        },
        {
          label: "Certification (i.e. FSC, RSPO, RTRS) Documentation",
          type: "file",
        },
        {
          label: "Land Use Change Monitoring Reports",
          type: "file",
        },
        {
          label: "Supplier Engagement and Risk Reduction Plans",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3D: CDP Supply Chain Documentation",
      fields: [
        {
          label: "Supplier GHG Emissions Data (Scope 3)",
          type: "file",
        },
        {
          label: "Supplier Climate Risk Assessments",
          type: "file",
        },
        {
          label: "Procurement Policies with Sustainability Criteria",
          type: "file",
        },
        {
          label: "Supplier Engagement and Capacity Building Programs",
          type: "file",
        },
        {
          label: "Monitoring of Supplier Emissions Targets",
          type: "file",
        },
        {
          label: "Climate Risk Integration in Contracts",
          type: "file",
        },
      ],
    },

    {
      title: "Section 4: Requested AI-Generated Compliance Outputs",
      fields: [
        {
          label: "Climate Change Reports & Analysis",
          type: "checkbox",
          options: [
            "GHG Emissions Inventory & Reduction Performance Report",
            "Internal Carbon Pricing Analysis",
            "Science-Based Targets (SBTi) Alignment Report",
            "Climate Risk & Opportunity Assessment",
            "Climate Scenario Analysis Summary",
            "CDP Climate Disclosure Readiness Scorecard",
          ],
        },
        {
          label: "Water Security Reports & Analysis",
          type: "checkbox",
          options: [
            "Water Risk Exposure & Mitigation Report",
            "Water Use & Efficiency Performance Report",
            "Wastewater Management & Compliance Summary",
          ],
        },
        {
          label: "Forests Reports & Analysis",
          type: "checkbox",
          options: [
            "Forest-Risk Commodity Sourcing Assessment",
            "Forest Certification Compliance Report",
            "Land Use Change Monitoring Summary",
          ],
        },
        {
          label: "Supply Chain Reports & Analysis",
          type: "checkbox",
          options: [
            "Scope 3 Supplier Emissions Report",
            "Supplier Climate Target Monitoring Tracker",
          ],
        },
        {
          label: "Integrated & Cross-Cutting Reports",
          type: "checkbox",
          options: [
            "CDP–TCFD Alignment Report",
            "CDP–ESRS Climate Module Crosswalk",
            "CDP–IFRS S2 Readiness Report",
            "CDP Submission Readiness & Gap Analysis",
          ],
        },
      ],
    },
  ],
};
export const AI_DRIVEN_CDP_FORM = {
  title: "AI-Driven CDP Compliance Submission Form",
  subtitle: "",
  formTitle: "CDP Customized Reporting Form",
  downloadFileName: "CDP_Customized_Reporting_Form",
  downloadFileExtension: "png",
  formImageUrl: { EsgImg },

  sections: [
    {
      title: "Section 1: Organization Details",
      description:
        "✅ This ensures your CDP compliance outputs are customized to your company profile.",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
      ],
    },
    {
      title: "Section 2: Upload Relevant Company Information",
      description:
        "✅ Please upload any available files, trackers, or internal documents. You don't need to prepare detailed technical reports — just provide the most relevant available materials. The system will sort, analyze, and identify where more data may be needed for full CDP compliance.",
      fields: [
        {
          label: "📦 Climate Change",
          type: "checkbox",
          description: "⬆ Upload (if available):",
          options: [
            "General sustainability or climate policies",
            "Energy consumption records (monthly or annual)",
            "Emissions logs or any GHG tracking spreadsheets",
            "Notes on climate targets, net-zero goals, or reduction initiatives",
            "Any carbon pricing or internal cost estimation summaries",
            "Climate-related risks or opportunities identified for your business",
            "Any available climate scenario or stress test outputs",
          ],
        },
        {
          label: "",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv",
        },
        {
          label: "💧 Water Security",
          type: "checkbox",
          description: "⬆ Upload (if available):",
          options: [
            "Records on water withdrawal or usage (plant, facility, office)",
            "Internal water efficiency goals or plans",
            "Wastewater management policies or logs",
            "Any assessments of water-related risks or basin stress",
            "Notes on how water risks are integrated into company strategy",
          ],
        },
        {
          label: "",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv",
        },
        {
          label: "🌳 Forests",
          type: "checkbox",
          description: "⬆ Upload (if available):",
          options: [
            "Supplier lists showing forest-risk commodities (palm oil, soy, timber, cattle)",
            "Traceability or sourcing records (even basic volume/origin notes)",
            "Forest-related commitments or supplier codes of conduct",
            "Any certifications (FSC, RSPO, etc.) or progress reports on forest-risk reduction",
          ],
        },
        {
          label: "",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv",
        },
        {
          label: "🔗 Supply Chain",
          type: "checkbox",
          description: "⬆ Upload (if available):",
          options: [
            "Supplier sustainability or procurement policies",
            "Supplier engagement records (emails, questionnaires, summary notes)",
            "Any Scope 3 (supplier-side) emissions estimates or spend-based calculations",
            "Records showing supplier incentives, contracts, or sustainability targets",
          ],
        },
        {
          label: "",
          type: "file",
          multiple: true,
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv",
        },
        {
          label:
            "✅ You don't need technical reports — just share what you have; the system will align it.",
          type: "info",
        },
      ],
    },
    {
      title:
        "Section 3: Please Tick the Reports or Outputs You Would Like the System to Generate",
      description:
        "✅ The system will process your uploads and generate these reports (please tick all that apply):",
      fields: [
        {
          type: "checkbox",
          options: [
            "Climate Change Reports & Analysis",
            "GHG Emissions Inventory & Reduction Performance Report",
            "Internal Carbon Pricing Analysis",
            "Science-Based Targets (SBTi) Alignment Report",
            "Climate Risk & Opportunity Assessment",
            "Climate Scenario Analysis Summary",
            "CDP Climate Disclosure Readiness Scorecard",
            "Water Security Reports & Analysis",
            "Water Risk Exposure & Mitigation Report",
            "Water Use & Efficiency Performance Report",
            "Wastewater Management & Compliance Summary",
            "Forests Reports & Analysis",
            "Forest-Risk Commodity Sourcing Assessment",
            "Forest Certification Compliance Report",
            "Land Use Change Monitoring Summary",
            "Supply Chain Reports & Analysis",
            "Scope 3 Supplier Emissions Report",
            "Supplier Climate Target Monitoring Tracker",
            "Integrated & Cross-Cutting Reports",
            "CDP–TCFD Alignment Report",
            "CDP–ESRS Climate Module Crosswalk",
            "CDP–IFRS S2 Readiness Report",
            "CDP Submission Readiness & Gap Analysis",
          ],
        },
      ],
    },
    {
      title: "Final Reminder",
      description: "",
      fields: [
        {
          label:
            "✅ Final Reminder: Simply upload general materials you already have — no extra preparation or technical formatting is needed. The system will handle mapping, analysis, and generation of all requested CDP compliance outputs.",
          type: "info",
        },
      ],
    },
  ],
};
export const WB_COMPLIANCE_FORM = {
  title: "Download WB Customized form",
  downloadFileName: "WB_Customized_Reporting_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This section ensures your compliance outputs are tailored to your organization’s size, sector, and project context.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Company and Project Information",
      description:
        "✅ Upload summaries, assessments, or reports for ESS requirements — formal formatting not needed.",
      fields: [
        { label: "Environmental & Social Assessments (ESS1)", type: "file" },
        { label: "Labor & Working Conditions (ESS2)", type: "file" },
        { label: "Resource Efficiency & Pollution (ESS3)", type: "file" },
        { label: "Community Health & Safety (ESS4)", type: "file" },
        { label: "Land Acquisition & Resettlement (ESS5)", type: "file" },
        { label: "Biodiversity (ESS6)", type: "file" },
        { label: "Indigenous Peoples (ESS7)", type: "file" },
        { label: "Cultural Heritage (ESS8)", type: "file" },
        { label: "Financial Intermediaries (ESS9)", type: "file" },
        { label: "Stakeholder Engagement (ESS10)", type: "file" },
        {
          label:
            "✅Reminder: You don’t need to prepare technical documents — general summaries, policies, or notes are sufficient. The system will process them.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Select the Reports You Want to Generate",
      description:
        "✅ Tick the outputs you'd like the system to generate based on your document uploads.",
      fields: [
        {
          label: "Compliance Reports to Generate",
          type: "checkbox",
          options: [
            "Environmental and Social Risk Matrix",
            "Environmental and Social Due Diligence Assessment (ESDD)",
            "Impact Assessment Summary Report",
            "Labor & Working Conditions Compliance Report",
            "Resource Efficiency & Pollution Prevention Report",
            "Community Health & Safety Evaluation",
            "Resettlement & Compensation Tracker",
            "Biodiversity Risk Assessment",
            "Indigenous Peoples Engagement Tracker",
            "Cultural Heritage Monitoring Report",
            "Financial Intermediary Subproject Compliance Review",
            "Stakeholder Engagement Effectiveness Report",
            "Gap Analysis & Corrective Action Report",
            "Grievance Redress System Tracker",
            "Stakeholder Mapping & Influence Matrix",
            "Cumulative Impact Tracker",
            "Audit-Ready Compliance Checklist",
            "Adaptive Management Performance Review",
            "Annual Environmental and Social Progress Report",
            "Full World Bank Safeguard Compliance Report",
          ],
        },
      ],
    },
  ],
};
export const AI_DRIVEN_WB_COMPLIANCE_FORM = {
  title: "Download WB Safeguards Form",
  // subtitle: "World Bank E&S Safeguard Compliance Upload + Report Generation",
  formTitle: "World Bank Environmental and Social Safeguards Compliance Form",
  downloadFileName: "WB_Safeguards_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text", required: true },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
      ],
    },

    {
      title: "Section 2: Upload General Information and Documents",
      description:
        "✅ Upload general summaries, policies, or reports. The system will extract and auto-analyze.",
      fields: [
        { label: " General Environmental & Social Information", type: "file" },
        { label: " Labor & Working Conditions", type: "file" },
        { label: " Resource Use & Pollution", type: "file" },
        { label: " Community & Land Issues", type: "file" },
        { label: " Biodiversity & Ecosystem", type: "file" },
        { label: " Indigenous Peoples & Cultural Heritage", type: "file" },
        { label: " Financial Intermediary Oversight", type: "file" },
        { label: " Stakeholder Engagement", type: "file" },
      ],
    },

    {
      title: "Section 3: Automated System-Generated Compliance Reports",
      description:
        "✅ Select the reports you want the AI to auto-generate based on your uploads.",
      fields: [
        {
          label: "Compliance Reports to Generate",
          type: "checkbox",
          options: [
            "Environmental and Social Risk Matrix",
            "Environmental and Social Due Diligence Assessment (ESDD)",
            "Impact Assessment Summary Report",
            "Labor & Working Conditions Compliance Report",
            "Resource Efficiency & Pollution Prevention Report",
            "Community Health & Safety Evaluation",
            "Resettlement & Compensation Tracker",
            "Biodiversity Risk Assessment",
            "Indigenous Peoples Engagement Tracker",
            "Cultural Heritage Monitoring Report",
            "Financial Intermediary Subproject Compliance Review",
            "Stakeholder Engagement Effectiveness Report",
            "Gap Analysis & Corrective Action Report",
            "Grievance Redress System Tracker",
            "Stakeholder Mapping & Influence Matrix",
            "Cumulative Impact Tracker",
            "Audit-Ready Compliance Checklist",
            "Adaptive Management Performance Review",
            "Annual Environmental and Social Progress Report",
            "Full World Bank Safeguard Compliance Report",
          ],
        },
      ],
    },
  ],
};
export const IFC_COMPLIANCE_FORM = {
  title: "Download IFC Customized form",
  downloadFileName: "WB_Customized_Reporting_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures that your IFC compliance outputs are tailored to your company's profile and context.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Supporting Materials",
      description:
        "✅ Please upload general company files, summaries, or records related to these topics (you don't need highly technical documents, the system will extract the necessary compliance information).",
      fields: [
        {
          label: " Environmental and Social Risk Management",
          type: "header",
        },
        { label: "Environmental & Social Policies", type: "file" },
        { label: "ESIA, ESMP, or Environmental Action Plans", type: "file" },
        { label: "Risk assessments or mitigation plans", type: "file" },
        { label: "Stakeholder consultation records", type: "file" },

        {
          label: " Labor and Working Conditions",
          type: "header",
        },
        { label: "Employee handbooks or HR policies", type: "file" },
        { label: "Health and safety procedures", type: "file" },
        { label: "Workforce grievance records", type: "file" },
        { label: "Labor statistics or reports", type: "file" },

        {
          label: " Resource Efficiency and Pollution Prevention",
          type: "header",
        },
        { label: "Energy or water use reports", type: "file" },
        { label: "Waste management summaries", type: "file" },
        { label: "Pollution prevention efforts", type: "file" },
        { label: "Emissions tracking summaries", type: "file" },

        {
          label: " Community Health, Safety, and Security",
          type: "header",
        },
        { label: "Emergency response plans", type: "file" },
        { label: "Community engagement summaries", type: "file" },
        { label: "Road or infrastructure safety documents", type: "file" },
        { label: "Security management procedures", type: "file" },

        {
          label: " Land, Biodiversity, Indigenous Peoples, Cultural Heritage",
          type: "header",
        },
        { label: "Resettlement or compensation plans (if any)", type: "file" },
        { label: "Biodiversity or conservation initiatives", type: "file" },
        { label: "Indigenous community engagement records", type: "file" },
        { label: "Cultural heritage protection procedures", type: "file" },
      ],
    },

    {
      title: "Section 3: Reports and Outputs You Want the System to Generate",
      description: "✅ Please tick the reports or outputs you want:",
      fields: [
        {
          label: "Reports to Generate",
          type: "checkbox",
          options: [
            "Full IFC Performance Standards Compliance Report",
            "Environmental and Social Management System (ESMS) Implementation Report",
            "ESAP (Environmental & Social Action Plan) Monitoring Report",
            "IFC-Aligned Gap Analysis Report",
            "IFC Risk Categorization Matrix (High, Medium, Low)",
            "Stakeholder Engagement & Disclosure Summary",
            "IFC Audit-Ready Documentation Tracker",
            "Monitoring & Evaluation Framework Status Report",
            "Labor & Working Conditions Compliance Review",
            "Occupational Health & Safety (OHS) Matrix",
            "Worker Grievance Management Report",
            "GHG Emissions & Intensity Reporting (Scope 1 & 2)",
            "Energy & Water Use Efficiency Report",
            "Community Risk & Safety Assessment Report",
            "Resettlement Action Plan (RAP) Implementation Report",
            "Compensation Disbursement Tracker",
            "Livelihood Restoration Effectiveness Report",
            "Biodiversity Risk & Impact Report",
            "Biodiversity Monitoring Indicators Tracker",
            "Indigenous Peoples Plan (IPP) Implementation Tracker",
            "Cultural Heritage Management Plan (CHMP) Monitoring Report",
          ],
        },
      ],
    },
  ],
};
export const AI_DRIVEN_IFC_COMPLIANCE_FORM = {
  title: "Download AI-Driven IFC Compliance form",
  downloadFileName: "AI_Driven_IFC_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system aligns the compliance reports to your business sector, size, and regional context.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Company Information",
      description:
        "✅ Please upload any available general files or summaries — they do not need to be technical. The system will automatically extract the required data.",
      fields: [
        {
          label: "Environmental and Social Management",
          type: "header",
        },
        { label: "Company environmental/social policies", type: "file" },
        { label: "Risk assessments or mitigation plans", type: "file" },
        { label: "Environmental and social project summaries", type: "file" },

        {
          label: " Labor and Working Conditions",
          type: "header",
        },
        { label: "HR or workforce policies", type: "file" },
        { label: "Health & safety protocols", type: "file" },
        { label: "Employee or contractor grievance summaries", type: "file" },

        {
          label: " Resource Efficiency & Pollution",
          type: "header",
        },
        { label: "Energy/water use records", type: "file" },
        { label: "Waste and emissions summaries", type: "file" },
        { label: "Pollution control efforts", type: "file" },

        {
          label: " Community & Stakeholder Engagement",
          type: "header",
        },
        { label: "Community engagement or consultation records", type: "file" },
        { label: "Emergency preparedness procedures", type: "file" },
        { label: "Security management or road safety measures", type: "file" },

        {
          label: " Land, Biodiversity, Indigenous Peoples, Cultural Heritage",
          type: "header",
        },
        { label: "Land acquisition or resettlement notes", type: "file" },
        {
          label: "Biodiversity or conservation activity reports",
          type: "file",
        },
        {
          label: "Indigenous peoples or cultural heritage engagement materials",
          type: "file",
        },

        {
          label:
            "✅ Reminder: Upload whatever relevant you have available, the AI system will analyze and fill in alignment with the IFC Performance Standards.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Automated System-Generated Reports",
      description:
        "✅ Based on your uploads, the system will automatically generate the following reports:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "Full IFC Performance Standards Compliance Report",
            "Environmental and Social Management System (ESMS) Implementation Report",
            "ESAP (Environmental & Social Action Plan) Monitoring Report",
            "IFC Gap Analysis Report",
            "IFC Risk Categorization Matrix",
            "Stakeholder Engagement & Disclosure Summary",
            "Audit-Ready Documentation Tracker",
            "Monitoring & Evaluation Framework Report",
            "Labor & Working Conditions Compliance Review",
            "Occupational Health & Safety (OHS) Matrix",
            "Worker Grievance Management Summary",
            "GHG Emissions & Intensity Report",
            "Energy & Water Use Efficiency Report",
            "Community Health, Safety & Risk Assessment Report",
            "Resettlement Action Plan (RAP) Tracker",
            "Compensation Disbursement Monitoring",
            "Livelihood Restoration Effectiveness Review",
            "Biodiversity Risk & Monitoring Report",
            "Indigenous Peoples Plan (IPP) Implementation Tracker",
            "Cultural Heritage Management Monitoring Report",
          ],
        },
      ],
    },
  ],
};
export const EP_COMPLIANCE_FORM = {
  title: "Download Equator Principles Compliance Form",
  downloadFileName: "AI_Driven_EP_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization and Project Details",
      fields: [
        { label: "Company / Borrower Name", type: "text" },
        { label: "Project Name", type: "text" },
        { label: "Project Location (Country & Region)", type: "text" },
        { label: "Project Type (Sector)", type: "text" },
        {
          label: "Project Phase",
          type: "select",
          options: ["Feasibility", "Development", "Construction", "Operations"],
        },
        { label: "Project Financing Size (USD)", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone", type: "text" },
      ],
    },

    {
      title: "Section 2: Upload General Project and Risk Documents",
      description:
        "✅ Please upload general, non-technical documents (partial or internal versions are fine) to help the system build compliance reports. The AI will sort and extract details aligned to each EP area.",
      fields: [
        {
          label: "📂 Project Risk Information",
          type: "header",
        },
        { label: "Project descriptions or summaries", type: "file" },
        { label: "Risk assessments or risk registers", type: "file" },
        { label: "Country or sectoral context analysis", type: "file" },

        {
          label: "📂 Environmental and Social Assessments",
          type: "header",
        },
        {
          label:
            "Environmental and Social Impact Assessments (ESIA) or summaries",
          type: "file",
        },
        { label: "Management or mitigation plans", type: "file" },
        {
          label: "Permits, approvals, or compliance certificates",
          type: "file",
        },

        {
          label: "📂 Stakeholder & Community Engagement",
          type: "header",
        },
        { label: "Stakeholder engagement summaries or notes", type: "file" },
        { label: "Public consultation materials", type: "file" },
        { label: "Grievance logs or community communications", type: "file" },

        {
          label: "📂 Independent Reviews / Monitoring",
          type: "header",
        },
        {
          label: "Independent third-party reviews or audit summaries",
          type: "file",
        },
        { label: "Monitoring and progress reports", type: "file" },
        { label: "Corrective action tracking sheets", type: "file" },

        {
          label: "📂 Legal / Covenant Documents",
          type: "header",
        },
        {
          label: "Loan or financing agreements with E&S conditions",
          type: "file",
        },
        { label: "Covenants or compliance clauses", type: "file" },
        { label: "Non-compliance resolution documents", type: "file" },
      ],
    },

    {
      title: "Section 3: AI-Generated Reports (Based on Uploaded Materials)",
      description:
        "✅ Please tick the reports or outputs you would like the system to generate for your Equator Principles alignment:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "Equator Principles Compliance Report",
            "Project Risk Categorization Report (EP1)",
            "Environmental and Social Impact & Management Summary (EP2, EP3)",
            "EP Action Plan Implementation Report (EPAP, EP4)",
            "Stakeholder Engagement & FPIC Report (EP5)",
            "Grievance Redress Mechanism (GRM) Dashboard (EP6)",
            "Independent Review Validation Log (EP7)",
            "Covenant and Compliance Enforcement Summary (EP8)",
            "Monitoring and Reporting Tracker (EP9)",
            "Annual Lender Compliance Submission Pack (EP10)",
            "Gap Analysis and Remediation Plan",
            "ESMS Operational Effectiveness Review",
            "Public Transparency Disclosure Sheet",
            "Cross-Framework Alignment Report (EP ↔ IFC / WB / TCFD)",
          ],
        },
        {
          label:
            "✅ Reminder: You do NOT need to prepare specialized technical files. Upload what you have, and the system will handle the extraction, matching, and generation.",
          type: "note",
        },
      ],
    },
  ],
};
export const AI_DRIVEN_EP = {
  title: "Download AI-Driven Equator Principles (EP) Compliance Form",
  downloadFileName: "AI_Driven_Equator_Principles_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization and Project Details",
      description:
        "✅ This ensures all outputs are tailored to your project's size, scope, and risk level.",
      fields: [
        { label: "Company / Borrower Name", type: "text" },
        { label: "Project Name", type: "text" },
        { label: "Project Location (Country & Region)", type: "text" },
        { label: "Sector / Industry", type: "text" },
        {
          label: "Project Phase",
          type: "select",
          options: ["Feasibility", "Development", "Construction", "Operation"],
        },
        { label: "Project Finance Amount (USD)", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Role)", type: "text" },
        { label: "Email & Phone", type: "text" },
      ],
    },

    {
      title:
        "Section 2: Upload General Documents (AI Will Extract All Relevant Details)",
      description:
        "✅ Please upload general, non-technical files — the system will extract, analyze, and align them automatically to the 10 Equator Principles (EP1–EP10). No need to format or compile specialized technical documents — partial, simple, or internal records are fine; the AI will process and match them to EP compliance needs.",
      fields: [
        {
          label: "📂 Project and Risk Documents",
          type: "header",
        },
        { label: "Project description, summary, or overview", type: "file" },
        { label: "Country or sectoral context information", type: "file" },
        {
          label: "Risk assessments or early screening summaries",
          type: "file",
        },

        {
          label: "📂 Environmental & Social Management",
          type: "header",
        },
        {
          label: "ESIA or Environmental/Social Management Plans (if available)",
          type: "file",
        },
        {
          label: "Any permits, approvals, or compliance statements",
          type: "file",
        },
        { label: "E&S monitoring or due diligence summaries", type: "file" },

        {
          label: "📂 Stakeholder & Community Engagement",
          type: "header",
        },
        { label: "Stakeholder engagement summaries or records", type: "file" },
        {
          label: "Community consultations or grievance summaries",
          type: "file",
        },
        {
          label: "Indigenous Peoples engagement documentation (if relevant)",
          type: "file",
        },

        {
          label: "📂 Independent Reviews / Monitoring",
          type: "header",
        },
        {
          label: "Third-party reviews, audits, or advisory reports",
          type: "file",
        },
        {
          label: "Monitoring, progress, or corrective action tracking",
          type: "file",
        },

        {
          label: "📂 Covenant / Loan / Legal Documents",
          type: "header",
        },
        { label: "E&S covenants or compliance clauses", type: "file" },
        {
          label: "Loan or financing agreements with EP requirements",
          type: "file",
        },
        { label: "Annual or periodic lender reports", type: "file" },

        {
          label:
            "✅ Reminder: No need to format or compile specialized technical documents — partial, simple, or internal records are fine; the AI will process and match them to EP compliance needs.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Automated Reports You Want the System to Generate",
      description:
        "✅ Please tick the reports or outputs you would like the system to deliver:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "Equator Principles Full Compliance Report",
            "EP1 – Project Risk Categorization Report",
            "EP2–3 – Environmental and Social Impact & Management Summary",
            "EP4 – EP Action Plan (EPAP) Implementation Tracker",
            "EP5 – Stakeholder Engagement & FPIC Report",
            "EP6 – Grievance Redress Mechanism (GRM) Dashboard",
            "EP7 – Independent Review Validation Log",
            "EP8 – Covenant & Compliance Summary",
            "EP9 – Monitoring and Reporting Dashboard",
            "EP10 – Annual Lender Compliance Submission Pack",
            "Gap Analysis & Remediation Plan",
            "ESMS Operational Effectiveness Review",
            "Transparency Disclosure Sheet (for public reporting)",
            "Cross-Framework Alignment Report (EP ↔ IFC, WB, TCFD, CDP)",
          ],
        },
      ],
    },

    {
      title: "Section 4: Preferred Report Format",
      description: "✅ Select your desired output format:",
      fields: [
        {
          label: "Report Format",
          type: "radio",
          options: [
            "Dashboard Visualization Summary",
            "Detailed PDF Report",
            "Editable Word Document",
            "Excel Tracker / Data File",
          ],
        },
        {
          label:
            "✅ Final Note: You do NOT need to worry about manually linking documents to specific EP principles. The AI system will process, categorize, and generate all selected reports using the provided uploads.",
          type: "note",
        },
      ],
    },
  ],
};
export const ISO_STANDARDS_CUSTOM_FORM = {
  title: "Download ISO Standards Custom Compliance Form",
  downloadFileName: "ISO_Standards_Custom_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your compliance outputs are tailored to your company's sector, geography, and scale.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Company Information",
      description:
        "✅ Please upload any available general files, summaries, or internal documents, no special technical formatting required. The system will sort and analyze them to align with ISO requirements.",
      fields: [
        {
          label: "📦 Environmental Management (ISO 14001)",
          type: "header",
        },
        {
          label: "Environmental policies, procedures, or system documents",
          type: "file",
        },
        {
          label: "Records of environmental risks, impacts, or assessments",
          type: "file",
        },
        {
          label:
            "Resource use, energy conservation, or environmental performance",
          type: "file",
        },

        {
          label: "💼 Occupational Health & Safety (ISO 45001)",
          type: "header",
        },
        {
          label: "OHS management practices, safety policies, or procedures",
          type: "file",
        },
        {
          label:
            "Incident logs, workplace safety records, or hazard assessments",
          type: "file",
        },

        {
          label: "⭐ Quality Management (ISO 9001)",
          type: "header",
        },
        {
          label:
            "Quality control, product/service performance, customer satisfaction data",
          type: "file",
        },
        {
          label:
            "Non-conformance records, CAPA actions, or quality review summaries",
          type: "file",
        },

        {
          label: "⚡ Energy Management (ISO 50001)",
          type: "header",
        },
        {
          label:
            "Energy consumption data, energy efficiency initiatives, or energy policies",
          type: "file",
        },
        {
          label: "Monitoring records, metering reports, or energy audits",
          type: "file",
        },

        {
          label: "🌱 Social Responsibility (ISO 26000)",
          type: "header",
        },
        {
          label:
            "Human rights, labor practices, community engagement, or ethical conduct",
          type: "file",
        },
        {
          label: "Supply chain social impact or sustainability practices",
          type: "file",
        },

        {
          label: "🌍 GHG Accounting (ISO 14064)",
          type: "header",
        },
        {
          label:
            "GHG inventories, Scope 1/2/3 emissions data, reduction plans, or carbon reporting",
          type: "file",
        },

        {
          label: "📦 Sustainable Procurement (ISO 20400)",
          type: "header",
        },
        {
          label:
            "Supplier criteria, sustainable sourcing policies, or supply chain sustainability assessments",
          type: "file",
        },

        {
          label: "🚨 Risk Management (ISO 31000)",
          type: "header",
        },
        {
          label:
            "Risk registers, hazard mapping, risk assessment summaries, or mitigation strategies",
          type: "file",
        },

        {
          label: "🔒 Anti-Bribery Management (ISO 37001)",
          type: "header",
        },
        {
          label:
            "Anti-bribery policies, risk assessments, whistleblower reports, or compliance documents",
          type: "file",
        },

        {
          label:
            "✅ Reminder: Just upload what you have — policies, reports, summaries, spreadsheets, or logs — the system will extract and map the information.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Select Reports for Automated Generation",
      description:
        "✅ Please tick the reports or outputs you would like the system to generate:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "ISO Compliance Dashboard (By Standard)",
            "Internal Audit & Non-Conformance Report",
            "ISO Certification Tracker Report",
            "Non-Conformance Register (Multi-Standard)",
            "Corrective Action and Preventive Action (CAPA) Tracker",
            "ISO 31000 Risk Assessment Matrix",
            "ISO 9001 QMS Performance Review",
            "ISO 14001 Environmental Risk & Aspect Register",
            "ISO 45001 H&S Risk Analysis & Incident Log",
            "ISO 50001 Energy Efficiency & Usage Report",
            "GHG Emissions & Reduction Analysis (ISO 14064)",
            "Social Responsibility Implementation Report (ISO 26000)",
            "ISO Crosswalk Report (Integrated Management Systems)",
            "ISO Policy Gap Analysis (Integrated Standards)",
            "ISO-Based ESG Maturity Index",
            "Anti-Bribery Compliance Report (ISO 37001:2025)",
            "Annual ISO Compliance Statement",
          ],
        },
        {
          label:
            "✅ Final Note: You do not need to prepare detailed technical documents, upload whatever general material you have, and the system will analyze, compile, and align it to the relevant ISO standards and generate the requested compliance reports.",
          type: "note",
        },
      ],
    },
  ],
};
export const ISO_AI_DRIVEN_FORM = {
  title: "Download ISO AI-Driven Compliance Form",
  downloadFileName: "ISO_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
      ],
    },

    {
      title: "Section 2: General Supporting Uploads",
      description:
        "✅ Please upload general company materials, they do not need to be highly technical. The system will analyze them for alignment with ISO requirements.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },
        {
          label:
            "Company policies (environmental, health & safety, quality, anti-bribery, social responsibility, energy management)",
          type: "file",
        },
        {
          label:
            "Internal summaries or management reports (on sustainability, operations, risk, performance, ESG progress)",
          type: "file",
        },
        {
          label:
            "Health, safety, or environmental checklists and routine inspection logs",
          type: "file",
        },
        {
          label:
            "Employee training records, workshop attendance summaries, or awareness materials",
          type: "file",
        },
        {
          label:
            "Supplier or procurement-related policies, ethical sourcing guidelines, or supplier evaluation records",
          type: "file",
        },
        {
          label:
            "Energy, water, or emissions tracking files (basic logs, summaries, spreadsheets, or utility data)",
          type: "file",
        },
        {
          label:
            "Past ISO certifications, surveillance audits, re-certification records, or third-party validation reports",
          type: "file",
        },
        {
          label:
            "Incident reports or near-miss records (if relevant to OHS or quality)",
          type: "file",
        },
        {
          label:
            "Customer feedback summaries, complaint logs, or satisfaction surveys (if relevant to quality management)",
          type: "file",
        },
        {
          label: "Waste, recycling, or resource efficiency tracking summaries",
          type: "file",
        },
        {
          label:
            "Equipment maintenance logs, calibration records, or asset performance summaries",
          type: "file",
        },
        {
          label:
            "Internal communications, awareness posters, or bulletins promoting ISO-related practices",
          type: "file",
        },
        {
          label:
            "Community engagement or corporate social responsibility (CSR) reports",
          type: "file",
        },
        {
          label:
            "Anti-bribery or anti-corruption declarations, due diligence checklists, or third-party declarations",
          type: "file",
        },
        {
          label: "Risk registers, risk assessments, or risk treatment plans",
          type: "file",
        },
        {
          label:
            "Any other general compliance, governance, sustainability, or performance-related documents your company uses",
          type: "file",
        },
        {
          label:
            "👉 Note: You do not need to upload detailed technical or system-level files unless you have them. The system will process general materials and identify missing details.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Select Automated Reports You Want Generated",
      description:
        "✅ Please tick the reports or outputs you want the system to compile:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "ISO Compliance Dashboard (Multi-Standard Summary)",
            "ISO 14001 Environmental Management Compliance Report",
            "ISO 45001 Health & Safety Management Review",
            "ISO 9001 Quality Management System Summary",
            "ISO 50001 Energy Management Efficiency Report",
            "ISO 26000 Social Responsibility Overview",
            "ISO 14064 GHG Emissions Reporting & Summary",
            "ISO 20400 Sustainable Procurement Tracker",
            "ISO 31000 Risk Management Framework Report",
            "ISO 37001 Anti-Bribery Compliance Report",
            "Internal Audit & Non-Conformance Summary",
            "Corrective Action / Preventive Action (CAPA) Log",
            "ISO Certification Readiness & Renewal Report",
            "Integrated Gap Analysis Across Standards",
            "ESG Alignment & Crosswalk Summary",
            "Annual ISO Compliance Declaration",
          ],
        },
        {
          label:
            "✅ Reminder: The system will match your uploads to ISO standards, identify gaps, and generate automated reports. You only need to provide the most accessible, non-technical documents you have available.",
          type: "note",
        },
      ],
    },
  ],
};
export const OECD_CUSTOM_FORM = {
  title: "Download OECD AI-Driven Compliance Form",
  downloadFileName: "OECD_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures we align OECD compliance topics with your sector and organizational context.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload Relevant Supporting Documents",
      description:
        "✅ Please upload documents or summaries specifically aligned with the compliance topics below. You do NOT need highly technical materials; general policies, procedures, summaries, or management-level reports are acceptable.",

      fields: [
        { label: "📢 Disclosure", type: "header" },
        { label: "Sustainability or ESG reports", type: "file" },
        { label: "Materiality analysis or disclosure summaries", type: "file" },
        {
          label: "Climate or environmental financial disclosures",
          type: "file",
        },
        { label: "Human rights and due diligence transparency", type: "file" },

        { label: "⚖ Human Rights", type: "header" },
        { label: "Human rights policies or due diligence files", type: "file" },
        { label: "Grievance mechanism summaries or records", type: "file" },
        { label: "Stakeholder engagement logs", type: "file" },
        { label: "Vulnerable group or inclusion policies", type: "file" },
        { label: "Labor and social protections", type: "file" },

        { label: "🏢 Employment and Industrial Relations", type: "header" },
        {
          label: "Fair wages, decent work, and labor standards policies",
          type: "file",
        },
        { label: "Occupational health & safety summaries", type: "file" },
        {
          label: "Workforce consultation or collective bargaining records",
          type: "file",
        },
        {
          label: "Gender equality or anti-discrimination policies",
          type: "file",
        },

        { label: "🌱 Environment", type: "header" },
        {
          label: "Environmental policies or resource use summaries",
          type: "file",
        },
        {
          label: "Climate change mitigation or adaptation measures",
          type: "file",
        },
        {
          label: "Biodiversity or ecosystem protection policies",
          type: "file",
        },
        {
          label: "Circular economy or waste management strategies",
          type: "file",
        },

        { label: "🚫 Combating Bribery and Corruption", type: "header" },
        { label: "Anti-bribery and anti-corruption policies", type: "file" },
        {
          label: "Internal compliance or whistleblowing procedures",
          type: "file",
        },
        {
          label: "Third-party due diligence or supplier screening summaries",
          type: "file",
        },
        { label: "Ethics and compliance training records", type: "file" },

        { label: "🛡 Consumer Interests", type: "header" },
        {
          label: "Product safety, labeling, or customer rights documents",
          type: "file",
        },
        { label: "Data protection or digital safety policies", type: "file" },
        {
          label: "Complaint handling or dispute resolution records",
          type: "file",
        },

        { label: "💡 Science, Technology, and Innovation", type: "header" },
        {
          label: "Technology use and ethical innovation policies",
          type: "file",
        },
        { label: "AI ethics or cybersecurity frameworks", type: "file" },
        {
          label: "Intellectual property or open innovation policies",
          type: "file",
        },

        { label: "📊 Competition", type: "header" },
        { label: "Antitrust or fair competition policies", type: "file" },
        {
          label: "Tendering and procurement fairness guidelines",
          type: "file",
        },
        {
          label: "Regulatory compliance reports or competition assessments",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3: Select Reports You Want Generated",
      description:
        "✅ Please tick the reports you want the system to generate from the uploaded materials:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "Full OECD Compliance & Readiness Report",
            "OECD Due Diligence Implementation Tracker",
            "OECD Risk Categorization Matrix",
            "ESG Risk Register (OECD-Aligned)",
            "Human Rights Due Diligence (HRDD) Report",
            "Environmental Risk & Disclosure Matrix",
            "Green Innovation & Technology Adoption Summary",
            "Anti-Bribery Compliance Assessment Report",
            "Stakeholder Engagement & Complaint Summary Report",
            "OECD Framework Crosswalk & Alignment Report",
          ],
        },
        {
          label:
            "✅ Reminder: You do not need to provide formalized or highly detailed compliance documents — even general policies, management notes, or summaries are acceptable. The system will apply smart sorting and gap detection aligned to OECD guidelines.",
          type: "note",
        },
      ],
    },
  ],
};
export const OECD_AI_DRIVEN_CUSTOM_FORM = {
  title: "Download OECD AI-Driven Compliance Form",
  downloadFileName: "OECD_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your compliance outputs are aligned to your company profile and sector.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: General Supporting Information Upload",
      description:
        "✅ Please upload any general documents, summaries, or policies related to the following — no need for specialized formats; the system will analyze and extract the necessary compliance elements.",
      fields: [
        {
          label: "⬆ Upload any or all of these (if available):",
          type: "header",
        },
        {
          label: "Company sustainability reports or ESG summaries",
          type: "file",
        },
        {
          label:
            "Human rights policies, grievance logs, or stakeholder engagement notes",
          type: "file",
        },
        {
          label:
            "Labor and occupational health & safety policies or summary reports",
          type: "file",
        },
        {
          label: "Environmental performance or resource use summaries",
          type: "file",
        },
        {
          label: "Anti-bribery and anti-corruption policy documents",
          type: "file",
        },
        {
          label:
            "Consumer protection policies or product responsibility summaries",
          type: "file",
        },
        {
          label: "Supplier engagement or due diligence summaries",
          type: "file",
        },
        { label: "Innovation, digital, or technology policies", type: "file" },
        {
          label: "Competition, fair market, or procurement guidelines",
          type: "file",
        },
        {
          label: "Any general corporate governance or ethics policies",
          type: "file",
        },
        {
          label: "Past audit reports, certifications, or compliance reviews",
          type: "file",
        },
        {
          label:
            "👉 Note: Even general or partial documents are useful; the AI system will match and identify any gaps for automated reporting.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Please Select the Reports You Want Generated",
      description:
        "✅ Based on your uploads, the system will automatically generate the following reports. Please tick all that apply:",
      fields: [
        {
          label: "Select Reports to Generate",
          type: "checkbox",
          options: [
            "Full OECD Compliance & Readiness Report",
            "OECD Due Diligence Implementation Tracker",
            "OECD Risk Categorization Matrix",
            "Enterprise-Level ESG Risk Register (OECD-aligned)",
            "Human Rights Due Diligence (HRDD) Report",
            "Environmental Risk & Disclosure Matrix",
            "Green Innovation & Technology Adoption Report",
            "Resource Efficiency & Circular Economy Analysis",
            "Anti-Bribery & Anti-Corruption Compliance Assessment",
            "Stakeholder Engagement Plan (SEP) Engagement Log & Complaint Summary",
            "OECD Crosswalk Alignment Report (linking to other frameworks like UNGP, TCFD, ESRS)",
          ],
        },
        {
          label:
            "Reminder: You do not need to upload technical or highly detailed files if they are not readily available — general company-level documents and summaries are sufficient. The system will apply automated intelligence to sort, analyze, and build a complete compliance profile, including gap identification and readiness recommendations.",
          type: "note",
        },
      ],
    },
  ],
};
export const TNFD_CUSTOM_FORM = {
  title: "Download TNFD AI-Driven Disclosure Form",
  downloadFileName: "TNFD_AI_Driven_Disclosure_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: General Information",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your TNFD disclosures are tailored to your organization’s nature-related profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Company Materials",
      description:
        "✅ Please upload any general supporting documents. You do not need to submit technical or highly detailed files — the system will process and analyze what you provide automatically.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },
        { label: "Environmental or sustainability policies", type: "file" },
        {
          label:
            "Risk assessments related to nature, biodiversity, or ecosystems",
          type: "file",
        },
        {
          label:
            "Site-level or operational maps (including protected areas, sensitive sites)",
          type: "file",
        },
        {
          label: "Stakeholder engagement records (community, indigenous, NGOs)",
          type: "file",
        },
        {
          label:
            "Internal management reports on environmental or nature-related topics",
          type: "file",
        },
        {
          label:
            "Supply chain sustainability summaries or procurement sustainability policies",
          type: "file",
        },
        {
          label:
            "Climate or nature-related financial risk or opportunity summaries",
          type: "file",
        },
        {
          label:
            "Past biodiversity assessments, certifications, or conservation project records",
          type: "file",
        },
        {
          label: "Water, land, or resource use summaries or tracking sheets",
          type: "file",
        },
        {
          label:
            "Performance reports touching on nature, ecosystem impact, or environmental KPIs",
          type: "file",
        },
        {
          label:
            "Any general ESG or sustainability disclosure reports your company has prepared",
          type: "file",
        },
        {
          label:
            "Organizational charts or governance documents showing environmental oversight",
          type: "file",
        },
        {
          label:
            "Board meeting minutes or executive summaries mentioning nature-related risks",
          type: "file",
        },
        {
          label:
            "General risk registers or enterprise risk management (ERM) documents",
          type: "file",
        },
        {
          label:
            "Contracts, policies, or supplier commitments related to nature or biodiversity",
          type: "file",
        },
        {
          label:
            "Summaries of community benefit or nature-positive initiatives",
          type: "file",
        },
        {
          label:
            "Any spatial data files or GIS snapshots if available (but not required)",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3: Customize TNFD Compliance Areas",
      description:
        "✅ Please tick the areas your organization wants to include in its compliance review:",
      fields: [
        {
          label: "🌍 General",
          type: "checkbox",
          options: [
            "Nature-related dependencies",
            "Ecosystem services (pollination, water purification, climate regulation)",
            "Environmental and financial materiality",
            "Natural capital and biodiversity impacts",
            "Global vs local nature impacts",
            "Value chain connections to nature",
          ],
        },
        {
          label: "📊 LEAP Framework",
          type: "checkbox",
          options: [
            "Locate: Identify nature interfaces (e.g., forests, rivers, reefs)",
            "Evaluate: Dependencies and impacts on ecosystem services",
            "Assess: Exposure to nature risks, materiality thresholds",
            "Prepare: Disclosure alignment and target readiness",
          ],
        },
        {
          label: "🏛 Governance",
          type: "checkbox",
          options: [
            "Board oversight on nature risks",
            "Integration of ESG and biodiversity governance",
            "Internal audits of biodiversity processes",
            "Stakeholder consultation and accountability",
          ],
        },
        {
          label: "📈 Strategy",
          type: "checkbox",
          options: [
            "Nature-positive transformation plans",
            "Biodiversity No Net Loss / Net Gain commitments",
            "Adaptation to nature-related policy and regulation",
            "Sector-specific biodiversity strategies",
          ],
        },
        {
          label: "⚠️ Risk & Impact",
          type: "checkbox",
          options: [
            "Physical nature risks (flood, drought, wildfire)",
            "Transition risks (e.g., deforestation regulations, nature-based taxes)",
            "Reputational risks and NGO/media exposure",
            "Risks to indigenous rights and traditional land use",
          ],
        },
        {
          label: "🎯 Metrics & Targets",
          type: "checkbox",
          options: [
            "Impacted biodiversity areas (hectares, regions)",
            "Water and land use intensity",
            "Biodiversity Net Gain ratios",
            "Nature-based solutions (e.g., reforestation, conservation projects)",
            "Supply chain biodiversity assessments",
            "Monitoring systems (spatial data, satellite imagery)",
            "Alignment with Science-Based Targets for Nature (SBTN)",
          ],
        },
      ],
    },

    {
      title: "Section 4: Reports to Be Automatically Generated",
      description: "✅ Please tick the outputs you want the system to deliver:",
      fields: [
        {
          label: "Select TNFD Reports",
          type: "checkbox",
          options: [
            "Nature-Related Risk Register (LEAP Output)",
            "Physical Risk Impact Analysis (Acute/Chronic)",
            "Ecosystem Dependency & Impact Report",
            "TNFD Metrics & Target Progress Tracker",
            "Nature Positive Transition Plan",
            "Sector-Location Nature Risk Heatmap",
            "GHG Emissions Inventory Report (Scope 1–3)",
            "Biodiversity Impact Disclosure Report",
            "TNFD Readiness & Gap Assessment Report",
            "TNFD Crosswalk Report (with other frameworks)",
            "Geospatial Nature Risk Report",
            "Full TNFD-Aligned Disclosure Report",
          ],
        },
        {
          label:
            "👉 Reminder: You do not need to upload specialized technical data unless you already have it. The system will analyze your uploaded materials and generate detailed, structured outputs aligned with TNFD requirements.",
          type: "note",
        },
      ],
    },
  ],
};
export const TNFD_AI_DRIVEN_CUSTOM_FORM = {
  title: "Download TNFD AI-Driven Disclosure Form",
  downloadFileName: "TNFD_AI_Driven_Disclosure_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your disclosures are sector- and geography-appropriate and allows the system to tailor its outputs.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Company Materials",
      description:
        "✅ Please upload any general supporting materials (even if partial or non-technical). The system will analyze these inputs automatically.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },
        { label: "Environmental or sustainability policies", type: "file" },
        {
          label:
            "Risk assessments related to nature, biodiversity, or ecosystems",
          type: "file",
        },
        {
          label:
            "Site-level or operational maps (protected areas, sensitive sites)",
          type: "file",
        },
        {
          label: "Stakeholder engagement records (community, indigenous, NGOs)",
          type: "file",
        },
        {
          label:
            "Internal management or board-level reports on environmental or nature-related topics",
          type: "file",
        },
        {
          label: "Supply chain sustainability or procurement policies",
          type: "file",
        },
        {
          label: "Climate- or nature-related financial disclosures",
          type: "file",
        },
        {
          label:
            "Biodiversity or conservation certifications or project records",
          type: "file",
        },
        {
          label: "Water, land, or resource use tracking summaries",
          type: "file",
        },
        {
          label: "ESG, climate, or sustainability disclosure reports",
          type: "file",
        },
        {
          label: "Governance documents showing environmental/nature oversight",
          type: "file",
        },
        {
          label:
            "Organizational charts or role descriptions linked to biodiversity management",
          type: "file",
        },
        {
          label: "Risk registers or enterprise risk management (ERM) summaries",
          type: "file",
        },
        {
          label:
            "Contracts, policies, or supplier commitments touching on biodiversity/nature",
          type: "file",
        },
        {
          label:
            "Community benefit project summaries or nature-positive initiatives",
          type: "file",
        },
        {
          label: "Any spatial data (maps, GIS snapshots) — optional but useful",
          type: "file",
        },
        {
          label:
            "👉 Reminder: The system will auto-process general materials, flag gaps, and fill missing technical details wherever possible.",
          type: "note",
        },
      ],
    },

    {
      title:
        "Section 3: Please Tick the Reports You Want the System to Generate",
      description:
        "✅ Based on your uploaded materials, the system will automatically generate the following reports (please tick what you want):",
      fields: [
        {
          label: "Select TNFD Reports",
          type: "checkbox",
          options: [
            "Nature-Related Risk Register (LEAP Output)",
            "Physical Risk Impact Analysis (Acute/Chronic)",
            "Ecosystem Dependency & Impact Report",
            "TNFD Metrics & Target Progress Tracker",
            "Nature Positive Transition Plan",
            "Sector-Location Nature Risk Heatmap",
            "GHG Emissions Inventory Report (Scope 1–3, where applicable)",
            "Biodiversity Impact Disclosure Report",
            "TNFD Readiness & Gap Assessment Report",
            "TNFD Crosswalk Report (with ISSB/IFRS S2/ESRS linkages)",
            "Geospatial Nature Risk Report",
            "Full TNFD-Aligned Disclosure Report",
          ],
        },
        {
          label:
            "✅ Important Note: You don't need specialized technical files or expert-prepared documents; the system is designed to work with general evidence and will build detailed outputs automatically, including identifying data gaps and offering corrective recommendations.",
          type: "note",
        },
      ],
    },
  ],
};
export const AA_SERIES_CUSTOM_FORM = {
  title: "Download AA1000 Series Compliance Form",
  downloadFileName: "AA1000_Series_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the compliance outputs are tailored to your organization's profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General and Specific Supporting Materials",
      description:
        "✅ Please upload both general and specific supporting materials; they do not need to be perfectly structured; the system will process, sort, and extract what is needed for AA1000 compliance reporting.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },

        {
          label: "🌍 For AA1000AP (AccountAbility Principles):",
          type: "subheader",
        },
        {
          label: "Company sustainability or ESG policy statements",
          type: "file",
        },
        {
          label:
            "Records showing how stakeholder concerns were prioritized (materiality assessments, issue ranking)",
          type: "file",
        },
        {
          label:
            "Internal summaries of how stakeholder feedback was addressed (responsiveness logs)",
          type: "file",
        },
        {
          label:
            "Evidence of impact tracking (e.g., outcome reports, ESG performance summaries)",
          type: "file",
        },
        {
          label: "Governance or leadership oversight documents related to ESG",
          type: "file",
        },

        {
          label: "👥 For AA1000SES (Stakeholder Engagement Standard):",
          type: "subheader",
        },
        {
          label: "Stakeholder mapping and identification records",
          type: "file",
        },
        {
          label:
            "Meeting notes or engagement logs with stakeholders, NGOs, or local communities",
          type: "file",
        },
        {
          label: "Records on marginalized or vulnerable group consultations",
          type: "file",
        },
        {
          label:
            "Logs or summaries of grievances, complaints, or feedback received from stakeholders",
          type: "file",
        },
        {
          label:
            "Documentation on stakeholder influence on decisions or policy changes",
          type: "file",
        },
        {
          label:
            "Multi-channel engagement records (surveys, workshops, online platforms)",
          type: "file",
        },

        { label: "📊 For AA1000AS (Assurance Standard):", type: "subheader" },
        {
          label: "Internal assurance or review summaries (if any)",
          type: "file",
        },
        {
          label: "External assurance provider documentation (if engaged)",
          type: "file",
        },
        {
          label: "Source data logs for KPIs, metrics, or ESG performance",
          type: "file",
        },
        {
          label:
            "Audit or verification reports from third parties (even partial or draft)",
          type: "file",
        },
        {
          label:
            "GHG emissions data, carbon footprint reports, Scope 1/2/3 estimates",
          type: "file",
        },
        {
          label: "Climate-related risk assessments or emissions factor data",
          type: "file",
        },
        {
          label:
            "Any relevant evidence trails or documentation for reported ESG data",
          type: "file",
        },

        {
          label:
            "👉 Reminder: Upload whatever you have, even if informal — the system will analyze gaps, match to the required standards, and prepare assurance-ready outputs.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Confirm Relevant AA1000 Areas for Reporting",
      description:
        "✅ Based on your inputs, the system will automatically generate:",
      fields: [
        {
          label: "Automatic System-Generated Reports",
          type: "checkbox",
          options: [
            "AA1000AP Reports (Inclusivity, Materiality, Responsiveness, Impact)",
            "AA1000SES Reports (Stakeholder Engagement Effectiveness, Grievance Analysis, Feedback Integration)",
            "AA1000AS Assurance Reports (Scope, Evidence Logs, Balanced Narrative, GHG Verification)",
          ],
        },
        {
          label:
            "✅ Please tick below if you want to explicitly include these system-generated reports:",
          type: "header",
        },
        {
          label: "Additional Detailed Reports",
          type: "checkbox",
          options: [
            "Stakeholder Engagement Report",
            "Materiality Determination Report",
            "GHG Assurance Report",
            "Inclusivity and Responsiveness Report",
            "Engagement Effectiveness Assessment",
            "Stakeholder Grievance and Issue Log Analysis",
            "Cross-Standard Assurance Mapping",
            "Inclusivity Gap Analysis",
            "KPI Assurance Consistency Check",
          ],
        },
      ],
    },
  ],
};
export const AA_SERIES_AI_DRIVEN_CUSTOM_FORM = {
  title: "Download AA1000 Series AI-Driven Compliance Form",
  downloadFileName: "AA1000_Series_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system customizes outputs to your organization's profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Supporting Materials",
      description:
        "✅ Please upload as much as you can (partial or informal is acceptable); the system will process and match details to generate the required reports.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },
        {
          label:
            "Stakeholder engagement plans, mapping, or consultation records",
          type: "file",
        },
        {
          label:
            "Grievance logs, complaint registers, or stakeholder feedback trackers",
          type: "file",
        },
        {
          label:
            "Materiality assessments, prioritization notes, or risk-relevance maps",
          type: "file",
        },
        {
          label:
            "GHG emissions data, Scope 1–3 inventories, or climate impact summaries",
          type: "file",
        },
        {
          label:
            "Internal ESG or sustainability performance reports (including KPIs)",
          type: "file",
        },
        {
          label:
            "Past audit, assurance, or verification reports (internal or third-party)",
          type: "file",
        },
        { label: "Inclusivity and diversity program materials", type: "file" },
        {
          label: "Community and indigenous stakeholder engagement summaries",
          type: "file",
        },
        {
          label: "Board-level ESG oversight meeting notes or policy documents",
          type: "file",
        },
        {
          label: "Supply chain ESG or sustainability documentation",
          type: "file",
        },
        {
          label:
            "Any relevant ESG-related policy, governance, or performance documents",
          type: "file",
        },
        {
          label:
            "👉 Reminder: You do not need to format or structure these technically — the system will analyze and extract all needed assurance and stakeholder details.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Confirm Relevant AA1000 Areas for Reporting",
      description:
        "✅ Based on your inputs, the system will automatically generate:",
      fields: [
        {
          label: "Automatic System-Generated Reports",
          type: "checkbox",
          options: [
            "AA1000AP Reports (Inclusivity, Materiality, Responsiveness, Impact)",
            "AA1000SES Reports (Stakeholder Engagement Effectiveness, Grievance Analysis, Feedback Integration)",
            "AA1000AS Assurance Reports (Scope, Evidence Logs, Balanced Narrative, GHG Verification)",
          ],
        },
        {
          label:
            "✅ Please tick below if you want to explicitly include these system-generated reports:",
          type: "header",
        },
        {
          label: "Additional Detailed Reports",
          type: "checkbox",
          options: [
            "Stakeholder Engagement Report",
            "Materiality Determination Report",
            "GHG Assurance Report",
            "Inclusivity and Responsiveness Report",
            "Engagement Effectiveness Assessment",
            "Stakeholder Grievance and Issue Log Analysis",
            "Cross-Standard Assurance Mapping",
            "Inclusivity Gap Analysis",
            "KPI Assurance Consistency Check",
          ],
        },
      ],
    },
  ],
};
export const PRI_PRINCIPLE_CUSTOM_FORM = {
  title: "Download PRI Principles Compliance Form",
  downloadFileName: "PRI_Principles_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Countries of Investment / Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system tailors outputs to your organizational profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload Supporting Materials by PRI Principle",
      description:
        "✅ Please upload any available internal files, summaries, or records under each relevant area. You do not need to provide polished technical reports; the system will process and extract the required information.",
      fields: [
        { label: "🌍 General PRI Tags & Strategy", type: "subheader" },
        { label: "⬆ Upload (if available):", type: "header" },
        {
          label:
            "General responsible investment policies or position statements",
          type: "file",
        },
        {
          label: "ESG integration or ESG risk management summaries",
          type: "file",
        },
        {
          label: "PRI transparency or public commitment statements",
          type: "file",
        },
        {
          label: "Climate strategy or net-zero commitment summaries",
          type: "file",
        },
        { label: "SDG-aligned investment policies or notes", type: "file" },
        {
          label: "General ESG due diligence or screening approaches",
          type: "file",
        },

        {
          label: "📈 Principle 1 – ESG Integration into Investment Decisions",
          type: "subheader",
        },
        { label: "⬆ Upload:", type: "header" },
        {
          label:
            "ESG screening tools or general criteria used in investment decisions",
          type: "file",
        },
        {
          label: "Investment procedures or guidelines that include ESG factors",
          type: "file",
        },
        {
          label: "Sector-level ESG risk notes or summary assessments",
          type: "file",
        },
        {
          label: "Summarized ESG integration into financial modeling",
          type: "file",
        },
        {
          label: "Lists or notes on exclusion/inclusion screening policies",
          type: "file",
        },

        { label: "🤝 Principle 2 – Active Ownership", type: "subheader" },
        { label: "⬆ Upload:", type: "header" },
        {
          label: "Shareholder engagement summaries or stewardship policies",
          type: "file",
        },
        {
          label: "General records of company dialogues on ESG topics",
          type: "file",
        },
        {
          label:
            "Simple tracking of shareholder votes, resolutions, or outcomes",
          type: "file",
        },
        {
          label: "Statements or summaries on long-term investor responsibility",
          type: "file",
        },

        { label: "🗣 Principle 3 – ESG Disclosure Advocacy", type: "subheader" },
        { label: "⬆ Upload:", type: "header" },
        {
          label:
            "Requests or letters sent to investee companies for ESG reporting",
          type: "file",
        },
        {
          label:
            "Notes or logs monitoring corporate sustainability disclosures",
          type: "file",
        },
        {
          label:
            "Summaries showing use of international ESG frameworks (e.g., TCFD, SASB)",
          type: "file",
        },
        {
          label:
            "Notes on private market or supply chain ESG disclosure practices",
          type: "file",
        },

        {
          label: "🌐 Principle 4 – Promote PRI & ESG Practices",
          type: "subheader",
        },
        { label: "⬆ Upload:", type: "header" },
        {
          label: "Materials from ESG training or educational sessions",
          type: "file",
        },
        {
          label:
            "Evidence of participation in ESG leadership events, conferences, or working groups",
          type: "file",
        },
        {
          label:
            "Public endorsements, awareness campaigns, or advocacy materials",
          type: "file",
        },
        {
          label: "Peer collaboration records or case sharing on PRI practices",
          type: "file",
        },

        {
          label: "✊ Principle 5 – Collaboration for Impact",
          type: "subheader",
        },
        { label: "⬆ Upload:", type: "header" },
        {
          label: "Records of collective investor actions or initiatives",
          type: "file",
        },
        {
          label: "Documentation of collaborative engagements or coalitions",
          type: "file",
        },
        {
          label: "Shared risk/opportunity assessments or group reports",
          type: "file",
        },
        {
          label: "Evidence of participation in stewardship or joint platforms",
          type: "file",
        },

        { label: "📊 Principle 6 – Reporting Progress", type: "subheader" },
        { label: "⬆ Upload:", type: "header" },
        {
          label: "PRI transparency or annual reporting documents (if any)",
          type: "file",
        },
        {
          label: "Internal ESG progress reports or tracking logs",
          type: "file",
        },
        { label: "ESG performance monitoring summaries", type: "file" },
        {
          label: "Third-party ESG assurance or audit records (if available)",
          type: "file",
        },

        {
          label: "🌱 Principle 7 – SDG & Just Transition (Addendum)",
          type: "subheader",
        },
        { label: "⬆ Upload:", type: "header" },
        {
          label: "SDG-aligned investment summaries or mapping documents",
          type: "file",
        },
        {
          label: "Notes on climate justice or just transition strategies",
          type: "file",
        },
        {
          label: "Records on local, indigenous, or community investments",
          type: "file",
        },
        {
          label: "Human rights integration into financial strategies",
          type: "file",
        },

        {
          label:
            "👉 Reminder: Upload what you have general or partial files are fine. The system will analyze and map them automatically to generate compliance outputs.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: System-Generated Compliance Outputs",
      description:
        "✅ Based on your uploaded materials, the system will generate:",
      fields: [
        {
          label: "Select Compliance Reports",
          type: "checkbox",
          options: [
            "Full PRI Compliance Report",
            "PRI Transparency Report",
            "ESG Integration Practices Report",
            "ESG Target Monitoring Report",
            "ESG Disclosure Advocacy Report",
            "Active Ownership & Engagement Report",
            "SDG-Aligned Investment Report",
            "Net-Zero and Climate-Aligned Investment Report",
            "Transition & Social Investment Report",
            "PRI Principle-by-Principle Maturity Assessment",
            "Responsible Investment Readiness Assessment",
            "ESG Materiality Assessment for Investment Strategy",
            "Gap Assessment on PRI Compliances",
            "Collaborative Engagement Readiness Assessment",
            "Portfolio ESG Exposure Analysis",
            "PRI Reporting Progress Tracker",
            "PRI Crosswalk Analysis",
          ],
        },
        {
          label: "✅ Please select your preferred report format:",
          type: "header",
        },
        {
          label: "Report Format Options",
          type: "checkbox",
          options: [
            "Dashboard Summary",
            "Detailed PDF Report",
            "Editable Word Document",
            "Excel Data Tracker",
          ],
        },
      ],
    },
  ],
};
export const PRI_PRINCIPLE_AI_DRIVEN_CUSTOM_FORM = {
  title: "Download PRI Principles AI-Driven Compliance Form",
  downloadFileName: "PRI_Principles_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Countries of Investment / Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your PRI compliance outputs are tailored to your organization's profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload General Supporting Materials",
      description:
        "✅ Please upload available documents — they do not need to be highly technical or pre-organized. The system will sort and analyze them to generate the reports below.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },
        {
          label: "Responsible Investment Policies or ESG Integration Policies",
          type: "file",
        },
        { label: "Portfolio ESG Risk Assessment Summaries", type: "file" },
        {
          label: "Active Ownership or Shareholder Engagement Records",
          type: "file",
        },
        {
          label: "ESG Screening Criteria or Sector Exclusion Lists",
          type: "file",
        },
        { label: "ESG Voting and Resolution Tracking Logs", type: "file" },
        {
          label: "ESG Disclosure and Reporting Requests to Investee Companies",
          type: "file",
        },
        {
          label: "ESG Stewardship Reports or Investor Education Materials",
          type: "file",
        },
        {
          label: "Investor Collaboration or Coalition Participation Records",
          type: "file",
        },
        {
          label: "Annual PRI Transparency Reports (if applicable)",
          type: "file",
        },
        { label: "ESG Impact or SDG Mapping Summaries", type: "file" },
        {
          label: "Climate-Aligned or Net-Zero Investment Strategies",
          type: "file",
        },
        { label: "Internal ESG Monitoring Tools or Dashboards", type: "file" },
        { label: "ESG Assurance or Third-Party Audit Findings", type: "file" },
        {
          label: "Portfolio-Level ESG Metrics and Progress Trackers",
          type: "file",
        },
        {
          label:
            "Any Other ESG-Related Documents, Reports, or Framework Summaries",
          type: "file",
        },
        {
          label:
            "👉 Note: Uploading broad, general files is perfectly acceptable — the system will extract the necessary elements to align with each PRI principle.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Confirm PRI Principles and System-Generated Reports",
      description:
        "✅ Based on your uploaded materials and selected focus areas, the system will generate:",
      fields: [
        {
          label: "General PRI Reports",
          type: "checkbox",
          options: [
            "Full PRI Compliance Report",
            "PRI Transparency Report",
            "ESG Integration Practices Report",
            "ESG Disclosure Advocacy Report",
          ],
        },
        {
          label: "Active Ownership & Collaboration Reports",
          type: "checkbox",
          options: [
            "Active Ownership & Engagement Report",
            "Collaborative Engagement Readiness Assessment",
            "ESG Voting and Resolution Tracking Summary",
          ],
        },
        {
          label: "Performance & Progress Reports",
          type: "checkbox",
          options: [
            "ESG Target Monitoring Report",
            "ESG Materiality Assessment for Investment Strategy",
            "ESG Disclosure Advocacy Report",
            "SDG-Aligned Investment Report",
            "Net-Zero and Climate-Aligned Investment Report",
            "Transition & Social Investment Report",
            "PRI Reporting Progress Tracker",
          ],
        },
        {
          label: "Maturity & Gap Assessments",
          type: "checkbox",
          options: [
            "PRI Principle-by-Principle Maturity Assessment",
            "Responsible Investment Readiness Assessment",
            "Gap Assessment on PRI Compliances",
            "Portfolio ESG Exposure Analysis",
            "PRI Crosswalk Analysis",
          ],
        },
      ],
    },
  ],
};
export const IRIS_COMPLIANCE_CUSTOM_FORM = {
  title: "Download IRIS+ GIIN Compliance Form",
  downloadFileName: "IRIS_Plus_Principles_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system tailors all IRIS+ outputs to your organizational profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload Supporting Materials",
      description:
        "✅ Please upload any general or specific materials — they do not need to be highly technical; the system will extract and align the required data to IRIS+ metrics.",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        { label: "Monitoring & Evaluation (M&E) reports", type: "file" },
        { label: "Baseline & endline assessments", type: "file" },
        { label: "Financial impact disclosures or summaries", type: "file" },
        {
          label: "Stakeholder engagement logs or consultation notes",
          type: "file",
        },
        {
          label: "Environmental performance reports or resource use summaries",
          type: "file",
        },
        {
          label: "Social performance or community development summaries",
          type: "file",
        },
        { label: "Gender equity or inclusion records", type: "file" },
        { label: "Job creation, labor, or workforce data", type: "file" },
        {
          label:
            "Climate risk assessments or environmental footprint estimates",
          type: "file",
        },
        {
          label: "Governance, ownership, or management structure documentation",
          type: "file",
        },
        {
          label: "Supply chain ESG risk summaries or supplier audit reports",
          type: "file",
        },
        {
          label:
            "Land use, biodiversity, or natural resource management summaries",
          type: "file",
        },
        {
          label: "Client, beneficiary, or stakeholder reach records",
          type: "file",
        },
        {
          label:
            "GHG emissions data, water use logs, or energy consumption summaries",
          type: "file",
        },
        {
          label: "Health and education program impact summaries",
          type: "file",
        },
        {
          label: "SME (Small & Medium Enterprise) development impact records",
          type: "file",
        },
        { label: "Indigenous or minority inclusion materials", type: "file" },
        { label: "SDG alignment or mapping records", type: "file" },
        {
          label: "Any third-party audit, evaluation, or assurance documents",
          type: "file",
        },
        {
          label:
            "Any additional internal reports, trackers, or operational documents related to social, environmental, or governance performance",
          type: "file",
        },
        {
          label:
            "👉 Reminder: You can submit summary files, raw data logs, draft reports, or internal notes; the system will process and match all relevant sections automatically.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Confirm Requested Reports and Outputs",
      description:
        "✅ Tick the IRIS+-aligned reports, assessments, and analyses you would like the system to automatically generate:",
      fields: [
        {
          label: "🧾 Reports",
          type: "checkbox",
          options: [
            "Impact Performance Report",
            "Social Return on Investment Report",
            "Environmental Performance Report",
            "Gender Equity Impact Report",
            "Client/Stakeholder Reach Report",
            "Governance & Ownership Metrics Report",
            "Job Creation and Labor Report",
            "Health & Education Impact Report",
            "Climate Risk Exposure Report",
            "Supply Chain ESG Compliance Report",
            "Land Use and Resource Management Report",
            "Crosswalk Report (with SDGs, ESG frameworks)",
            "Transparency and Disclosure Summary",
            "Gap Assessment Report",
            "Full IRIS+ Compliance Report for Decision Making",
          ],
        },
        {
          label: "🧾 Assessments",
          type: "checkbox",
          options: [
            "GHG Emissions Baseline Assessment",
            "Water Use & Treatment Impact Assessment",
            "SME Development Impact Assessment",
            "Workforce Demographics Assessment",
            "Environmental & Social Policy Compliance Review",
            "Indigenous/Minority Inclusion Assessment",
            "Gender Lens Investment Assessment",
            "Governance Risk Assessment",
            "GIIN-Aligned Indicator Summary",
          ],
        },
        {
          label: "🧾 Analyses",
          type: "checkbox",
          options: [
            "Impact Heat Map (Gender, Climate, Jobs)",
            "Sectoral SDG Alignment Analysis",
            "Investment Impact Trajectory Analysis",
            "Baseline vs Actual Outcome Analysis",
            "Impact Forecast and Scenario Modeling",
            "Depth & Duration of Impact Visualization",
            "Geographic Disaggregation Analysis",
            "IRIS Metrics Trendline Comparison",
          ],
        },
      ],
    },
  ],
};
export const IRIS_AI_DRIVEN_CUSTOM_FORM = {
  title: "Download IRIS+ AI-Driven Compliance Form",
  downloadFileName: "IRIS_Plus_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system tailors all IRIS+ outputs to your organizational profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload Supporting Materials",
      description:
        "✅ Please upload any general or specific materials — they do not need to be highly technical; the system will extract and align the required data to IRIS+ metrics.",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        { label: "Monitoring & Evaluation (M&E) reports", type: "file" },
        { label: "Baseline & endline assessments", type: "file" },
        { label: "Financial impact disclosures or summaries", type: "file" },
        {
          label: "Stakeholder engagement logs or consultation notes",
          type: "file",
        },
        {
          label: "Environmental performance reports or resource use summaries",
          type: "file",
        },
        {
          label: "Social performance or community development summaries",
          type: "file",
        },
        { label: "Gender equity or inclusion records", type: "file" },
        { label: "Job creation, labor, or workforce data", type: "file" },
        {
          label:
            "Climate risk assessments or environmental footprint estimates",
          type: "file",
        },
        {
          label: "Governance, ownership, or management structure documentation",
          type: "file",
        },
        {
          label: "Supply chain ESG risk summaries or supplier audit reports",
          type: "file",
        },
        {
          label:
            "Land use, biodiversity, or natural resource management summaries",
          type: "file",
        },
        {
          label: "Client, beneficiary, or stakeholder reach records",
          type: "file",
        },
        {
          label:
            "GHG emissions data, water use logs, or energy consumption summaries",
          type: "file",
        },
        {
          label: "Health and education program impact summaries",
          type: "file",
        },
        {
          label: "SME (Small & Medium Enterprise) development impact records",
          type: "file",
        },
        { label: "Indigenous or minority inclusion materials", type: "file" },
        { label: "SDG alignment or mapping records", type: "file" },
        {
          label: "Any third-party audit, evaluation, or assurance documents",
          type: "file",
        },
        {
          label:
            "Any additional internal reports, trackers, or operational documents related to social, environmental, or governance performance",
          type: "file",
        },
        {
          label:
            "👉 Reminder: You can submit summary files, raw data logs, draft reports, or internal notes; the system will process and match all relevant sections automatically.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: Confirm Requested Reports and Outputs",
      description:
        "✅ Tick the IRIS+-aligned reports, assessments, and analyses you would like the system to automatically generate:",
      fields: [
        {
          label: "🧾 Reports",
          type: "checkbox",
          options: [
            "Impact Performance Report",
            "Social Return on Investment Report",
            "Environmental Performance Report",
            "Gender Equity Impact Report",
            "Client/Stakeholder Reach Report",
            "Governance & Ownership Metrics Report",
            "Job Creation and Labor Report",
            "Health & Education Impact Report",
            "Climate Risk Exposure Report",
            "Supply Chain ESG Compliance Report",
            "Land Use and Resource Management Report",
            "Crosswalk Report (with SDGs, ESG frameworks)",
            "Transparency and Disclosure Summary",
            "Gap Assessment Report",
            "Full IRIS+ Compliance Report for Decision Making",
          ],
        },
        {
          label: "🧾 Assessments",
          type: "checkbox",
          options: [
            "GHG Emissions Baseline Assessment",
            "Water Use & Treatment Impact Assessment",
            "SME Development Impact Assessment",
            "Workforce Demographics Assessment",
            "Environmental & Social Policy Compliance Review",
            "Indigenous/Minority Inclusion Assessment",
            "Gender Lens Investment Assessment",
            "Governance Risk Assessment",
            "GIIN-Aligned Indicator Summary",
          ],
        },
        {
          label: "🧾 Analyses",
          type: "checkbox",
          options: [
            "Impact Heat Map (Gender, Climate, Jobs)",
            "Sectoral SDG Alignment Analysis",
            "Investment Impact Trajectory Analysis",
            "Baseline vs Actual Outcome Analysis",
            "Impact Forecast and Scenario Modeling",
            "Depth & Duration of Impact Visualization",
            "Geographic Disaggregation Analysis",
            "IRIS Metrics Trendline Comparison",
          ],
        },
      ],
    },
  ],
};
export const GHG_EMISSIONS_MANAGEMENT_FORM = {
  title: "Download GHG Emissions Management Form",
  downloadFileName: "GHG_Emissions_Management_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
      ],
    },

    {
      title: "Section 2: Select Emissions Scope to Track",
      description:
        "✅ Please select which emissions you want the system to calculate:",
      fields: [
        {
          label: "Emissions Scope Selection",
          type: "checkbox",
          options: [
            "Scope 1 – Direct emissions (onsite fuel use, company vehicles, process emissions)",
            "Scope 2 – Indirect emissions (purchased electricity, heating, cooling, steam)",
            "Scope 3 – Upstream/Downstream emissions (supply chain, transport, product use, end-of-life)",
            "Scope 4 – Avoided emissions (renewable energy shift, efficiency upgrades, circularity impacts)",
          ],
        },
      ],
    },

    {
      title: "Section 3: Select Emission Factors and Methodology",
      description: "✅ Choose your preferred emissions calculation framework:",
      fields: [
        {
          label: "Emissions Calculation Framework",
          type: "checkbox",
          options: [
            "📘 GHG Protocol (Corporate, Project, Product Life Cycle Standards)",
            "🌍 ISO 14064-compatible calculation",
            "🌿 AFOLU Sector Guidance (for agriculture, forestry, land use sectors)",
            "🇨🇦 Canadian GHGRP, BC Greenhouse Gas Industrial Reporting, Alberta Climate Plan",
          ],
        },
      ],
    },

    {
      title: "Section 4: Upload Input Data / Evidence",
      description:
        "✅ Please upload any available general data — the system will process both detailed and high-level inputs automatically:",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        {
          label: "Fuel consumption logs (diesel, gasoline, natural gas, etc.)",
          type: "file",
        },
        {
          label:
            "Energy purchase records (electricity, heating, steam, cooling)",
          type: "file",
        },
        {
          label:
            "Transport and logistics activity data (freight, shipping, supply chain)",
          type: "file",
        },
        { label: "Raw materials and product lifecycle details", type: "file" },
        {
          label: "Facility-specific data (site codes, production volumes)",
          type: "file",
        },
        {
          label: "Any carbon footprint calculations or reports done previously",
          type: "file",
        },
        {
          label: "Waste management and circularity/recycling summaries",
          type: "file",
        },
        {
          label: "Renewable energy purchase or offset documentation",
          type: "file",
        },
        {
          label:
            "GHG reduction projects or energy efficiency project summaries",
          type: "file",
        },
        {
          label:
            "Emissions factors or industry benchmarks used in prior reporting",
          type: "file",
        },
        { label: "Water or wastewater-related emissions info", type: "file" },
        {
          label: "Internal or external ESG or GHG audit reports",
          type: "file",
        },
        {
          label: "Any official filings or regulatory emissions reports",
          type: "file",
        },
        {
          label: "Historical data you want included for trend tracking",
          type: "file",
        },
        {
          label:
            "👉 Reminder: You do not need to format or calculate data manually. The system will ingest general records, perform automatic alignment with selected methodologies, and deliver full emissions tracking, reporting, and forecasting outputs across the selected scopes.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 5: Confirm Requested Outputs",
      description:
        "✅ The system will automatically generate the following reports and outputs:",
      fields: [
        {
          label: "🧾 GHG Reports & Analysis",
          type: "checkbox",
          options: [
            "Scope-wise emissions summary (tCO₂e)",
            "Emissions pie chart by scope",
            "Year-on-year emissions trend analysis",
            "GHG Inventory Report (by scope, site, and source)",
            "Product Lifecycle Emissions Report (GHG Product Standard alignment)",
            "Audit trail and archive for MRV (Monitoring, Reporting & Verification)",
            "Benchmark vs. sector average (NAICS/SIC-based)",
            "Reduction targets and science-based alignment analysis",
            "AI-powered emissions forecasting (scope-wise, multi-year)",
          ],
        },
        {
          label: "🧾 Regulatory-Ready Exports",
          type: "checkbox",
          options: [
            "Canadian GHGRP Reporting Format",
            "BC Industrial GHG Reporting Format",
            "Alberta Offset Program Reporting Format",
          ],
        },
        {
          label: "📍 Alberta Offset Program – Add-On Outputs",
          type: "checkbox",
          description:
            "☑ Optional advanced outputs for organizations participating in Alberta’s Offset Program:",
          options: [
            "Audit trail and archive for MRV (Monitoring, Reporting & Verification)",
            "Benchmark vs. sector average (NAICS/SIC-based)",
            "Reduction targets and science-based alignment analysis",
            "AI-powered emissions forecasting (scope-wise, multi-year)",
          ],
        },
      ],
    },
  ],
};
export const GHG_EMISSIONS_FORM_AI = {
  title: "Download GHG Emissions Management Form",
  downloadFileName: "GHG_Emissions_Management_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system auto-customizes outputs based on your organizational profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Upload Input Data / Evidence",
      description:
        "✅ Please upload any available materials, raw files, drafts, or summaries are welcome. The system will process and align everything automatically.",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        {
          label:
            "Fuel use records (diesel, gasoline, natural gas, coal, biofuels)",
          type: "file",
        },
        {
          label:
            "Energy purchase records (electricity, heating, cooling, steam)",
          type: "file",
        },
        {
          label: "Transportation, freight, or supply chain data",
          type: "file",
        },
        { label: "Raw materials and product lifecycle details", type: "file" },
        {
          label:
            "Facility/site-specific data (including production or output levels)",
          type: "file",
        },
        {
          label: "Past carbon footprint estimates or emissions reports",
          type: "file",
        },
        { label: "Waste, recycling, or circularity summaries", type: "file" },
        {
          label: "Renewable energy contracts or offset documents",
          type: "file",
        },
        {
          label: "GHG reduction or energy efficiency project summaries",
          type: "file",
        },
        {
          label:
            "Emission factors, benchmarks, or conversion tables used before",
          type: "file",
        },
        { label: "Business travel, fleet, or commuting data", type: "file" },
        {
          label: "Water or wastewater-related emissions details",
          type: "file",
        },
        { label: "Internal or external ESG or audit reports", type: "file" },
        { label: "Prior regulatory filings or reports", type: "file" },
        {
          label: "Any historical data you want tracked over time",
          type: "file",
        },
        {
          label:
            "👉 Note: No need to pre-calculate or structure files. The system will extract and organize the information.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 3: AI-Driven Scope and Methodology Selection",
      description: "✅ The system will automatically determine:",
      fields: [
        {
          label: "Automatic System Determinations",
          type: "info",
          content: [
            "• Relevant scopes (Scope 1, Scope 2, Scope 3, Scope 4)",
            "• Correct emission factors (GHG Protocol, ISO 14064, AFOLU, Canadian GHGRP, etc.)",
            "• Industry-specific or geography-specific compliance triggers",
            "• Avoided emissions opportunities (if applicable)",
          ],
        },
        {
          label: "**No manual selections are required**",
          type: "note",
        },
      ],
    },

    {
      title: "Section 4: Auto-Generated Reports and Outputs",
      description: "✅ Once the data is processed, the system will generate:",
      fields: [
        {
          label: "🧾 Emissions Reporting",
          type: "checkbox",
          options: [
            "Scope-wise emissions summary (tCO₂e)",
            "Pie chart breakdown by scope",
            "Year-on-year emissions trend analysis",
            "GHG inventory (by scope, site, and source)",
            "Product lifecycle emissions report (aligned with GHG Product Standard)",
          ],
        },
        {
          label: "🧾 Regulatory-Ready Exports",
          type: "checkbox",
          options: [
            "Canadian GHGRP format",
            "BC Industrial GHG Reporting format",
            "Alberta Offset Program format",
            "Full audit trail for MRV (Monitoring, Reporting & Verification)",
          ],
        },
        {
          label: "🧾 Benchmarking & Forecasting",
          type: "checkbox",
          options: [
            "Sector average comparison (by NAICS/SIC code)",
            "Science-based target alignment check",
            "AI-powered emissions forecasts (multi-year, scope-wise)",
            "KPI gap vs. commitments",
            "Reduction opportunity analysis",
          ],
        },
        {
          label:
            "👉 Final Reminder: You only need to upload general records; the AI system will handle scope classification, methodology matching, calculation, reporting, and forecasting across all selected emissions categories.",
          type: "note",
        },
        {
          title: "Section 6: Benchmarking & Regulatory Outputs",
          fields: [
            {
              label: "🧾 Regulatory-Ready Exports & Analysis",
              type: "checkbox",
              options: [
                "Canadian GHGRP Reporting Format",
                "BC Industrial GHG Reporting Format",
                "Alberta Offset Program Reporting Format",
                "Full audit trail for MRV (Monitoring, Reporting & Verification)",
                "Benchmark vs. sector average (NAICS/SIC-based)",
                "Reduction targets and science-based alignment analysis",
                "AI-powered emissions forecasting (scope-wise, multi-year)",
              ],
            },
          ],
        },
      ],
    },
  ],
};
export const CLIMATE_IMPACT_ASSESSMENT_FORM = {
  title: "Download Climate Impact Assessment Form",
  downloadFileName: "Climate_Impact_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Project & Climate Assessment Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Type",
          type: "select",
          placeholder: "Select Project Type",
          options: [
            "Energy",
            "Transport",
            "Infrastructure",
            "Buildings",
            "Manufacturing",
            "Water",
            "Agriculture",
            "Waste",
          ],
        },
        {
          label: "Location (Country / Province / District)",
          type: "text",
          placeholder: "Enter location with geo-coordinates if available",
        },
        {
          label: "Project Stage",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Closure",
          ],
        },
        {
          label: "Asset Type",
          type: "checkbox",
          options: [
            "Fixed-site facility",
            "Mobile fleet",
            "Distributed assets",
            "Linear infrastructure (e.g., pipeline, road)",
          ],
        },
        {
          label: "Is the Site Located In or Near:",
          type: "checkbox",
          options: [
            "Floodplain",
            "Coastal zone",
            "Drought-prone area",
            "Forested area",
            "Heat island zone",
          ],
        },
        {
          label: "Historical Exposure to Extreme Events:",
          type: "checkbox",
          options: [
            "Flood",
            "Cyclone",
            "Drought",
            "Heatwave",
            "Wildfire",
            "None / Unknown",
          ],
        },
        {
          label: "Projected Climate Stressors (RCP-based):",
          type: "checkbox",
          options: [
            "Rising temperatures",
            "Water scarcity",
            "Sea level rise",
            "Extreme rainfall",
            "Storm surge",
          ],
        },
        {
          label: "Climate Zone Classification",
          type: "select",
          placeholder: "Select Climate Zone",
          options: [
            "Tropical",
            "Arid",
            "Temperate",
            "Coastal",
            "Mountain",
            "Continental",
            "Polar",
            "Mediterranean",
            "Subtropical",
          ],
        },
        {
          label: "Natural Resource Dependence (if any)",
          type: "checkbox",
          options: [
            "Water-intensive",
            "Energy-intensive",
            "Land-intensive",
            "None",
          ],
        },
        {
          label: "Community Exposure Dependency",
          type: "radio",
          options: ["Yes (local community is climate-exposed)", "No"],
        },
        {
          label: "Sensitive Ecosystem or Protected Area Nearby",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Adaptation/Resilience Measures in Place",
          type: "checkbox",
          options: ["Yes (documented)", "No", "Planned"],
        },
        {
          label: "GHG Emission Intensity (Estimated)",
          type: "radio",
          options: ["High", "Medium", "Low"],
        },
        {
          label: "Time Horizon for Climate Impact Modeling",
          type: "select",
          placeholder: "Select Time Horizon",
          options: ["Current", "2030", "2050", "2080"],
        },
      ],
    },
  ],
};
export const CLIMATE_IMPACT_SMART_DATA_FORM = {
  title: "",
  downloadFileName: "Climate_Impact_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,
  sections: [
    {
      // title: "Step 5: Upload Data",
      fields: [
        {
          label: "Checklist / Upload Relevant Evidence",
          type: "checkbox",
          options: [
            "Fuel and Electricity Consumption Logs (Scope 1 & 2)",
            "Supplier and Transport Emissions Data (Scope 3 – if tracked)",
            "GHG Emissions Monitoring Logs or Emissions Calculator Outputs",
            "Energy Efficiency Audit Results (internal or 3rd party)",
            "Documentation of Adaptation or Resilience Measures Implemented",
            "Climate Action Plan or Emission Reduction Roadmap",
            "Net Zero Target Documentation (SBTi approval, company pledge, etc.)",
            "Emergency Response or Business Continuity Plans",
            "Organizational or Community Resilience Surveys (if conducted)",
            "Scenario Modeling Data (if already modeled in-house or externally)",
            "Financial Sensitivity Tables (CapEx/OpEx under 2°C/4.5 RCPs)",
            "Internal Memos or Expert Commentary on Climate Risks",
            "Community Engagement Notes on Perceived Climate Vulnerability",
            "Draft or Published Climate Disclosures (TCFD, CDP, NDC-related)",
            "Other (Specify)",
          ],
        },
        {
          label: "Additional Supporting Evidence",
          type: "file",
          description:
            "Attach any forms, surveys, self-generated data, or relevant evidence documents.",
          acceptedFileTypes: ["pdf", "docx", "xlsx", "jpg", "png"],
        },
      ],
    },
  ],
};
export const CARBON_CREDIT_OFFSET_MANAGEMENT_FORM = {
  title: "Download Carbon Credit / Offset Strategy Form",
  downloadFileName: "Carbon_Credit_Offset_Strategy_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your carbon credit activities and reports are fully tailored to your organizational profile.",
          type: "note",
        },
      ],
    },
    {
      title: "Section 2: Select Carbon Credit / Offset Strategy",
      description: "✅ Please tick what applies:",
      fields: [
        {
          label: "Carbon Credit / Offset Strategies",
          type: "checkbox",
          options: [
            "🎯 Carbon Offsetting Strategy (achieving net-zero or carbon-neutral targets)",
            "💳 Carbon Credit Transactions (buy, sell, trade)",
            "📜 Certification & Compliance Tracking (MRV, retirement, validation)",
            "📈 Market Instruments & Emission Trading (ETS, offsets, voluntary markets)",
          ],
        },
      ],
    },
    {
      title: "Section 3: Select Credit Type or Standard",
      description:
        "✅ The system will automatically align with the standards you select:",
      fields: [
        { label: "📘 Voluntary & Verified Standards", type: "subheader" },
        {
          label: "Voluntary Standards",
          type: "checkbox",
          options: [
            "Verra (VCS, REDD+, CCB, ART)",
            "Gold Standard",
            "Plan Vivo",
            "American Carbon Registry",
            "Climate Action Reserve",
            "SOCIALCARBON",
            "Fairtrade Climate Standard",
            "Nori",
            "Global Carbon Council",
            "ICR (Internal Carbon Reduction)",
            "Carbon Neutral Certification",
            "Carbon Trust Standard",
          ],
        },
        {
          label: "✅ Emission Trading & Market Instruments",
          type: "subheader",
        },
        {
          label: "Market Instruments",
          type: "checkbox",
          options: [
            "Certified Emission Reduction (CER – CDM)",
            "Emission Reduction Unit (ERU – JI)",
            "Renewable Energy Credits (RECs)",
            "Assigned Amount Units (AAUs)",
            "Voluntary Carbon Market (VCM)",
            "EU ETS, California Cap-and-Trade, NZ ETS, South Korea ETS, Japan JCM",
            "Canada OBPS, Alberta TIER, BC Carbon Tax, Quebec Cap-and-Trade, Ontario EPS",
          ],
        },
        { label: "✅ Sector-Specific Standards", type: "subheader" },
        {
          label: "Sector Standards",
          type: "checkbox",
          options: [
            "CORSIA (Aviation)",
            "Responsible Care (Chemicals)",
            "IPIECA (Oil & Gas)",
            "FSC, MSC, SFI",
            "Quebec/Canada Forest Monitoring",
            "Ontario Green Energy Act",
          ],
        },
        { label: "✅ Country-Specific Systems", type: "subheader" },
        {
          label: "Country Systems",
          type: "checkbox",
          options: [
            "Canadian GHG Offset Credit System",
            "British Columbia Forest Carbon Offsets",
            "Alberta TIER",
            "Quebec Cap-and-Trade",
            "OBPS Canada",
            "China VER",
            "Japan JCM",
            "NZ ETS",
            "South Korea ETS",
          ],
        },
      ],
    },
    {
      title: "Section 4: Upload Supporting Materials",
      description:
        "✅ Please upload any available materials — raw, draft, or summarized formats are accepted; the system will process them automatically.",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        {
          label: "Emissions or offset project details (type, geography, scale)",
          type: "file",
        },
        {
          label: "Supporting documents (methodology, baselines, MRV plans)",
          type: "file",
        },
        {
          label:
            "Total emissions by scope (linked from emissions tracking module)",
          type: "file",
        },
        {
          label:
            "Planned offset strategies (e.g., reforestation, biochar, renewable energy)",
          type: "file",
        },
        {
          label: "Certification records (Verra, Gold Standard, etc.)",
          type: "file",
        },
        {
          label: "Credit issuance IDs, registry links, retirement logs",
          type: "file",
        },
        {
          label: "Financial records or credit transaction histories",
          type: "file",
        },
        {
          label: "Green finance alignment records (ICMA, CBI, SLLP)",
          type: "file",
        },
        {
          label: "Energy, water, waste reduction project summaries",
          type: "file",
        },
        {
          label: "Climate risk assessments or net-zero strategy documentation",
          type: "file",
        },
        { label: "Community or biodiversity benefit statements", type: "file" },
        {
          label: "Any sector- or country-specific compliance materials",
          type: "file",
        },
        {
          label:
            "Historical offsets, trading, or market participation summaries",
          type: "file",
        },
      ],
    },
    {
      title: "Section 5: Confirm Requested Reports & Outputs",
      description:
        "✅ The system will automatically generate the following reports and dashboards:",
      fields: [
        { label: "🧾 Core Reports", type: "subheader" },
        {
          label: "Select Core Reports",
          type: "checkbox",
          options: [
            "Verified Carbon Credit Ledger",
            "Credit Usage & Trading Ledger",
            "Offset Performance & Retirement Report",
            "Green Bond Alignment Report",
            "Sector-Specific Offset Alignment (e.g., REDD+, CORSIA)",
            "Net-Zero Pathway Forecast",
            "MRV (Monitoring, Reporting, Verification) Compliance Status",
          ],
        },
        { label: "🧾 Dashboard Insights", type: "subheader" },
        {
          label: "Select Dashboard Insights",
          type: "checkbox",
          options: [
            "Real-time offset-to-emission ratio",
            "Forecasted credit demand",
            "Expiry/reminder alerts for verification or issuance",
            "Offset gap analysis for net-zero alignment",
            "Market eligibility and trading opportunity insights",
            "Emissions cap vs. actual and credit requirements",
            "AI-powered buy/sell recommendations",
          ],
        },
        {
          label:
            "👉 Reminder: No need to pre-organize or technically prepare files. The system uses advanced AI to extract, calculate, match, and report across your selected carbon credit strategies, standards, and markets — delivering end-to-end compliance, tracking, forecasting, and management.",
          type: "note",
        },
      ],
    },
  ],
};

export const CARBON_CREDIT_OFFSET_MANAGEMENT_FORM_AI = {
  title: "Download Carbon Credit / Offset Strategy Form",
  downloadFileName: "Carbon_Credit_Offset_Strategy_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
      ],
    },
    {
      title: "Section 2: Upload Supporting Materials",
      description:
        "✅ Please upload **any available materials** (raw, draft, or summarized — no technical formatting needed):",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        {
          label: "Emissions reports (Scope 1, 2, 3, 4) or GHG inventory",
          type: "file",
        },
        {
          label:
            "Offset project descriptions (reforestation, renewable energy, carbon capture)",
          type: "file",
        },
        { label: "Methodology and baseline documents", type: "file" },
        {
          label: "MRV (Monitoring, Reporting, Verification) plans",
          type: "file",
        },
        {
          label:
            "Carbon credit registry IDs, transaction records, retirement logs",
          type: "file",
        },
        {
          label:
            "External certifications (Verra, Gold Standard, Plan Vivo, etc.)",
          type: "file",
        },
        {
          label:
            "Green finance alignment evidence (Green Bonds, SLLPs, CBI frameworks)",
          type: "file",
        },
        {
          label: "Climate risk and net-zero alignment strategies",
          type: "file",
        },
        {
          label: "Energy, water, waste reduction project summaries",
          type: "file",
        },
        { label: "Financial or market participation records", type: "file" },
        { label: "Community or biodiversity benefit statements", type: "file" },
        {
          label: "Sector-specific or country-specific compliance records",
          type: "file",
        },
        { label: "Historical offsets or trading histories", type: "file" },
        {
          label: "Any other carbon management, credit, or offset materials",
          type: "file",
        },
      ],
    },
    {
      title: "Section 3: System-Automated Processing",
      description:
        "✅ Once uploads are processed, the system will **automatically identify, match, and generate**:",
      fields: [
        { label: "🧾 Core Reports:", type: "subheader" },
        {
          label: "Core Reports",
          type: "checkbox",
          options: [
            "Verified Carbon Credit Ledger (with issuance, usage, retirement)",
            "Carbon Credit Usage & Trading Ledger",
            "Offset Performance & Retirement Report",
            "Green Bond or Green Finance Alignment Report",
            "Sector-Specific Offset Alignment (REDD+, CORSIA, AFOLU, etc.)",
            "Net-Zero Pathway Forecast Report",
            "MRV Compliance and Status Report",
          ],
        },
        { label: "🧾 Real-Time Dashboards:", type: "subheader" },
        {
          label: "Real-Time Dashboards",
          type: "checkbox",
          options: [
            "Offset-to-emission ratio (Scope-linked)",
            "Forecasted credit demand (market-adjusted)",
            "Expiry / renewal alerts (certifications, issuances)",
            "Offset gap analysis (for net-zero or climate target alignment)",
            "Market eligibility & trading opportunity insights",
            "Emissions cap vs. actual emissions",
            "AI-powered buy/sell recommendations (market-aligned)",
          ],
        },
        {
          label:
            "👉 **Note:** You **do not need to pre-classify, structure, or manually enter standards or credit types**. The system **auto-detects alignment** across voluntary, compliance, country, and sectoral frameworks (Verra, Gold Standard, CDM, EU ETS, Alberta TIER, Canada OBPS, CORSIA, etc.).",
          type: "note",
        },
      ],
    },
  ],
};

export const ESG_BOND_COMPLIANCE_SUBMISSION_FORM = {
  title: "Download ESG Bond Compliance Form",
  downloadFileName: "ESG_Bond_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Section 1: Organization & Financing Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Headquarters / Countries of Operation", type: "text" },
        {
          label:
            "Reporting Period / Issuance Window (e.g., Jan 2024 – Dec 2024)",
          type: "text",
        },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures the system tailors ESG bond outputs to your financing profile.",
          type: "note",
        },
      ],
    },

    {
      title: "Section 2: Select Financing Instrument Type",
      description:
        "✅ Please select the type(s) of instruments applicable to your organization:",
      fields: [
        {
          label: "Financing Instrument Types",
          type: "checkbox",
          options: [
            "Green Bonds",
            "Social Bonds",
            "Sustainability Bonds",
            "Sustainability-Linked Bonds",
            "Green Loans",
            "Social Loans",
            "Sustainability-Linked Loans",
          ],
        },
        {
          label: "⬆ Existing bond/loan term sheet or framework (if available)",
          type: "file",
        },
      ],
    },

    {
      title: "Section 3: Select Applicable Standards & Guidelines",
      description: "✅ Please select the framework(s) you are aligning with:",
      fields: [
        {
          label: "Framework Selection",
          type: "checkbox",
          options: [
            "Green Bond Principles (GBP)",
            "• Standard Green Use of Proceeds Bond",
            "• Green Revenue Bond",
            "• Green Project Bond",
            "• Secured Green Bond",
            "Social Bond Principles (SBP)",
            "• Standard Social Use of Proceeds Bond",
            "• Social Revenue Bond",
            "• Social Project Bond",
            "• Secured Social Bond",
            "Sustainability Bond Guidelines (SBG)",
            "Sustainability-Linked Bond Principles (SLBP)",
            "Green Loan Principles (GLP)",
            "Social Loan Principles (SLP)",
            "Sustainability-Linked Loan Principles (SLLP)",
            "Climate Bonds Initiative (CBI) Taxonomy",
            "EU Green Bond Standard (for cross-border alignment)",
            "Canadian Green Bond Framework",
            "Canada Infrastructure Bank (CIB) Green Bond Requirements",
          ],
        },
      ],
    },

    {
      title: "Section 4: Define Use of Proceeds / Linkage Criteria",
      description: "✅ Indicate your primary objectives:",
      fields: [
        {
          label: "Primary ESG Objectives",
          type: "checkbox",
          options: [
            "Climate mitigation (renewable energy, energy efficiency)",
            "Climate adaptation (flood resilience, water management)",
            "Social inclusion (education, health, housing)",
            "Green infrastructure",
            "Sustainability performance targets (for SLBs/SLLPs)",
          ],
        },
      ],
    },

    {
      title:
        "Section 5: Upload Supporting Materials for Eligibility & Disclosure",
      description:
        "✅ Please upload general supporting materials (raw, draft, or structured — no need for technical formatting):",
      fields: [
        { label: "⬆ Upload (if available):", type: "header" },
        {
          label: "Any internal frameworks or alignment summaries",
          type: "file",
        },
        {
          label: "Descriptions of how funds will be used (use of proceeds)",
          type: "file",
        },
        {
          label: "Any external opinions, reviews, or verification letters",
          type: "file",
        },
        {
          label: "ESG or sustainability reports or company disclosures",
          type: "file",
        },
        {
          label: "Impact forecasts or baseline numbers (climate, social, etc.)",
          type: "file",
        },
        {
          label: "General energy, water, or waste data or audits",
          type: "file",
        },
        {
          label: "Statements on SDG (Sustainable Development Goals) alignment",
          type: "file",
        },
        {
          label: "Notes or summaries on expected community or social benefits",
          type: "file",
        },
        {
          label: "Greenhouse gas estimates or environmental impact summaries",
          type: "file",
        },
        { label: "General risk or materiality assessments", type: "file" },
        {
          label: "Climate risk overviews or sustainability strategies",
          type: "file",
        },
        {
          label: "Land use, biodiversity, or nature-related summaries",
          type: "file",
        },
        {
          label: "Any internal sustainability or green finance policies",
          type: "file",
        },
        {
          label: "Governance or oversight summaries related to ESG topics",
          type: "file",
        },
        {
          label: "Notes from stakeholder meetings or consultations",
          type: "file",
        },
        {
          label: "Past annual reports or ESG/CSR performance summaries",
          type: "file",
        },
        {
          label: "Post-issuance monitoring or tracking updates (if any)",
          type: "file",
        },
        {
          label: "Any relevant certifications or assurance letters",
          type: "file",
        },
        {
          label:
            "Any other useful materials you think help explain your ESG bond, loan, or sustainability commitments",
          type: "file",
        },
      ],
    },

    {
      title: "Section 6: Confirm Requested Reports and Outputs",
      description:
        "✅ Tick which system-generated reports and analyses you want:",
      fields: [
        {
          label: "🧾 Standard Reports",
          type: "checkbox",
          options: [
            "Environmental/Social Impact Report",
            "Eligible Project Category Breakdown",
            "Use-of-Proceeds Verification",
            "Renewable Energy Capacity Added (MW)",
            "Beneficiaries of Social Impact Projects",
            "SDG Alignment Tags",
            "Additionally & Materiality Assessment",
            "KPI Gap vs Commitments",
            "Unverified Impact Claims Flagging",
            "Investor Summary",
          ],
        },
        {
          label: "🧾 Specialized Impact Reports",
          type: "checkbox",
          options: [
            "Green/Social/Sustainability Bond Impact Report",
            "SDG-Linked Bond Impact Map",
            "GHG Reduction Report (Green Finance)",
            "Canada Green Bond Alignment Matrix",
            "Bond Framework Gap Analysis",
            "ESG-Bond Compliance Alignment Sheet",
            "KPI Tracker for Sustainability-Linked Instruments",
            "Full ICMA-Compliant Report",
          ],
        },
      ],
    },

    {
      title: "Section 7: Preferred Output Format",
      description: "✅ Select your preferred delivery format:",
      fields: [
        {
          label: "Output Format",
          type: "checkbox",
          options: [
            "Dashboard Summary",
            "PDF Report",
            "Word Document",
            "Excel Data Tracker",
          ],
        },
        {
          label:
            "👉 Reminder: You do not need to prepare detailed technical submissions. The system is designed to process, extract, and match information automatically, even from general or summary documents, ensuring compliance across the selected ESG bond frameworks and standards.",
          type: "note",
        },
      ],
    },
  ],
};
export const AI_DRIVEN_ESG_BOND_COMPLIANCE_FORM = {
  title: "Download ESG Bond Compliance Form",
  downloadFileName: "ESG_Bond_Compliance_Form",
  downloadFileExtension: "png",
  formImageUrl: "EsgImg",

  sections: [
    {
      title: "Section 1: Organization & Financing Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
        },
        {
          label: "Industry / Sector",
          type: "text",
        },
        {
          label: "Headquarters / Countries of Operation",
          type: "text",
        },
        {
          label:
            "Reporting Period / Issuance Window (e.g., Jan 2024 – Dec 2024)",
          type: "text",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
        },
        {
          label: "Email & Phone (for follow-up)",
          type: "text",
        },
      ],
    },

    {
      title: "Section 2: Upload Supporting Materials",
      description:
        "✅ Please upload any available materials — no technical formatting is needed. The system will review and align everything automatically.",
      fields: [
        {
          label: "⬆ Upload (if available):",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv",
          multiple: true,
        },
        {
          type: "checkbox",
          options: ["Internal financing frameworks or summaries"],
        },
        {
          type: "checkbox",
          options: ["Descriptions of fund use (use of proceeds)"],
        },
        {
          type: "checkbox",
          options: ["External review letters or second-party opinions (SPO)"],
        },
        {
          type: "checkbox",
          options: ["ESG/sustainability reports or public disclosures"],
        },
        {
          type: "checkbox",
          options: ["Climate or social impact forecasts"],
        },
        {
          type: "checkbox",
          options: ["Energy, water, waste data or audits"],
        },
        {
          type: "checkbox",
          options: ["SDG alignment notes or mappings"],
        },
        {
          type: "checkbox",
          options: ["Community or social benefit summaries"],
        },
        {
          type: "checkbox",
          options: ["GHG estimates or climate impact records"],
        },
        {
          type: "checkbox",
          options: ["Risk or materiality assessments"],
        },
        {
          type: "checkbox",
          options: ["Sustainability policies or climate strategies"],
        },
        {
          type: "checkbox",
          options: ["Governance or oversight summaries"],
        },
        {
          type: "checkbox",
          options: ["Stakeholder meeting notes or consultations"],
        },
        {
          type: "checkbox",
          options: ["Past ESG/CSR performance summaries"],
        },
        {
          type: "checkbox",
          options: ["Post-issuance monitoring or tracking updates"],
        },
        {
          type: "checkbox",
          options: ["Certifications or assurance records"],
        },
        {
          type: "checkbox",
          options: [
            "Any other supporting materials explaining ESG bond, loan, or sustainability goals",
          ],
        },
      ],
    },

    {
      title: "Section 3: System-Generated Reports & Outputs",
      description:
        "✅ The system will automatically produce a set of reports and analyses based on the uploaded materials:",
      fields: [
        {
          label: "🧾 Standard Reports",
          type: "header",
        },
        {
          type: "checkbox",
          options: ["Environmental / Social Impact Report"],
        },
        {
          type: "checkbox",
          options: ["Eligible Project Category Breakdown"],
        },
        {
          type: "checkbox",
          options: ["Use-of-Proceeds Verification"],
        },
        {
          type: "checkbox",
          options: ["Renewable Energy Capacity Added"],
        },
        {
          type: "checkbox",
          options: ["Beneficiaries of Social Impact Projects"],
        },
        {
          type: "checkbox",
          options: ["SDG Alignment Tags"],
        },
        {
          type: "checkbox",
          options: ["Materiality & Additionality Assessment"],
        },
        {
          type: "checkbox",
          options: ["KPI Gap vs Commitments Analysis"],
        },
        {
          type: "checkbox",
          options: ["Unverified Impact Claims Check"],
        },
        {
          type: "checkbox",
          options: ["Investor Summary"],
        },
        {
          label: "🧾 Specialized Impact Reports",
          type: "header",
        },
        {
          type: "checkbox",
          options: ["ESG Bond Impact Report (Green / Social / Sustainability)"],
        },
        {
          type: "checkbox",
          options: ["SDG-Linked Bond Impact Map"],
        },
        {
          type: "checkbox",
          options: ["GHG Reduction and Climate Impact Report"],
        },
        {
          type: "checkbox",
          options: ["Canada Green Bond Alignment Matrix"],
        },
        {
          type: "checkbox",
          options: ["Bond Framework Gap Analysis"],
        },
        {
          type: "checkbox",
          options: ["ESG Compliance Alignment Sheet"],
        },
        {
          type: "checkbox",
          options: ["KPI Tracker for Sustainability-Linked Instruments"],
        },
        {
          type: "checkbox",
          options: ["ICMA-Compliant Full Report"],
        },
      ],
    },

    {
      title: "Note",
      fields: [
        {
          label:
            "👉 Note: Simply submit what materials you have — even general summaries or internal drafts. The system's automated engine will process, map, and deliver outputs tailored to the relevant ESG bond frameworks and compliance standards.",
          type: "note",
        },
      ],
    },
  ],
};
export const ENVIROMENTAL_COMPLIANCE_REPORTING_FORM = {
  title: "Download Biodiversity & Ecosystem Impact Assessment Form",
  downloadFileName: "Biodiversity_Ecosystem_Impact_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Project & Environmental Assessment Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Mining",
            "Roads",
            "Agriculture",
            "Manufacturing",
            "Water",
            "ICT",
            "Waste",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
        },
        {
          label: "Type of Ecosystem",
          type: "checkbox",
          options: [
            "Wetland",
            "Forest",
            "Coastal",
            "Desert",
            "Grassland",
            "Urban/Industrial",
          ],
        },
        {
          label: "Nearby Protected Areas or Critical Habitats",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Is Critical Habitat Screening Required?",
          type: "radio",
          options: ["Yes", "No", "Already Completed"],
        },
      ],
    },
    {
      title: "🔶 Species Survey Details",
      fields: [
        {
          label: "Species Inventory Conducted (Flora/Fauna)",
          type: "checkbox_with_upload",
          options: ["Species Inventory Conducted (Flora/Fauna)"],
          uploadLabel: "Upload Species Survey Checklist",
        },
        {
          label: "IUCN Red List Status Checked",
          type: "checkbox_with_upload",
          options: ["IUCN Red List Status Checked"],
          uploadLabel: "Upload IUCN Classification Form",
        },
        {
          label: "Endemic or Migratory Species Present",
          type: "checkbox_with_upload",
          options: ["Endemic or Migratory Species Present"],
          uploadLabel: "Upload List or Summary",
        },
        {
          label: "Presence of Protected or Threatened Species",
          type: "checkbox_with_upload",
          options: ["Presence of Protected or Threatened Species"],
          uploadLabel: "Upload Supporting Evidence (Photos, Reports)",
        },
        {
          label: "Presence of Invasive Alien Species",
          type: "checkbox_with_upload",
          options: ["Presence of Invasive Alien Species"],
          uploadLabel: "Upload Invasive Species Checklist",
        },
      ],
    },
    {
      title: "🔶 Habitat and Ecosystem Characterization",
      fields: [
        {
          label: "Ecosystem Type Mapped (Land Cover, Water Bodies)",
          type: "checkbox_with_upload",
          options: ["Ecosystem Type Mapped (Land Cover, Water Bodies)"],
          uploadLabel: "Upload Ecosystem Services Mapping Sheet",
        },
        {
          label: "Critical Habitat Screening Completed",
          type: "checkbox_with_upload",
          options: ["Critical Habitat Screening Completed"],
          uploadLabel: "Upload Critical Habitat Screening Template",
        },
        {
          label: "Habitat Disturbance Assessment Done",
          type: "checkbox_with_upload",
          options: ["Habitat Disturbance Assessment Done"],
          uploadLabel: "Upload Habitat Disturbance Record",
        },
        {
          label: "Connectivity and Fragmentation Analysis",
          type: "checkbox_with_upload",
          options: ["Connectivity and Fragmentation Analysis"],
          uploadLabel: "Upload Connectivity Map or GIS Layer",
        },
        {
          label:
            "Ecosystem Services Identified (e.g., pollination, water retention, erosion control)",
          type: "checkbox_with_upload",
          options: [
            "Ecosystem Services Identified (e.g., pollination, water retention, erosion control)",
          ],
          uploadLabel: "Upload Ecosystem Services Summary",
        },
      ],
    },
    {
      title: "🔶 Impact and Sensitivity Analysis",
      fields: [
        {
          label: "Biodiversity Sensitivity Mapping Completed",
          type: "checkbox_with_upload",
          options: ["Biodiversity Sensitivity Mapping Completed"],
          uploadLabel: "Upload Sensitivity Map or Matrix",
        },
        {
          label: "Seasonal or Migratory Patterns Assessed",
          type: "checkbox_with_upload",
          options: ["Seasonal or Migratory Patterns Assessed"],
          uploadLabel: "Upload Temporal Data or Analysis",
        },
        {
          label: "Direct Impacts Identified (footprint, habitat loss)",
          type: "checkbox_with_upload",
          options: ["Direct Impacts Identified (footprint, habitat loss)"],
          uploadLabel: "Upload Impact Matrix",
        },
        {
          label: "Indirect or Cumulative Impacts Analyzed",
          type: "checkbox_with_upload",
          options: ["Indirect or Cumulative Impacts Analyzed"],
          uploadLabel: "Upload Cumulative Impact Mapping Table",
        },
        {
          label: "Proposed Mitigation or Offset Measures Documented",
          type: "checkbox_with_upload",
          options: ["Proposed Mitigation or Offset Measures Documented"],
          uploadLabel: "Upload Mitigation Plan or Proposal",
        },
      ],
    },
    {
      title: "🔶 Evidence and Supporting Documents",
      fields: [
        {
          label: "Baseline Biodiversity Survey Reports",
          type: "file_upload",
          uploadLabel: "Upload Baseline Biodiversity Survey Reports",
        },
        {
          label: "Field Photos or Drone Images",
          type: "file_upload",
          uploadLabel: "Upload Field Photos or Drone Images",
        },
        {
          label: "GIS Layers or KMZ Files for Critical Areas",
          type: "file_upload",
          uploadLabel: "Upload GIS Layers or KMZ Files",
        },
        {
          label: "Habitat and Ecosystem Maps",
          type: "file_upload",
          uploadLabel: "Upload Habitat and Ecosystem Maps",
        },
        {
          label: "Species Identification Sheets or Taxonomic Lists",
          type: "file_upload",
          uploadLabel: "Upload Species Identification Sheets",
        },
        {
          label: "Third-Party Environmental Assessments (if available)",
          type: "file_upload",
          uploadLabel: "Upload Third-Party Environmental Assessments",
        },
        {
          label: "Community or NGO Consultation Records (if relevant)",
          type: "file_upload",
          uploadLabel: "Upload Community or NGO Consultation Records",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports",
      fields: [
        {
          label: "Biodiversity Risk and Sensitivity Assessment",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Critical Habitat and Protected Area Screening Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Ecosystem Services Impact Assessment",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Species Inventory and Threat Status Summary",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Biodiversity Mitigation and Offset Plan",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Habitat Disturbance and Fragmentation Analysis Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Invasive Species Risk and Management Plan",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Migratory Species and Seasonal Movement Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Biodiversity Monitoring and Long-Term Trends Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Ecosystem Connectivity and Corridors Assessment",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Biodiversity Action Plan (BAP) Status Tracker",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Post-Project Biodiversity Impact Evaluation",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Community-Based Biodiversity Conservation Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Landscape-Level Cumulative Biodiversity Impact Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Climate Change Impact on Biodiversity and Ecosystems",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
        {
          label: "Restoration and Rehabilitation Progress Report",
          type: "checkbox_with_generate",
          options: ["Generate"],
          generateLabel: "Generate Report",
        },
      ],
    },
  ],
};
export const BIODIVERSITY_ASSESSTMENT_REPORTING_FORM = {
  title: "Download Biodiversity & Ecosystem Impact Assessment Form",
  downloadFileName: "Biodiversity_Ecosystem_Impact_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Project & Environmental Assessment Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Mining",
            "Roads",
            "Agriculture",
            "Manufacturing",
            "Water",
            "ICT",
            "Waste",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
        },
        {
          label: "Type of Ecosystem",
          type: "checkbox",
          options: [
            "Wetland",
            "Forest",
            "Coastal",
            "Desert",
            "Grassland",
            "Urban/Industrial",
          ],
        },
        {
          label: "Nearby Protected Areas or Critical Habitats",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Is Critical Habitat Screening Required?",
          type: "radio",
          options: ["Yes", "No", "Already Completed"],
        },
      ],
    },
    {
      title: "🔶 Species Survey Details",
      description:
        "✅ Complete species assessment checklist and upload supporting documentation:",
      fields: [
        { label: "⬆ Upload Species Survey Data:", type: "header" },
        {
          label: "Species Inventory Conducted (Flora/Fauna)",
          type: "checkbox",
          options: ["Species Inventory Conducted (Flora/Fauna)"],
        },
        { label: "Species Survey Checklist", type: "file" },
        {
          label: "IUCN Red List Status Checked",
          type: "checkbox",
          options: ["IUCN Red List Status Checked"],
        },
        { label: "IUCN Classification Form", type: "file" },
        {
          label: "Endemic or Migratory Species Present",
          type: "checkbox",
          options: ["Endemic or Migratory Species Present"],
        },
        { label: "Endemic/Migratory Species List or Summary", type: "file" },
        {
          label: "Presence of Protected or Threatened Species",
          type: "checkbox",
          options: ["Presence of Protected or Threatened Species"],
        },
        { label: "Supporting Evidence (Photos, Reports)", type: "file" },
        {
          label: "Presence of Invasive Alien Species",
          type: "checkbox",
          options: ["Presence of Invasive Alien Species"],
        },
        { label: "Invasive Species Checklist", type: "file" },
      ],
    },
    {
      title: "🔶 Habitat and Ecosystem Characterization",
      description:
        "✅ Assess habitat characteristics and upload ecosystem mapping data:",
      fields: [
        { label: "⬆ Upload Habitat Assessment Data:", type: "header" },
        {
          label: "Ecosystem Type Mapped (Land Cover, Water Bodies)",
          type: "checkbox",
          options: ["Ecosystem Type Mapped (Land Cover, Water Bodies)"],
        },
        { label: "Ecosystem Services Mapping Sheet", type: "file" },
        {
          label: "Critical Habitat Screening Completed",
          type: "checkbox",
          options: ["Critical Habitat Screening Completed"],
        },
        { label: "Critical Habitat Screening Template", type: "file" },
        {
          label: "Habitat Disturbance Assessment Done",
          type: "checkbox",
          options: ["Habitat Disturbance Assessment Done"],
        },
        { label: "Habitat Disturbance Record", type: "file" },
        {
          label: "Connectivity and Fragmentation Analysis",
          type: "checkbox",
          options: ["Connectivity and Fragmentation Analysis"],
        },
        { label: "Connectivity Map or GIS Layer", type: "file" },
        {
          label:
            "Ecosystem Services Identified (e.g., pollination, water retention, erosion control)",
          type: "checkbox",
          options: ["Ecosystem Services Identified"],
        },
        { label: "Ecosystem Services Summary", type: "file" },
      ],
    },
    {
      title: "🔶 Impact and Sensitivity Analysis",
      description:
        "✅ Analyze biodiversity impacts and upload assessment documentation:",
      fields: [
        { label: "⬆ Upload Impact Analysis Data:", type: "header" },
        {
          label: "Biodiversity Sensitivity Mapping Completed",
          type: "checkbox",
          options: ["Biodiversity Sensitivity Mapping Completed"],
        },
        { label: "Sensitivity Map or Matrix", type: "file" },
        {
          label: "Seasonal or Migratory Patterns Assessed",
          type: "checkbox",
          options: ["Seasonal or Migratory Patterns Assessed"],
        },
        { label: "Temporal Data or Analysis", type: "file" },
        {
          label: "Direct Impacts Identified (footprint, habitat loss)",
          type: "checkbox",
          options: ["Direct Impacts Identified"],
        },
        { label: "Impact Matrix", type: "file" },
        {
          label: "Indirect or Cumulative Impacts Analyzed",
          type: "checkbox",
          options: ["Indirect or Cumulative Impacts Analyzed"],
        },
        { label: "Cumulative Impact Mapping Table", type: "file" },
        {
          label: "Proposed Mitigation or Offset Measures Documented",
          type: "checkbox",
          options: ["Proposed Mitigation or Offset Measures Documented"],
        },
        { label: "Mitigation Plan or Proposal", type: "file" },
      ],
    },
    {
      title: "🔶 Evidence and Supporting Documents",
      description:
        "✅ Upload all available supporting documentation — the system will process both detailed and high-level inputs automatically:",
      fields: [
        { label: "⬆ Upload Supporting Evidence:", type: "header" },
        { label: "Baseline Biodiversity Survey Reports", type: "file" },
        { label: "Field Photos or Drone Images", type: "file" },
        { label: "GIS Layers or KMZ Files for Critical Areas", type: "file" },
        { label: "Habitat and Ecosystem Maps", type: "file" },
        {
          label: "Species Identification Sheets or Taxonomic Lists",
          type: "file",
        },
        {
          label: "Third-Party Environmental Assessments (if available)",
          type: "file",
        },
        {
          label: "Community or NGO Consultation Records (if relevant)",
          type: "file",
        },
        {
          label:
            "👉 Reminder: You do not need to format or organize data manually. The system will process all uploaded documents, perform automatic alignment with biodiversity assessment methodologies, and deliver comprehensive ecosystem impact reports, species risk assessments, and habitat management recommendations.",
          type: "note",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports",
      description:
        "✅ Select reports to generate based on uploaded data and assessments:",
      fields: [
        { label: "📊 Available Report Types:", type: "header" },
        {
          label: "Biodiversity Risk and Sensitivity Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Critical Habitat and Protected Area Screening Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Ecosystem Services Impact Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Species Inventory and Threat Status Summary",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Biodiversity Mitigation and Offset Plan",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Habitat Disturbance and Fragmentation Analysis Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Invasive Species Risk and Management Plan",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Migratory Species and Seasonal Movement Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Biodiversity Monitoring and Long-Term Trends Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Ecosystem Connectivity and Corridors Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Biodiversity Action Plan (BAP) Status Tracker",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Post-Project Biodiversity Impact Evaluation",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Community-Based Biodiversity Conservation Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Landscape-Level Cumulative Biodiversity Impact Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Climate Change Impact on Biodiversity and Ecosystems",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Restoration and Rehabilitation Progress Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
      ],
    },
  ],
};
export const WATER_WASTE_RESOURCE_FORM = {
  title: "Water, Waste, and Resources Form",
  downloadFileName: "Pollution_Monitoring_Emissions_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Basic Project Information",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Site Location (Country / Province)",
          type: "select",
          placeholder: "Select location or geo-tag",
          options: [],
        },
        {
          label: "Facility Type",
          type: "checkbox",
          options: [
            "Industrial",
            "Commercial",
            "Agricultural",
            "Other (Specify)",
          ],
        },
        {
          label: "Water Source Type",
          type: "checkbox",
          options: [
            "Groundwater",
            "Surface Water",
            "Municipal Supply",
            "Desalinated",
          ],
        },
        {
          label: "Waste Type Generated",
          type: "checkbox",
          options: ["Non-Hazardous", "Hazardous", "Medical", "E-Waste"],
        },
        {
          label: "Resource Efficiency Program Present?",
          type: "checkbox",
          options: ["Yes", "No", "Planned"],
        },
      ],
    },
    {
      title: "Water Use & Wastewater Details (Upload if available)",
      description: "Checklist",
      fields: [
        {
          label: "Water Use & Wastewater Checklist",
          type: "checkbox",
          options: [
            "Water Use Inventory (Daily, Monthly, Annual)",
            "Wastewater Discharge Volumes and Quality (COD, BOD, TSS, pH, etc.)",
            "Water Treatment System Specifications",
            "Discharge Permit Details and Compliance Monitoring",
            "Stormwater Management and Runoff Control Measures",
            "Water Reuse or Recycling Practices (if applicable)",
          ],
        },
      ],
    },
    {
      title: "Waste Management (Upload if available)",
      description: "Checklist",
      fields: [
        {
          label: "Waste Management Checklist",
          type: "checkbox",
          options: [
            "Solid Waste Inventory (by type and volume)",
            "Hazardous Waste Inventory and Storage Logs",
            "E-Waste, Medical Waste, or Specialized Waste Tracking",
            "Waste Handling and Disposal Procedures",
            "Licensed Waste Contractor/Disposal Certificates",
            "On-site Waste Segregation and Recycling Measures",
            "Waste Minimization or Circular Economy Initiatives",
          ],
        },
      ],
    },
    {
      title: "Resource Efficiency (Upload if available)",
      description: "Checklist",
      fields: [
        {
          label: "Resource Efficiency Checklist",
          type: "checkbox",
          options: [
            "Energy Use Inventory (Electricity, Gas, Renewables)",
            "Material Input-Output Analysis",
            "Resource Efficiency Targets and Monitoring (Water, Energy, Raw Materials)",
            "Circular Economy Practices (reuse, recovery, repurposing)",
            "Equipment Efficiency and Upgrade Logs",
            "Renewable Energy Integration Assessment",
          ],
        },
      ],
    },
    {
      title: "Upload Required Evidence (Upload if available)",
      description: "Water, Waste, and Resources Upload Section",
      fields: [
        { label: "Water Use Logs / Meters / Utility Bills", type: "file" },
        { label: "Waste Disposal Certificates / Contracts", type: "file" },
        { label: "Wastewater Sampling and Laboratory Results", type: "file" },
        {
          label: "Resource Efficiency Policy or Program Records",
          type: "file",
        },
        { label: "Permits, Licenses, and Compliance Records", type: "file" },
        { label: "Contractor Reports or Audit Findings", type: "file" },
        {
          label: "Energy Consumption Records (e.g., Electricity, Fuel)",
          type: "file",
        },
        { label: "Waste Segregation or Recycling Documentation", type: "file" },
        {
          label: "Hazardous Materials Storage or Handling Records",
          type: "file",
        },
        { label: "Environmental Monitoring Data (if available)", type: "file" },
        {
          label: "Photos or Evidence of On-site Practices (Optional)",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports (Selectable)",
      description: "Select reports to generate based on uploaded data:",
      fields: [
        {
          label: "Report Types",
          type: "checkbox",
          options: [
            "Water Use and Wastewater Discharge Assessment",
            "Solid and Hazardous Waste Management Compliance Report",
            "Resource and Energy Efficiency Performance Report",
            "Circular Economy and Waste Minimization Progress Report",
            "Stormwater and Runoff Quality Monitoring Report",
            "Waste Stream Audit and Optimization Recommendations",
            "Annual Environmental Resource Use and Efficiency Report",
            "Water Balance and Conservation Action Plan",
            "Wastewater Reuse Feasibility and Impact Report",
            "Life Cycle Resource Efficiency and Materials Flow Analysis",
            "Sustainable Materials Management and Substitution Plan",
            "Packaging Waste and Extended Producer Responsibility (EPR) Report",
            "Waste Management Contractor Compliance Assessment",
            "Microplastics and Emerging Contaminants Monitoring Summary",
          ],
        },
      ],
    },
  ],
};
export const CLIMATE_RISK_REPORTING_FORM = {
  title: "Download Climate & Risk Reporting Form",
  downloadFileName: "Climate_Risk_Reporting_Form",
  downloadFileExtension: "png",
  //   formImageUrl: ClimateImg, // Replace with your actual image import

  sections: [
    {
      title: "Basic Project Information",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select industry sector",
          options: [
            "Energy",
            "Mining",
            "Roads",
            "Agriculture",
            "Manufacturing",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text", // You could change to "geo" if integrating geo-tag UI
          placeholder: "Enter or select location",
        },
        {
          label: "Climate Zone",
          type: "checkbox",
          options: ["Arid", "Temperate", "Tropical", "Polar", "Mountainous"],
        },
        {
          label: "GHG Emissions Category",
          type: "checkbox",
          options: ["Low", "Medium", "High"],
        },
        {
          label: "Vulnerability to Natural Hazards",
          type: "checkbox",
          options: ["Flood", "Heatwave", "Drought", "Cyclone", "Earthquake"],
        },
      ],
    },
    {
      title: "🔶 GHG and Energy Data",
      description: "Checklist / Uploads",
      fields: [
        {
          label: "GHG Emissions Inventory Prepared (Scopes 1, 2, 3)",
          type: "file",
        },
        {
          label: "Energy Consumption and Sources Assessed",
          type: "file",
        },
        {
          label: "Renewable Energy Contribution Reported",
          type: "file",
        },
        {
          label: "Carbon Footprint Calculated",
          type: "file",
        },
        {
          label: "Carbon Offsetting or Credit Purchase Records",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Climate Vulnerability and Adaptation",
      description: "Checklist / Uploads",
      fields: [
        {
          label: "Climate Vulnerability Screening Completed",
          type: "file",
        },
        {
          label: "Climate Risk Assessment Conducted",
          type: "file",
        },
        {
          label: "Adaptation and Resilience Plans Developed",
          type: "file",
        },
        {
          label: "Disaster Risk and Emergency Preparedness Assessed",
          type: "file",
        },
        {
          label: "Business Continuity Plans Incorporating Climate Risks",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Evidence and Supporting Documents",
      description: "Upload Section",
      fields: [
        { label: "GHG Inventory Reports", type: "file" },
        { label: "Energy Audit or Efficiency Reports", type: "file" },
        {
          label: "Climate Vulnerability Assessment or Screening Documents",
          type: "file",
        },
        {
          label: "Climate Adaptation or Resilience Strategy Documents",
          type: "file",
        },
        {
          label: "Natural Hazard and Disaster Risk Maps or GIS Layers",
          type: "file",
        },
        {
          label: "Historical Climate Data or Trends (if available)",
          type: "file",
        },
        { label: "Carbon Credit or Offsetting Purchase Records", type: "file" },
        {
          label: "Third-Party Climate Risk Assessments or Certifications",
          type: "file",
        },
        {
          label: "Business Continuity and Emergency Preparedness Documents",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports",
      description: "Select reports to generate",
      fields: [
        {
          label: "Report Type",
          type: "checkbox",
          options: [
            "Climate Risk and Resilience Assessment Report",
            "Greenhouse Gas Emissions Inventory and Compliance Report",
            "Carbon Footprint and Emission Reduction Action Plan",
            "Climate Change Adaptation and Mitigation Strategy Report",
            "Energy Efficiency and Renewable Energy Performance Report",
            "Disaster Risk and Emergency Preparedness Assessment Report",
            "Climate Vulnerability Mapping and Analysis Report",
            "Carbon Offsetting and Net-Zero Progress Summary",
            "Corporate Climate Policy and Compliance Summary",
            "Science-Based Targets and Emission Reduction Pathway Report",
            "Climate Risk Disclosure Report (IFRS, TCFD, or Equivalent)",
            "Cumulative Climate Risk and Opportunity Assessment",
            "Business Continuity and Climate Resilience Performance Report",
            "Climate Change Impact on Project Operations and Supply Chains",
            "Sectoral Climate Transition and Physical Risk Summary",
            "Post-Project Climate Impact Evaluation Report",
          ],
        },
      ],
    },
  ],
};
export const EMISSION_POLLUTION_CONTROL_FORM = {
  form_name: "Emissions and Pollution Control Form",
  sections: [
    {
      section: "Project Information",
      fields: [
        { label: "Project Name", type: "text" },
        { label: "Site Location (Country / Province / District)", type: "geo" },
        {
          label: "Facility Type",
          type: "dropdown",
          options: [
            "Industrial Plant",
            "Power Plant",
            "Refinery",
            "Mining Site",
            "Construction Site",
            "Waste Facility",
            "Transportation Hub",
            "Other",
          ],
        },
        {
          label: "Operational Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Type of Emissions Present",
          type: "checkbox",
          options: [
            "Air Emissions (PM, SO₂, NOₓ, CO, VOCs)",
            "Greenhouse Gases (CO₂, CH₄, N₂O, F-gases)",
            "Wastewater Discharge (BOD, COD, TSS, nutrients, metals)",
            "Noise / Vibration",
            "Odor Emissions",
            "Light Pollution",
          ],
        },
      ],
    },
    {
      section: "Monitoring Setup",
      fields: [
        {
          label: "Air Emissions",
          type: "checkbox",
          options: [
            "Stack Emission Monitoring",
            "Ambient Air Quality Monitoring (nearby receptors)",
            "Fugitive Emission Monitoring (leaks, vents)",
          ],
        },
        {
          label: "Greenhouse Gases (GHG)",
          type: "checkbox",
          options: [
            "Scope 1 Direct Emissions",
            "Scope 2 Indirect Emissions",
            "Scope 3 Supply Chain/Downstream Emissions",
          ],
        },
        {
          label: "Wastewater Discharge",
          type: "checkbox",
          options: [
            "Effluent Sampling and Testing",
            "Stormwater Runoff Monitoring",
            "Compliance with Discharge Permits",
          ],
        },
        {
          label: "Noise / Vibration",
          type: "checkbox",
          options: [
            "Baseline Noise Survey",
            "Construction / Operational Noise Monitoring",
            "Vibration Impact Assessment",
          ],
        },
        {
          label: "Odor / Light Pollution",
          type: "checkbox",
          options: [
            "Odor Source Identification",
            "Community Complaints Logging",
            "Nighttime Light Spill Measurements",
          ],
        },
      ],
    },
    {
      section: "Regulatory and Framework Mapping",
      fields: [
        {
          label: "Applicable Standards / Laws",
          type: "checkbox",
          options: [
            "IFC PS3 – Resource Efficiency and Pollution Prevention",
            "National Air Quality Standards (e.g., CEPA)",
            "EU Industrial Emissions Directive (if applicable)",
            "ISO 14064 – GHG Accounting and Reporting",
            "Kyoto Protocol / Paris Agreement Targets",
            "National Wastewater Discharge Standards",
            "Local Noise and Odor Control Regulations",
            "Client-Specific or Lender-Specific Emissions Requirements",
          ],
          upload_option: true,
        },
      ],
    },
    {
      section: "Downloadable Monitoring Forms",
      fields: [
        {
          label: "Form Downloads",
          type: "checkbox",
          options: [
            "Stack Emissions Log Sheet",
            "Air Quality Monitoring Data Template",
            "GHG Emissions Inventory Sheet (Scope 1, 2, 3)",
            "Wastewater Sampling and Analysis Form",
            "Noise and Vibration Monitoring Log",
            "Odor Complaint Register",
            "Light Pollution Measurement Sheet",
            "Permit Compliance Checklist",
          ],
        },
      ],
    },
    {
      section: "Upload Data and Evidences",
      title: "🔶 Upload Data and Evidences",
      description: "Checklist / Uploads",
      fields: [
        { label: "Air Emission Test Results (Lab-certified)", type: "file" },
        { label: "GHG Calculation Sheets and Assumptions", type: "file" },
        { label: "Effluent Discharge Lab Reports", type: "file" },
        { label: "Noise Survey Reports", type: "file" },
        { label: "Vibration Impact Reports", type: "file" },
        { label: "Permit Copies (Air, Water, Noise)", type: "file" },
        { label: "Community Complaint Logs", type: "file" },
        { label: "Equipment Calibration Certificates", type: "file" },
      ],
    },
    {
      section: "Auto-Generated Reports (Selectable)",
      fields: [
        {
          label: "Report Type",
          type: "checkbox",
          options: [
            "Air Emissions Inventory and Compliance Report",
            "Greenhouse Gas Emissions Report (Scopes 1–3)",
            "Wastewater Discharge Compliance Assessment",
            "Noise and Vibration Monitoring Summary",
            "Odor and Light Pollution Impact Summary",
            "Emissions Mitigation and Corrective Action Plan",
            "Permit Compliance and Regulatory Alignment Report",
            "Cumulative Pollution Load Analysis",
            "Stack Emissions Variance Analysis Report",
            "Ambient Air Quality Baseline and Trend Report",
            "Fugitive Emissions and Leak Detection Summary",
            "GHG Reduction Progress Tracking Report (vs. Targets)",
            "Effluent Treatment Efficiency and Compliance Report",
            "Stormwater Runoff Quality and Management Assessment",
            "Noise Contour Mapping and Sensitive Receptor Impact Analysis",
            "Vibration Impact and Structural Risk Report",
            "Odor Source Investigation and Community Complaint Analysis",
            "Light Pollution Impact on Wildlife and Community Report",
            "Climate Adaptation Measures and Infrastructure Stress Analysis",
            "Cross-Sector Pollution Exchange and Cumulative Risk Summary",
            "Environmental Incident and Non-Compliance Log Summary",
            "Regulatory Reporting Dashboard (Annual, Quarterly, Monthly)",
          ],
        },
      ],
    },
  ],
};
export const RELATIVE_COMMUNITY_SENSITIVITY_FORM = {
  title: "",
  downloadFileName: "Community_Socioeconomic_Sensitivity_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "🔹 Community & Project Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Roads",
            "Housing",
            "Manufacturing",
            "ICT",
            "Public Infrastructure",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Geo-tagged selection or text input",
        },
        {
          label: "Type of Community",
          type: "checkbox",
          options: ["Urban", "Rural", "Peri-Urban"],
        },
        {
          label: "Presence of Indigenous Peoples",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Conflict Zone / Fragile Area",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Target Groups",
          type: "checkbox",
          options: [
            "Women",
            "Youth",
            "Migrants",
            "Informal Workers",
            "Religious Minorities",
          ],
        },
      ],
    },
  ],
};
export const GENDER_IMPACT_ASSESSMENT_FORM = {
  title: "Download Gender Impact Assessment (GIA) Form",
  downloadFileName: "Gender_Impact_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "Project & Assessment Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Roads",
            "Housing",
            "Manufacturing",
            "ICT",
            "Agriculture",
            "Mining",
            "Water",
            "Waste",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
        },
        {
          label: "Community Type",
          type: "checkbox",
          options: ["Urban", "Rural", "Peri-Urban"],
        },
        {
          label: "Presence of Indigenous Peoples",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Target Groups (tick all that apply)",
          type: "checkbox",
          options: [
            "Women",
            "Youth",
            "Migrants",
            "Informal Workers",
            "Religious Minorities",
          ],
        },
      ],
    },
    {
      title: "🔶 Workforce Gender Profile",
      description:
        "✅ Complete workforce assessment checklist and upload supporting documentation:",
      fields: [
        { label: "⬆ Upload Workforce Gender Data:", type: "header" },
        {
          label: "Worker Gender Breakdown Table (Male / Female / Other)",
          type: "checkbox",
          options: ["Worker Gender Breakdown Table Available"],
        },
        { label: "Worker Gender Breakdown Table", type: "file" },
        {
          label: "Female Representation in Management Positions",
          type: "checkbox",
          options: ["Female Management Representation Data Available"],
        },
        { label: "Management Gender Diversity Data", type: "file" },
        {
          label: "Availability of Separate Toilets & Facilities",
          type: "checkbox",
          options: ["Separate Facilities Available"],
        },
        { label: "Facilities Description Document", type: "file" },
        {
          label: "Existence of Gender-Sensitive HR Policies",
          type: "checkbox",
          options: ["Gender-Sensitive HR Policies Exist"],
        },
        { label: "HR Policy Documents", type: "file" },
      ],
    },
    {
      title: "🔶 Gender-Based Violence (GBV) and Harassment",
      description: "✅ Assess GBV prevention measures and upload evidence:",
      fields: [
        { label: "⬆ Upload GBV Prevention Data:", type: "header" },
        {
          label: "GBV Referral Pathway Map Available",
          type: "checkbox",
          options: ["GBV Referral Pathway Map Available"],
        },
        { label: "GBV Referral Maps and Contact Lists", type: "file" },
        {
          label: "Workplace Harassment Complaints Logged (Past 12 months)",
          type: "checkbox",
          options: ["Harassment Complaints Register Maintained"],
        },
        { label: "Harassment Complaints Register", type: "file" },
        {
          label: "Procedures for Handling Harassment Cases",
          type: "checkbox",
          options: ["Harassment Handling Procedures Exist"],
        },
        { label: "Harassment Policy and Procedures", type: "file" },
        {
          label: "Access to Confidential Reporting Mechanism",
          type: "checkbox",
          options: ["Confidential Reporting Mechanism Available"],
        },
        { label: "Reporting Mechanism Details", type: "file" },
      ],
    },
    {
      title: "🔶 Training and Awareness",
      description:
        "✅ Document training programs and upload training materials:",
      fields: [
        { label: "⬆ Upload Training Data:", type: "header" },
        {
          label: "Training on Gender Sensitivity Delivered",
          type: "checkbox",
          options: ["Gender Sensitivity Training Delivered"],
        },
        { label: "Training Attendance Logs", type: "file" },
        {
          label: "Training Frequency",
          type: "select",
          placeholder: "Select Training Frequency",
          options: [
            "Annual",
            "Biannual",
            "Quarterly",
            "Ad Hoc",
            "Not Scheduled",
          ],
        },
        {
          label: "Target Audience for Training",
          type: "checkbox",
          options: [
            "Staff",
            "Management",
            "Suppliers",
            "Contractors",
            "Community Members",
          ],
        },
        { label: "Training Records and Materials", type: "file" },
      ],
    },
    {
      title: "🔶 Monitoring and Performance",
      description:
        "✅ Upload monitoring data and performance tracking documentation:",
      fields: [
        { label: "⬆ Upload Monitoring Data:", type: "header" },
        {
          label: "Gender-Specific Performance Indicators Tracked",
          type: "checkbox",
          options: ["Gender KPIs Tracked"],
        },
        { label: "Gender KPIs List and Data", type: "file" },
        {
          label: "Gender Impact Monitoring Reports Available",
          type: "checkbox",
          options: ["Gender Monitoring Reports Available"],
        },
        { label: "Gender Impact Monitoring Reports", type: "file" },
        {
          label: "Identified Gaps or Challenges in Gender Inclusion",
          type: "checkbox",
          options: ["Gender Inclusion Gaps Identified"],
        },
        { label: "Gap Analysis Summary", type: "file" },
      ],
    },
    {
      title: "🔶 Supporting Documents and Evidence",
      description:
        "✅ Upload all available supporting documentation — the system will process both detailed and high-level inputs automatically:",
      fields: [
        { label: "⬆ Upload Supporting Evidence:", type: "header" },
        {
          label: "Gender-Sensitive Policies (HR, Code of Conduct)",
          type: "file",
        },
        { label: "Community Consultation Records", type: "file" },
        { label: "Stakeholder Engagement Documentation", type: "file" },
        {
          label: "Third-Party Gender Assessments (if available)",
          type: "file",
        },
        { label: "Grievance Mechanism Documentation", type: "file" },
        { label: "Women's Safety and Security Measures", type: "file" },
        { label: "Any Other Relevant Evidence", type: "file" },
        {
          label:
            "👉 Reminder: You do not need to format or organize data manually. The system will process all uploaded documents, perform automatic alignment with gender assessment methodologies, and deliver comprehensive gender impact reports, risk assessments, and action plan recommendations.",
          type: "note",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports",
      description:
        "✅ Select reports to generate based on uploaded data and assessments:",
      fields: [
        { label: "📊 Available Report Types:", type: "header" },
        {
          label: "Gender Impact Assessment Report (Full)",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "GIA Executive Summary",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender Risk and Gap Analysis",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender KPIs Dashboard Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Workforce Gender Diversity Analysis",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "GBV Prevention and Response Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender Training Needs Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender Action Plan (GAP) Template",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Women's Economic Empowerment Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender Monitoring and Evaluation Framework",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Community Gender Impact Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender-Responsive Budgeting Analysis",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Intersectional Gender Analysis Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Gender Compliance and Standards Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
      ],
    },
  ],
};
export const STAKEHOLDER_ENGAGEMENT_SUMMARY_FORM = {
  title: "Download Stakeholder Engagement Summary Form",
  downloadFileName: "Stakeholder_Engagement_Summary_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,
  sections: [
    {
      title: "Project & Engagement Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Roads",
            "Housing",
            "Manufacturing",
            "ICT",
            "Agriculture",
            "Mining",
            "Water",
            "Waste",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
        },
        {
          label: "Community Type",
          type: "checkbox",
          options: ["Urban", "Rural", "Peri-Urban"],
        },
        {
          label: "Presence of Indigenous Peoples",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Conflict Zone / Fragile Area",
          type: "radio",
          options: ["Yes", "No"],
        },
      ],
    },
    {
      title: "🔶 Stakeholder Identification",
      description:
        "✅ Complete stakeholder identification checklist and upload supporting documentation:",
      fields: [
        {
          label: "⬆ Upload Stakeholder Identification Data:",
          type: "header",
        },
        {
          label: "Stakeholder Identification List",
          type: "checkbox",
          options: ["Stakeholder Identification List Available"],
        },
        {
          label: "Stakeholder Register",
          type: "file",
        },
        {
          label: "Categorization by Type (Govt, Community, NGO, Private)",
          type: "checkbox",
          options: ["Stakeholder Categorization Completed"],
        },
        {
          label: "Stakeholder Category Details",
          type: "file",
        },
        {
          label: "Vulnerable Groups or Indigenous Peoples Identified",
          type: "checkbox",
          options: ["Vulnerable Groups Identified"],
        },
        {
          label: "Vulnerable Groups Evidence",
          type: "file",
        },
        {
          label: "Stakeholder Influence/Impact Assessment Conducted",
          type: "checkbox",
          options: ["Influence/Impact Assessment Conducted"],
        },
        {
          label: "Stakeholder Assessment Summary",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Engagement Activities and Records",
      description:
        "✅ Document engagement activities and upload meeting records:",
      fields: [
        {
          label: "⬆ Upload Engagement Activity Data:",
          type: "header",
        },
        {
          label: "Meeting Attendance Lists",
          type: "checkbox",
          options: ["Meeting Attendance Lists Available"],
        },
        {
          label: "Meeting Attendance Records",
          type: "file",
        },
        {
          label: "Meeting Notes or Minutes of Meetings",
          type: "checkbox",
          options: ["Meeting Minutes Available"],
        },
        {
          label: "Meeting Notes or Minutes",
          type: "file",
        },
        {
          label: "Issues Raised by Stakeholders",
          type: "checkbox",
          options: ["Stakeholder Issues Documented"],
        },
        {
          label: "Issues and Concerns Summary",
          type: "file",
        },
        {
          label: "Resolution Follow-ups or Response Records",
          type: "checkbox",
          options: ["Follow-up Records Available"],
        },
        {
          label: "Follow-up Tracker",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Free, Prior and Informed Consent (FPIC)",
      description:
        "✅ Document FPIC processes and upload consent documentation:",
      fields: [
        {
          label: "⬆ Upload FPIC Documentation:",
          type: "header",
        },
        {
          label: "FPIC Process Applied (for Indigenous Communities)",
          type: "checkbox",
          options: ["FPIC Process Applied"],
        },
        {
          label: "FPIC Process Description",
          type: "file",
        },
        {
          label: "FPIC Documentation Checklist Completed",
          type: "checkbox",
          options: ["FPIC Checklist Completed"],
        },
        {
          label: "FPIC Agreements or Checklists",
          type: "file",
        },
        {
          label: "FPIC Agreements or Consent Forms (if applicable)",
          type: "checkbox",
          options: ["FPIC Agreements Available"],
        },
        {
          label: "FPIC Consent Forms",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Grievance Handling and Feedback",
      description: "✅ Track grievances and feedback mechanisms:",
      fields: [
        {
          label: "⬆ Upload Grievance and Feedback Data:",
          type: "header",
        },
        {
          label: "Grievances Raised During Engagements",
          type: "checkbox",
          options: ["Grievances Documented"],
        },
        {
          label: "Grievance and Resolution Logs",
          type: "file",
        },
        {
          label: "Resolution Time and Satisfaction Level Tracked",
          type: "checkbox",
          options: ["Resolution Tracking Available"],
        },
        {
          label: "Resolution Summary",
          type: "file",
        },
        {
          label: "Feedback Surveys Conducted",
          type: "checkbox",
          options: ["Feedback Surveys Conducted"],
        },
        {
          label: "Survey Results",
          type: "file",
        },
        {
          label: "Anonymous Feedback Channels Available",
          type: "checkbox",
          options: ["Anonymous Feedback Channels Available"],
        },
        {
          label: "Feedback Channel Details",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Supporting Documents and Evidence",
      description:
        "✅ Upload all available supporting documentation — the system will process both detailed and high-level inputs automatically:",
      fields: [
        {
          label: "⬆ Upload Supporting Evidence:",
          type: "header",
        },
        {
          label: "Stakeholder List / Register",
          type: "file",
        },
        {
          label: "Meeting Attendance Records",
          type: "file",
        },
        {
          label: "FPIC Agreements or Checklists",
          type: "file",
        },
        {
          label: "Grievance and Resolution Logs",
          type: "file",
        },
        {
          label: "Audio / Video Recordings (if available)",
          type: "file",
        },
        {
          label: "Stakeholder Communication Materials (notices, letters)",
          type: "file",
        },
        {
          label: "Any Other Relevant Evidence",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports",
      description:
        "✅ Select reports to generate based on uploaded data and assessments:",
      fields: [
        {
          label: "📊 Available Report Types:",
          type: "header",
        },
        {
          label: "Stakeholder Engagement Summary Report (Full)",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "FPIC Verification Report (if applicable)",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Grievance Mechanism Performance Summary",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Stakeholder Communication Effectiveness Analysis",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Stakeholder Engagement Risk and Gap Assessment",
          type: "checkbox",
          options: ["Generate Report"],
        },
      ],
    },
  ],
};
export const LIVELIHOOD_IMPACT_ASSESSMENT_FORM = {
  title: "Download Livelihood Impact Assessment (LIA) Form",
  downloadFileName: "Livelihood_Impact_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg, // assuming you want the same image placeholder

  sections: [
    {
      title: "Project & Basic Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Roads",
            "Housing",
            "Manufacturing",
            "ICT",
            "Agriculture",
            "Mining",
            "Water",
            "Waste",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
        },
        {
          label: "Community Type",
          type: "checkbox",
          options: ["Urban", "Rural", "Peri-Urban"],
        },
        {
          label: "Presence of Indigenous Peoples",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Conflict Zone / Fragile Area",
          type: "radio",
          options: ["Yes", "No"],
        },
      ],
    },
    {
      title: "🔶 Livelihood Impact Profile",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Displaced Household Register Compiled",
          type: "checkbox",
          options: ["Displaced Household Register Compiled"],
        },
        {
          label: "Upload Household List",
          type: "file",
        },
        {
          label:
            "Displaced Persons by Category (Women, Youth, Elderly, Others)",
          type: "checkbox",
          options: ["Displaced Persons by Category Identified"],
        },
        {
          label: "Upload Disaggregation Table",
          type: "file",
        },
        {
          label: "Income Sources Identified Pre-Project",
          type: "checkbox",
          options: ["Income Sources Identified"],
        },
        {
          label: "Upload Income Source Baseline",
          type: "file",
        },
        {
          label: "Post-Intervention Livelihood Status Tracked",
          type: "checkbox",
          options: ["Livelihood Status Tracking Completed"],
        },
        {
          label: "Upload Follow-up Survey / Data",
          type: "file",
        },
        {
          label: "Household Asset Inventory Conducted",
          type: "checkbox",
          options: ["Asset Inventory Conducted"],
        },
        {
          label: "Upload Asset Inventory Checklist",
          type: "file",
        },
        {
          label: "Agricultural / Fishing / Livestock Dependency Mapped",
          type: "checkbox",
          options: ["Resource Dependency Mapped"],
        },
        {
          label: "Upload Resource Dependency Chart",
          type: "file",
        },
        {
          label: "Alternative Livelihoods or Job Placements Provided",
          type: "checkbox",
          options: ["Alternative Livelihoods Provided"],
        },
        {
          label: "Upload Replacement Income Plan",
          type: "file",
        },
        {
          label: "Microenterprise or Small Business Support Provided",
          type: "checkbox",
          options: ["Microenterprise Support Provided"],
        },
        {
          label: "Upload Support Plan or Summary",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Resettlement and Compensation",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Resettlement Action Plan (RAP) Prepared (if applicable)",
          type: "checkbox",
          options: ["RAP Prepared"],
        },
        {
          label: "Upload RAP Document",
          type: "file",
        },
        {
          label: "Compensation Packages Designed and Disclosed",
          type: "checkbox",
          options: ["Compensation Packages Designed"],
        },
        {
          label: "Upload Compensation Tables",
          type: "file",
        },
        {
          label: "Grievance Redress for Compensation Issues",
          type: "checkbox",
          options: ["Grievance Redress Documented"],
        },
        {
          label: "Upload Grievance Log (Specific)",
          type: "file",
        },
        {
          label: "Community Consultation on Livelihood Options",
          type: "checkbox",
          options: ["Community Consultation Conducted"],
        },
        {
          label: "Upload Meeting Notes / Summaries",
          type: "file",
        },
        {
          label: "Special Measures for Vulnerable Groups",
          type: "checkbox",
          options: ["Special Measures Implemented"],
        },
        {
          label: "Upload Special Measures Plan",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Livelihood Risks and Mitigation",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Risk of Income Loss Mapped",
          type: "checkbox",
          options: ["Risk of Income Loss Mapped"],
        },
        {
          label: "Upload Risk Matrix or Summary",
          type: "file",
        },
        {
          label: "Seasonal Livelihood Impact Identified",
          type: "checkbox",
          options: ["Seasonal Impact Identified"],
        },
        {
          label: "Upload Seasonal Risk Chart",
          type: "file",
        },
        {
          label: "Market Access Disruption Identified",
          type: "checkbox",
          options: ["Market Access Disruption Identified"],
        },
        {
          label: "Upload Market Access Analysis",
          type: "file",
        },
        {
          label: "Food Security Risks Evaluated",
          type: "checkbox",
          options: ["Food Security Risks Evaluated"],
        },
        {
          label: "Upload Food Security Review",
          type: "file",
        },
        {
          label: "Mitigation Strategies Designed and Communicated",
          type: "checkbox",
          options: ["Mitigation Strategies Designed"],
        },
        {
          label: "Upload Mitigation Plan",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Attachments / Uploads",
      description: "Required / Optional Supporting Documents — Upload Section",
      fields: [
        { label: "Displaced Household Register", type: "file" },
        { label: "Baseline Income and Asset Surveys", type: "file" },
        { label: "Resource Dependency Maps or Charts", type: "file" },
        {
          label: "Replacement Income or Alternative Livelihood Plans",
          type: "file",
        },
        { label: "Resettlement Action Plan (if applicable)", type: "file" },
        { label: "Compensation Agreements and Documentation", type: "file" },
        { label: "Vulnerable Group Measures Documentation", type: "file" },
        { label: "Grievance Resolution Logs", type: "file" },
        { label: "Any Other Relevant Evidence", type: "file" },
      ],
    },
    {
      title: "🔶 Auto-Generated Outputs",
      description: "Report Type — Generate Report (Checkbox)",
      fields: [
        {
          label: "Livelihood Impact Assessment Report (Full)",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Summary of Displaced Households and Livelihood Restoration",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Compensation and Resettlement Compliance Summary",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Livelihood Risk and Mitigation Action Plan",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Vulnerable Group Livelihood Risk Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Post-Resettlement Livelihood Monitoring Summary",
          type: "checkbox",
          options: ["Generate Report"],
        },
      ],
    },
  ],
};
export const WORKER_WELFARE_AUDIT_FORM = {
  title: "Download Worker Welfare Audit Form",
  downloadFileName: "Worker_Welfare_Audit_Form",
  downloadFileExtension: "png",
  //   formImageUrl: EsgImg, // keeping your placeholder image

  sections: [
    {
      title: "Project & Basic Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
          variableName: "projectName",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
          variableName: "projectPhase",
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Roads",
            "Housing",
            "Manufacturing",
            "ICT",
            "Agriculture",
            "Mining",
            "Water",
            "Waste",
          ],
          variableName: "sectorIndustry",
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
          variableName: "location",
        },
        {
          label: "Community Type",
          type: "checkbox",
          options: ["Urban", "Rural", "Peri-Urban"],
          variableName: "communityType",
        },
        {
          label: "Presence of Indigenous Peoples",
          type: "radio",
          options: ["Yes", "No"],
          variableName: "indigenousPresence",
        },
        {
          label: "Conflict Zone / Fragile Area",
          type: "radio",
          options: ["Yes", "No"],
          variableName: "conflictZone",
        },
        {
          label: "Number of Workers on Site",
          type: "number",
          placeholder: "Enter number",
          variableName: "workerCount",
        },
        {
          label: "Worker Demographics",
          type: "file",
          description:
            "Upload Worker Breakdown (Gender, Age, Nationality, etc.)",
          variableName: "workerDemographicsFile",
        },
      ],
    },

    {
      title: "🔶 Worker Accommodation and Facilities Audit",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Worker Accommodation Inspected",
          type: "checkbox",
          options: ["Inspected"],
          variableName: "accommodationInspected",
        },
        {
          label: "Upload Accommodation Checklist",
          type: "file",
          variableName: "accommodationChecklistFile",
        },
        {
          label: "Room Capacity and Density Meets Standards",
          type: "checkbox",
          options: ["Meets Standards"],
          variableName: "roomCapacityStandards",
        },
        {
          label: "Upload Room Layout / Occupancy Data",
          type: "file",
          variableName: "roomLayoutFile",
        },
        {
          label: "Adequate Toilets, Showers, and Washing Facilities",
          type: "checkbox",
          options: ["Adequate Facilities"],
          variableName: "sanitationFacilities",
        },
        {
          label: "Upload Sanitation Facilities Log",
          type: "file",
          variableName: "sanitationLogFile",
        },
        {
          label: "Drinking Water Supply Tested and Certified",
          type: "checkbox",
          options: ["Water Supply Certified"],
          variableName: "waterSupplyTested",
        },
        {
          label: "Upload Water Quality Certificates",
          type: "file",
          variableName: "waterQualityCertificatesFile",
        },
        {
          label: "Kitchen and Canteen Hygiene Inspected",
          type: "checkbox",
          options: ["Hygiene Inspected"],
          variableName: "kitchenHygiene",
        },
        {
          label: "Upload Food & Hygiene Checklist",
          type: "file",
          variableName: "foodHygieneChecklistFile",
        },
        {
          label: "Recreational Facilities Provided (if required)",
          type: "checkbox",
          options: ["Recreational Facilities Provided"],
          variableName: "recreationalFacilities",
        },
        {
          label: "Upload Photos or Facility Inventory",
          type: "file",
          variableName: "recreationalFacilitiesPhotos",
        },
      ],
    },

    {
      title: "🔶 Worker Rights and Contracts Audit",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Written Labor Contracts Provided to Workers",
          type: "checkbox",
          options: ["Contracts Provided"],
          variableName: "laborContractsProvided",
        },
        {
          label: "Upload Sample Labor Contracts",
          type: "file",
          variableName: "sampleContractsFile",
        },
        {
          label: "Contracts in Local / Understandable Language",
          type: "checkbox",
          options: ["Contracts in Local Language"],
          variableName: "contractsLocalLanguage",
        },
        {
          label: "Upload Translation Samples (if any)",
          type: "file",
          variableName: "translationSamplesFile",
        },
        {
          label: "Minimum Wage Compliance Verified",
          type: "checkbox",
          options: ["Minimum Wage Verified"],
          variableName: "minimumWageCompliance",
        },
        {
          label: "Upload Payroll Samples / Wage Slips",
          type: "file",
          variableName: "payrollSamplesFile",
        },
        {
          label: "Working Hours and Overtime Records Checked",
          type: "checkbox",
          options: ["Hours and Overtime Checked"],
          variableName: "workingHoursChecked",
        },
        {
          label: "Upload Time Sheets or Logs",
          type: "file",
          variableName: "timeSheetsFile",
        },
        {
          label: "Freedom of Association and Collective Bargaining",
          type: "checkbox",
          options: ["Freedom of Association Confirmed"],
          variableName: "freedomOfAssociation",
        },
        {
          label: "Upload Evidence (Union, Worker Committees)",
          type: "file",
          variableName: "unionEvidenceFile",
        },
      ],
    },

    {
      title: "🔶 Health, Safety, and Medical Access Audit",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "On-Site Medical Facilities Available",
          type: "checkbox",
          options: ["Medical Facilities Available"],
          variableName: "medicalFacilitiesAvailable",
        },
        {
          label: "Upload Medical Access & Emergency Log",
          type: "file",
          variableName: "medicalAccessLogFile",
        },
        {
          label: "First Aid Kits Available and Accessible",
          type: "checkbox",
          options: ["First Aid Kits Available"],
          variableName: "firstAidKitsAvailable",
        },
        {
          label: "Upload First Aid Inventory",
          type: "file",
          variableName: "firstAidInventoryFile",
        },
        {
          label: "PPE Provided and Used Correctly",
          type: "checkbox",
          options: ["PPE Provided"],
          variableName: "ppeProvided",
        },
        {
          label: "Upload PPE Checklist",
          type: "file",
          variableName: "ppeChecklistFile",
        },
        {
          label: "Incident / Accident Log Maintained",
          type: "checkbox",
          options: ["Incident Log Maintained"],
          variableName: "incidentLogMaintained",
        },
        {
          label: "Upload Incident Logbook",
          type: "file",
          variableName: "incidentLogbookFile",
        },
        {
          label: "Safety Trainings Conducted and Recorded",
          type: "checkbox",
          options: ["Safety Trainings Conducted"],
          variableName: "safetyTrainingsConducted",
        },
        {
          label: "Upload Safety Training Log",
          type: "file",
          variableName: "safetyTrainingLogFile",
        },
      ],
    },

    {
      title: "🔶 Grievance and Complaint Mechanism Audit",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Grievance Redress Mechanism Established",
          type: "checkbox",
          options: ["Mechanism Established"],
          variableName: "grievanceMechanismEstablished",
        },
        {
          label: "Upload Grievance Procedure",
          type: "file",
          variableName: "grievanceProcedureFile",
        },
        {
          label: "Anonymous Complaint Channels Available",
          type: "checkbox",
          options: ["Anonymous Channels Available"],
          variableName: "anonymousComplaintChannels",
        },
        {
          label: "Upload Anonymous Complaint Samples",
          type: "file",
          variableName: "anonymousComplaintSamplesFile",
        },
        {
          label: "Complaint Resolution Time Monitored",
          type: "checkbox",
          options: ["Resolution Time Monitored"],
          variableName: "complaintResolutionTimeMonitored",
        },
        {
          label: "Upload Grievance Resolution Log",
          type: "file",
          variableName: "grievanceResolutionLogFile",
        },
        {
          label: "Worker Satisfaction with Grievance Process Surveyed",
          type: "checkbox",
          options: ["Satisfaction Surveyed"],
          variableName: "workerSatisfactionSurveyed",
        },
        {
          label: "Upload Survey Results (if any)",
          type: "file",
          variableName: "surveyResultsFile",
        },
      ],
    },

    {
      title: "🔶 Attachments / Uploads",
      description: "Required / Optional Supporting Documents — Upload Section",
      fields: [
        {
          label: "Worker Accommodation Checklists",
          type: "file",
          variableName: "accommodationChecklistsFile",
        },
        {
          label: "Food & Water Supply Checklists",
          type: "file",
          variableName: "foodWaterChecklistsFile",
        },
        {
          label: "Medical Access Logs and Safety Incident Reports",
          type: "file",
          variableName: "medicalAccessLogsFile",
        },
        {
          label: "Labor Contract Samples",
          type: "file",
          variableName: "laborContractSamplesFile",
        },
        {
          label: "Worker Demographic Breakdown",
          type: "file",
          variableName: "workerDemographicBreakdownFile",
        },
        {
          label: "Grievance and Complaint Logs",
          type: "file",
          variableName: "grievanceComplaintLogsFile",
        },
        {
          label: "Any Other Relevant Evidence",
          type: "file",
          variableName: "otherRelevantEvidenceFile",
        },
      ],
    },

    {
      title: "🔶 Auto-Generated Outputs",
      description: "Report Type — Generate Report (Checkbox)",
      fields: [
        {
          label: "Worker Welfare Audit Report (Full)",
          type: "checkbox",
          options: ["Generate Report"],
          variableName: "reportFullAudit",
        },
        {
          label: "Accommodation and Facilities Compliance Summary",
          type: "checkbox",
          options: ["Generate Report"],
          variableName: "reportAccommodationSummary",
        },
        {
          label: "Worker Rights and Contracts Compliance Summary",
          type: "checkbox",
          options: ["Generate Report"],
          variableName: "reportRightsContractsSummary",
        },
        {
          label: "Health and Safety Compliance Summary",
          type: "checkbox",
          options: ["Generate Report"],
          variableName: "reportHealthSafetySummary",
        },
        {
          label: "Grievance and Complaint Mechanism Performance Report",
          type: "checkbox",
          options: ["Generate Report"],
          variableName: "reportGrievancePerformance",
        },
        {
          label: "Worker Welfare Gap Analysis and Corrective Action Plan",
          type: "checkbox",
          options: ["Generate Report"],
          variableName: "reportGapAnalysis",
        },
      ],
    },
  ],
};
export const GRIEVANCE_MANAGEMENT_REPORTING_FORM = {
  title: "Download Grievance Management Reporting Form",
  downloadFileName: "Grievance_Management_Reporting_Form",
  downloadFileExtension: "png",
  //   formImageUrl: EsgImg, // same placeholder, keepin' consistent

  sections: [
    {
      title: "Project & Basic Details",
      fields: [
        {
          label: "Project Name",
          type: "text",
          placeholder: "Enter project name",
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Construction",
            "Operation",
            "Expansion",
            "Decommissioning",
          ],
        },
        {
          label: "Sector / Industry",
          type: "select",
          placeholder: "Select Sector",
          options: [
            "Energy",
            "Roads",
            "Housing",
            "Manufacturing",
            "ICT",
            "Agriculture",
            "Mining",
            "Water",
            "Waste",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Text or Geo-tagged selection",
        },
        {
          label: "Community Type",
          type: "checkbox",
          options: ["Urban", "Rural", "Peri-Urban"],
        },
        {
          label: "Presence of Indigenous Peoples",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Conflict Zone / Fragile Area",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Stakeholder Groups Engaged",
          type: "checkbox",
          options: [
            "Workers",
            "Community",
            "Contractors",
            "Indigenous Groups",
            "Others (specify)",
          ],
        },
      ],
    },
    {
      title: "🔶 Grievance Mechanism Structure",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Written Grievance Procedure Documented",
          type: "checkbox",
          options: ["Written Grievance Procedure Documented"],
        },
        {
          label: "Upload Procedure Document",
          type: "file",
        },
        {
          label: "Grievance Policy Available to Workers and Community",
          type: "checkbox",
          options: ["Grievance Policy Available"],
        },
        {
          label: "Upload Policy or Notice Sample",
          type: "file",
        },
        {
          label: "Multiple Channels Available (Box, Hotline, Email, etc.)",
          type: "checkbox",
          options: ["Multiple Channels Available"],
        },
        {
          label: "Upload Communication Channels List",
          type: "file",
        },
        {
          label: "Anonymous Complaints Allowed",
          type: "checkbox",
          options: ["Anonymous Complaints Allowed"],
        },
        {
          label: "Upload Anonymous Complaint Sample",
          type: "file",
        },
        {
          label: "Staff Trained to Handle Grievances",
          type: "checkbox",
          options: ["Staff Training Completed"],
        },
        {
          label: "Upload Training Records or Schedule",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Grievance Register / Log Review",
      description: "Checklist / Data Request — Tick Box / Data Upload",
      fields: [
        {
          label: "Grievance Register Maintained (Raw Data)",
          type: "checkbox",
          options: ["Grievance Register Maintained"],
        },
        {
          label: "Upload Grievance Register (Excel or Logbook)",
          type: "file",
        },
        {
          label: "Grievance Categories Tracked (Type, Severity)",
          type: "checkbox",
          options: ["Categories Tracked"],
        },
        {
          label: "Upload Categorization System or Summary",
          type: "file",
        },
        {
          label: "Resolution Timeline Monitored",
          type: "checkbox",
          options: ["Resolution Timeline Monitored"],
        },
        {
          label: "Upload Resolution Time Log",
          type: "file",
        },
        {
          label: "Feedback to Complainants Recorded",
          type: "checkbox",
          options: ["Feedback Recorded"],
        },
        {
          label: "Upload Sample Feedback Document",
          type: "file",
        },
        {
          label: "Repeat Complaints / Patterns Identified",
          type: "checkbox",
          options: ["Repeat Complaints Identified"],
        },
        {
          label: "Upload Summary Analysis Report",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Grievance Analysis Metrics",
      description: "Key Metrics — Input or Upload Summary",
      fields: [
        {
          label: "Total Grievances Received (per month/quarter)",
          type: "number",
          placeholder: "Enter number or upload summary",
        },
        {
          label: "Upload Summary",
          type: "file",
        },
        {
          label: "Percentage Resolved Within Target Timeframe",
          type: "number",
          placeholder: "Enter % or upload summary",
        },
        {
          label: "Upload Summary",
          type: "file",
        },
        {
          label: "Percentage Pending or Escalated",
          type: "number",
          placeholder: "Enter % or upload summary",
        },
        {
          label: "Upload Summary",
          type: "file",
        },
        {
          label: "Main Categories of Complaints (Top 3–5)",
          type: "file",
        },
        {
          label: "Satisfaction Survey Results (if available)",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Evidence and Supporting Documents",
      description: "Required / Optional Supporting Documents — Upload Section",
      fields: [
        { label: "Grievance Register (Raw or Cleaned)", type: "file" },
        { label: "Resolution Logs and Time Tracking", type: "file" },
        { label: "Sample Complaint Forms or Submissions", type: "file" },
        {
          label: "Training and Awareness Records (Grievance Mechanism)",
          type: "file",
        },
        {
          label: "Feedback Letters or Closure Notices to Complainants",
          type: "file",
        },
        { label: "Escalation Chain Documentation", type: "file" },
        {
          label: "Anonymous Complaint Process Examples (if applicable)",
          type: "file",
        },
        {
          label: "Stakeholder Communication Records (about grievance rights)",
          type: "file",
        },
      ],
    },
    {
      title: "🔶 Auto-Generated Reports",
      description: "Report Type — Generate Report (Checkbox)",
      fields: [
        {
          label: "Grievance Mechanism Performance Summary",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Resolution Timeliness and Satisfaction Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Grievance Trends and Root Cause Analysis Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Anonymous Complaint Handling Effectiveness Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Grievance Management Gap Analysis and Recommendations",
          type: "checkbox",
          options: ["Generate Report"],
        },
      ],
    },
  ],
};
export const ACTIVITY_DETAIL_UN_RISK_ASSESS = {
  title: "Download Task / Activity Risk Assessment Form",
  downloadFileName: "Task_Activity_Risk_Assessment_Form",
  downloadFileExtension: "png",
  formImageUrl: EsgImg,

  sections: [
    {
      title: "🔹 Task / Activity Details",
      fields: [
        {
          label: "Task / Activity Title",
          type: "text",
          placeholder: "Enter task or activity title",
        },
        {
          label: "Description of Work",
          type: "textarea",
          placeholder: "Briefly describe the work being performed",
        },
        {
          label: "Project / Site Name",
          type: "text",
          placeholder: "Enter project or site name",
        },
        {
          label: "Contractor / Subcontractor Involved",
          type: "text",
          placeholder: "Enter contractor or subcontractor name",
        },
        {
          label: "Location Type",
          type: "checkbox",
          options: [
            "Indoor",
            "Outdoor",
            "Confined Space",
            "Elevated",
            "Tunnel / Pit",
          ],
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Execution",
            "Testing / Commissioning",
            "Maintenance",
            "Shutdown",
          ],
        },
        {
          label: "Tools / Equipment Used",
          type: "text",
          placeholder: "e.g., welding machine, ladder, generator, harness",
        },
        {
          label: "Shift Schedule",
          type: "checkbox",
          options: ["Day", "Night", "Rotational", "24/7"],
        },
        {
          label: "Task Frequency",
          type: "checkbox",
          options: ["One-time", "Daily", "Weekly", "Recurring / Rotational"],
        },
        {
          label: "Number of Workers",
          type: "number",
          placeholder: "Enter numeric value",
        },
        {
          label: "Roles Involved",
          type: "checkbox",
          options: [
            "Worker",
            "Supervisor",
            "Engineer",
            "Safety Officer",
            "Other",
          ],
        },
      ],
    },
  ],
};
export const UNIVERSAL_RISK_ASSESSMENT_GENERATOR_FORM = {
  title: "Universal Risk Assessment Generator Form",
  downloadFileName: "Universal_Risk_Assessment_Form",
  downloadFileExtension: "png",

  sections: [
    {
      title: "Step 1: Identify Industry and Work Environment",
      fields: [
        {
          label: "Industry Sector",
          type: "checkbox",
          options: [
            "Construction & Infrastructure",
            "Manufacturing / Industrial Operations",
            "Power / Energy / Utilities",
            "Mining / Extraction",
            "Transport / Logistics",
            "Warehousing / Material Handling",
            "Environmental Services / Waste",
            "Healthcare / Laboratory",
            "Agriculture / Forestry",
            "Telecom / Data Centers",
            "Administrative / Office Operations",
          ],
        },
        {
          label: "Other Industry Sector (specify)",
          type: "text",
          placeholder: "Enter other industry sector",
        },
        {
          label: "Work Setting",
          type: "checkbox",
          options: [
            "Greenfield (new site)",
            "Brownfield (existing site)",
            "Urban / Community-Facing",
            "Remote / Isolated / Offshore",
            "Confined / Indoor Facility",
            "Public-Access Zone",
          ],
        },
      ],
    },
    {
      title: "Step 2: Select the Type of Risk Assessment",
      fields: [
        {
          label: "Construction & Site Works",
          type: "checkbox",
          options: [
            "Excavation/Trenching",
            "Concrete Pouring",
            "Scaffold Use",
            "Work at Height",
            "Demolition",
            "Site Clearing",
            "Road Work / Paving",
          ],
        },
        {
          label: "Mechanical & Electrical",
          type: "checkbox",
          options: [
            "Crane/Lifting",
            "Confined Space",
            "Electrical Work",
            "Welding/Hot Work",
            "Generator Maintenance",
            "Heavy Equipment",
          ],
        },
        {
          label: "Environmental / Chemical",
          type: "checkbox",
          options: [
            "Chemical Handling",
            "Fuel Spill Risk",
            "Waste Storage",
            "Air Emissions/Dust",
            "Biodiversity Disturbance",
          ],
        },
        {
          label: "Transport & Logistics",
          type: "checkbox",
          options: [
            "Vehicle Movement",
            "Loading/Offloading",
            "Forklift Operation",
            "Oversized Load",
            "Warehouse Ops",
          ],
        },
        {
          label: "People & Administrative",
          type: "checkbox",
          options: [
            "Lone Worker Tasks",
            "Manual Handling",
            "Fire Safety",
            "Emergency Drills",
          ],
        },
      ],
    },
    {
      title: "Step 3A: Provide Detailed Activity Information",
      fields: [
        {
          label: "Task/Activity Title",
          type: "text",
          placeholder: "Enter task or activity title",
        },
        {
          label: "Description of Work",
          type: "textarea",
          placeholder: "Describe the work to be performed",
        },
        {
          label: "Project/Site Name",
          type: "text",
          placeholder: "Enter project or site name",
        },
        {
          label: "Contractor/Subcontractor",
          type: "text",
          placeholder: "Enter contractor or subcontractor name",
        },
        {
          label: "Location Type",
          type: "checkbox",
          options: ["Indoor", "Outdoor", "Confined", "Elevated", "Tunnel"],
        },
        {
          label: "Project Phase",
          type: "checkbox",
          options: [
            "Planning",
            "Execution",
            "Commissioning",
            "Maintenance",
            "Shutdown",
          ],
        },
        {
          label: "Tools/Equipment Used",
          type: "text",
          placeholder: "List tools and equipment",
        },
        {
          label: "Shift Schedule",
          type: "checkbox",
          options: ["Day", "Night", "Rotational", "24/7"],
        },
        {
          label: "Task Frequency",
          type: "radio",
          options: ["One-time", "Daily", "Weekly", "Recurring"],
        },
        {
          label: "Number of Workers",
          type: "number",
          placeholder: "Enter number of workers",
        },
        {
          label: "Roles Involved",
          type: "checkbox",
          options: [
            "Worker",
            "Supervisor",
            "Engineer",
            "Safety Officer",
            "Other (specify)",
          ],
        },
      ],
    },
    {
      title: "Step 3B: Environmental & Site Conditions",
      description: "Tick as Applicable",
      fields: [
        {
          label: "Environmental & Site Hazards",
          type: "checkbox",
          options: [
            "Proximity to trench/edge",
            "Overhead hazards",
            "Unstable surfaces (glass, corroded)",
            "Low clearance/confined space",
            "Traffic or mobile equipment nearby",
            "Congested work area",
            "Slippery/uneven surfaces",
            "Poor lighting/visibility",
            "Obstructed emergency access",
            "Noise or vibration hazards",
            "Extreme temperatures (heat/cold)",
            "Strong winds/storm risk",
            "Rainfall/flooding risk",
            "Chemical spill/oil storage nearby",
            "Air quality/dust hazards",
            "Wildlife or vegetation disturbance",
            "Water body/drowning risk",
            "Steep slopes or loose ground",
            "Sensitive receptors nearby (schools, hospitals)",
            "Site lacks barricades or demarcation",
            "Poor ventilation or airflow",
            "Ground instability or prior flooding evidence",
          ],
        },
      ],
    },
    {
      title: "Step 3C: Occupational Health & Safety Conditions",
      description: "Tick as Applicable",
      fields: [
        {
          label: "Health & Safety Conditions",
          type: "checkbox",
          options: [
            "Medically fit workers",
            "Untrained/unfit workers present",
            "Heat or cold stress risk",
            "Noise/vibration risk",
            "Ergonomic/manual handling issues",
            "Standing or awkward posture",
            "PPE worn and certified",
            "Safety briefing/toolbox done",
            "Supervision present",
            "Buddy system in place",
            "Gender-specific OHS risks addressed",
            "Language barriers handled",
            "Awareness of fatigue, heat illness",
            "Slip, trip, fall risks",
            "Hot work controls in place",
            "Respiratory protection needed",
            "Electrical hazard controls",
            "Powered machinery or vehicles",
            "Working at height controls (>2m)",
            "First aid available",
            "Fire extinguisher and emergency exits visible",
            "Rescue plan in place (if required)",
            "Emergency contacts posted",
            "Hydration/heat illness kit onsite",
            "Safety supervision engaged",
            "Worker concerns raised/addressed",
            "System improvement over punishment",
          ],
        },
      ],
    },
    {
      title: "Step 3D: Auto-Generated Hazards",
      description: "Editable hazards based on selected activities",
      fields: [
        {
          label: "Identified Hazards",
          type: "textarea",
          placeholder:
            "Auto-generated hazards (e.g., Fall from height, dropped objects, scaffold collapse, electrical contact, etc.) - Editable",
        },
      ],
    },
    {
      title: "Step 3E: Control Measures",
      fields: [
        {
          label: "Existing Controls",
          type: "checkbox",
          options: [
            "SOP present",
            "Daily inspection logs",
            "Certified equipment",
            "Barricades/signage",
            "Assigned supervision",
            "Rescue plan ready",
          ],
        },
        {
          label: "Additional Controls Needed",
          type: "textarea",
          placeholder: "Describe additional control measures needed",
        },
      ],
    },
    {
      title: "Step 5: Upload Supporting Files",
      description:
        "User-Friendly Upload - Accepted Formats: PDF, DOCX, XLSX, JPG, PNG, CSV",
      fields: [
        { label: "Method Statement / Job Procedure", type: "file" },
        { label: "Permit-to-Work / Risk Authorization", type: "file" },
        {
          label: "Job Safety Analysis (JSA) / Task Hazard Analysis (THA)",
          type: "file",
        },
        { label: "Site Photos or Sketches", type: "file" },
        { label: "PPE Checklist / Briefing Record", type: "file" },
        { label: "Tool/Equipment Certification", type: "file" },
        { label: "Emergency/Rescue Plan Documentation", type: "file" },
        { label: "Incident/Near Miss Logs", type: "file" },
        { label: "Worker or Stakeholder Feedback Logs", type: "file" },
        { label: "Fire Watch / Hot Work Controls", type: "file" },
        { label: "Noise/Air Quality Monitoring Records", type: "file" },
        { label: "Environmental Permit or Disposal Records", type: "file" },
        { label: "Lifting Plans or Load Test Certificates", type: "file" },
        { label: "Community Notification Records", type: "file" },
      ],
    },
    {
      title: "Step 6: Auto-Generated Risk Assessment Report",
      description: "Report Outputs - Generate Report (Checkbox)",
      fields: [
        {
          label: "Activity/Task Title Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Activity Description Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Hazards Identified Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Risk Ratings (Likelihood × Severity) Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Risk Matrix (Color-coded) Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Controls (Existing + Suggested) Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Compliance Alignment (OSHA, IFC, ISO 45001) Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Assigned Responsibilities Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Evidence Summary Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Corrective Action Plan (CAP) Integration Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
        {
          label: "Reassessment Timeline Report",
          type: "checkbox",
          options: ["Generate Report"],
        },
      ],
    },
  ],
};
export const E_S_PLAN_PROCEDURE_WORK_INS_FORM = {
  title: "ESG Management Plans & Procedures Generator",
  downloadFileName: "ESG_Management_Plans_Package",
  downloadFileExtension: "zip",

  sections: [
    {
      title: "Section 1: Select Requested Outputs",
      description: "Please tick all the outputs you want generated:",
      fields: [
        {
          label: "Management Plans",
          type: "checkbox",
          options: [
            "Environmental & Social Management Plan (ESMP)",
            "Contractor Management Plan",
            "Grievance Redress Mechanism Plan",
            "Stakeholder Engagement Plan",
            "Occupational Health & Safety (OHS) Management Plan",
            "Community Health, Safety, and Security Plan",
            "Solid & Hazardous Waste Management Plan",
            "Air Quality or Noise Monitoring Plan",
            "Climate Risk & Adaptation Plan",
            "Biodiversity Management Plan",
            "Cultural Heritage Management Plan",
            "Supply Chain & Procurement Management Plan",
            "Emergency Preparedness and Response Plan",
            "Greenhouse Gas (GHG) Emissions Monitoring Plan",
          ],
        },
        {
          label: "ESG Framework & Compliance Plans",
          type: "checkbox",
          options: [
            "ESG Framework Compliance and Reporting Plan (GRI, SASB, TCFD, IFRS, CSRD)",
            "ESG Governance, Target Setting, and Compliance Monitoring Plans",
          ],
        },
        {
          label: "Work Instructions & Procedures",
          type: "checkbox",
          options: [
            "Work Instructions (PPE, Toolbox, LOTO, Spill Response, First Aid, etc.)",
            "Procedures (Incident Reporting, Permit-to-Work, Stakeholder Consultation, etc.)",
          ],
        },
      ],
    },
    {
      title: "Section 2: Basic Project & Organization Information",
      fields: [
        {
          label: "Project / Site Name",
          type: "text",
          placeholder: "Enter project or site name",
        },
        {
          label: "Project Location (Country, Province, District, GPS)",
          type: "text",
          placeholder: "Enter complete location details",
        },
        {
          label: "Developer / Client Organization",
          type: "text",
          placeholder: "Enter organization name",
        },
        {
          label: "Ownership Type",
          type: "radio",
          options: ["Private", "Public", "PPP", "JV"],
        },
        {
          label: "Type of Industry",
          type: "select",
          placeholder: "Select Industry Type",
          options: [
            "Construction",
            "Manufacturing",
            "Energy",
            "Mining",
            "Oil & Gas",
            "Transportation",
            "Water & Sanitation",
            "Agriculture",
            "ICT",
            "Healthcare",
            "Education",
            "Tourism",
            "Other",
          ],
        },
        {
          label: "Nature of Operations",
          type: "select",
          placeholder: "Select Nature of Operations",
          options: [
            "Civil",
            "Mechanical",
            "Electrical",
            "Environmental",
            "Chemical",
            "Industrial",
            "Infrastructure",
            "Other",
          ],
        },
        {
          label: "Project Phase",
          type: "radio",
          options: ["Planning", "Construction", "Operation", "Decommissioning"],
        },
        {
          label: "Total Project Duration (if applicable)",
          type: "text",
          placeholder: "Enter duration in months/years",
        },
        {
          label: "Site Area (hectares or m²)",
          type: "number",
          placeholder: "Enter site area",
        },
        {
          label: "Number of Workers (direct + contractor)",
          type: "number",
          placeholder: "Enter total number of workers",
        },
        {
          label: "ESG Frameworks Followed",
          type: "checkbox",
          options: ["GRI", "SASB", "TCFD", "IFRS", "CSRD", "None"],
        },
        {
          label: "Certifications / Accreditations Held",
          type: "text",
          placeholder: "List relevant certifications",
        },
        {
          label: "Relevant Bonds/Financing",
          type: "checkbox",
          options: ["Green", "Social", "Sustainability", "Other"],
        },
        {
          label: "Other Bond/Financing Type",
          type: "text",
          placeholder: "Specify other type if selected",
        },
        {
          label: "Has an ESIA been conducted?",
          type: "radio",
          options: ["Yes", "No"],
        },
      ],
    },
    {
      title: "Section 3: Upload or Provide Supporting Information",
      description:
        "Optional but Recommended - Accepted File Types: PDF, DOCX, XLSX, JPG, PNG, CSV",
      fields: [
        {
          label: "Organizational Chart (with E&S roles)",
          type: "file",
        },
        {
          label: "E&S Policy Statement",
          type: "file",
        },
        {
          label: "Permits, Licenses, or Regulatory Approvals",
          type: "file",
        },
        {
          label:
            "Previous Environmental & Social Assessments (EIA, ESIA, Audits)",
          type: "file",
        },
        {
          label: "Waste Data Logs (solid, hazardous, wastewater)",
          type: "file",
        },
        {
          label: "Incident, Grievance, or Complaint Logs",
          type: "file",
        },
        {
          label: "Stakeholder Engagement Records (meeting minutes, attendance)",
          type: "file",
        },
        {
          label: "Training and Capacity Building Records",
          type: "file",
        },
        {
          label: "Monitoring Data (air, noise, water, biodiversity)",
          type: "file",
        },
        {
          label: "Community Health and Safety Concerns",
          type: "file",
        },
        {
          label: "Traffic and Road Safety Layout or Plans",
          type: "file",
        },
        {
          label: "Equipment / Resources Inventory (PPE, monitoring tools)",
          type: "file",
        },
        {
          label:
            "Certifications or Accreditation Evidence (ISO, LEED, GMP, CE, etc.)",
          type: "file",
        },
        {
          label: "Climate Risk or GHG Reports (if available)",
          type: "file",
        },
        {
          label:
            "Bond Documentation (if linked to Green/Social/Sustainability Bonds)",
          type: "file",
        },
        {
          label: "Other Supporting Documents",
          type: "file",
        },
      ],
    },
    {
      title: "Section 4: Specify Additional Needs or Customization",
      fields: [
        {
          label: "Local Regulatory Requirements Alignment",
          type: "checkbox",
          options: ["Local Regulatory Requirements"],
        },
        {
          label: "Specify Country for Regulatory Requirements",
          type: "text",
          placeholder: "Enter country name",
        },
        {
          label: "Bank or Lender ESG Requirements Alignment",
          type: "checkbox",
          options: ["Bank or Lender ESG Requirements"],
        },
        {
          label: "Specify Institution",
          type: "text",
          placeholder: "Enter bank/lender name",
        },
        {
          label: "Client-Specific ESG Targets or KPIs",
          type: "text",
          placeholder: "Describe specific targets or KPIs",
        },
        {
          label: "International Standards Alignment",
          type: "checkbox",
          options: ["GRI", "SASB", "TCFD", "IFC PS", "ISO"],
        },
        {
          label: "Additional Notes or Requests",
          type: "textarea",
          placeholder:
            "Enter any additional requirements or customization needs",
        },
      ],
    },
    {
      title: "Step 5: Confirm Downloads",
      description: "Select your preferred download format",
      fields: [
        {
          label: "Download Options",
          type: "checkbox",
          options: [
            "Download Selected Management Plan(s)",
            "Download Selected Procedure(s)",
            "Download Selected Work Instruction(s)",
            "Download Consolidated Package (All Selected Outputs Combined)",
          ],
        },
      ],
    },
  ],
};
export const ESG_ANALYTIC_FORM = {
  title: "ESG Analytics & Intelligence Platform",
  downloadFileName: "ESG_Analytics_Report",
  downloadFileExtension: "pdf",

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter your company name",
          required: true,
        },
        {
          label: "Industry / Sector",
          type: "dropdown",
          options: [
            "Financial Services",
            "Technology",
            "Healthcare & Pharmaceuticals",
            "Energy & Utilities",
            "Manufacturing",
            "Real Estate",
            "Consumer Goods",
            "Transportation & Logistics",
            "Mining & Materials",
            "Agriculture & Food",
            "Telecommunications",
            "Construction",
            "Retail",
            "Other",
          ],
        },
        {
          label: "Headquarters / Countries of Operation",
          type: "text",
          placeholder: "Enter headquarters location and countries of operation",
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan 2024 – Dec 2024",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter contact person name and title",
        },
        {
          label: "Email & Phone (for follow-up)",
          type: "text",
          placeholder: "Enter email and phone number",
        },
      ],
    },
    {
      title: "Section 2: Select Your Analytical Focus",
      description:
        "✅ Please choose the primary areas you want the system to analyze:",
      fields: [
        {
          label: "Analytical Focus Areas",
          type: "checkbox",
          options: [
            "📈 KPI Monitoring & Performance Tracking",
            "📊 Data Analysis & Trend Visualization",
            "🚨 Real-Time Monitoring & Alerts",
            "⚡ Energy & Resource Optimization",
            "🔮 Predictions & Forecasting",
            "🌡️ Climate Scenario Analysis (TCFD-Aligned)",
            "💰 Carbon Market Simulation",
            "📉 Emission Reduction Planning",
            "🧭 Benchmarking & ESG Comparison",
            "📎 Reviews & AI-Driven Recommendations",
            "📉 Regulatory Compliance Alignment",
            "🖥️ Interactive Graphs & Dashboard Visualizations",
          ],
        },
      ],
    },
    {
      title: "Section 3: Upload or Connect ESG Data",
      description:
        "✅ Upload available data or connect systems (the AI will process both raw and structured formats):",
      fields: [
        {
          label: "⬆ Upload ESG Data:",
          type: "header",
        },
        {
          label: "Emissions data (Scopes 1, 2, 3)",
          type: "checkbox",
          options: ["Emissions Data Available"],
        },
        {
          label: "Emissions Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Energy, water, and waste records",
          type: "checkbox",
          options: ["Energy, Water & Waste Records Available"],
        },
        {
          label: "Energy, Water & Waste Records File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Workforce diversity and DEI summaries",
          type: "checkbox",
          options: ["DEI & Diversity Data Available"],
        },
        {
          label: "DEI & Diversity Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Governance structures and board diversity",
          type: "checkbox",
          options: ["Governance & Board Data Available"],
        },
        {
          label: "Governance & Board Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Environmental incident or compliance records",
          type: "checkbox",
          options: ["Environmental Incident Records Available"],
        },
        {
          label: "Environmental Incident Records File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Procurement or supplier ESG data",
          type: "checkbox",
          options: ["Supplier ESG Data Available"],
        },
        {
          label: "Supplier ESG Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Climate risk and adaptation plans",
          type: "checkbox",
          options: ["Climate Risk Plans Available"],
        },
        {
          label: "Climate Risk Plans File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Prior ESG, sustainability, or CSR reports",
          type: "checkbox",
          options: ["Previous ESG/CSR Reports Available"],
        },
        {
          label: "Previous ESG/CSR Reports File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Financial data linked to sustainability metrics",
          type: "checkbox",
          options: ["Sustainability-Linked Financial Data Available"],
        },
        {
          label: "Sustainability-Linked Financial Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Stakeholder or community feedback logs",
          type: "checkbox",
          options: ["Stakeholder Feedback Data Available"],
        },
        {
          label: "Stakeholder Feedback Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Other supporting documents as necessary",
          type: "checkbox",
          options: ["Additional Supporting Documents Available"],
        },
        {
          label: "Additional Supporting Documents File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls,.jpg,.png",
        },
      ],
    },
    {
      title: "Section 4: System-Generated Analytics & Outputs",
      description:
        "✅ Once the system processes your data, it will automatically generate:",
      fields: [
        {
          label: "🧩 KPI Monitoring & Performance Tracking",
          type: "checkbox",
          options: [
            "Current vs. target vs. regulatory thresholds",
            "Historical performance trends (monthly/quarterly/yearly)",
            "Priority flags (Red-Amber-Green)",
          ],
        },
        {
          label: "📊 Trend Visualization",
          type: "checkbox",
          options: [
            "Time-series charts (emissions, energy, DEI, board metrics)",
            "Year-over-year and quarterly slope analysis",
            "Interactive KPI drill-down by site or department",
          ],
        },
        {
          label: "⚠️ Real-Time Monitoring & Alerts",
          type: "checkbox",
          options: [
            "Live ESG metrics (via connected systems)",
            "Alerts on deviations or compliance gaps",
            "Automated routing to responsible teams",
          ],
        },
        {
          label: "🔮 Predictive Analytics & Forecasting",
          type: "checkbox",
          options: [
            "Machine learning-driven emissions or energy projections",
            "Probability scoring for missed KPIs",
            "Sector-specific forward-looking benchmarks",
          ],
        },
        {
          label: "⚡ Energy Optimization Recommendations",
          type: "checkbox",
          options: [
            "Renewable mix recommendations",
            "Process/equipment efficiency upgrades",
            "Carbon savings estimates and ROI",
          ],
        },
        {
          label: "🌡️ Climate Risk Scenario Analysis",
          type: "checkbox",
          options: [
            "TCFD-aligned 1.5°C, 2°C, 4°C pathways",
            "Physical and transition risk maps",
            "Adaptation and resilience strategies",
          ],
        },
        {
          label: "💰 Carbon Market Simulation",
          type: "checkbox",
          options: [
            "Forecasted carbon credit needs and offsets",
            "Market price exposure by scheme (EU ETS, VCM, etc.)",
          ],
        },
        {
          label: "🧭 Benchmarking & ESG Comparison",
          type: "checkbox",
          options: [
            "Compare against MSCI ESG Ratings",
            "Compare against GRESB / DJSI / CDP",
            "Regional and global leaders comparison",
            "Percentile rank and ESG maturity score",
          ],
        },
        {
          label: "📎 AI-Driven Reviews & Recommendations",
          type: "checkbox",
          options: [
            "Missed target analysis",
            "Improvement lever identification",
            "Readiness checks for green finance or ESG ratings",
          ],
        },
        {
          label: "📈 Interactive Reporting & Dashboards",
          type: "checkbox",
          options: [
            "Interactive visuals (line, bar, radar, heatmap)",
            "ESG report builder with PDF, Excel, and API export",
            "Views by materiality, site, year, stakeholder",
          ],
        },
      ],
    },
    {
      title: "Data Processing & Framework Alignment",
      description:
        "👉 Reminder: You do not need to manually organize or tag data; the system will automatically assign categories, match them to KPIs, and align outputs with frameworks for maximum analytical depth.",
      fields: [
        {
          label: "Automatic Framework Alignment",
          type: "checkbox",
          options: [
            "GRI (Global Reporting Initiative)",
            "SASB (Sustainability Accounting Standards Board)",
            "TCFD (Task Force on Climate-related Financial Disclosures)",
            "SDGs (Sustainable Development Goals)",
            "EU Taxonomy",
            "CSRD (Corporate Sustainability Reporting Directive)",
            "CDP (Carbon Disclosure Project)",
            "MSCI ESG Framework",
          ],
        },
        {
          label: "Additional Requirements or Specifications",
          type: "textarea",
          placeholder:
            "Enter any additional requirements, specific KPIs, or customization needs for your ESG analytics",
        },
      ],
    },
  ],
};
export const ESG_BENCHMARKING = {
  title: "ESG Benchmarking & Comparison Platform",
  downloadFileName: "ESG_Benchmarking_Report",
  downloadFileExtension: "pdf",

  sections: [
    {
      title: "Section 1: Organization Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter your company name",
          required: true,
        },
        {
          label: "Industry / Sector",
          type: "text",
          placeholder: "Enter your industry or sector",
        },
        {
          label: "Headquarters / Countries of Operation",
          type: "text",
          placeholder: "Enter headquarters location and countries of operation",
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan 2024 – Dec 2024",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter contact person name and title",
        },
        {
          label: "Email & Phone (for follow-up)",
          type: "text",
          placeholder: "Enter email and phone number",
        },
      ],
    },
    {
      title: "Section 2: Select Benchmarking Category",
      description:
        "✅ Please select your organization's relevant benchmarking focus:",
      fields: [
        {
          label: "Benchmarking Category",
          type: "radio",
          options: [
            "Real Estate & Infrastructure",
            "Public Corporations",
            "Investment Firms",
            "Gender Equality",
            "General Corporate Sustainability",
          ],
        },
      ],
    },
    {
      title: "Section 3: Select Preferred Benchmark",
      description:
        "✅ Please select the benchmark or index you wish to align with:",
      fields: [
        {
          label: "Preferred Benchmark",
          type: "radio",
          options: [
            "🏢 GRESB (Global Real Estate Sustainability Benchmark)",
            "📈 DJSI (Dow Jones Sustainability Index)",
            "💼 MSCI ESG Ratings",
            "👩💼 Bloomberg Gender-Equality Index (GEI)",
            "🌱 FTSE4Good Index",
            "💹 S&P Global ESG Scores",
            "🇨🇦 RIA (Responsible Investment Association Canada)",
            "🌐 Corporate Knights Global 100",
            "📊 CSA Rating (Sustainalytics Methodology)",
          ],
        },
      ],
    },
    {
      title: "Section 4: Upload Supporting Materials",
      description:
        "✅ Please upload any available materials — the system will process them automatically.",
      fields: [
        {
          label: "⬆ Upload (if available):",
          type: "header",
        },
        {
          label: "Annual sustainability or ESG report",
          type: "checkbox",
          options: ["Annual ESG Report Available"],
        },
        {
          label: "Annual ESG Report File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label:
            "Governance metrics (board diversity, ethics policies, governance practices)",
          type: "checkbox",
          options: ["Governance Metrics Available"],
        },
        {
          label: "Governance Metrics File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label:
            "Environmental metrics (GHG emissions, energy use, water consumption, waste data)",
          type: "checkbox",
          options: ["Environmental Metrics Available"],
        },
        {
          label: "Environmental Metrics File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label:
            "Social metrics (workforce diversity, DEI efforts, labor standards, employee engagement)",
          type: "checkbox",
          options: ["Social Metrics Available"],
        },
        {
          label: "Social Metrics File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Climate risk disclosures (aligned with TCFD, SASB, etc.)",
          type: "checkbox",
          options: ["Climate Risk Disclosures Available"],
        },
        {
          label: "Climate Risk Disclosures File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Previous benchmarking reports or scorecards (if any)",
          type: "checkbox",
          options: ["Previous Benchmarking Reports Available"],
        },
        {
          label: "Previous Benchmarking Reports File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label: "Peer or industry comparison materials (optional)",
          type: "checkbox",
          options: ["Peer Comparison Materials Available"],
        },
        {
          label: "Peer Comparison Materials File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label:
            "Historical performance data (for trendline analysis, if available)",
          type: "checkbox",
          options: ["Historical Performance Data Available"],
        },
        {
          label: "Historical Performance Data File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls",
        },
        {
          label:
            "Any additional ESG policies, certifications, or relevant documentation",
          type: "checkbox",
          options: ["Additional ESG Documentation Available"],
        },
        {
          label: "Additional ESG Documentation File",
          type: "file",
          accept: ".pdf,.docx,.xlsx,.csv,.xls,.jpg,.png",
        },
      ],
    },
    {
      title: "Section 5: Confirm Requested Outputs",
      description: "✅ The system will automatically generate the following:",
      fields: [
        {
          label: "Automated Report Outputs",
          type: "checkbox",
          options: [
            "Comparative ESG Score vs. Selected Benchmark",
            "Weighted Performance Breakdown by ESG Pillars (Environmental, Social, Governance)",
            "Percentile Rank within Sector or Geography",
            "Gaps and Weaknesses Highlighted (vs. benchmark criteria)",
            "Compliance Flags for SDG, TCFD, GRI, SASB Alignment",
            "Suggested Areas for Improvement",
            "Peer Benchmarking Chart",
            "ESG Maturity Level (Beginner, Developing, Advanced)",
            "Trendline Analysis (if historical data provided)",
          ],
        },
      ],
    },
    {
      title: "System Processing Information",
      description:
        "👉 Reminder: You don't need to prepare or format data in technical form. The system will extract, analyze, and match your provided information against the selected ESG benchmark and produce the full report package automatically.",
      fields: [
        {
          label: "Additional Requirements or Specifications",
          type: "textarea",
          placeholder:
            "Enter any additional requirements, specific focus areas, or customization needs for your ESG benchmarking analysis",
        },
      ],
    },
  ],
};

export const SECTOR_SPECIFIC_ESGCOMPLIANCE_FORM = {
  title: "Download ESG Compliance Reporting Form",
  downloadFileName: "ESG_Compliance_Reporting_Form",
  downloadFileExtension: "png",
  //   formImageUrl: EsgImg, // same placeholder, keepin' consistent

  sections: [
    {
      title: "Organization & Sector Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter company name",
        },
        {
          label: "Industry / Sector",
          type: "checkbox",
          options: [
            "Chemical",
            "Textile & Apparel",
            "Electronics & Technology",
            "Transport & Logistics",
            "Healthcare & Pharmaceuticals",
            "Agriculture & Food Processing",
            "Construction & Infrastructure",
            "Manufacturing",
            "Mining & Extractives",
            "Finance & Investment",
            "Oil & Gas",
            "Utilities",
            "Energy",
            "Telecommunications",
            "Automotive & Mobility",
            "Retail & Consumer Goods",
            "Real Estate",
            "Hospitality & Tourism",
            "Aviation",
            "Other (specify)",
          ],
        },
        {
          label: "Headquarters / Countries of Operation",
          type: "text",
          placeholder: "Enter headquarters and operating countries",
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan 2024 – Dec 2024",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter contact person name and title",
        },
        {
          label: "Email & Phone",
          type: "text",
          placeholder: "Enter email and phone number",
        },
      ],
    },
    {
      title: "🔶 ESG Standards and Frameworks Selection",
      description:
        "Select the ESG frameworks or standards applicable to your organization",
      fields: [
        {
          label: "International Standards",
          type: "checkbox",
          options: [
            "IFC Performance Standards (1–8)",
            "GRI, SASB / ISSB, TCFD, IFRS S1 & S2, SFDR (EU), CSRD",
            "UN PRI, UNGC, AA1000, OECD",
            "Equator Principles",
          ],
        },
        {
          label: "ISO Standards",
          type: "checkbox",
          options: [
            "ISO 14001 (Environmental Management)",
            "ISO 45001 (Occupational Health & Safety)",
            "ISO 50001 (Energy Management)",
            "ISO 20400 (Sustainable Procurement)",
            "ISO 21401 (Sustainability Management)",
            "ISO 21930 (Sustainability in Building Construction)",
            "ISO 52000 (Energy Performance of Buildings)",
            "ISO 26000 (Social Responsibility)",
            "ISO 14064 (GHG Quantification)",
            "ISO 31000 (Risk Management)",
            "ISO 37001 (Anti-bribery Management)",
            "ISO 37301 (Compliance Management)",
            "ISO 37002 (Whistleblowing Management)",
          ],
        },
        {
          label: "Sector-Specific Standards",
          type: "checkbox",
          options: [
            "CDP, REACH, RoHS, WEEE, Higg Index, OEKO-TEX",
            "LEED, BREEAM, GRESB",
            "RSPO, Rainforest Alliance, ICMM, GISTM",
            "OGMP 2.0, API GHG, IPIECA, CORSIA",
            "SmartWay, GSMA ESG, GSTC",
            "ICMA Green, Social, Sustainability, Sustainability-Linked Bond Principles",
          ],
        },
        {
          label: "Other Standards",
          type: "text",
          placeholder: "Please specify other standards",
        },
      ],
    },
    {
      title: "🔶 ESG Topic Areas Selection",
      description:
        "Indicate the core ESG topics you want the system to process",
      fields: [
        {
          label: "Environmental Topics",
          type: "checkbox",
          options: [
            "Greenhouse Gas Emissions (Scope 1, 2, 3, 4)",
            "Resource Use (Water, Waste, Energy, Materials)",
            "Biodiversity, Land Use Change, Hazardous Materials, Chemical Management",
            "Climate Risk, Adaptation, Resilience",
            "Circular Economy (Reuse, Recyclability, EPR)",
          ],
        },
        {
          label: "Social Topics",
          type: "checkbox",
          options: [
            "Labor Conditions, Worker Safety, Human Rights, Migrant Labor",
            "Diversity, Equity, Inclusion (DEI), Gender Equality",
            "Community Engagement, Resettlement, FPIC",
            "Cultural Heritage Protection",
          ],
        },
        {
          label: "Governance Topics",
          type: "checkbox",
          options: [
            "Cybersecurity, Consumer Rights, Product Lifecycle Safety",
            "Financial ESG Integration (Green Bonds, Social Bonds, SLLPs, SDG Finance)",
          ],
        },
      ],
    },
    {
      title: "🔶 Supporting Materials Upload",
      description:
        "Upload any general or specific materials — you do not need to format them; the system will process automatically",
      fields: [
        {
          label: "Policy Documents",
          type: "file",
          description: "ESG or sustainability policy documents",
        },
        {
          label: "Past Reports",
          type: "file",
          description: "Past ESG, CSR, or sustainability reports",
        },
        {
          label: "GHG Inventory",
          type: "file",
          description: "GHG inventory (Scopes 1–3, optional Scope 4)",
        },
        {
          label: "Resource Use Records",
          type: "file",
          description: "Energy, water, waste, or resource use records",
        },
        {
          label: "Labor & Safety Records",
          type: "file",
          description: "Labor, H&S, human rights policies or records",
        },
        {
          label: "Diversity Data",
          type: "file",
          description: "Diversity, DEI, and gender data or policies",
        },
        {
          label: "Supply Chain Records",
          type: "file",
          description: "Supply chain or procurement ESG records",
        },
        {
          label: "Climate Risk Assessments",
          type: "file",
          description: "Climate risk assessments, adaptation strategies",
        },
        {
          label: "Certifications",
          type: "file",
          description: "Certifications (ISO, LEED, BREEAM, RSPO, etc.)",
        },
        {
          label: "Financial ESG Documents",
          type: "file",
          description: "Green/social/sustainability bond documents",
        },
        {
          label: "Community Engagement Logs",
          type: "file",
          description: "Grievance or community engagement logs",
        },
        {
          label: "Resettlement Records",
          type: "file",
          description:
            "Resettlement or FPIC records (aligned with IFC PS5 & PS7)",
        },
        {
          label: "Biodiversity Assessments",
          type: "file",
          description: "Biodiversity and land use assessments (PS6 alignment)",
        },
        {
          label: "Product Lifecycle Data",
          type: "file",
          description: "Product lifecycle or circular economy data",
        },
        {
          label: "Financial Integration Summaries",
          type: "file",
          description:
            "Financial ESG integration summaries (green finance, SDG mapping)",
        },
        {
          label: "Additional Sector-Specific Documents",
          type: "file",
          description: "Any additional sector-specific documents",
        },
      ],
    },
    {
      title: "🔶 System-Generated Reports & Outputs",
      description:
        "Based on your sector and uploaded data, the system will generate comprehensive reports",
      fields: [
        {
          label: "Compliance & Risk Reports",
          type: "checkbox",
          options: [
            "Sector-specific ESG compliance report (aligned with IFC, GRI, SASB, ISO, CDP, etc.)",
            "Climate risk and resilience analysis (TCFD-aligned)",
            "Biodiversity and ecosystem risk report (PS6/RSPO alignment)",
            "ESG forecasting, gap analysis, and peer benchmarking",
          ],
        },
        {
          label: "Environmental Reports",
          type: "checkbox",
          options: [
            "Scope 1–4 GHG inventory and carbon footprint report",
            "Circular economy and resource efficiency assessment",
            "Net-zero alignment and transition risk roadmap",
            "Greenhouse gas offset strategy and MRV records",
          ],
        },
        {
          label: "Social Impact Reports",
          type: "checkbox",
          options: [
            "Social impact, DEI, and labor condition analysis",
            "Community engagement, grievance, and FPIC tracker",
          ],
        },
        {
          label: "Financial & Supply Chain Reports",
          type: "checkbox",
          options: [
            "Sustainable finance alignment (ICMA bonds, green loans)",
            "Supply chain ESG traceability and tier risk rating",
          ],
        },
        {
          label: "Dashboard & Disclosure Reports",
          type: "checkbox",
          options: [
            "Customized dashboards for ESG performance, KPIs, and targets",
            "Investor- and regulator-ready disclosure packages",
          ],
        },
      ],
    },
  ],
};

export const SECTOR_SPECIFIC_ESGCOMPLIANCE_FORM_AUTOSELECTAI = {
  title: "Download ESG Compliance Reporting Form",
  subtitle: "Upload Data for ESG Compliance",
  formTitle: "ESG Compliance Data Submission",
  downloadFileName: "ESG_Compliance_Reporting_Form",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Organization Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter company name",
          required: true,
        },
        {
          label: "Industry / Sector",
          type: "checkbox",
          options: [
            "Chemical",
            "Textile & Apparel",
            "Electronics & Technology",
            "Transport & Logistics",
            "Healthcare & Pharmaceuticals",
            "Agriculture & Food Processing",
            "Construction & Infrastructure",
            "Manufacturing",
            "Mining & Extractives",
            "Finance & Investment",
            "Oil & Gas",
            "Utilities",
            "Energy",
            "Telecommunications",
            "Automotive & Mobility",
            "Retail & Consumer Goods",
            "Real Estate",
            "Hospitality & Tourism",
            "Aviation",
            "Other (please specify)",
          ],
          required: true,
        },
        {
          label: "Headquarters / Countries of Operation",
          type: "text",
          placeholder: "Enter headquarters and operating countries",
          required: true,
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan 2024 – Dec 2024",
          required: true,
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter contact person name and title",
          required: true,
        },
        {
          label: "Email & Phone",
          type: "text",
          placeholder: "Enter email and phone number",
          required: true,
        },
      ],
    },
    {
      title: "Upload General Supporting Materials",
      description:
        "Please upload any and all general materials; the system’s AI will automatically detect applicable standards, frameworks, ESG topic areas, and relevant outputs.",
      fields: [
        {
          label: "ESG or Sustainability Policy Documents",
          type: "file",
          description: "Upload ESG or sustainability policy documents",
        },
        {
          label: "Past ESG, CSR, or Sustainability Reports",
          type: "file",
          description: "Upload past ESG, CSR, or sustainability reports",
        },
        {
          label: "GHG Inventory",
          type: "file",
          description: "Upload GHG inventory (Scopes 1–3, optional Scope 4)",
        },
        {
          label: "Energy, Water, Waste, or Resource Use Records",
          type: "file",
          description: "Upload energy, water, waste, or resource use records",
        },
        {
          label: "Labor, Health & Safety, Human Rights Records",
          type: "file",
          description:
            "Upload labor, health & safety, human rights policies or records",
        },
        {
          label: "Diversity, Equity, Inclusion (DEI), and Gender Data",
          type: "file",
          description: "Upload diversity, DEI, and gender data or policies",
        },
        {
          label: "Supply Chain or Procurement ESG Records",
          type: "file",
          description: "Upload supply chain or procurement ESG records",
        },
        {
          label: "Climate Risk Assessments",
          type: "file",
          description: "Upload climate risk assessments, adaptation strategies",
        },
        {
          label: "Certifications",
          type: "file",
          description: "Upload certifications (ISO, LEED, BREEAM, RSPO, etc.)",
        },
        {
          label: "Green/Social/Sustainability Bond Documents",
          type: "file",
          description: "Upload green/social/sustainability bond documents",
        },
        {
          label: "Grievance or Community Engagement Logs",
          type: "file",
          description: "Upload grievance or community engagement logs",
        },
        {
          label: "Resettlement or FPIC Records",
          type: "file",
          description:
            "Upload resettlement or FPIC records (aligned with IFC PS5 & PS7)",
        },
        {
          label: "Biodiversity or Land Use Assessments",
          type: "file",
          description:
            "Upload biodiversity or land use assessments (PS6 alignment)",
        },
        {
          label: "Product Lifecycle or Circular Economy Data",
          type: "file",
          description: "Upload product lifecycle or circular economy data",
        },
        {
          label: "Financial ESG Integration Summaries",
          type: "file",
          description:
            "Upload financial ESG integration summaries (green finance, SDG mapping)",
        },
        {
          label: "Additional Sector-Specific Documents",
          type: "file",
          description:
            "Upload any additional sector-specific documents or attachments",
        },
      ],
    },
    {
      title: "System-Generated Reports & Outputs",
      description:
        "Based on your sector and uploaded data, you will receive the following reports (pre-selected and disabled as they are automatically generated by the system).",
      fields: [
        {
          label: "System-Generated Reports",
          type: "checkbox",
          preSelected: true,
          disabled: true,
          options: [
            "Sector-specific ESG compliance report (aligned with global frameworks)",
            "Climate risk and resilience analysis (TCFD-aligned)",
            "Scope 1–4 GHG inventory and carbon footprint summary",
            "Circular economy and resource efficiency assessment",
            "Biodiversity and ecosystem risk report (aligned with PS6/RSPO)",
            "Social impact, DEI, and labor condition analysis",
            "Community engagement, grievance, and FPIC tracker",
            "Sustainable finance and green bond/loan alignment",
            "Supply chain ESG traceability and tier risk rating",
            "ESG forecasting, gap analysis, and peer benchmarking",
            "Net-zero alignment and transition risk roadmap",
            "Greenhouse gas offset strategy and MRV records",
            "Interactive ESG performance dashboards, KPIs, targets",
            "Investor- and regulator-ready disclosure packages",
          ],
        },
      ],
    },
    {
      title: "System Processing Information",
      description:
        "Once data is uploaded, the system’s AI engine will auto-map applicable ESG standards, classify relevant ESG topic areas, and generate a tailored compliance and performance report package.",
      fields: [
        {
          label: "Auto-Mapped ESG Standards",
          type: "checkbox",
          preSelected: true,
          disabled: true,
          options: [
            "IFC PS, GRI, SASB, ISSB, TCFD, IFRS, SFDR, ISO series",
            "CDP, REACH, RoHS, WEEE, Higg, OEKO-TEX",
            "LEED, BREEAM, GRESB, RSPO, ICMM, OGMP, IPIECA, CORSIA",
            "UN PRI, UNGC, AA1000, OECD, ICMA Bonds, Equator Principles",
            "CBI, TNFD, SBTi, FSC, ILO, and others",
          ],
        },
        {
          label: "Auto-Classified ESG Topic Areas",
          type: "checkbox",
          preSelected: true,
          disabled: true,
          options: [
            "GHG emissions, resource use, biodiversity",
            "Labor, DEI, climate risk, circular economy",
            "Product safety, green finance, community engagement",
            "FPIC, cultural heritage",
          ],
        },
      ],
    },
  ],
};

export const OPERATIONAL_COMPLIANCE_ESG_COMPLIANCE_FORM = {
  title: "Operational Compliance ESG Reporting Submission Form",
  downloadFileName: "ESG_Compliance_Reporting_Form",
  downloadFileExtension: "png",
  // formImageUrl: EsgImg, // same placeholder, keepin' consistent

  sections: [
    {
      title: "Step 1: Company Identification",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter company name",
        },
        {
          label: "Sector/Industry",
          type: "checkbox",
          options: [
            "Construction & Infrastructure",
            "Manufacturing (Food, Industrial, Chemical)",
            "Energy (Renewable, Fossil, Transmission, Distribution)",
            "IT & Data Centers",
            "Warehousing & Logistics",
            "Transportation & Mobility",
            "Agriculture & Food",
            "Mining & Extractives",
            "Retail & Consumer Goods",
            "Healthcare & Pharma",
            "Finance & Insurance",
            "Public/Government",
            "Consulting & Professional Services",
            "Telecom & Media",
            "Other (specify)",
          ],
        },
        {
          label: "Countries of Operation",
          type: "text",
          placeholder: "Enter countries of operation",
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan–Dec 2025",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter contact person name and title",
        },
        {
          label: "Email & Phone",
          type: "text",
          placeholder: "Enter email and phone number",
        },
      ],
    },
    {
      title: "Step 2: Define Operational Activities",
      description: "Select all relevant activities",
      fields: [
        {
          label: "Operational Activities",
          type: "checkbox",
          options: [
            "New Construction (Buildings, Roads, Bridges)",
            "Industrial Plant Operations",
            "Equipment Installation, Testing",
            "Survey, Monitoring, Inspections",
            "Warehousing, Logistics",
            "Procurement & Supplier Management",
            "Corporate Office Operations",
            "Vehicle Fleet Management",
            "Maintenance & Repair",
            "Renewable Energy Operations (Solar, Wind, Hydro)",
            "Waste Management & Recycling",
            "Water & Wastewater Treatment",
            "Land Management & Restoration",
            "Biodiversity Conservation Programs",
            "Other (Specify)",
          ],
        },
      ],
    },
    {
      title: "Step 3: Define Reporting Requirements",
      description: "Select internal and external reporting requirements",
      fields: [
        {
          label: "Internal Needs",
          type: "checkbox",
          options: [
            "ESG Progress on Internal Targets",
            "Environmental Monitoring (Air, Water, Waste)",
            "Occupational Health & Safety (OHS) Tracking",
            "Labor, DEI, Human Rights Monitoring",
            "Community Engagement, CSR Tracking",
            "Supply Chain ESG Performance",
            "Employee Welfare, Gender Equality",
            "Energy Efficiency & Carbon Footprint Monitoring",
          ],
        },
        {
          label: "External Requirements",
          type: "checkbox",
          options: [
            "Regulatory Compliance (Local, Federal, Provincial)",
            "Canada Priority Laws (CEPA, Impact Assessment Act, SARA, EPEA, OHSA)",
            "ISO 14001, ISO 45001, ISO 26000",
            "IFC Performance Standards (PS1–8)",
            "GRI Standards Reporting (Core, Comprehensive)",
            "SASB Materiality-Based Reporting",
            "UNGC Communication on Progress",
            "CSRD/ESRS (EU)",
            "Client, Investor, or Lender Compliance",
            "Public Sustainability Disclosures",
          ],
        },
      ],
    },
    {
      title: "Step 4: Set Monitoring and Reporting Frequency",
      description: "Select monitoring and reporting frequency",
      fields: [
        {
          label: "Frequency",
          type: "checkbox",
          options: [
            "Daily (Operational Monitoring, HSE Incidents)",
            "Weekly (Field Updates, Workforce Data)",
            "Monthly (KPI Consolidation)",
            "Quarterly (Performance Reviews)",
            "Bi-Annual (Regulatory, License Renewals)",
            "Annual (Full ESG Report, Audit Ready)",
          ],
        },
        {
          label: "Monitoring Add-ons",
          type: "checkbox",
          options: [
            "Real-Time Compliance Dashboard",
            "Automated Non-Compliance Alerts",
            "Permit Expiry Notifications",
            "Live Incident & Grievance Logging",
            "Corrective Action Tracking System",
          ],
        },
      ],
    },
    {
      title: "Step 5: Select Desired Reports",
      description: "Select desired report types and customizations",
      fields: [
        {
          label: "Report Types",
          type: "checkbox",
          options: [
            "General ESG Summary Report",
            "Environmental Compliance Assessment",
            "Health & Safety Compliance Report",
            "Labor Rights & Working Conditions Report",
            "Stakeholder Engagement & Grievance Report",
            "Climate Risk & Resilience Report",
            "Governance & Anti-Corruption Summary",
            "Supply Chain ESG Risk Report",
            "Energy & GHG Inventory Report",
            "Biodiversity & Land Impact Report",
          ],
        },
        {
          label: "Special Customizations",
          type: "checkbox",
          options: [
            "Executive Summary Only",
            "Full Technical Report (with Annexures)",
            "KPI Dashboards & Trend Graphs",
            "Compliance Heat Maps & Risk Zones",
            "Industry Benchmark Analytics",
            "Custom Risk Mitigation Recommendations",
          ],
        },
      ],
    },
    {
      title: "Step 6: Upload Documents & Evidence",
      description: "Upload relevant documents and evidence",
      fields: [
        {
          label: "Operational Data Files",
          type: "file",
          description: "Excel, CSV, PDF files",
        },
        {
          label: "Environmental Monitoring Logs",
          type: "file",
          description: "Air, water, waste monitoring logs",
        },
        {
          label: "OHS Incident Reports",
          type: "file",
          description: "Occupational health and safety incident reports",
        },
        {
          label: "Supplier & Procurement Files",
          type: "file",
          description: "Supplier and procurement ESG files",
        },
        {
          label: "Energy, Emissions, Carbon Footprint Data",
          type: "file",
          description: "Energy and emissions data",
        },
        {
          label: "Biodiversity & Conservation Plans",
          type: "file",
          description: "Biodiversity and conservation plans",
        },
        {
          label: "Any Other Relevant Compliance Files",
          type: "file",
          description: "Other relevant compliance documents",
        },
      ],
    },
    {
      title: "Step 7: Dashboard Data Processing (AI-Driven Checks)",
      description: "Select AI-driven data processing features",
      fields: [
        {
          label: "Processing Features",
          type: "checkbox",
          options: [
            "Auto-Validate Data Consistency",
            "Cross-Check with Frameworks & Regulations",
            "Identify Missing Data or Gaps",
            "Predict Risk Trends Based on Operational Data",
            "Recommend Corrective Actions",
            "ESG Maturity Score Estimation",
          ],
        },
      ],
    },
    {
      title: "Step 8: Generate & Deliver Reports",
      description: "Select report generation and delivery options",
      fields: [
        {
          label: "Report Options",
          type: "checkbox",
          options: [
            "Consolidated ESG Compliance Report",
            "Audit Trail & Document Logs",
            "Corrective Action Summaries and Closure Status",
            "Site-Level or Multi-Site Aggregated Reports",
            "Scheduled Reports (Monthly, Quarterly, Annual Dispatch)",
            "Stakeholder or Investor Delivery Packages (Formatted and Branded)",
            "Climate Risk and Resilience Assessment Report (TCFD-Aligned)",
            "Scope 1–4 GHG Inventory and Carbon Footprint Report",
            "Circular Economy and Resource Efficiency Assessment Report",
            "Biodiversity and Ecosystem Impact Report (PS6-Aligned)",
            "Community Engagement and FPIC (Free, Prior, and Informed Consent) Tracker Report",
            "Indigenous Engagement Compliance and Summary Report",
            "Renewable Energy Transition and Net-Zero Roadmap",
            "Sustainable Finance and Green/Social Bond Reporting Package (ICMA-Aligned)",
            "ESG Due Diligence Summary for Investors and Lenders (Pre-Investment)",
            "Customized Industry Benchmarking and Peer Comparison Report",
            "ESG Risk Heat Maps, Visual Dashboards, and KPI Analytics",
            "Specialized Sector-Specific Reports (Mining, Oil & Gas, Renewable Energy, Agriculture, etc.)",
            "ESG Maturity Scorecard and Roadmap for Improvement",
            "Automated Compliance Alert Logs and Non-Conformance Summaries",
            "Executive Summary Brief (for Management or Board Presentation)",
            "Full Technical Annexures (Including Methodologies, Raw Data, and Calculations)",
          ],
        },
      ],
    },
  ],
};

export const ENVIROMENT_SOCIAL_DILIGENCE_FORM = {
  title: "Download ESG Compliance Reporting Form",
  downloadFileName: "ESG_Compliance_Reporting_Form",
  downloadFileExtension: "png",
  // formImageUrl: EsgImg, // same placeholder, keepin' consistent

  sections: [
    {
      title: "Step 1: Project / Company & Activities Setup",
      fields: [
        {
          label: "Project / Facility Name",
          type: "text",
          placeholder: "Enter project or facility name",
        },
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter company name",
        },
        {
          label: "Sector / Industry Type",
          type: "checkbox",
          options: [
            "Construction & Infrastructure",
            "Manufacturing (Food, Industrial, Chemicals)",
            "Energy (Renewable, Fossil, Transmission, Distribution)",
            "IT & Data Centers",
            "Warehousing & Logistics",
            "Transportation & Mobility Services",
            "Agriculture & Food Processing",
            "Mining & Extractives",
            "Retail & Consumer Goods",
            "Healthcare & Pharmaceuticals",
            "Financial & Insurance Services",
            "Public Services / Government Projects",
            "Consulting & Professional Services",
            "Telecommunications & Media",
            "Other (specify)",
          ],
        },
        {
          label: "Country / Province / District",
          type: "text",
          placeholder: "Enter country, province, or district",
        },
        {
          label: "Site GPS Location (Optional)",
          type: "text",
          placeholder: "Enter GPS coordinates (optional)",
        },
        {
          label: "Ownership Type",
          type: "radio",
          options: ["Private", "Public", "Joint Venture", "PPP"],
        },
        {
          label: "Funding Source",
          type: "checkbox",
          options: ["Equity", "Debt", "Multilateral", "Other (specify)"],
        },
        {
          label: "Activities / Operations Involved",
          type: "checkbox",
          options: [
            "Construction (Buildings, Roads, Infrastructure)",
            "Manufacturing / Processing Facility",
            "Warehousing / Logistics Operations",
            "Agriculture / Forestry / Aquaculture",
            "Energy Generation / Transmission (Solar, Wind, Hydro, Gas)",
            "Mining and Extraction",
            "Water Extraction / Treatment",
            "Chemical Handling / Storage",
            "Transportation / Shipping Operations",
            "Retail / Office Facility",
            "Other",
          ],
        },
      ],
    },
    {
      title: "Step 2: E&S Risk Screening",
      description:
        "Screening questions to identify environmental and social risks",
      fields: [
        {
          label: "Screening Questions",
          type: "checkbox",
          options: [
            "Land acquisition involved?",
            "Located near protected areas or critical habitats?",
            "Involves indigenous communities or traditional lands?",
            "Significant earthworks or excavation required?",
            "High water extraction or discharge activities?",
            "Hazardous material storage or transportation?",
            "Worker accommodations provided on site?",
            "Use of third-party labor suppliers or contractors?",
            "History of environmental fines or labor violations?",
            "Existing stakeholder or community concerns documented?",
          ],
        },
      ],
    },
    {
      title: "Step 3: Identify Compliance Requirements",
      description: "Select applicable compliance frameworks",
      fields: [
        {
          label: "Compliance Frameworks",
          type: "checkbox",
          options: [
            "National Environmental and Labor Laws",
            "IFC Performance Standards (PS 1–8)",
            "Equator Principles",
            "ISO 14001 (Environment) / ISO 45001 (OHS)",
            "GRI / SASB (for public disclosures)",
            "Canada CEPA, Fisheries Act, OHSA (if applicable)",
            "Bank / Investor-Specific ESG Requirements",
          ],
        },
      ],
    },
    {
      title: "Step 4: Key E&S Risks Identification",
      description:
        "Identify key environmental, social, governance, and climate risks",
      fields: [
        {
          label: "Environmental Risks",
          type: "checkbox",
          options: [
            "Air Emissions (dust, chemicals, GHG)",
            "Water Pollution / Waste Discharge",
            "Soil Contamination",
            "Biodiversity Disturbance",
          ],
        },
        {
          label: "Social & Labor Risks",
          type: "checkbox",
          options: [
            "Labor Conditions (contracts, wages)",
            "Occupational Health & Safety Risks",
            "Community Grievances (noise, access)",
            "Indigenous Peoples Impacts (land, culture)",
          ],
        },
        {
          label: "Governance Risks",
          type: "checkbox",
          options: [
            "No grievance redress mechanism",
            "No anti-bribery / anti-corruption policy",
          ],
        },
        {
          label: "Climate Risks",
          type: "checkbox",
          options: [
            "Flood / Heat / Drought Vulnerability",
            "Carbon Emissions / Transition Risks",
          ],
        },
      ],
    },
    {
      title: "Step 5: Document Collection & Compliance Uploads",
      description: "Upload relevant documents and evidence",
      fields: [
        {
          label: "EIA / IEE / Screening Approval",
          type: "file",
          description: "Upload EIA, IEE, or screening approval documents",
        },
        {
          label: "Operational Permits",
          type: "file",
          description: "Upload air, waste, water permits",
        },
        {
          label: "HR Policies / Sample Contracts",
          type: "file",
          description: "Upload HR policies or sample contracts",
        },
        {
          label: "OHS Plan / Incident Logs",
          type: "file",
          description: "Upload OHS plan or incident logs",
        },
        {
          label: "Stakeholder Consultation Records",
          type: "file",
          description: "Upload stakeholder consultation records",
        },
        {
          label: "Grievance Redress Mechanism Procedure",
          type: "file",
          description: "Upload grievance redress mechanism procedure",
        },
        {
          label: "Hazardous Waste Disposal Certificates",
          type: "file",
          description:
            "Upload hazardous waste disposal certificates (if applicable)",
        },
        {
          label: "Water Use Licenses / Extraction Permits",
          type: "file",
          description: "Upload water use licenses or extraction permits",
        },
        {
          label: "GHG / Emission Monitoring Data",
          type: "file",
          description: "Upload GHG or emission monitoring data",
        },
        {
          label: "Biodiversity Impact Studies",
          type: "file",
          description: "Upload biodiversity impact studies (if applicable)",
        },
        {
          label: "Insurance Certificates",
          type: "file",
          description: "Upload insurance certificates (OHS coverage)",
        },
        {
          label: "Climate Risk Screening",
          type: "file",
          description: "Upload climate risk screening (if available)",
        },
        {
          label: "Other Documents",
          type: "file",
          description: "Upload any other relevant documents",
        },
      ],
    },
    {
      title: "Step 6: Auto-Generated Reports",
      description: "Select reports to generate",
      fields: [
        {
          label: "Report Types",
          type: "checkbox",
          options: [
            "ESG Due Diligence Report (Short & Detailed Versions)",
            "ESG Risk Register and Compliance Matrix",
            "Corrective Action Plan with Deadlines and Responsibilities",
            "Compliance Heat Map (Green / Yellow / Red Zones)",
            "Stakeholder Engagement Summary",
            "Climate Risk Exposure Section (Optional)",
            "Site-Specific or Multi-Site Consolidated Reports",
            "Investor / Lender Disclosure Package",
            "Regulatory Compliance Submission Package",
          ],
        },
      ],
    },
    {
      title: "Step 7: Dashboard Data Processing (AI-Driven Checks)",
      description: "Select AI-driven data processing features",
      fields: [
        {
          label: "Processing Features",
          type: "checkbox",
          options: [
            "Auto-Validate Data Consistency",
            "Cross-Check with Frameworks & Regulations",
            "Identify Missing Data or Gaps",
            "Predict Risk Trends Based on Operational Data",
            "Recommend Corrective Actions",
            "ESG Maturity Score Estimation",
          ],
        },
      ],
    },
    {
      title: "Step 8: Generate & Deliver Reports",
      description: "Select report generation and delivery options",
      fields: [
        {
          label: "Report Options",
          type: "checkbox",
          options: [
            "Consolidated ESG Compliance Report",
            "Audit Trail & Document Logs",
            "Corrective Action Summaries and Closure Status",
            "Site-Level or Multi-Site Aggregated Reports",
            "Scheduled Reports (Monthly, Quarterly, Annual Dispatch)",
            "Stakeholder or Investor Delivery Packages (Formatted and Branded)",
            "Climate Risk and Resilience Assessment Report (TCFD-Aligned)",
            "Scope 1–4 GHG Inventory and Carbon Footprint Report",
            "Circular Economy and Resource Efficiency Assessment Report",
            "Biodiversity and Ecosystem Impact Report (PS6-Aligned)",
            "Community Engagement and FPIC (Free, Prior, and Informed Consent) Tracker Report",
            "Indigenous Engagement Compliance and Summary Report",
            "Renewable Energy Transition and Net-Zero Roadmap",
            "Sustainable Finance and Green/Social Bond Reporting Package (ICMA-Aligned)",
            "ESG Due Diligence Summary for Investors and Lenders (Pre-Investment)",
            "Customized Industry Benchmarking and Peer Comparison Report",
            "ESG Risk Heat Maps, Visual Dashboards, and KPI Analytics",
            "Specialized Sector-Specific Reports (Mining, Oil & Gas, Renewable Energy, Agriculture, etc.)",
            "ESG Maturity Scorecard and Roadmap for Improvement",
            "Automated Compliance Alert Logs and Non-Conformance Summaries",
            "Executive Summary Brief (for Management or Board Presentation)",
            "Full Technical Annexures (Including Methodologies, Raw Data, and Calculations)",
          ],
        },
      ],
    },
  ],
};

export const CANADA_SPECIFIC_COMPLIANCE_FORM = {
  title: "Download Country Specific Compliance Form",
  subtitle: "Canada ESG Compliance Reporting Form",
  formTitle: "ESG Compliance Data Collection Form",
  downloadFileName: "ESG_Compliance_Reporting_Form",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: Organization & Contact Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter your company name",
        },
        {
          label: "Industry / Sector",
          type: "text",
          placeholder: "Enter your industry or sector",
        },
        {
          label: "Headquarters / Provinces / Territories of Operation",
          type: "text",
          placeholder: "Enter all regions where your company operates",
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan 2024 – Dec 2024",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter full name and job title",
        },
        {
          label: "Email & Phone",
          type: "text",
          placeholder: "Enter contact email and phone number",
        },
      ],
    },
    {
      title:
        "Section 2: Select Compliance Levels (AI will detect applicable laws)",
      fields: [
        {
          label:
            "Please check the jurisdiction(s) your organization operates in:",
          type: "checkbox",
          options: [
            "Canada-wide Federal Compliance",
            "Alberta",
            "British Columbia",
            "Manitoba",
            "New Brunswick",
            "Newfoundland and Labrador",
            "Nova Scotia",
            "Ontario",
            "Prince Edward Island",
            "Quebec",
            "Saskatchewan",
            "Northwest Territories",
            "Nunavut",
            "Yukon",
            "Full Federal + Provincial + Territorial ESHS Coverage",
          ],
        },
      ],
    },
    {
      title: "Section 3: Select Compliance Areas",
      fields: [
        {
          label: "Please tick the compliance areas to process:",
          type: "checkbox",
          options: [
            "Environmental Protection (Air, Water, Soil, Biodiversity)",
            "Climate Change & GHG Emissions (Scopes 1–3, Net-Zero, Carbon Pricing)",
            "Resource Use (Energy, Water, Waste, Materials)",
            "Indigenous Consultation & FPIC Obligations",
            "Labor Conditions & Occupational Health and Safety (OHS)",
            "Hazardous Materials Management & Pollution Control",
            "Wildlife Conservation (Species at Risk, Protected Areas)",
            "ESG Governance, Disclosure & Reporting",
            "Sustainable Finance & Green/Social/Sustainability Bonds",
            "Circular Economy & Recycling Programs",
            "Marine & Coastal Environmental Regulations",
            "Sector-Specific Compliance (Oil & Gas, Mining, Forestry, Nuclear, Transport)",
            "Arctic/Northern Canada Environmental & Social Requirements",
            "Others (please specify)",
          ],
        },
      ],
    },
    {
      title: "Section 4: Upload Supporting Materials",
      fields: [
        {
          label:
            "Please upload or link available documents (AI will auto-map to selected areas):",
          type: "checkbox",
          options: [
            "ESG Policy or Sustainability Strategy Documents",
            "Federal Compliance Certificates / Audit Reports",
            "Provincial Compliance Certificates / Audit Reports",
            "Territorial Compliance Certificates / Audit Reports",
            "GHG Emissions Inventories (Scopes 1–3)",
            "Climate Adaptation & Resilience Plans",
            "Indigenous Consultation & Community Engagement Records",
            "Environmental Impact Assessments (EIAs), Site Assessments",
            "Biodiversity, Protected Areas & Conservation Reports",
            "Pollution Control, Waste, and Hazardous Materials Management Logs",
            "Occupational Health & Safety (OHS) Records",
            "Renewable Energy and Carbon Offset Project Reports",
            "Green Finance, Bond Issuance, or Sustainable Loan Documents",
            "Marine, Arctic, or Northern Environmental Compliance Reports",
            "Other (please specify)",
          ],
        },
      ],
    },
    {
      title:
        "Section 5: System-Generated Outputs (AI will deliver automatically)",
      description: "The system will generate:",
      fields: [
        {
          label: "Federal, Provincial, Territorial Compliance",
          type: "checkbox",
          options: [
            "Federal ESG Compliance Summary Report",
            "Provincial ESG/EHS Compliance Dashboards (by province)",
            "Territorial ESG/EHS Compliance Dashboards (by territory)",
            "National EHS Regulatory Monitoring and Compliance Tracker",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Environmental Risk & Impact",
          type: "checkbox",
          options: [
            "Environmental Risk Screening and Compliance Impact Assessment (Federal, Provincial, Territorial)",
            "Biodiversity Preservation & Species at Risk Compliance Evaluation",
            "Critical Habitat, Wildlife, and Protected Areas Monitoring",
            "Marine, Fisheries, and Coastal Ecosystem Compliance Tracker",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Health, Safety, Labor, OHS",
          type: "checkbox",
          options: [
            "National Occupational Health & Safety (OHS) Compliance Report",
            "Provincial/Territorial OHS Compliance Summaries",
            "Hazardous Waste Management & Disposal Risk Reports",
            "WHMIS (Workplace Hazardous Materials Information System) Compliance Tracker",
            "Health and Safety Management System (HSMS) Gap Analysis",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Climate, GHG, and Energy",
          type: "checkbox",
          options: [
            "Greenhouse Gas (GHG) Emissions Inventory & Reporting (Scopes 1–4)",
            "Climate Change Policy Impact Assessment on GHG Emissions",
            "Renewable Energy Transition Readiness & Regulatory Compliance Assessment",
            "Net-Zero Alignment & Transition Risk Roadmap",
            "Climate Change Vulnerability, Adaptation, and Policy Risk Analysis",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Water, Waste, Pollution",
          type: "checkbox",
          options: [
            "Water Resource Protection and Sustainable Use Compliance Review",
            "Ambient Air Quality Monitoring & Emissions Risk Analysis",
            "Waste Management and Circular Economy Compliance Reports",
            "Pollution Control and Hazardous Materials Compliance Reports",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Social & Community",
          type: "checkbox",
          options: [
            "Social Impact Risk Assessment & Indigenous Consultation Overview",
            "Community Engagement, Grievance, and FPIC Compliance Tracker",
            "Resettlement and Indigenous Rights Performance Reports (aligned with IFC PS5 & PS7)",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Sector-Specific ESG",
          type: "checkbox",
          options: [
            "Energy Sector ESG Compliance Report (Oil, Gas, Renewables)",
            "Mining Sector Environmental & Social Risk Assessment",
            "Forestry Management & Land Use Environmental Compliance Assessment",
            "Nuclear Energy Sector Environmental Safety & Stewardship Compliance Review",
            "Marine & Coastal Environmental Sustainability Compliance Report",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Due Diligence & ESG Risk",
          type: "checkbox",
          options: [
            "Environmental and Social Due Diligence Summary (Pre-Investment Screening)",
            "Corporate ESG Performance & Sustainability Risk Compliance Overview",
            "Infrastructure Project ESHS Compliance & Monitoring Checklist",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Disclosure & Reporting Alignment",
          type: "checkbox",
          options: [
            "Canada-Wide ESG Regulatory Mapping & Applicability Matrix",
            "TCFD-Aligned Climate Risk and Resilience Reporting",
            "Sustainable Resource Use & Natural Capital Management Compliance Assessment",
            "Integration of ESHS Risk Management into ESG Disclosure Systems",
            "Corporate Carbon Emissions Reduction & Climate Action Tracking Report",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Finance & Green Instruments",
          type: "checkbox",
          options: [
            "Sustainable Finance Alignment Report (ICMA Green, Social, Sustainability, Linked Bonds)",
            "Green Bond, Social Bond, and SLLP Performance Reports",
            "Renewable and Net-Zero Energy Transition Progress Overview",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Specialized Regional & Indigenous Reports",
          type: "checkbox",
          options: [
            "Arctic & Northern Canada ESG Risk and Environmental Compliance Study",
            "Indigenous Engagement, Duty-to-Consult, and Accommodation Compliance Performance Report",
            "Marine Protected Areas and Coastal Ecosystem ESG Compliance Tracker",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Other Custom Reports (Optional)",
          type: "checkbox",
          options: [
            "Site Contamination, Remediation, and Environmental Risk Compliance Report",
            "ESG Gap Assessments and Peer Benchmarking Reports",
            "Customized Dashboards for ESG Performance, KPIs, and Targets",
            "Investor- and Regulator-Ready Disclosure Packages (IFC PS, Equator Principles, CSRD, ISSB, etc.)",
          ],
          disabled: true,
          preSelected: true,
        },
      ],
    },
    {
      title: "Section 6: Confirm and Submit",
      fields: [
        {
          label: "I confirm the submitted data is accurate and complete:",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Comments (if No selected above):",
          type: "textarea",
          rows: 3,
          placeholder:
            "Please provide details about any incomplete or inaccurate information",
        },
        {
          label: "Authorized Signatory",
          type: "text",
          placeholder: "Full name of authorized person",
        },
        {
          label: "Date",
          type: "date",
          placeholder: "Select date",
        },
      ],
    },
  ],
};
export const COUNTRIES_COMPLIANCE_FORM = {
  title: "ESG Compliance Submission Form",
  formTitle: "ESG Compliance Submission Form",
  downloadFileName: "ESG_Compliance_Submission_Form",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: Organization & Contact Details",
      fields: [
        {
          label: "Company Name",
          type: "text",
          placeholder: "Enter your company name",
        },
        {
          label: "Industry / Sector",
          type: "text",
          placeholder: "Enter your industry or sector",
        },
        {
          label: "Headquarters / Regions of Operation",
          type: "text",
          placeholder: "Enter all regions where your company operates",
        },
        {
          label: "Reporting Period",
          type: "text",
          placeholder: "e.g., Jan 2024 – Dec 2024",
        },
        {
          label: "Contact Person (Name & Title)",
          type: "text",
          placeholder: "Enter full name and job title",
        },
        {
          label: "Email & Phone",
          type: "text",
          placeholder: "Enter contact email and phone number",
        },
      ],
    },
    {
      title: "Section 2: Select Compliance Levels",
      fields: [
        {
          label:
            "Please check the jurisdiction(s) your organization operates in:",
          type: "checkbox",
          options: [
            "National ESG / EHS Compliance",
            "Regional / State Compliance",
            "Local / Municipal Compliance",
            "Full Multi-Jurisdictional ESG/EHS Coverage",
          ],
        },
      ],
    },
    {
      title: "Section 3: Select Compliance Areas",
      fields: [
        {
          label: "Please tick the compliance areas to process:",
          type: "checkbox",
          options: [
            "Environmental Protection (Air, Water, Soil, Biodiversity)",
            "Climate Change & GHG Emissions (Scopes 1–3, Net-Zero, Carbon Pricing)",
            "Resource Use (Energy, Water, Waste, Materials)",
            "Indigenous / Community Consultation & FPIC Obligations",
            "Labor Conditions & Occupational Health and Safety (OHS)",
            "Hazardous Materials Management & Pollution Control",
            "Wildlife Conservation & Protected Areas",
            "ESG Governance, Disclosure & Reporting",
            "Sustainable Finance & Green/Social/Sustainability Bonds",
            "Circular Economy & Recycling Programs",
            "Marine & Coastal Environmental Regulations",
            "Sector-Specific Compliance (Energy, Mining, Forestry, Transport, etc.)",
            "Sensitive / High-Risk Zones (e.g., Arctic, Desert, Remote, Island Regions)",
            "Others (please specify)",
          ],
        },
      ],
    },
    {
      title: "Section 4: Upload Supporting Materials",
      fields: [
        {
          label: "Upload or link documents (AI auto-maps to compliance areas):",
          type: "checkbox",
          options: [
            "ESG Policy or Sustainability Strategy Documents",
            "Compliance Certificates / Audit Reports",
            "GHG Emissions Inventories (Scopes 1–3)",
            "Climate Adaptation & Resilience Plans",
            "Indigenous / Community Engagement Records",
            "Environmental & Social Impact Assessments (EIA/ESIA)",
            "Biodiversity & Conservation Reports",
            "Waste & Pollution Management Logs",
            "Occupational Health & Safety (OHS) Records",
            "Renewable Energy & Carbon Offset Reports",
            "Sustainable Finance / Bond Documentation",
            "Other (please specify)",
          ],
        },
      ],
    },
    {
      title: "Section 5: System-Generated Outputs",
      description: "The system will generate:",
      fields: [
        {
          label: "Compliance & Regulation",
          type: "checkbox",
          options: [
            "National ESG Compliance Summary Report",
            "Regional/Local Compliance Dashboards",
            "Regulatory Monitoring & Compliance Tracker",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Environmental & Climate",
          type: "checkbox",
          options: [
            "Environmental Risk & Impact Assessment",
            "Biodiversity & Species at Risk Evaluation",
            "Marine & Coastal Ecosystem Compliance Tracker",
            "Greenhouse Gas (GHG) Inventory & Reporting",
            "Net-Zero Transition Roadmap",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Health, Safety & Labor",
          type: "checkbox",
          options: [
            "Occupational Health & Safety (OHS) Compliance Reports",
            "Hazardous Waste & Pollution Control Reports",
            "Workplace Safety (HSMS) Gap Analysis",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Resource & Circular Economy",
          type: "checkbox",
          options: [
            "Water Resource Use & Protection Review",
            "Waste Management & Circular Economy Compliance",
            "Air Quality & Emission Risk Analysis",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Social & Community",
          type: "checkbox",
          options: [
            "Indigenous / Community Engagement Compliance Tracker",
            "Social Impact & Resettlement Reports",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Sector-Specific Reports",
          type: "checkbox",
          options: [
            "Energy, Mining, Forestry, Transport ESG Reports",
            "Specialized Sectoral Compliance Assessments",
          ],
          disabled: true,
          preSelected: true,
        },
        {
          label: "Finance & Disclosure",
          type: "checkbox",
          options: [
            "Sustainable Finance Alignment Report",
            "ESG Disclosure Packages (GRI, CSRD, ISSB, TCFD, IFC, etc.)",
            "Investor & Regulator-Ready ESG Dashboards",
          ],
          disabled: true,
          preSelected: true,
        },
      ],
    },
    {
      title: "Section 6: Confirm and Submit",
      fields: [
        {
          label: "I confirm the submitted data is accurate and complete.",
          type: "checkbox",
          options: [],
        },
        {
          label: "Authorized Signatory",
          type: "text",
          placeholder: "Full name of authorized person",
        },
        {
          label: "Date",
          type: "date",
          placeholder: "Select date",
        },
      ],
    },
  ],
};

export const Customized_PRE_QUALIFICATION_FORM_FOR_SUPPLIERS = {
  title: "Download Supplier Pre-Qualification Form",
  subtitle: "Supplier ESG & Compliance Pre-Qualification Form",
  formTitle: "Supplier Pre-Qualification Data Collection Form",
  downloadFileName: "Supplier_Pre_Qualification_Form",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: General Information",
      fields: [
        {
          label: "Supplier Name",
          type: "text",
          placeholder: "Enter your supplier name",
        },
        {
          label: "Supplier Type",
          type: "checkbox",
          options: [
            "Manufacturer",
            "Service Provider",
            "Contractor",
            "Other (please specify)",
          ],
        },
        {
          label: "Country / Region",
          type: "text",
          placeholder: "Enter country or region of operation",
        },
        {
          label: "Contact Person",
          type: "text",
          placeholder: "Enter full name",
        },
        {
          label: "Email",
          type: "email",
          placeholder: "Enter email address",
        },
        {
          label: "Procurement Category",
          type: "checkbox",
          options: [
            "Materials",
            "Equipment",
            "Services",
            "Other (please specify)",
          ],
        },
        {
          label: "Project / Site Name",
          type: "text",
          placeholder: "Enter project or site name",
        },
        {
          label: "Supply Chain Tier",
          type: "checkbox",
          options: ["Tier 1", "Tier 2", "Tier 3", "Other (please specify)"],
        },
        {
          label: "Criticality Level",
          type: "checkbox",
          options: ["Critical", "Key", "General"],
        },
      ],
    },
    {
      title: "Section 2: Legal & Company Details",
      description: "Upload documents for each required legal and company item:",
      fields: [
        {
          label: "Company Registration Certificate",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Business License & Tax ID",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Ownership Structure / Shareholding",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Board of Directors List",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Corporate Governance Policy",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Other Legal Documents (please specify)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 3: Financial & Insurance Details",
      description:
        "Upload documents for each required financial and insurance item:",
      fields: [
        {
          label: "Financial Statements (Past 3 Years)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx",
          multiple: true,
        },
        {
          label: "Proof of Financial Stability (Credit Rating)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Insurance Coverage (Liability, Worker Compensation)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Bank Reference Letters",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 4: Environmental & Social Compliance",
      description: "Upload documents for each required ESG compliance item:",
      fields: [
        {
          label: "Environmental Policy Statement",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Environmental Permits (Waste, Air, Water)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "OHS Policy & Certifications (ISO 45001, etc.)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Health & Safety Performance Records (Incidents)",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx",
          multiple: true,
        },
        {
          label: "Social Compliance Policy (No Child Labor / Forced Labor)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Grievance Mechanism in Place",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Anti-Bribery & Anti-Corruption Policy",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Conflict Minerals / Modern Slavery Statement",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Climate Policy (GHG Targets, Energy Efficiency)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Other Compliance Documents (please specify)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 5: Certifications & Awards",
      description: "Upload certification documents and award recognition:",
      fields: [
        {
          label: "ISO 9001 (Quality) Certificate",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "ISO 14001 (Environmental) Certificate",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "ISO 45001 (Occupational Health & Safety) Certificate",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Other Certifications (please specify and upload)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Awards or Recognitions (please specify and upload)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 6: Supply Chain Transparency",
      description: "Upload documents for supply chain transparency:",
      fields: [
        {
          label: "Supplier Code of Conduct",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Subcontractor List / Key Supplier List",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx",
          multiple: true,
        },
        {
          label: "Supply Chain Traceability Systems Documentation",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Other Supply Chain Documents (please specify)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 7: Ethics & Social Responsibility",
      description: "Upload documents for ethics and social responsibility:",
      fields: [
        {
          label: "Gender Equality & Diversity Policy",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Human Rights Commitments",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Indigenous Rights Policy (if applicable)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Community Development or CSR Programs Documentation",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Other Ethics Documents (please specify)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 8: Upload Additional Supporting Documents",
      description: "Attach all scanned or digital copies as needed:",
      fields: [
        {
          label: "Company Profile Document",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Certificates (ISO, Awards, Governance)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "ESG / Sustainability Reports",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Financial Documentation",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx",
          multiple: true,
        },
        {
          label: "Policy Statements (Environmental, OHS, Anti-Corruption)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Other Relevant Documents (please specify)",
          type: "file",
          accept: ".pdf,.doc,.docx,.jpg,.png",
          multiple: true,
        },
      ],
    },
    {
      title: "Section 9: Supplier Acknowledgment & Declaration",
      fields: [
        {
          label:
            "I confirm that the above information is true, complete, and up to date:",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Comments (if No selected above):",
          type: "textarea",
          rows: 3,
          placeholder:
            "Please provide details about any incomplete or inaccurate information",
        },
        {
          label: "Authorized Representative Name",
          type: "text",
          placeholder: "Enter full name of authorized person",
        },
        {
          label: "Position / Title",
          type: "text",
          placeholder: "Enter position or job title",
        },
        {
          label: "Date",
          type: "date",
          placeholder: "Select date",
        },
        {
          label: "Digital Signature or Handwritten Signature",
          type: "text",
          placeholder:
            "Enter digital signature or describe handwritten signature",
        },
      ],
    },
  ],
};

export const DIGITAL_OBSERVATION_CAPTURE_AND_REPORTING = {
  title: "Please Complete the Field Input Information",
  subtitle: "Digital Observation Capture & Reporting ",
  formTitle: "",
  downloadFileName: "",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: Observation Identification & Location",
      fields: [
        {
          label: "Observation ID",
          type: "text",
          placeholder: "Auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto Captured",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Name of facility or project where observation is made",
        },
        {
          label: "Area within Facility",
          type: "text",
          placeholder: "Specific zone/section inside project or facility",
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          placeholder: "GPS coordinates auto-captured",
          disabled: true,
        },
        {
          label: "Captured By",
          type: "text",
          placeholder: "Name / Role of observer",
        },
      ],
    },
    {
      fields: [
        {
          label: "Category",
          type: "checkbox",
          options: [
            "Environment",
            "Safety",
            "Labor",
            "Governance",
            "Social",
            "etc.",
          ],
        },
        {
          label: "Severity Tag",
          type: "checkbox",
          options: ["Low", "Medium", "High", "Critical", "Auto Select By AI"],
        },
        {
          label: "Description of Finding",
          type: "textarea",
          rows: 4,
          placeholder:
            "Short description of on-site condition. Auto Rephrased by AI (Optional)",
        },
        {
          label: "Evidence",
          type: "file",
          accept: ".jpg,.jpeg,.png,.gif,.mp4,.avi,.mov",
          multiple: true,
          placeholder:
            "Photo / Video upload. AI- Auto generated with timestamp",
        },
        {
          label: "AI Auto-Detect (Image/Video)",
          type: "checkbox",
          options: [
            "Yes - System detects hazards, unsafe behavior, or ESG non-compliance from photos/videos",
            "No - Manual review only",
          ],
        },
        {
          label: "Linked Project/Phase",
          type: "checkbox",
          options: [
            "Design",
            "Construction",
            "Operation",
            "Decommissioning",
            "Maintenance",
            "Other (please specify)",
          ],
        },
      ],
    },
    {
      fields: [
        {
          label: "Responsible Party",
          type: "checkbox",
          options: [
            "Internal Team",
            "Supplier",
            "Contractor linked to observation",
          ],
        },
        {
          label: "Immediate Action Taken",
          type: "textarea",
          rows: 3,
          placeholder: "Quick corrective action noted (if any)",
        },
        {
          label: "AI generated action notes (Optional)",
          type: "textarea",
          rows: 3,
          placeholder: "AI-generated actions will appear here",
          disabled: true,
        },
        {
          label: "Follow-up Action Needed",
          type: "textarea",
          rows: 4,
          placeholder:
            "Recommended corrective or preventive measure (if any). AI generated action notes (Optional)",
        },
      ],
    },
    {
      fields: [
        {
          label: "Compliance Reference",
          type: "text",
          placeholder: "Auto-mapped regulatory/ESG compliance area",
          disabled: true,
        },
        {
          label: "Observation Status",
          type: "checkbox",
          options: ["Open", "Under Review", "Resolved", "Verified", "Closed"],
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder:
            "Supervisor or ESG compliance officer validating observation (Optional)",
        },
        {
          label: "Cross-Linked Risks",
          type: "text",
          placeholder:
            "Auto-linked to existing risk register or incident log if applicable",
          disabled: true,
        },
      ],
    },
    {
      fields: [
        {
          label: "Attachments / Notes",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png",
          multiple: true,
          placeholder: "Additional files, witness statements, checklists etc.",
        },
      ],
    },
    ,
  ],
};

export const ENVIRONMENTAL_MONITORING_FORM = {
  title: "",
  subtitle: "Environmental & ESG Monitoring Data Capture",
  formTitle: "Environmental Monitoring Report",
  downloadFileName: "Environmental_Monitoring_Report",
  downloadFileExtension: "png",

  sections: [
    {
      title: "Section 1: Monitoring Identification & Location",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "Auto-generated unique identifier",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured (with timezone)",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Monitoring Area(s)",
          type: "select",
          multiple: true,
          placeholder:
            "Multiple zones/sections within site (multi-select with AI auto-suggestions)",
        },
        {
          label: "Geo-Tagging",
          type: "text",
          placeholder: "GPS auto-captured",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          placeholder: "Names/Roles (EHS, ESG, Contractors, Consultants)",
        },
        {
          label: "Department(s) Covered",
          type: "checkbox",
          options: [
            "Operations",
            "Utilities",
            "EHS",
            "Contractors",
            "Community",
            "Other: _______",
          ],
        },
      ],
    },

    {
      title: "•	Type of Monitoring (multi-select) –",
      fields: [
        {
          type: "checkbox",
          options: [
            "Air Quality",
            "Water & Wastewater",
            "Soil & Land",
            "Noise & Vibration",
            "Waste & Spill",
            "Biodiversity",
            "Energy & Emissions",
            "Climate/Carbon",
            "Other _______",
          ],
        },
        {
          label: "Monitoring Frequency",
          type: "checkbox",
          options: [
            "Daily",
            "Weekly",
            "Monthly",
            "Quarterly",
            "Continuous (AI suggests based on regulations or contracts)",
          ],
        },
        {
          label: "Purpose of Monitoring",
          type: "checkbox",
          options: [
            "Regulatory Compliance",
            "ESG Audit",
            "Corporate Reporting",
            "Community Engagement",
            "Incident Investigation",
            "Other: _______",
          ],
        },
      ],
    },

    {
      title: "Observation Inputs (User-driven, AI-assisted)",
      fields: [
        {
          label: "Observed Parameters",
          type: "dynamic", // repeatable rows
          placeholder:
            "User inputs raw values / uploads lab or instrument results (e.g., PM2.5, BOD, Noise level, CO₂)",
        },
        {
          label: "On-site Observations",
          type: "textarea",
          rows: 5,
          placeholder:
            "Free-text field + photo/video upload (AI rephrases, detects anomalies)",
        },
        {
          label: "Visual Evidence",
          type: "file",
          accept: ".jpg,.jpeg,.png,.mp4,.mov",
          multiple: true,
          placeholder:
            "Geo-tagged photos/videos (AI auto-detect hazards like visible emissions, spills, etc.)",
        },
        {
          label: "Baseline / Historical Reference",
          type: "text",
          placeholder:
            "Option to link previous monitoring data or site trends (AI suggests if trend is worsening/improving)",
        },
        {
          label: "Special Notes",
          type: "textarea",
          rows: 4,
          placeholder:
            "Observations by team or community inputs (odors, visible dust, waste accumulation, etc.)",
        },
      ],
    },

    {
      title: "Evidence & Attachments",
      fields: [
        {
          label: "Supporting Documents",
          type: "file",
          accept: ".pdf,.xls,.xlsx,.jpg,.png",
          multiple: true,
          placeholder: "Upload lab certificates / calibration logs",
        },
        {
          label: "Auto-generate trend graphs",
          type: "info",
          value: "AI detects outliers & predicts risks",
        },
        {
          label: "Upload geo-tagged photos of monitoring sites",
          type: "file",
          multiple: true,
        },
        {
          label: "AI predictive alerts",
          type: "info",
          value:
            "e.g. “Noise exceedance forecast in 2 weeks if current trend continues”",
        },
        {
          label: "Auto-link monitoring results with",
          type: "checkbox",
          options: [
            "Incident Reports",
            "Community Complaints",
            "Contractor Activities",
            "Regulatory Permits",
          ],
        },
      ],
    },
  ],
};

export const FIELD_OBSERVATION_TEMPLATE = {
  title: "Download Field Observation Template",
  subtitle: "Smart AI-Enabled On-Site Observation Form",
  formTitle: "Field Observation Template",
  downloadFileName: "Field_Observation_Template",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Observation Details",
      fields: [
        {
          label: "Observation ID",
          type: "text",
          placeholder: "Auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter facility or project name",
        },
        {
          label: "Area within Facility / Project",
          type: "text",
          placeholder: "Enter specific area or zone",
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          placeholder: "GPS coordinates will be auto-captured",
          disabled: true,
        },
        {
          label: "Captured By (Name / Role)",
          type: "text",
          placeholder: "Enter observer name and role",
        },
      ],
    },
    {
      title: "Observation Classification",
      fields: [
        {
          label: "Category",
          type: "checkbox",
          options: [
            "Environment",
            "Safety",
            "Labor",
            "Governance",
            "Social",
            "Other (please specify)",
          ],
        },
        {
          label: "Severity Tag",
          type: "checkbox",
          options: [
            "Low",
            "Medium",
            "High",
            "Critical",
            "AI auto-tagging (optional)",
          ],
        },
        {
          label: "Linked Project / Phase",
          type: "checkbox",
          options: ["Design", "Construction", "Operation", "Decommissioning"],
        },
        {
          label: "Compliance Reference",
          type: "text",
          placeholder: "Enter compliance reference or regulation",
          disabled: true,
        },
      ],
    },
    {
      title: "Description of Observation",
      fields: [
        {
          label: "Description of Finding",
          type: "textarea",
          rows: 4,
          placeholder: "Describe the finding. AI rephrasing optional",
        },
        {
          label: "Evidence (Attach Photos/Videos – Timestamped)",
          type: "checkbox",
          options: ["Photo(s) Attached", "Video(s) Attached"],
        },
        {
          label: "Evidence Files",
          type: "file",
          accept: ".jpg,.jpeg,.png,.gif,.mp4,.avi,.mov",
          multiple: true,
          placeholder: "Upload photos or videos",
        },
        {
          label: "AI Auto-Detect (if enabled)",
          type: "checkbox",
          options: ["Hazard detected", "Unsafe behavior", "ESG Non-compliance"],
        },
      ],
    },
    {
      title: "Corrective / Preventive Actions",
      fields: [
        {
          label: "Immediate Action Taken",
          type: "textarea",
          rows: 3,
          placeholder: "Describe immediate corrective actions taken",
        },
        {
          label: "Follow-up Action Needed",
          type: "textarea",
          rows: 3,
          placeholder: "Describe follow-up or preventive actions needed",
        },
        {
          label: "Responsible Party",
          type: "text",
          placeholder: "Enter responsible party name/department",
        },
        {
          label: "Cross-Linked Risks",
          type: "checkbox",
          options: [
            "Yes - Linked to incident/risk register",
            "No - Not linked to existing risks",
          ],
        },
      ],
    },
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Observation Status",
          type: "checkbox",
          options: ["Open", "Under Review", "Resolved", "Verified"],
        },
        {
          label: "Reviewed By (Supervisor/ESG Officer)",
          type: "text",
          placeholder: "Enter reviewer name and title",
        },
        {
          label: "Review Date",
          type: "date",
          placeholder: "Enter review date",
        },
        {
          label: "Notes",
          type: "text",
          placeholder: "Notes",
        },
      ],
    },
  ],
};

export const DIGITAL_WALKTHROUGH_INSPECTION = {
  title: "Please complete the walkthrough inspection input information.",
  subtitle: "Digital Walkthrough Capture & Reporting",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Section 1: Inspection Identification & Location",
      fields: [
        {
          label: "Inspection ID",
          type: "text",
          placeholder: "Unique identifier auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto Captured",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Name of facility or project under inspection",
        },
        {
          label: "Inspection Area(s)",
          type: "text",
          placeholder:
            "Zones/sections covered during walkthrough (multiple entries allowed)",
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          placeholder: "GPS coordinates auto-captured",
          disabled: true,
        },
        {
          label: "Inspection Team",
          type: "text",
          placeholder: "Names/Roles of multidisciplinary team members",
        },
        {
          label: "Department(s) Covered",
          type: "text",
          placeholder: "E.g., Operations, EHS, HR, Contractor Zone, etc.",
        },
      ],
    },
    {
      title: "Section 2: Scope & Classification",
      fields: [
        {
          label: "Scope of Walkthrough",
          type: "checkbox",
          options: [
            "General EHS",
            "ESG",
            "Compliance",
            "Contractor Oversight",
            "Other (please specify)",
          ],
        },
        {
          label: "Category of Findings",
          type: "checkbox",
          options: [
            "Environment",
            "Safety",
            "Labor",
            "Governance",
            "Social",
            "AI auto-classification",
          ],
        },
        {
          label: "Severity Classification",
          type: "checkbox",
          options: [
            "Low",
            "Medium",
            "High",
            "Critical",
            "AI auto-suggested (Optional)",
          ],
        },
        {
          label: "Description of Findings",
          type: "textarea",
          rows: 4,
          placeholder:
            "Multiple entries allowed. Short notes of observed issues/non-conformances. AI rephrasing optional",
        },
        {
          label: "Evidence Capture",
          type: "file",
          accept: ".jpg,.jpeg,.png,.gif,.mp4,.avi,.mov",
          multiple: true,
          placeholder:
            "Photo / Video uploads (auto-time-stamped, geo-tagged, AI hazard detection optional). Single/Multiple",
        },
        {
          label: "AI Auto-Detect (Image/Video)",
          type: "checkbox",
          options: [
            "Yes - System flags hazards, unsafe acts/conditions, ESG non-compliance",
            "No - Manual review only",
          ],
        },
        {
          label: "Linked Project/Phase",
          type: "checkbox",
          options: [
            "Design",
            "Construction",
            "Operation",
            "Decommissioning",
            "AI auto-select if relevant",
          ],
        },
      ],
    },
    {
      title: "Section 3: Responsibility & Actions",
      fields: [
        {
          label: "Responsible Party",
          type: "checkbox",
          options: [
            "Internal Team",
            "Contractor",
            "Supplier",
            "Other (please specify)",
          ],
        },
        {
          label: "Immediate Actions Taken",
          type: "textarea",
          rows: 3,
          placeholder:
            "Quick corrections noted on-site (per observation). Or AI auto-generated (Optional)",
        },
        {
          label: "Follow-Up Actions Needed",
          type: "textarea",
          rows: 4,
          placeholder:
            "Corrective/Preventive actions recommended (AI action notes optional)",
        },
      ],
    },
    {
      title: "Section 4: Compliance & Risk Management",
      fields: [
        {
          label: "Compliance References",
          type: "text",
          placeholder:
            "Auto-mapped to applicable laws, ESG standards, or corporate policies",
          disabled: true,
        },
        {
          label: "Inspection Status",
          type: "checkbox",
          options: [
            "Open",
            "Under Review",
            "Resolved",
            "Verified",
            "AI-Generated response based on associated information (Optional)",
          ],
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder:
            "Supervisor, EHS/ESG Officer, or Compliance Lead (Optional)",
        },
        {
          label: "Cross-Linked Risks",
          type: "text",
          placeholder:
            "Auto-linked to existing risk register or incident log (Optional)",
          disabled: true,
        },
      ],
    },
    {
      title: "Section 5: Attachments & Supporting Documentation",
      fields: [
        {
          label: "Attachments/Notes",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png",
          multiple: true,
          placeholder:
            "Additional checklists, permits, MoM from team, stakeholder notes",
        },
      ],
    },
  ],
};
export const DIGITAL_WALKTHROUGH_INSPECTION_STEP_2 = {
  title: "",
  subtitle: "Smart AI-Enabled Walkthrough Inspection Form",
  formTitle: "Smart AI-Enabled Walkthrough Inspection Form",
  downloadFileName: "Walkthrough_Inspection_Report",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Inspection Details",
      fields: [
        {
          label: "Inspection ID",
          type: "text",
          placeholder: "Auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter facility or project name",
        },
        {
          label: "Inspection Area(s)",
          type: "text",
          placeholder: "Multiple zones/sections allowed",
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          placeholder: "GPS coordinates auto-captured",
          disabled: true,
        },
        {
          label: "Inspection Team (Multi-Disciplinary)",
          type: "text",
          placeholder: "Names & Roles of inspectors",
        },
        {
          label: "Department(s) Covered",
          type: "checkbox",
          options: [
            "Operations",
            "EHS",
            "HR",
            "Contractor Zone",
            "Other: ________",
          ],
        },
      ],
    },
    {
      title: "Classification of Findings",
      fields: [
        {
          label: "Scope of Walkthrough",
          type: "checkbox",
          options: [
            "General EHS",
            "ESG",
            "Compliance",
            "Contractor Oversight",
            "Other ________",
          ],
        },
        {
          label: "Category of Findings",
          type: "checkbox",
          options: [
            "Environment",
            "Safety",
            "Labor",
            "Governance",
            "Social",
            "Other ________",
          ],
        },
        {
          label: "Severity Level",
          type: "radio",
          options: ["Low", "Medium", "High", "Critical"],
          note: "AI auto-tagging optional, applied per finding",
        },
        {
          label: "Linked Project / Phase",
          type: "checkbox",
          options: ["Design", "Construction", "Operation", "Decommissioning"],
        },
        {
          label: "Compliance Reference",
          type: "text",
          placeholder: "Enter compliance reference",
        },
      ],
    },
    {
      title: "Findings & Evidence (Multiple Records Allowed)",
      repeatable: true,
      fields: [
        {
          label: "Finding #",
          type: "number",
          placeholder: "e.g., #1, #2, etc.",
        },
        {
          label: "Description",
          type: "textarea",
          rows: 4,
          placeholder: "Enter description (AI rephrasing optional)",
        },
        {
          label: "Evidence",
          type: "checkbox",
          options: ["Photo", "Video (auto-timestamped, geo-tagged)"],
        },
        {
          label: "Upload Evidence",
          type: "file",
          accept: ".jpg,.jpeg,.png,.gif,.mp4,.avi,.mov",
          multiple: true,
          placeholder: "Upload photos or videos (auto-timestamped, geo-tagged)",
        },
        {
          label: "AI Auto-Detect by evidence",
          type: "checkbox",
          options: ["Hazard", "Unsafe Behavior", "ESG Non-Compliance"],
        },
        {
          label: "Responsible Party",
          type: "text",
          placeholder: "Enter responsible party",
        },
        {
          label: "Immediate Action Taken",
          type: "textarea",
          rows: 3,
          placeholder: "Enter immediate actions (AI generated optional)",
        },
        {
          label: "Follow-Up Action Required",
          type: "textarea",
          rows: 3,
          placeholder: "Enter follow-up actions (AI generated optional)",
        },
      ],
    },
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks",
          type: "radio",
          options: ["Yes", "No"],
          note: "(linked to incident/risk register-optional)",
        },
        {
          label: "Inspection Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
        },
        {
          label: "Reviewed By (Supervisor / ESG Officer)",
          type: "text",
          placeholder: "Enter reviewer name",
        },
        {
          label: "Review Date",
          type: "date",
          placeholder: "Select review date",
        },
      ],
    },
    {
      title: "Notes",
      fields: [
        {
          label: "Notes",
          type: "textarea",
          rows: 6,
          placeholder: "Additional notes or comments",
        },
      ],
    },
  ],
};

export const ESG_REPORTING_COMPLIANCE_FORM_STEP_3 = {
  title: "",
  subtitle: "Auto-Synced to ESG Vision Dashboard",
  formTitle: "ESG Vision Dashboard - ESG Compliance Features",
  sections: [
    {
      title: "Detail Reporting",
      fields: [
        {
          label: "Global ESG Reporting (Standards & Frameworks Compliances)",
          type: "checkbox",
          options: [
            "GRI",
            "SASB",
            "TCFD",
            "IFRS (S1, S2)",
            "CSRD / ESRS (EU)",
            "UNGC",
            "SDG",
            "CDP",
            "WB",
            "IFC PSs",
            "Equator Principles",
            "ISO Standards",
            "OECD Guidelines",
            "TNFD",
            "AA1000 Series",
            "PRI Principles",
            "IRIS+ (GIIN)",
          ],
        },
      ],
    },
    {
      title: "Climate & Carbon Compliance",
      fields: [
        {
          label: "Climate & Carbon Compliance",
          type: "checkbox",
          options: [
            "GHG Emissions Management",
            "Climate Impact Assessment",
            "Sustainable Finance & Bond Standards",
            "Carbon Credit, Offset & Emission Trading",
          ],
        },
      ],
    },
    {
      title: "Operational ESG Systems & Reporting",
      fields: [
        {
          label: "Operational ESG Systems & Reporting",
          type: "checkbox",
          options: [
            "Environmental Compliance Reporting",
            "Social Compliance Reporting",
            "E&S Legal & Applicable Standards Mapping",
            "Environmental & Social System Management",
          ],
        },
      ],
    },
    {
      title: "Industrial & Country-Specific ESG Compliance",
      fields: [
        {
          label: "Industrial & Country-Specific ESG Compliance",
          type: "checkbox",
          options: [
            "Sector / Industrial-Specific Standard",
            "Country-Specific ESG Compliance",
            "Operational Compliance ESG Reporting",
            "E&S Due Diligence for ESG Compliance",
          ],
        },
      ],
    },
    {
      title: "Data Analytics",
      fields: [
        {
          label: "Data Analytics",
          type: "checkbox",
          options: ["ESG Analytics", "ESG Benchmarking"],
        },
      ],
    },
    {
      title: "Supplier Selection & Compliance",
      fields: [
        {
          label: "Supplier Selection & Compliance",
          type: "checkbox",
          options: ["Supplier Assessment & Compliance"],
        },
      ],
    },
    {
      title: "Capacity & Future Development",
      fields: [
        {
          label: "Capacity & Future Development",
          type: "checkbox",
          options: [
            "Training & Capacity Building Programs",
            "Upcoming Features",
          ],
        },
      ],
    },
  ],
};

export const DIGITAL_FIELD_NOTES_FORM_STEP_1 = {
  title: "Digital Field Notes Capture & Logging",
  subtitle: "Digital Field Notes Capture & Logging",
  sections: [
    {
      title: "Basic Information",
      fields: [
        {
          label: "Field Note ID",
          type: "text",
          placeholder: "Unique identifier auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto captured",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Name of facility or project where note is recorded",
        },
        {
          label: "Area within Facility / Project",
          type: "text",
          placeholder: "Specific zone or section referenced in notes",
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          placeholder: "GPS coordinates auto-captured",
          disabled: true,
        },
        {
          label: "Captured By",
          type: "text",
          placeholder: "Name / Role of note-taker",
        },
      ],
    },
    {
      title: "Note Details",
      fields: [
        {
          label: "Note Type",
          type: "checkbox",
          options: [
            "General",
            "Technical",
            "Safety",
            "Social",
            "Governance",
            "Other: ______",
          ],
        },
        {
          label: "Reference to Observation/Inspection",
          type: "text",
          placeholder:
            "Link to Field Observation / Walkthrough ID (if applicable)",
        },
        {
          label: "Description of Notes",
          type: "textarea",
          rows: 4,
          placeholder:
            "Free text or structured note entry; AI rephrasing optional",
        },
        {
          label: "Evidence Linked",
          type: "checkbox",
          options: [
            "Photo (auto timestamped)",
            "Video (auto timestamped)",
            "File references",
          ],
        },
        {
          label: "Upload Evidence",
          type: "file",
          accept: ".jpg,.jpeg,.png,.gif,.mp4,.avi,.mov,.pdf,.doc,.docx",
          multiple: true,
          placeholder: "Upload supporting photos, videos, or files",
        },
        {
          label: "AI Auto-Summary",
          type: "textarea",
          rows: 2,
          placeholder:
            "Optional quick summary of note contents (generated by system)",
          disabled: true,
        },
      ],
    },
    {
      title: "Follow-up & Compliance",
      fields: [
        {
          label: "Follow-up Requirement",
          type: "radio",
          options: ["None", "Action Item", "Escalation Needed"],
        },
        {
          label: "Responsible Party",
          type: "text",
          placeholder:
            "Internal team / Contractor / Other (if follow-up required)",
        },
        {
          label: "Compliance Linkage",
          type: "checkbox",
          options: ["ESG", "EHS", "Quality"],
          note: "Auto-mapped to ESG / EHS / Quality compliance areas",
        },
      ],
    },
    {
      title: "Attachments & Notes (Optional)",
      fields: [
        {
          label: "Attachments",
          type: "checkbox",
          options: ["Meeting Minutes", "Checklist(s)", "Supporting Files"],
        },
        {
          label: "Upload Attachments",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt",
          multiple: true,
          placeholder:
            "Upload meeting minutes, checklists, or supporting files",
        },
      ],
    },
  ],
};

export const HAZARD_IDENTIFICATION_HIRA_JSA_FORM = {
  title: "Smart AI-Powered Hazard Identification & Risk Assessment",
  subtitle: "Hazard Identification (HIRA/JSA)",
  formTitle: "",
  downloadFileName: "HIRA_JSA_AI_Risk_Report",
  downloadFileExtension: "pdf",

  showReportCountdownButton: true,
  showSaveButton: true,
  showNextButton: true,
  showDownloadButton: true,

  sections: [
    // ===================== 1. BASIC INFORMATION =====================
    {
      title: "Basic Information",
      description: "Auto-generated • GPS • Blockchain timestamped",
      fields: [
        { label: "Assessment ID", type: "text", disabled: true },
        { label: "Date & Time", type: "text", disabled: true },
        {
          label: "Facility / Project Name",
          type: "text",
          required: true,
          placeholder: "e.g., GreenField Solar Park, Rajasthan",
        },
        {
          label: "Work Activity / Task",
          type: "select",
          required: true,
          options: [
            "Welding",
            "Chemical Handling",
            "Lifting",
            "Working at Height",
            "Hot Work",
            "Confined Space Entry",
            "Excavation",
            "Electrical Work",
            "Grinding/Cutting",
            "Manual Handling",
            "Vehicle Movement",
            "Crane Operation",
            "Scaffolding",
            "Demolition",
            "Other (Specify)",
          ],
        },
        { label: "Location (Geo-Tagged)", type: "text", disabled: true },
        {
          label: "Assessor(s)",
          type: "text",
          required: true,
          placeholder: "Name, Designation & Role",
        },
      ],
    },

    // ===================== 2. HAZARD IDENTIFICATION =====================
    {
      title: "Hazard Identification",
      fields: [
        {
          label: "Hazard Identified (Mandatory)",
          type: "textarea",
          rows: 5,
          required: true,
          placeholder: "Flying sparks, Slippery surface, Falling object...",
        },
        {
          label: "Types of Hazards Identified (Select all applicable)",
          type: "checkbox",
          required: true,
          options: [
            "Physical",
            "Chemical",
            "Biological",
            "Ergonomic",
            "Psychosocial",
            "Environmental",
            "Other (Specify)",
          ],
        },
        {
          label: "Initial Hazard Description (Detailed)",
          type: "textarea",
          rows: 5,
          placeholder:
            "Describe location, condition, exposure level, who is at risk...",
        },
      ],
    },

    // ===================== 3. CONSEQUENCE & RISK RATING =====================
    {
      title: "Consequence & Risk Assessment",
      fields: [
        {
          label: "Potential Consequence if Hazard Occurs",
          type: "textarea",
          rows: 4,
          required: true,
        },
        { label: "Likelihood (AI Auto-Scoring)", type: "text", disabled: true },
        {
          label: "Risk Rating (Before Controls)",
          type: "text",
          disabled: true,
        },
        {
          label: "Existing Controls in Place",
          type: "textarea",
          rows: 6,
          required: true,
        },
        {
          label: "Additional Controls Required (AI Suggested)",
          type: "textarea",
          rows: 4,
        },
        {
          label: "Timeline / Priority",
          type: "select",
          options: [
            "Immediate (Critical – Within 24h)",
            "Short Term (1–7 days)",
            "Long Term (>7 days)",
          ],
        },
        {
          label: "Residual Risk Rating (After Controls)",
          type: "text",
          disabled: true,
        },
      ],
    },

    // ===================== 4. CORRECTIVE & PREVENTIVE ACTIONS =====================
    {
      title: "Corrective & Preventive Actions",
      fields: [
        {
          label: "Immediate Corrective Action",
          type: "textarea",
          rows: 4,
          required: true,
        },
        {
          label: "Follow-up Action Needed",
          type: "textarea",
          rows: 4,
        },
        {
          label: "Responsible Person / Role",
          type: "text",
          required: true,
        },
        {
          label: "Target Completion Date",
          type: "date",
        },
        {
          label: "Verification Method",
          type: "select",
          options: [
            "Inspection",
            "Training",
            "Checklist Verification",
            "AI Photo Validation",
            "Other",
          ],
        },
        {
          label: "Status",
          type: "select",
          required: true,
          options: ["Open", "Under Review", "Resolved", "Verified"],
        },
      ],
    },

    // ===================== 5. ATTACHMENTS & REFERENCES =====================
    {
      title: "Attachments & Linked Records",
      fields: [
        {
          label: "Upload Evidence (Photos / Videos / Docs)",
          type: "file",
          multiple: true,
          accept: ".jpg,.jpeg,.png,.mp4,.pdf,.doc,.docx",
        },
        {
          label: "Linked Safety Documentation",
          type: "checkbox",
          options: [
            "Permit-to-Work",
            "JSA / THA",
            "Photos / Videos",
            "SOP / Work Instructions",
            "Risk Matrix",
            "Incident Record",
            "Other (Specify)",
          ],
        },
      ],
    },
  ],
};

export const SMART_AI_FIELD_NOTES_TEMPLATE_STEP_2 = {
  title: "Smart AI-Enabled Field Notes Template",
  subtitle: "Smart AI-Enabled Field Notes Template",
  formTitle: "",
  sections: [
    {
      title: "Note Details",
      fields: [
        {
          label: "Field Note ID",
          type: "text",
          placeholder: "Auto-generated",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter facility or project name",
        },
        {
          label: "Area / Section",
          type: "text",
          placeholder: "Enter specific area or section",
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          placeholder: "Auto-captured GPS coordinates",
          disabled: true,
        },
        {
          label: "Captured By (Name / Role)",
          type: "text",
          placeholder: "Enter name and role",
        },
      ],
    },
    {
      title: "Classification of Notes",
      fields: [
        {
          label: "Note Type",
          type: "checkbox",
          options: [
            "General",
            "Technical",
            "Safety",
            "ESG",
            "Governance",
            "Other ______",
          ],
        },
        {
          label: "Reference",
          type: "radio",
          options: [
            "Field Observation ID",
            "Walkthrough ID",
            "Independent Note",
          ],
        },
        {
          label: "Field Observation ID (if applicable)",
          type: "text",
          placeholder: "Enter ID",
        },
        {
          label: "Walkthrough ID (if applicable)",
          type: "text",
          placeholder: "Enter ID",
        },
        {
          label: "Compliance Linkage",
          type: "text",
          placeholder: "Enter compliance linkage",
        },
        {
          label: "Confidentiality",
          type: "radio",
          options: ["Public", "Internal", "Restricted"],
        },
      ],
    },
    {
      title: "Content of Notes",
      fields: [
        {
          label: "Notes Entry (AI rephrasing optional)",
          type: "textarea",
          rows: 6,
          placeholder: "Enter notes here",
        },
        {
          label: "Evidence",
          type: "checkbox",
          options: [
            "Photo(s) (auto time-stamped, geo-tagged)",
            "Video(s) (auto time-stamped, geo-tagged)",
            "Document(s)",
            "Other ______",
          ],
        },
        {
          label: "Upload Evidence",
          type: "file",
          accept: ".jpg,.jpeg,.png,.gif,.mp4,.avi,.mov,.pdf,.doc,.docx",
          multiple: true,
          placeholder: "Upload supporting files",
        },
        {
          label: "AI Auto-Summary",
          type: "textarea",
          rows: 2,
          placeholder: "Auto-generated summary",
          disabled: true,
        },
      ],
    },
    {
      title: "Actions (if any)",
      fields: [
        {
          label: "Follow-up Required",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Responsible Party (if Yes)",
          type: "text",
          placeholder: "Enter responsible party",
        },
        {
          label: "Action Item / Escalation (if Yes)",
          type: "textarea",
          rows: 3,
          placeholder: "Enter action item or escalation details",
        },
        {
          label: "Timeline (if set)",
          type: "date",
          placeholder: "Select timeline date",
        },
      ],
    },
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Linked to Risk Register / Incident Log",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "Enter reviewer name",
        },
        {
          label: "Review Date",
          type: "date",
          placeholder: "Select review date",
        },
      ],
    },
    {
      title: "Notes",
      fields: [
        {
          label: "Additional Notes",
          type: "textarea",
          rows: 4,
          placeholder: "Enter additional notes or comments",
        },
      ],
    },
  ],
};

export const ESG_REPORTING_COMPLIANCE_FORM_S3 = {
  title: "",
  subtitle: "Auto-Synced to ESG Vision Dashboard",
  formTitle: "ESG Vision Dashboard - ESG Compliance Features",
  sections: [
    {
      title: "Detail Reporting",
      fields: [
        {
          label: "Global ESG Reporting (Standards & Frameworks Compliances)",
          type: "checkbox",
          options: [
            "GRI",
            "SASB",
            "TCFD",
            "IFRS (S1, S2)",
            "CSRD / ESRS (EU)",
            "UNGC",
            "SDG",
            "CDP",
            "WB",
            "IFC PSs",
            "Equator Principles",
            "ISO Standards",
            "OECD Guidelines",
            "TNFD",
            "AA1000 Series",
            "PRI Principles",
            "IRIS+ (GIIN)",
          ],
        },
      ],
    },
    {
      title: "Climate & Carbon Compliance",
      fields: [
        {
          label: "Climate & Carbon Compliance",
          type: "checkbox",
          options: [
            "GHG Emissions Management",
            "Climate Impact Assessment",
            "Sustainable Finance & Bond Standards",
            "Carbon Credit, Offset & Emission Trading",
          ],
        },
      ],
    },
    {
      title: "Operational ESG Systems & Reporting",
      fields: [
        {
          label: "Operational ESG Systems & Reporting",
          type: "checkbox",
          options: [
            "Environmental Compliance Reporting",
            "Social Compliance Reporting",
            "E&S Legal & Applicable Standards Mapping",
            "Environmental & Social System Management",
          ],
        },
      ],
    },
    {
      title: "Industrial & Country-Specific ESG Compliance",
      fields: [
        {
          label: "Industrial & Country-Specific ESG Compliance",
          type: "checkbox",
          options: [
            "Sector / Industrial-Specific Standard",
            "Country-Specific ESG Compliance",
            "Operational Compliance ESG Reporting",
            "E&S Due Diligence for ESG Compliance",
          ],
        },
      ],
    },
    {
      title: "Data Analytics",
      fields: [
        {
          label: "Data Analytics",
          type: "checkbox",
          options: ["ESG Analytics", "ESG Benchmarking"],
        },
      ],
    },
    {
      title: "Supplier Selection & Compliance",
      fields: [
        {
          label: "Supplier Selection & Compliance",
          type: "checkbox",
          options: ["Supplier Assessment & Compliance"],
        },
      ],
    },
    {
      title: "Capacity & Future Development",
      fields: [
        {
          label: "Capacity & Future Development",
          type: "checkbox",
          options: [
            "Training & Capacity Building Programs",
            "Upcoming Features",
          ],
        },
      ],
    },
  ],
};

export const Hazard_Identification_Step_3 = [
  // DETAIL REPORTING – SABSE UPAR
  {
    heading: "Detail Reporting",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  // GLOBAL ESG REPORTING
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const ESG_REPORTING_COMPLIANCE_FORM_S4 = {
  title: "ESG Reporting and Compliance Checklist",
  subtitle: "Auto-Synced to ESG Vision Dashboard",
  formTitle: "ESG Vision Dashboard - ESG Compliance Features",
  sections: [
    {
      title: "Detail Reporting",
      fields: [
        {
          label: "Global ESG Reporting (Standards & Frameworks Compliances)",
          type: "checkbox",
          options: [
            "GRI",
            "SASB",
            "TCFD",
            "IFRS (S1, S2)",
            "CSRD / ESRS (EU)",
            "UNGC",
            "SDG",
            "CDP",
            "WB",
            "IFC PSs",
            "Equator Principles",
            "ISO Standards",
            "OECD Guidelines",
            "TNFD",
            "AA1000 Series",
            "PRI Principles",
            "IRIS+ (GIIN)",
          ],
        },
      ],
    },
    {
      title: "Climate & Carbon Compliance",
      fields: [
        {
          label: "Climate & Carbon Compliance",
          type: "checkbox",
          options: [
            "GHG Emissions Management",
            "Climate Impact Assessment",
            "Sustainable Finance & Bond Standards",
            "Carbon Credit, Offset & Emission Trading",
          ],
        },
      ],
    },
    {
      title: "Operational ESG Systems & Reporting",
      fields: [
        {
          label: "Operational ESG Systems & Reporting",
          type: "checkbox",
          options: [
            "Environmental Compliance Reporting",
            "Social Compliance Reporting",
            "E&S Legal & Applicable Standards Mapping",
            "Environmental & Social System Management",
          ],
        },
      ],
    },
    {
      title: "Industrial & Country-Specific ESG Compliance",
      fields: [
        {
          label: "Industrial & Country-Specific ESG Compliance",
          type: "checkbox",
          options: [
            "Sector / Industrial-Specific Standard",
            "Country-Specific ESG Compliance",
            "Operational Compliance ESG Reporting",
            "E&S Due Diligence for ESG Compliance",
          ],
        },
      ],
    },
    {
      title: "Data Analytics",
      fields: [
        {
          label: "Data Analytics",
          type: "checkbox",
          options: ["ESG Analytics", "ESG Benchmarking"],
        },
      ],
    },
    {
      title: "Supplier Selection & Compliance",
      fields: [
        {
          label: "Supplier Selection & Compliance",
          type: "checkbox",
          options: ["Supplier Assessment & Compliance"],
        },
      ],
    },
    {
      title: "Capacity & Future Development",
      fields: [
        {
          label: "Capacity & Future Development",
          type: "checkbox",
          options: [
            "Training & Capacity Building Programs",
            "Upcoming Features",
          ],
        },
      ],
    },
  ],
};

export const DIGITAL_MEETING_CAPTURE_AND_REPORTING = {
  title: "Digital Meeting Capture & Reporting Form",
  subtitle: "ESG & Compliance Meeting Documentation",
  formTitle: "Digital Meeting Capture & Reporting Form",
  downloadFileName: "Digital_Meeting_Capture_Report",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Meeting Information",
      fields: [
        {
          label: "MoM ID",
          type: "text",
          placeholder: "Unique identifier auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto Captured",
          disabled: true,
        },
        {
          label: "Meeting Type",
          type: "checkbox",
          options: [
            "Kick-off",
            "Progress Review",
            "Compliance",
            "Contractor",
            "Stakeholder Engagement",
            "Other (please specify)",
          ],
        },
        {
          label: "Project / Facility Name",
          type: "text",
          placeholder: "Meeting related project or facility",
        },
        {
          label: "Location / Platform",
          type: "text",
          placeholder: "Physical venue or digital platform (Teams/Zoom/etc.)",
        },
        {
          label: "Chairperson / Facilitator",
          type: "text",
          placeholder: "Name / Role",
        },
      ],
    },
    {
      title: "Participants & Attendees",
      fields: [
        {
          label: "Participants List",
          type: "textarea",
          rows: 4,
          placeholder:
            "Names, roles, organizations (auto-import from invite or attendance)",
        },
        {
          label: "Attendance Records",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt",
          multiple: false,
          placeholder: "Upload attendance list or sign-in sheet",
        },
      ],
    },
    {
      title: "Agenda & Discussion",
      fields: [
        {
          label: "Agenda Items",
          type: "textarea",
          rows: 4,
          placeholder: "Pre-listed objectives (can attach document)",
        },
        {
          label: "AI Auto-Summarization of Agenda",
          type: "textarea",
          rows: 3,
          placeholder:
            "AI-generated agenda summary will appear here (optional)",
          disabled: true,
        },
        {
          label: "Meeting Detail",
          type: "textarea",
          rows: 5,
          placeholder: "Discussion records, key points, decisions made",
        },
      ],
    },
    {
      title: "Action Items & Ownership",
      fields: [
        {
          label: "Action Items",
          type: "textarea",
          rows: 4,
          placeholder: "List of action items, decisions, and outcomes",
        },
        {
          label: "Responsible Person",
          type: "text",
          placeholder: "Name and role of person responsible for action items",
        },
        {
          label: "Due Date",
          type: "date",
          placeholder: "Expected completion date for action items",
        },
      ],
    },
    {
      title: "Attachments & Supporting Documents",
      fields: [
        {
          label: "Presentation Decks",
          type: "file",
          accept: ".pdf,.ppt,.pptx",
          multiple: true,
          placeholder: "Upload presentation files",
        },
        {
          label: "Shared Documents",
          type: "file",
          accept: ".doc,.docx,.xls,.xlsx,.pdf,.txt",
          multiple: true,
          placeholder: "Upload shared documents and references",
        },
        {
          label: "Other Supporting Files",
          type: "file",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt,.zip",
          multiple: true,
          placeholder: "Upload any other supporting files",
        },
      ],
    },
    {
      title: "Meeting Confirmation & Submission",
      fields: [
        {
          label:
            "I confirm that all meeting information is accurate and complete:",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Additional Comments or Notes:",
          type: "textarea",
          rows: 3,
          placeholder: "Any additional context or observations",
        },
        {
          label: "Prepared By (Name & Title)",
          type: "text",
          placeholder: "Full name and title of person preparing MoM",
        },
        {
          label: "Prepared By Email",
          type: "email",
          placeholder: "Contact email for follow-up",
        },
        {
          label: "Submission Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured on submission",
          disabled: true,
        },
        {
          label: "Digital Signature",
          type: "text",
          placeholder: "Digital signature or typed signature confirmation",
        },
      ],
    },
  ],
};

// src/config/SmartTemplateData.js  (ya jahan rakhte ho)

export const NOISE_MONITORING_FORM = {
  title: "Digital Noise Monitoring Capture & Setup",
  subtitle: "AI-Powered Occupational & Environmental Noise Monitoring",
  formTitle: "Noise Monitoring Report",
  downloadFileName: "Noise_Monitoring_Report",
  downloadFileExtension: "pdf",

  // Buttons exactly as you said
  topRightButtons: ["SAVE", "USER ID"],
  bottomButtons: ["NEXT"],
  actionButtons: [],

  sections: [
    // ===================== SECTION 1: MONITORING SETUP =====================
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "Auto-generated unique identifier",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto captured (system clock + timezone)",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Monitoring Area(s)",
          type: "checkbox",
          options: [
            "Plant boundary",
            "Workstation",
            "Equipment Zone",
            "Community Area",
            "Other _______",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          placeholder: "GPS auto-captured from device",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          placeholder: "Names/Roles (EHS, ESG, Consultant, Contractor)",
        },
        {
          label: "Department(s) Covered",
          type: "checkbox",
          options: [
            "Operations",
            "Utilities",
            "EHS",
            "Contractors",
            "Community",
            "Other _______",
          ],
        },
      ],
    },

    // ===================== SECTION 2: NOISE MONITORING PARAMETERS =====================
    {
      title: "Noise Monitoring Parameters (User Input + AI Support)",
      fields: [
        {
          label: "Type of Monitoring",
          type: "checkbox",
          options: ["Occupational", "Environmental", "Community Noise"],
        },
        {
          label: "Noise Source(s)",
          type: "text",
          placeholder:
            "Equipment / Machinery / Traffic / Construction / Other _______",
        },
        {
          label: "Monitoring Duration",
          type: "checkbox",
          options: [
            "Instantaneous",
            "Short-term (e.g., 15 min)",
            "Continuous (AI suggests per regulation)",
          ],
        },
        {
          label: "Equipment Used",
          type: "text",
          placeholder:
            "Sound Level Meter / Dosimeter / AI IoT Sensor (AI validates calibration status)",
        },
        {
          label: "Applicable Standards",
          type: "text",
          placeholder:
            "OSHA, IFC, WHO, ISO 1996, Local Regulations (AI auto-links)",
          disabled: true,
          note: "AI auto-detects & suggests applicable standards",
        },
      ],
    },

    // ===================== SECTION 3: OBSERVATION INPUTS =====================
    {
      title: "Observation Inputs (User-Driven, AI-Assisted)",
      fields: [
        {
          label: "Noise Levels Measured",
          type: "dynamic",
          placeholder: "User enters values or uploads instrument data (dB)",
          note: "Example: Leq = 88 dB, Lmax = 102 dB",
        },
        {
          label: "Frequency Bands (Optional)",
          type: "text",
          placeholder:
            "AI can extract from uploaded logs (1/3 Octave analysis)",
        },
        {
          label: "On-site Observations / Activities",
          type: "textarea",
          rows: 4,
          placeholder:
            "e.g., loud hammering during welding, compressor running continuously",
        },
        {
          label: "Evidence Capture",
          type: "file",
          accept: ".jpg,.jpeg,.png,.mp4,.mov",
          multiple: true,
          placeholder:
            "Upload photo/video with time-stamp (AI detects source activities)",
        },
        {
          label: "Community Feedback",
          type: "textarea",
          rows: 3,
          placeholder: "Complaints, stakeholder notes (if applicable)",
        },
        {
          label: "Baseline Reference",
          type: "text",
          placeholder:
            "Link historical noise data (AI shows deviation from baseline)",
        },
      ],
    },

    // ===================== SECTION 4: EVIDENCE & ATTACHMENTS =====================
    {
      title: "Evidence & Attachments",
      fields: [
        {
          label: "Upload sound meter calibration logs",
          type: "file",
          accept: ".pdf,.jpg,.png",
          multiple: true,
        },
        {
          label: "Auto-generate noise maps",
          type: "info",
          value: "AI plots geo-tagged readings on facility map",
        },
        {
          label: "AI Predictive Analysis",
          type: "info",
          value:
            "Noise exceedance expected in Welding Bay if load > 70% after 2 weeks",
        },
        {
          label: "Auto-link monitoring results with",
          type: "checkbox",
          options: [
            "Community Complaints Register",
            "Contractor Records",
            "Permit-to-Work Logs",
          ],
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value",
      helperText: "Add another noise monitoring session / location",
    },
  ],
};

export const AI_GENERATED_NOISE_MONITORING_TEMPLATE = {
  title: "AI-Generated Noise Monitoring Table",
  subtitle: "Real-time Compliance | AI Auto-Check | IFC/WHO/OSHA Ready",
  formTitle: "Noise Level Monitoring Log",
  downloadFileName: "AI_Noise_Monitoring_Report",
  downloadFileExtension: "png",

  sections: [
    // ========= 1. Monitoring Setup Information =========
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "Auto-generated unique identifier",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto captured (system clock + timezone)",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter facility/project name",
          required: true,
        },
        {
          label: "Monitoring Area(s)",
          type: "checkbox",
          options: [
            "Plant boundary",
            "Workstation",
            "Equipment Zone",
            "Community Area",
            "Other (specify)",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          placeholder: "GPS auto-captured",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "textarea",
          rows: 3,
          placeholder: "EHS, ESG, Consultant, Contractor (Names & Roles)",
        },
      ],
    },

    // ========= 2. NOISE MONITORING RESULTS TABLE (With 3 Pre-filled Examples) =========
    {
      title: "Noise Monitoring Results (Live AI Compliance Check)",
      type: "table",
      addRowLabel: "Add Monitoring Point",
      defaultRows: 0,
      preFilledRows: [
        {
          "Monitoring Point": "Workstation A (Cutting Area)",
          "Standard / Benchmark": "OSHA ≤ 85 dB (8h avg)",
          "Method / Equipment": "Dosimeter",
          "Measured Value": "92",
          Unit: "dB",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+7 dB",
          "AI Suggested Action": "Install sound barriers, enforce hearing PPE",
          "Responsible Person": "Contractor Lead",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Monitoring Point": "Plant Boundary (North)",
          "Standard / Benchmark": "IFC ≤ 55 dB (Daytime)",
          "Method / Equipment": "Sound Level Meter",
          "Measured Value": "58",
          Unit: "dB",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+3 dB",
          "AI Suggested Action": "Limit machinery at night, tree barriers",
          "Responsible Person": "EHS Officer",
          Timeline: "2 Weeks",
          Status: "Open",
        },
        {
          "Monitoring Point": "Community Zone (Village)",
          "Standard / Benchmark": "WHO ≤ 45 dB (Night)",
          "Method / Equipment": "Continuous Sensor",
          "Measured Value": "42",
          Unit: "dB",
          "Compliance Status (AI)": "Compliant",
          "Variance from Standard": "Within limit",
          "AI Suggested Action": "Continue monitoring",
          "Responsible Person": "Community Liaison",
          Timeline: "Ongoing",
          Status: "Closed",
        },
      ],
      fields: [
        {
          label: "Monitoring Point",
          type: "text",
          width: "16%",
          placeholder: "e.g., Workstation A, Plant Boundary",
        },
        {
          label: "Standard / Benchmark",
          type: "text",
          width: "16%",
          placeholder: "e.g., OSHA ≤ 85 dB, IFC ≤ 55 dB",
        },
        { label: "Method / Equipment", type: "text", width: "14%" },
        { label: "Measured Value", type: "text", width: "9%" },
        {
          label: "Unit",
          type: "text",
          width: "7%",
          value: "dB",
          disabled: true,
        },
        {
          label: "Compliance Status (AI)",
          type: "text",
          disabled: true,
          width: "11%",
        },
        {
          label: "Variance from Standard",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Action",
          type: "text",
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        { label: "Timeline", type: "text", width: "10%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
    },

    // ========= 3. Validation & Closure =========
    {
      title: "Validation & Closure",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 4,
          value:
            "Workstation A exceedance → Risk ID: OHS-015 (Hearing Loss Risk)\nPlant Boundary exceedance → Risk ID: SOC-009 (Community Complaint Risk)",
          disabled: true,
        },
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "Supervisor / EHS-ESG Officer / Compliance Lead",
        },
        { label: "Review Date", type: "date" },
      ],
    },

    // ========= 4. Closing & Digital Signatures =========
    {
      title: "Closing & Signatures (Audit Ready)",
      fields: [
        {
          label: "Prepared By (Monitoring Lead)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Approved By (Project/Corporate ESG Lead)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Date",
          type: "date",
          disabled: true,
          placeholder: "Auto-filled on submission",
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all noise monitoring data is accurate and actions are assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const Noise_Monitoring_Report = {
  title: "AI-Generated Noise Monitoring Table",
  subtitle: "Real-time Compliance | AI Auto-Check | IFC/WHO/OSHA Ready",
  formTitle: "Noise Level Monitoring Log",
  downloadFileName: "AI_Noise_Monitoring_Report",
  downloadFileExtension: "png",

  sections: [
    // ========= 1. Monitoring Setup =========
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "Auto-generated unique identifier",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto captured (system clock + timezone)",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter facility/project name",
          required: true,
        },
        {
          label: "Monitoring Area(s)",
          type: "checkbox",
          options: [
            "Plant boundary",
            "Workstation",
            "Equipment Zone",
            "Community Area",
            "Other (specify)",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          placeholder: "GPS auto-captured",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "textarea",
          rows: 3,
          placeholder: "EHS, ESG, Consultant, Contractor (Names & Roles)",
        },
      ],
    },

    // ========= 2. NOISE MONITORING TABLE WITH 3 REAL EXAMPLES =========
    {
      title: "Noise Monitoring Results (Live AI Compliance Check)",
      type: "table",
      addRowLabel: "Add Monitoring Point",
      defaultRows: 0,
      preFilledRows: [
        {
          "Monitoring Point": "Workstation A (Cutting Area)",
          "Standard / Benchmark": "OSHA ≤ 85 dB (8h avg)",
          "Method / Equipment": "Dosimeter",
          "Measured Value": "92",
          Unit: "dB",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+7 dB",
          "AI Suggested Action": "Install sound barriers, enforce hearing PPE",
          "Responsible Person": "Contractor Lead",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Monitoring Point": "Plant Boundary (North)",
          "Standard / Benchmark": "IFC ≤ 55 dB (Daytime)",
          "Method / Equipment": "Sound Level Meter",
          "Measured Value": "58",
          Unit: "dB",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+3 dB",
          "AI Suggested Action": "Limit machinery at night, tree barriers",
          "Responsible Person": "EHS Officer",
          Timeline: "2 Weeks",
          Status: "Open",
        },
        {
          "Monitoring Point": "Community Zone (Village)",
          "Standard / Benchmark": "WHO ≤ 45 dB (Night)",
          "Method / Equipment": "Continuous Sensor",
          "Measured Value": "42",
          Unit: "dB",
          "Compliance Status (AI)": "Compliant",
          "Variance from Standard": "Within limit",
          "AI Suggested Action": "Continue monitoring",
          "Responsible Person": "Community Liaison",
          Timeline: "Ongoing",
          Status: "Closed",
        },
      ],
      fields: [
        { label: "Monitoring Point", type: "text", width: "16%" },
        { label: "Standard / Benchmark", type: "text", width: "16%" },
        { label: "Method / Equipment", type: "text", width: "14%" },
        { label: "Measured Value", type: "text", width: "9%" },
        {
          label: "Unit",
          type: "text",
          width: "7%",
          value: "dB",
          disabled: true,
        },
        {
          label: "Compliance Status (AI)",
          type: "text",
          disabled: true,
          width: "11%",
        },
        {
          label: "Variance from Standard",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Action",
          type: "text",
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        { label: "Timeline", type: "text", width: "10%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
    },

    // ========= 3. Validation & Closure =========
    {
      title: "Validation & Closure",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 4,
          value:
            "Workstation A exceedance → Risk ID: OHS-015 (Hearing Loss Risk)\nPlant Boundary exceedance → Risk ID: SOC-009 (Community Complaint Risk)",
          disabled: true,
        },
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
        },
        { label: "Reviewed By", type: "text", placeholder: "EHS/ESG Officer" },
        { label: "Review Date", type: "date" },
      ],
    },

    // ========= 4. Signatures =========
    {
      title: "Closing & Digital Signatures",
      fields: [
        {
          label: "Prepared By",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Verified By",
          type: "text",
          placeholder: "EHS/ESG Officer",
          required: true,
        },
        {
          label: "Approved By",
          type: "text",
          placeholder: "Project/ESG Head",
          required: true,
        },
        { label: "Date", type: "date", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: ["I confirm all data is accurate"],
          required: true,
        },
      ],
    },
  ],
};

export const NOISE_SYNC_ESG_DASHBOARD = [
  // Auto-Synced to ESG Vision Dashboard – Fully Compatible with StandardsSelector
  {
    heading: "Auto-Synced to ESG Vision Dashboard",
    items: [], // Just a title heading
  },

  // Detail Reporting
  {
    heading: "Detail Reporting",
    items: [{ id: "detail_reporting", label: "Enabled" }],
  },

  // Global ESG Reporting (Standards & Frameworks Compliances)
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_compliance", label: "Environmental Compliance Reporting" },
      { id: "social_compliance", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific ESG Compliance
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_compliance", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due_diligence", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "esg_benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier Selection & Compliance
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future Development
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming_features", label: "Upcoming Features" },
    ],
  },
];

// src/config/GRIFormConfig.js  (ya jahan bhi tu rakhta hai)

export const AIR_QUALITY_MONITORING_FORM = {
  title: "Digital Air Quality Monitoring Capture & Setup",
  subtitle: "",
  formTitle: "",
  downloadFileName: "Air_Quality_Monitoring_Report",
  downloadFileExtension: "pdf",

  // Buttons
  topRightButtons: ["SAVE", "USER ID"],
  bottomButtons: ["NEXT"],
  actionButtons: [],

  sections: [
    // ===================== SECTION 1: MONITORING SETUP =====================
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "Auto-generated unique ID",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Monitoring Area(s)",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Indoor offices, Near stacks, Workshops, Residential boundaries, Rooftop, Fence line",
        },
        {
          label: "Geo-Tagging",
          type: "text",
          placeholder: "GPS auto-captured from device",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          placeholder:
            "Names / Roles (EHS Lead, Consultant, Contractor, Operator, etc.)",
        },
        {
          label: "Department(s) Covered",
          type: "checkbox",
          options: [
            "Operations",
            "Utilities",
            "EHS",
            "Contractors",
            "Community",
            "Other _______",
          ],
        },
        {
          label: "Monitoring Objective",
          type: "checkbox",
          options: [
            "Regulatory Compliance",
            "Workplace Exposure",
            "ESG Reporting",
            "Community Engagement",
            "Incident Investigation",
            "Other _______",
          ],
        },
      ],
    },

    // ===================== SECTION 2: MONITORING PARAMETERS =====================
    {
      fields: [
        {
          label: "Type of Monitoring (multi-select) ",
          type: "checkbox",
          options: [
            "Ambient Air Quality",
            "Indoor Air Quality",
            "Workplace Exposure",
            "Emissions Source (stacks, generators, vehicles)",
          ],
        },
        {
          label: "Parameters to Monitor (AI Suggests)",
          type: "checkbox",
          options: [
            "PM2.5",
            "PM10",
            "SO₂",
            "NOx",
            "CO",
            "O₃",
            "VOCs",
            "CO₂ (Indoor)",
            "Other _______",
          ],
        },
        {
          label: "Monitoring Frequency",
          type: "checkbox",
          options: ["Daily", "Weekly", "Monthly", "Quarterly", "Continuous"],
          note: "AI suggests based on regulation / permits / contracts",
        },
        {
          label: "Applicable Standards / Benchmarks",
          type: "text",
          placeholder:
            "WHO, OSHA, EPA, IFC, ISO 14001, Local Standards (AI auto-links)",
          disabled: true,
          note: "AI auto-detects jurisdiction & ESG framework standards",
        },
        {
          label: "Monitoring Method / Equipment",
          type: "text",
          placeholder: "Portable samplers, Fixed sensors, Lab analysis, etc.",
          note: "AI checks calibration status & compliance with EPA/ISO methods",
        },
      ],
    },

    // ===================== SECTION 3: FIELD OBSERVATIONS =====================
    {
      title: "Observations / Field Notes (User Input)  ",
      fields: [
        {
          label: "Weather Conditions",
          type: "textarea",
          rows: 3,
          placeholder: "Wind speed, direction, temperature, humidity, rainfall",
        },
        {
          label: "Notable Events / Activities",
          type: "textarea",
          rows: 4,
          placeholder:
            "Construction, traffic surge, nearby burning, generator running, painting, welding, etc.",
        },
        {
          label: "Sensory Observations",
          type: "checkbox",
          options: [
            "Visible dust",
            "Smoke plumes",
            "Strong odors",
            "Haze",
            "Irritation reported",
            "None",
          ],
        },
      ],
    },

    // ===================== SECTION 4: EVIDENCE & ATTACHMENTS =====================
    {
      title: "Evidence & Attachments",
      fields: [
        {
          label: "Upload Lab Certificates / Sensor Calibration Logs",
          type: "file",
          accept: ".pdf,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload Geo-Tagged Photos of Monitoring Stations",
          type: "file",
          accept: ".jpg,.jpeg,.png",
          multiple: true,
        },
        {
          label: "AI Auto-Generated Trend Graphs",
          type: "info",
          value: "Daily, Weekly, Monthly trends plotted automatically",
        },
        {
          label: "AI Predictive Analysis",
          type: "info",
          value:
            "CO₂ levels expected to exceed 2000 ppm within 5 days if current trend continues",
        },
        {
          label: "Auto-Link Monitoring Results With",
          type: "checkbox",
          options: [
            "Incident Logs",
            "Community Complaints",
            "Regulatory Permits",
            "Contractor Activities",
          ],
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value",
      helperText: "Add another noise monitoring session / location",
    },
  ],
};

// GRIFormConfig.js — YE PURA CODE PASTE KAR DO

export const AIR_QUALITY_MONITORING_STEP_2 = {
  title: "Smart AI-Enabled Air Quality Monitoring Form",
  subtitle: "",
  formTitle: "Monitoring Results Table",
  downloadFileName: "Air_Quality_Monitoring_Report",
  downloadFileExtension: "pdf",

  sections: [
    // ========== BASIC INFO ==========
    {
      title: "",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "AQM-2025-11-0891",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: "2025-11-26T14:30",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "ABC Cement Plant, Aligarh",
          required: true,
        },
        {
          label: "Monitoring Area(s)",
          type: "textarea",
          rows: 3,
          value:
            "Near kiln stack\nCrusher area\nPlant boundary (East)\nCommunity village (800m)",
        },
        {
          label: "Geo-Tagging",
          type: "text",
          value: "28.7041° N, 77.1025° E",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          value: "Rajesh Kumar (EHS), Priya Sharma (Consultant), 2 Contractors", // FIXED: value:value: → value:
        },
      ],
    },

    // ========== MAIN TABLE — DATA DIKHEGA 100% ==========
    {
      title: "AI-Generated Air Quality Monitoring Results Table",
      type: "table",
      addRowLabel: "+ Click here to Add New Monitoring Point",

      fields: [
        { label: "Parameter Monitored", type: "text", width: "12%" },
        { label: "Standard / Benchmark", type: "text", width: "14%" },
        { label: "Method / Equipment", type: "text", width: "12%" },
        { label: "Measured Value", type: "text", width: "10%" },
        { label: "Unit", type: "text", width: "8%" },
        {
          label: "Compliance Status (AI)",
          type: "text",
          disabled: true,
          width: "12%",
        },
        {
          label: "Variance from Standard",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Action",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "select",
          options: [
            "Immediate",
            "1 Day",
            "1 Week",
            "2 Weeks",
            "1 Month",
            "Ongoing",
          ],
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],

      preFilledRows: [
        {
          "Parameter Monitored": "PM2.5",
          "Standard / Benchmark": "WHO ≤ 25 µg/m³",
          "Method / Equipment": "Portable Air Sampler",
          "Measured Value": "38",
          Unit: "µg/m³",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+13 µg/m³",
          "AI Suggested Action":
            "Water spraying, restrict vehicle access, PPE for workers",
          "Responsible Person": "EHS Officer",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          "Parameter Monitored": "SO₂",
          "Standard / Benchmark": "CPCB ≤ 80 µg/m³ (24-hr)",
          "Method / Equipment": "Fixed Stack Monitor",
          "Measured Value": "65",
          Unit: "µg/m³",
          "Compliance Status (AI)": "Compliant",
          "Variance from Standard": "Within Limit",
          "AI Suggested Action": "Continue monitoring",
          "Responsible Person": "Plant Utility Lead",
          Timeline: "Ongoing",
          Status: "Open",
        },
        {
          "Parameter Monitored": "CO₂ (Indoor)",
          "Standard / Benchmark": "ASHRAE ≤ 1000 ppm",
          "Method / Equipment": "Indoor CO₂ Sensor",
          "Measured Value": "1450",
          Unit: "ppm",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+450 ppm",
          "AI Suggested Action":
            "Improve ventilation, HVAC check, install CO₂ scrubber",
          "Responsible Person": "Facility Manager",
          Timeline: "1 Week",
          Status: "Open",
        },
      ],
    },

    // Validation & Status
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 3,
          value:
            "→ AIR-001: High PM2.5 → Health Risk (Workers)\n→ AIR-005: CO₂ exceedance → Indoor Air Quality Issue",
          disabled: true,
        },
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
        },
        { label: "Reviewed By", type: "text", placeholder: "EHS/ESG Officer" },
        { label: "Review Date", type: "date" },
      ],
    },

    // Closing & Signatures
    {
      title: "Closing & Digital Signatures",
      fields: [
        {
          label: "Prepared By (Monitoring Team Lead)",
          type: "text",
          value: "Rajesh Kumar",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Corporate ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-26", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: ["I confirm all data is accurate and actions are assigned"],
          required: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

// GRIFormConfig.js mein daal do

export const AIR_QUALITY_MONITORING_STEP_3 = [
  // Main Title (Just for display – no items)
  {
    heading: "",
    items: [],
  },

  // Detail Reporting
  {
    heading: "Detail Reporting",
    items: [],
  },

  // Global ESG Reporting Standards
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const AIR_QUALITY_MONITORING_FORM_STEP_4 = {
  title: "Digital Air Quality Monitoring Capture & Setup",
  subtitle: "AI-Powered Real-Time Air Quality Detection & Compliance Tracking",
  formTitle: "Air Quality Monitoring Report",
  downloadFileName: "Air_Quality_Monitoring_Report",
  downloadFileExtension: "pdf",

  sections: [
    // SECTION 3: Real-Time Table
    {
      title: "AI-Generated Real-Time Air Quality Data",
      type: "table",
      addRowLabel: "+ Add Manual Reading",
      fields: [
        { label: "Parameter", type: "text", width: "12%" },
        { label: "Location", type: "text", width: "15%" },
        { label: "Measured Value", type: "text", width: "12%" },
        { label: "Unit", type: "text", width: "8%" },
        { label: "Standard Limit", type: "text", width: "15%" },
        { label: "Compliance", type: "text", disabled: true, width: "12%" },
        { label: "AI Alert / Action", type: "textarea", rows: 2, width: "26%" },
      ],
      preFilledRows: [
        {
          Parameter: "PM2.5",
          Location: "Near Stack",
          "Measured Value": "68",
          Unit: "µg/m³",
          "Standard Limit": "60 (24-hr)",
          Compliance: "Non-Compliant",
          "AI Alert / Action":
            "High dust from raw mill – activate water sprinklers immediately",
        },
        {
          Parameter: "PM10",
          Location: "Boundary",
          "Measured Value": "142",
          Unit: "µg/m³",
          "Standard Limit": "100 (24-hr)",
          Compliance: "Non-Compliant",
          "AI Alert / Action": "Road dust control needed – deploy water tanker",
        },
        {
          Parameter: "SO₂",
          Location: "Stack Exit",
          "Measured Value": "312",
          Unit: "µg/m³",
          "Standard Limit": "365 (24-hr)",
          Compliance: "Compliant",
          "AI Alert / Action": "Within limit – continue scrubber operation",
        },
        {
          Parameter: "NOx",
          Location: "DG Area",
          "Measured Value": "89",
          Unit: "µg/m³",
          "Standard Limit": "80 (annual)",
          Compliance: "Slightly High",
          "AI Alert / Action": "Optimize combustion – check fuel quality",
        },
        {
          Parameter: "CO",
          Location: "Indoor Office",
          "Measured Value": "4.2",
          Unit: "ppm",
          "Standard Limit": "9 (8-hr)",
          Compliance: "Compliant",
          "AI Alert / Action": "Ventilation adequate",
        },
      ],
    },

    // SECTION 4: AUTO-SYNCED TO ESG VISION DASHBOARD — EXACTLY AS YOU WANTED!
    {
      title: "Auto-Synced to ESG Vision Dashboard",
      fields: [
        { label: "Detail Reporting", type: "checkbox", options: ["Active"] },

        {
          label: "Global ESG Reporting (Standards & Frameworks Compliances)",
          type: "checkbox",
          options: [
            "GRI",
            "SASB",
            "TCFD",
            "IFRS (S1, S2)",
            "CSRD / ESRS (EU)",
            "UNGC",
            "SDG",
            "CDP",
            "WB",
            "IFC PSs",
            "Equator Principles",
            "ISO Standards",
            "OECD Guidelines",
            "TNFD",
            "AA1000 Series",
            "PRI Principles",
            "IRIS+ (GIIN)",
          ],
        },

        {
          label: "Climate & Carbon Compliance",
          type: "checkbox",
          options: [
            "GHG Emissions Management",
            "Climate Impact Assessment",
            "Sustainable Finance & Bond Standards",
            "Carbon Credit, Offset & Emission Trading",
          ],
        },

        {
          label: "Operational ESG Systems & Reporting",
          type: "checkbox",
          options: [
            "Environmental Compliance Reporting",
            "Social Compliance Reporting",
            "E&S Legal & Applicable Standards Mapping",
            "Environmental & Social System Management",
          ],
        },

        {
          label: "Industrial & Country-Specific ESG Compliance",
          type: "checkbox",
          options: [
            "Sector / Industrial-Specific Standard",
            "Country-Specific ESG Compliance",
            "Operational Compliance ESG Reporting",
            "E&S Due Diligence for ESG Compliance",
          ],
        },

        {
          label: "Data Analytics",
          type: "checkbox",
          options: ["ESG Analytics", "ESG Benchmarking"],
        },

        {
          label: "Supplier Selection & Compliance",
          type: "checkbox",
          options: ["Supplier Assessment & Compliance"],
        },

        {
          label: "Capacity & Future Development",
          type: "checkbox",
          options: [
            "Training & Capacity Building Programs",
            "Upcoming Features",
          ],
        },
      ],
    },

    // SECTION 5: Evidence & AI Insights
    {
      title: "Evidence, AI Insights & Closure",
      fields: [
        {
          label: "Upload Lab Reports / Calibration Certs",
          type: "file",
          accept: "image/*,.pdf",
          multiple: true,
        },
        {
          label: "Upload Geo-Tagged Photos",
          type: "file",
          accept: "image/*",
          multiple: true,
        },
        {
          label: "AI Trend Insight",
          type: "info",
          value:
            "PM2.5 increased 28% in last 7 days – dust suppression recommended",
        },
        {
          label: "AI Predictive Alert",
          type: "info",
          value: "High risk of PM2.5 > 100 µg/m³ in next 48 hrs if no action",
        },
        {
          label: "Auto-Link Results With",
          type: "checkbox",
          options: [
            "Incident Logs",
            "Community Complaints",
            "Regulatory Permits",
            "ESG Dashboard",
          ],
        },
      ],
    },

    // SECTION 6: Digital Signatures
    {
      title: "Digital Signatures (Audit Ready)",
      fields: [
        {
          label: "Prepared By (EHS Officer)",
          type: "text",
          value: "Rajesh Kumar",
          required: true,
        },
        {
          label: "Verified By (Plant Head)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Corporate ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-26", disabled: true },
      ],
    },
  ],
};

export const WATER_QUALITY_MONITORING_FORM_STEP_1 = {
  title: "Digital Water & Wastewater Monitoring (User + AI Hybrid)",
  subtitle:
    "AI-Powered Real-Time Water Quality Detection & Compliance Tracking",
  formTitle: "Water & Wastewater Quality Monitoring Report",
  downloadFileName: "Water_Quality_Monitoring_Report",
  downloadFileExtension: "pdf",

  sections: [
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "WTR-2025-11-26-001",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured (IST)",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "ABC Chemical Plant, Gujarat",
          required: true,
        },
        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Raw water intake",
            "Process water",
            "Cooling water",
            "Wastewater discharge",
            "STP/ETP outlet",
            "Rainwater drain",
            "Community water point",
            "Other: _______",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          value: "23.0225° N, 72.5714° E (Auto-captured)",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          value:
            "Amit Patel (EHS Lead), Sunil Kumar (Operator), Neha Desai (Lab In-charge)",
        },
        {
          label: "Departments Covered",
          type: "checkbox",
          options: [
            "Utilities",
            "Operations",
            "EHS",
            "Contractors",
            "Community",
            "Other: _______",
          ],
        },
        {
          label: "Monitoring Objectives",
          type: "checkbox",
          options: [
            "Regulatory Compliance",
            "Permit Condition",
            "ESG Reporting",
            "Operational Control",
            "Community Engagement",
            "Incident Investigation",
            "Other: _______",
          ],
        },
      ],
    },

    // ==================== SECTION 2: PARAMETERS TO MONITOR ====================
    {
      title: "Parameters to Monitor (User Select + AI Suggestion)",
      fields: [
        {
          label: "General Parameters",
          type: "checkbox",
          options: [
            "pH",
            "Temperature",
            "Conductivity",
            "Turbidity",
            "Other: _______",
          ],
        },
        {
          label: "Organics",
          type: "checkbox",
          options: ["BOD", "COD", "TOC", "Oil & Grease", "Other: _______"],
        },
        {
          label: "Nutrients",
          type: "checkbox",
          options: ["Nitrates", "Phosphates", "Ammonia", "Other: _______"],
        },
        {
          label: "Metals",
          type: "checkbox",
          options: ["Pb", "Hg", "Cd", "Cr", "As", "Other: _______"],
        },
        {
          label: "Microbiological",
          type: "checkbox",
          options: ["Coliform", "E. coli", "Other: _______"],
        },
        {
          label: "Others",
          type: "checkbox",
          options: [
            "TSS",
            "TDS",
            "Chlorides",
            "Sulphates",
            "Cyanide",
            "Other: _______",
          ],
        },
        {
          label: "AI Auto-Recommendation",
          type: "info",
          value:
            "Mandatory: pH, BOD, COD, TSS, Oil & Grease, Coliform (per GPCB Consent & IFC PS3)",
        },
      ],
    },

    // ==================== SECTION 3: MONITORING FREQUENCY & STANDARDS ====================
    {
      title: "Monitoring Frequency & Applicable Standards",
      fields: [
        {
          label: "Monitoring Frequency",
          type: "checkbox",
          options: [
            "Daily",
            "Weekly",
            "Monthly",
            "Quarterly",
            "Continuous (online sensors, SCADA)",
          ],
          note: "AI suggests: Daily for discharge point (per Consent to Operate)",
        },
        {
          label: "Applicable Standards / Benchmarks",
          type: "text",
          value:
            "GPCB Consent Limits | CPCB Effluent Standards | WHO Drinking Water | IFC EHS Guidelines | ISO 14001 | ISO 46001",
          disabled: true,
          note: "AI auto-matched based on Gujarat location & Chemical sector",
        },
        {
          label: "Monitoring Method / Equipment",
          type: "text",
          value:
            "Hach DR3900 (Lab), Online pH/TSS meters (Endress+Hauser), Grab sampling per IS 3025",
          note: "Last calibration: 10-Nov-2025 | All instruments valid",
        },
      ],
    },

    // ==================== SECTION 4: AI + USER INPUT TABLE (REAL DATA) ====================
    {
      title: "Manual User Input – Monitoring Values",
      type: "table",
      addRowLabel: "+ Add New Parameter Reading",
      columns: [
        { key: "parameter", label: "Parameter", type: "text", required: true },
        {
          key: "standard",
          label: "Standard/Benchmark",
          type: "text",
          required: true,
        },
        {
          key: "measured",
          label: "Measured Value",
          type: "number",
          required: true,
        },
        { key: "unit", label: "Unit", type: "text" },
        { key: "method", label: "Method / Equipment", type: "text" },
        {
          key: "evidence",
          label: "Evidence Upload",
          type: "file",
          accept: ".pdf,.jpg",
          multiple: true,
        },
        {
          key: "remarks",
          label: "Remarks (User Notes)",
          type: "textarea",
          rows: 2,
        },
      ],
      sampleRows: [
        {
          parameter: "pH (Effluent)",
          standard: "6.5–8.5 (GPCB)",
          measured: 9.1,
          unit: "",
          method: "pH Meter",
          evidence: null,
          remarks: "Slight odor noted – dosing pump issue suspected",
        },
        {
          parameter: "BOD (STP Outlet)",
          standard: "≤ 30 mg/L",
          measured: 42,
          unit: "mg/L",
          method: "Lab (Winkler)",
          evidence: null,
          remarks: "Aeration tank overloaded due to production surge",
        },
        {
          parameter: "COD (Discharge)",
          standard: "≤ 250 mg/L",
          measured: 318,
          unit: "mg/L",
          method: "Lab",
          evidence: null,
          remarks: "Chemical dosing to be increased",
        },
        {
          parameter: "TSS",
          standard: "≤ 100 mg/L",
          measured: 156,
          unit: "mg/L",
          method: "Online Sensor",
          evidence: null,
          remarks: "Settling tank cleaning overdue",
        },
        {
          parameter: "Oil & Grease",
          standard: "≤ 10 mg/L",
          measured: 8.2,
          unit: "mg/L",
          method: "Lab",
          evidence: null,
          remarks: "Within limit – skimmer working",
        },
        {
          parameter: "Total Coliform",
          standard: "≤ 100 MPN/100ml",
          measured: 2400,
          unit: "MPN/100ml",
          method: "Lab",
          evidence: null,
          remarks: "UV system malfunction – urgent repair needed",
        },
      ],
    },

    // ==================== SECTION 5: OBSERVATIONS / FIELD NOTES ====================
    {
      title: "Observations / Field Notes (User Input)",
      fields: [
        {
          label: "Site Conditions",
          type: "textarea",
          rows: 4,
          value:
            "Minor oil sheen observed near ETP outlet | Leak from chemical dosing line | STP blower #2 not working | No visible spillage at community point",
        },
        {
          label: "Operational Events",
          type: "textarea",
          rows: 3,
          value:
            "Production increased by 18% this week | Bypass of primary clarifier for 2 hours due to maintenance",
        },
        {
          label: "Community Concerns",
          type: "textarea",
          rows: 3,
          value:
            "3 complaints received: foul smell from drain, colored water in handpump (nearby village)",
        },
      ],
    },

    // ==================== SECTION 6: EVIDENCE & ATTACHMENTS ====================
    {
      title: "Evidence & Attachments",
      fields: [
        {
          label: "Upload Lab Reports / Calibration Certificates",
          type: "file",
          accept: ".pdf,.jpg",
          multiple: true,
        },
        {
          label: "Upload Photos of Sampling Points",
          type: "file",
          accept: ".jpg,.jpeg,.png",
          multiple: true,
        },
        {
          label: "Upload Contractor Log Sheets / MoM",
          type: "file",
          accept: ".pdf",
          multiple: true,
        },
        {
          label: "Upload Community Complaint Record",
          type: "file",
          accept: ".pdf,.jpg",
          multiple: true,
        },
        {
          label: "AI Predictive Alert",
          type: "info",
          value:
            "BOD likely to exceed 50 mg/L in next 72 hours if aeration not restored",
        },
        {
          label: "AI Trend Insight",
          type: "info",
          value:
            "TSS increased 42% in last 7 days – urgent settling tank cleaning recommended",
        },
      ],
    },

    // ==================== SECTION 7: DIGITAL SIGNATURES ====================
    {
      title: "Digital Signatures (Audit Ready)",
      type: "signature",
      fields: [
        {
          label: "Prepared By (EHS Officer)",
          type: "signature",
          placeholder: "Amit Patel",
          required: true,
        },
        {
          label: "Verified By (Plant Manager)",
          type: "signature",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Corporate ESG Head)",
          type: "signature",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", required: true },
      ],
    },
  ],
};

export const DIGITAL_WATER_WASTEWATER_MONITORING = {
  title: "Digital Water & Wastewater Monitoring Form",
  subtitle: "Digital Water & Wastewater Monitoring (User + AI Hybrid)",
  formTitle: "Digital Water & Wastewater Monitoring Form",
  downloadFileName: "Water_Wastewater_Monitoring_Report",
  downloadFileExtension: "pdf",

  sections: [
    // 1. Monitoring Setup Information
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "WWM-2025-11-0421",
          disabled: true,
          note: "Auto-generated unique ID",
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured (system clock + timezone)",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "e.g. ABC Chemicals Ltd., Gujarat",
          required: true,
        },
        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Raw water intake",
            "Process water",
            "Cooling water",
            "Wastewater discharge",
            "STP/ETP outlet",
            "Rainwater drain",
            "Community water point",
            "Other (specify)",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          value: "23.0225° N, 72.5714° E (Auto-captured)",
          disabled: true,
          note: "GPS auto-captured with map overlay",
        },
        {
          label: "Monitoring Team",
          type: "textarea",
          rows: 4,
          placeholder:
            "EHS Lead: Rajesh Patel\nUtility Operator: Sneha Mehta\nExternal Consultant: Dr. Anil Kumar\nContractor Rep: ...",
        },
        {
          label: "Departments Covered",
          type: "checkbox",
          options: [
            "Utilities",
            "Operations",
            "EHS",
            "Contractors",
            "Community",
            "Other (specify)",
          ],
        },
      ],
    },

    // 2. Monitoring Objectives
    {
      title: "Monitoring Objectives",
      fields: [
        {
          label: "Select Monitoring Objectives",
          type: "checkbox",
          options: [
            "Regulatory Compliance",
            "Permit Condition",
            "ESG Reporting",
            "Operational Control",
            "Community Engagement",
            "Incident Investigation",
            "Other (specify)",
          ],
        },
      ],
    },

    // 3. Parameters to Monitor (User Select + AI Suggestion)
    {
      title: "Parameters to Monitor (User Select + AI Suggestion)",
      fields: [
        {
          label: "General Parameters",
          type: "checkbox",
          options: [
            "pH",
            "Temperature",
            "Conductivity",
            "Turbidity",
            "Other (specify)",
          ],
        },
        {
          label: "Organics",
          type: "checkbox",
          options: ["BOD", "COD", "TOC", "Oil & Grease", "Other (specify)"],
        },
        {
          label: "Nutrients",
          type: "checkbox",
          options: ["Nitrates", "Phosphates", "Ammonia", "Other (specify)"],
        },
        {
          label: "Metals",
          type: "checkbox",
          options: ["Pb", "Hg", "Cd", "Cr", "As", "Other (specify)"],
        },
        {
          label: "Microbiological",
          type: "checkbox",
          options: ["Coliform", "E. coli", "Other (specify)"],
        },
        {
          label: "Others",
          type: "checkbox",
          options: [
            "TSS",
            "TDS",
            "Chlorides",
            "Sulphates",
            "Cyanide",
            "Other (specify)",
          ],
        },
        {
          label: "User-defined Parameters",
          type: "text",
          placeholder: "e.g. Color, Odor, Fluoride, Phenol...",
        },
        {
          label: "AI Auto-Recommendation",
          type: "textarea",
          rows: 5,
          disabled: true,
          value:
            "Based on GPCB/ZLD Consent & Chemical Industry:\n• Mandatory: pH, BOD, COD, TSS, TDS, Oil & Grease, Ammonia, Phosphates\n• Quarterly: Heavy Metals (Pb, Cr, Cd, Hg, As)\n• ESG Focus: Track Specific Water Consumption (m³/ton) & Reuse %",
        },
      ],
    },

    // 4. Monitoring Frequency
    {
      title: "Monitoring Frequency",
      fields: [
        {
          label: "Frequency",
          type: "radio",
          options: [
            "Daily",
            "Weekly",
            "Monthly",
            "Quarterly",
            "Continuous (online sensors, SCADA)",
          ],
          value: "Monthly",
        },
        {
          label: "AI Suggested Frequency",
          type: "text",
          disabled: true,
          value:
            "Monthly for treated effluent | Daily pH & Flow (as per Consent to Operate)",
        },
      ],
    },

    // 5. Applicable Standards / Benchmarks
    {
      title: "Applicable Standards / Benchmarks",
      fields: [
        {
          label: "Select Applicable Standards",
          type: "checkbox",
          options: [
            "Local Environmental Regulations (e.g. GPCB, CPCB)",
            "WHO Drinking Water Guidelines",
            "IFC EHS Guidelines – Water & Wastewater",
            "ISO 14001, ISO 46001 (Water Efficiency)",
            "Corporate ESG / Net Zero Water Targets",
          ],
        },
        {
          label: "AI Auto-Recommendation",
          type: "textarea",
          rows: 4,
          disabled: true,
          value:
            "Mandatory: GPCB Consent Limits + CPCB Standards\nRecommended: IFC EHS Guidelines (Chemicals Sector)\nCorporate Target: Zero Liquid Discharge (ZLD) by 2027 | ≥80% Wastewater Reuse",
        },
      ],
    },

    // 6. Monitoring Method / Equipment
    {
      title: "Monitoring Method / Equipment",
      fields: [
        {
          label: "Method / Equipment Used",
          type: "text",
          placeholder:
            "e.g. Hach DR3900, Online pH/Flow Meter, NABL Lab Analysis...",
        },
        {
          label: "AI Validation Note",
          type: "textarea",
          rows: 3,
          disabled: true,
          value:
            "Instruments calibrated: 15-Nov-2025 (valid till May-2026)\nMethods: APHA 23rd Edition / IS 3025\nLab: NABL Accredited – EnviroCare Labs, Ahmedabad",
        },
      ],
    },

    // 7. MAIN TABLE – Manual Monitoring Values (Optional)
    {
      title: "Manual Monitoring Values (Optional)",
      type: "table",
      addRowLabel: "+ Add New Parameter Reading",
      fields: [
        { label: "Parameter", type: "text", width: "16%" },
        {
          label: "Standard/Benchmark",
          type: "text",
          width: "18%",
          placeholder: "e.g. ≤ 30 mg/L (GPCB)",
        },
        { label: "Measured Value", type: "text", width: "12%" },
        { label: "Unit", type: "text", width: "8%" },
        { label: "Method / Equipment", type: "text", width: "16%" },
        {
          label: "Evidence Upload",
          type: "file",
          accept: ".pdf,.jpg,.png",
          width: "15%",
        },
        { label: "Remarks", type: "textarea", rows: 2, width: "15%" },
      ],
      preFilledRows: [
        {
          Parameter: "pH (Final Effluent)",
          "Standard/Benchmark": "6.5 – 8.5 (GPCB)",
          "Measured Value": "9.1",
          Unit: "-",
          "Method / Equipment": "Hach HQ40d Portable Meter",
          "Evidence Upload": null,
          Remarks:
            "Slightly alkaline – excess lime dosing in neutralization tank",
        },
        {
          Parameter: "BOD (STP Outlet)",
          "Standard/Benchmark": "≤ 30 mg/L",
          "Measured Value": "42",
          Unit: "mg/L",
          "Method / Equipment": "NABL Lab Analysis",
          "Evidence Upload": null,
          Remarks:
            "High due to production increase – aeration capacity enhancement required",
        },
        {
          Parameter: "TSS",
          "Standard/Benchmark": "≤ 100 mg/L",
          "Measured Value": "89",
          Unit: "mg/L",
          "Method / Equipment": "Gravimetric (Lab)",
          "Evidence Upload": null,
          Remarks: "Within limit",
        },
      ],
    },

    // 8. Observations / Field Notes
    {
      title: "Observations / Field Notes",
      fields: [
        {
          label: "Site Conditions & Observations",
          type: "textarea",
          rows: 8,
          placeholder:
            "• Site Conditions: Leaks, spillages, visible contamination.\n• Operational Events: High load, process upset, bypass.\n• Community Concerns: Odor, discoloration, fish kills, complaints.",
          value: "",
        },
      ],
    },

    // 9. Evidence & Attachments
    {
      title: "Evidence & Attachments",
      fields: [
        {
          label: "Lab Reports / Calibration Certificates",
          type: "file",
          accept: ".pdf,.xlsx",
          multiple: true,
        },
        {
          label: "Photos of Sampling Points & Site",
          type: "file",
          accept: "image/*",
          multiple: true,
        },
        {
          label: "Contractor Log Sheets / MoM",
          type: "file",
          accept: ".pdf,.docx",
          multiple: true,
        },
        {
          label: "Community Complaint Records (if any)",
          type: "file",
          accept: ".pdf,.xlsx",
          multiple: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const DIGITAL_WATER_WASTEWATER_MONITORING_STEP_1 = {
  title: "Smart AI-Enabled Water & Wastewater Monitoring Log",
  subtitle: "Real-time Compliance | AI Auto-Check | Audit-Ready",
  formTitle: "Water & Wastewater Monitoring Log",
  downloadFileName: "Water_Wastewater_Monitoring_Log",
  downloadFileExtension: "png",
  sections: [
    // ========= 1. Setup =========
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          placeholder: "Auto-generated",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter facility name",
          required: true,
        },
        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Raw water intake",
            "Process water",
            "Cooling water",
            "Wastewater discharge",
            "STP/ETP outlet",
            "Rainwater drain",
            "Community water point",
            "Other (specify)",
          ],
        },
        {
          label: "Monitoring Team",
          type: "textarea",
          rows: 3,
          placeholder: "EHS Lead, Operator, Consultant, etc.",
        },
      ],
    },

    // ========= 2. MAIN TABLE (AI Powered) =========
    {
      title: "Monitoring Results Table (AI-Powered Compliance Check)",
      type: "table",
      addRowLabel: "Add Parameter",
      defaultRows: 3,
      fields: [
        { label: "Parameter Monitored", type: "text", width: "14%" },
        {
          label: "Standard / Benchmark",
          type: "text",
          placeholder: "e.g., ≤30 mg/L",
          width: "15%",
        },
        { label: "Method / Equipment", type: "text", width: "12%" },
        { label: "Measured Value", type: "text", width: "10%" },
        {
          label: "Unit",
          type: "text",
          placeholder: "mg/L, µS/cm, etc.",
          width: "8%",
        },
        {
          label: "Compliance Status (AI)",
          type: "text",
          disabled: true,
          placeholder: "Auto",
          width: "10%",
        },
        { label: "Variance", type: "text", disabled: true, width: "8%" },
        {
          label: "AI Suggested Action",
          type: "text",
          disabled: true,
          width: "15%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "text",
          placeholder: "Immediate / 1 Week",
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
    },

    // ========= 3. AI Validation =========
    {
      title: "AI Validation & Risk Linkage",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., pH exceedance → Risk ID: RSK-ENV-003 (Regulatory Penalty)",
          disabled: true,
        },
        {
          label: "Overall Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          disabled: true,
        },

        {
          label: "Reviewed By",
          type: "text",
          placeholder: "EHS/ESG Officer / Compliance Lead Name",
        },
        {
          label: "Review Date",
          type: "date",
        },
      ],
    },

    // ========= 5. Closing & Signatures (Audit-Ready) =========
    {
      title: "Closing & Digital Signatures (Audit-Ready)",
      fields: [
        {
          label: "Prepared By (Monitoring Team Lead)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Approved By (Project/ESG Head)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Approval Date",
          type: "date",
          disabled: true,
          placeholder: "Auto-filled on submission",
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: ["I confirm that all information is accurate and complete"],
          required: true,
        },
      ],
    },
  ],
};

export const DIGITAL_WATER_WASTEWATER_MONITORING_STEP_2 = [
  // Top Big Banner – "Auto-Synced to ESG Vision Dashboard"
  {
    isFormSection: true,
    heading: "",
    fields: [], // empty fields → sirf heading dikhega
  },

  // Detail Reporting
  {
    heading: "Detail Reporting",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  // Global ESG Reporting (Standards & Frameworks)
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_compliance", label: "Environmental Compliance Reporting" },
      { id: "social_compliance", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific ESG Compliance
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_compliance", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due_diligence", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "esg_benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier Selection & Compliance
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future Development
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming_features", label: "Upcoming Features" },
    ],
  },
];

export const DIGITAL_WASTE_SPILL_TRACKING_FORM = {
  title: "Digital Waste & Spill Tracking (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Waste & Spill Tracking Report",
  downloadFileName: "Waste_Spill_Tracking_Report",
  downloadFileExtension: "pdf",

  // Buttons (tumhare SmartTemplate ke hisaab se)
  topRightButtons: ["SAVE", "USER ID"],
  bottomButtons: ["NEXT"],
  actionButtons: [],

  sections: [
    // ===================== SECTION 1: TRACKING SETUP INFORMATION =====================
    {
      title: "Tracking Setup Information",
      fields: [
        {
          label: "Tracking ID",
          type: "text",
          value: "WST-2025-11-0891",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: "2025-11-26T10:30",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "ABC Cement Plant, Aligarh",
          required: true,
        },

        {
          label: "Tracking Location(s)",
          type: "checkbox",
          options: [
            "Waste storage yard",
            "Process area",
            "Workshop",
            "STP/ETP",
            "Loading bay",
            "Contractor site",
            "Transport route",
            "Other: _______",
          ],
        },

        {
          label: "Geo-Tagging",
          type: "text",
          value: "28.7041° N, 77.1025° E (Auto-captured)",
          disabled: true,
        },

        {
          label: "Tracking Team",
          type: "text",
          placeholder:
            "Names/Roles (Waste Officer, EHS Lead, Contractor, Operator)",
        },

        {
          label: "Departments Covered",
          type: "checkbox",
          options: [
            "Operations",
            "Utilities",
            "EHS",
            "Contractors",
            "Community",
            "Other: _______",
          ],
        },
      ],
    },

    // ===================== SECTION 2: WASTE INFORMATION (USER + AI) =====================
    {
      title: "Waste Information (User Input + AI)",
      fields: [
        {
          label: "Type of Waste",
          type: "checkbox",
          options: [
            "Hazardous",
            "Non-hazardous",
            "Biomedical",
            "E-waste",
            "Plastic",
            "Food waste",
            "Construction/Demolition",
            "Other: _______",
          ],
        },

        {
          label: "Source of Waste",
          type: "checkbox",
          options: [
            "Process",
            "Packaging",
            "Maintenance",
            "Housekeeping",
            "Other: _______",
          ],
        },

        {
          label: "Quantity Generated",
          type: "text",
          placeholder: "e.g., 850 kg, 2.5 tons, 1200 liters",
        },

        {
          label: "Storage Method",
          type: "checkbox",
          options: [
            "Bags",
            "Drums",
            "Containers",
            "Bins",
            "Tanks",
            "Other: _______",
          ],
        },

        {
          label: "Disposal Method",
          type: "checkbox",
          options: [
            "Landfill",
            "Incineration",
            "Recycling",
            "Recovery",
            "TSDF",
            "Sewer",
            "Other: _______",
          ],
        },

        {
          label: "Contractor/Vendor",
          type: "text",
          placeholder:
            "Name + Permit No. (e.g., GreenWaste Ltd - PERMIT/UP/2024/087)",
        },
      ],
    },

    // ===================== SECTION 3: MANUAL WASTE TRACKING TABLE =====================
    {
      title: "Manual Input – Waste Tracking Values",
      type: "table",
      addRowLabel: "+ Add Waste Entry",
      fields: [
        { label: "Waste Type", type: "text", width: "18%" },
        { label: "Quantity", type: "text", width: "12%" },
        { label: "Storage", type: "text", width: "12%" },
        { label: "Disposal Method", type: "text", width: "15%" },
        { label: "Contractor", type: "text", width: "15%" },
        {
          label: "Evidence Upload",
          type: "file",
          accept: "image/*,.pdf",
          width: "15%",
        },
        { label: "Notes", type: "textarea", rows: 2, width: "13%" },
      ],
      preFilledRows: [
        {
          "Waste Type": "Plastic Waste",
          Quantity: "250 kg",
          Storage: "Bags",
          "Disposal Method": "Recycling",
          Contractor: "Vendor X",
          Notes: "Poor segregation noted – training required",
        },
        {
          "Waste Type": "Used Oil (Hazardous)",
          Quantity: "180 liters",
          Storage: "Drums",
          "Disposal Method": "TSDF",
          Contractor: "SafeChem Ltd",
          Notes: "Manifest attached",
        },
      ],
    },

    // ===================== SECTION 4: SPILL INFORMATION =====================
    {
      title: "Spill Information (User Input + AI)",
      fields: [
        {
          label: "Spill Type",
          type: "checkbox",
          options: [
            "Oil",
            "Chemical",
            "Hazardous",
            "Wastewater",
            "Other: _______",
          ],
        },

        {
          label: "Quantity Spilled",
          type: "text",
          placeholder: "e.g., 45 liters, 120 kg",
        },

        {
          label: "Spill Location",
          type: "text",
          placeholder: "Exact location + Geo-tag (auto-captured)",
        },

        {
          label: "Cause of Spill",
          type: "checkbox",
          options: [
            "Equipment failure",
            "Human error",
            "Overfill",
            "Transport accident",
            "Natural event",
            "Other: _______",
          ],
        },

        {
          label: "Immediate Action Taken",
          type: "textarea",
          rows: 3,
          placeholder:
            "Absorbent used, area cordoned, spill kit deployed, etc.",
        },

        {
          label: "Impact",
          type: "checkbox",
          options: [
            "Soil",
            "Water",
            "Air",
            "Worker exposure",
            "Community",
            "None",
          ],
        },

        {
          label: "Evidence Upload",
          type: "checkbox",
          options: ["Photos", "Videos", "Lab results"],
        },
      ],
    },

    // ===================== SECTION 5: EVIDENCE & ATTACHMENTS + AI INSIGHTS =====================
    {
      title: "Evidence & Attachments + AI Insights",
      fields: [
        {
          label: "Upload transport manifests / disposal certificates",
          type: "file",
          accept: ".pdf,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload spill response checklists",
          type: "file",
          accept: ".pdf,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload photos/videos (geo-tagged optional)",
          type: "file",
          accept: "image/*,video/*",
          multiple: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const WASTE_SPILL_TRACKING_LOG_STEP_1 = {
  title: "Smart AI-Enabled Waste & Spill Tracking Log",
  subtitle: "",
  formTitle: "Waste & Spill Tracking Report",
  downloadFileName: "Waste_Spill_Tracking_Log_Report",
  downloadFileExtension: "pdf",

  sections: [
    // ========== BASIC INFO ==========
    {
      title: "Tracking Setup Information",
      fields: [
        {
          label: "Tracking ID",
          type: "text",
          value: "WST-2025-11-1089",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: "2025-11-26T11:45",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "ABC Cement Plant, Aligarh",
          required: true,
        },

        {
          label: "Tracking Location(s)",
          type: "checkbox",
          options: [
            "Waste storage yard",
            "Process area",
            "Workshop",
            "STP/ETP",
            "Loading bay",
            "Contractor site",
            "Transport route",
            "Other: _______",
          ],
        },

        {
          label: "Tracking Team",
          type: "text",
          value:
            "Amit Sharma (Waste Officer), Rajesh Kumar (EHS Lead), GreenWaste Contractor",
        },
      ],
    },

    // ========== WASTE TRACKING RESULTS TABLE ==========
    {
      title: "Waste Tracking Results Table",
      type: "table",
      addRowLabel: "+ Add New Waste Entry",

      fields: [
        { label: "Waste Type", type: "text", width: "14%" },
        { label: "Source", type: "text", width: "12%" },
        { label: "Quantity", type: "text", width: "10%" },
        { label: "Storage", type: "text", width: "10%" },
        { label: "Disposal Method", type: "text", width: "12%" },
        { label: "Contractor", type: "text", width: "12%" },
        {
          label: "Compliance Status (AI)",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "Variance from Standard",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Action",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "16%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "select",
          options: [
            "Immediate",
            "1 Day",
            "1 Week",
            "2 Weeks",
            "1 Month",
            "Ongoing",
          ],
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],

      preFilledRows: [
        {
          "Waste Type": "Hazardous Waste",
          Source: "Paint Shop",
          Quantity: "1.2 Tons",
          Storage: "Drums",
          "Disposal Method": "TSDF Disposal",
          Contractor: "Vendor A",
          "Compliance Status (AI)": "Compliant",
          "Variance from Standard": "Within Permit",
          "AI Suggested Action": "Continue disposal contract as per schedule",
          "Responsible Person": "Waste Officer",
          Timeline: "Monthly",
          Status: "Open",
        },
        {
          "Waste Type": "Plastic Waste",
          Source: "Packaging",
          Quantity: "250 kg",
          Storage: "Bags",
          "Disposal Method": "Recycling",
          Contractor: "Vendor B",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "Poor segregation",
          "AI Suggested Action":
            "Introduce dual-bin system, conduct training for workers",
          "Responsible Person": "Contractor",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Waste Type": "E-waste",
          Source: "Admin Office",
          Quantity: "85 kg",
          Storage: "Containers",
          "Disposal Method": "Authorized Recycler",
          Contractor: "E-Cycle India",
          "Compliance Status (AI)": "Compliant",
          "Variance from Standard": "On track",
          "AI Suggested Action": "Schedule next pickup in 15 days",
          "Responsible Person": "Admin Head",
          Timeline: "2 Weeks",
          Status: "Open",
        },
      ],
    },

    // ========== SPILL INCIDENT LOG TABLE ==========
    {
      title: "Spill Incident Log Table",
      type: "table",
      addRowLabel: "+ Add New Spill Incident",

      fields: [
        { label: "Spill Type", type: "text", width: "12%" },
        { label: "Location", type: "text", width: "14%" },
        { label: "Quantity", type: "text", width: "10%" },
        { label: "Cause", type: "text", width: "12%" },
        { label: "Impact", type: "text", width: "12%" },
        {
          label: "Immediate Action Taken",
          type: "textarea",
          rows: 2,
          width: "16%",
        },
        {
          label: "Compliance Status (AI)",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Corrective Action",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "select",
          options: ["Immediate", "1 Day", "1 Week", "2 Weeks", "1 Month"],
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],

      preFilledRows: [
        {
          "Spill Type": "Oil Spill",
          Location: "Loading Bay",
          Quantity: "50 L",
          Cause: "Hose rupture",
          Impact: "Soil",
          "Immediate Action Taken":
            "Sand barrier deployed, absorbent pads used, area cordoned",
          "Compliance Status (AI)": "Non-Compliant",
          "AI Suggested Corrective Action":
            "Replace all old hoses, install secondary containment trays, conduct toolbox talk",
          "Responsible Person": "Maintenance Supervisor",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Spill Type": "Chemical Spill",
          Location: "Process Area",
          Quantity: "20 L",
          Cause: "Overfill during transfer",
          Impact: "Worker exposure",
          "Immediate Action Taken":
            "Neutralization done, affected workers sent for medical checkup, PPE issued",
          "Compliance Status (AI)": "Controlled",
          "AI Suggested Corrective Action":
            "Revise chemical transfer SOP, install level indicators, refresh spill response training",
          "Responsible Person": "Safety Officer",
          Timeline: "Immediate",
          Status: "Open",
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 4,
          value:
            "→ WST-001: Plastic waste segregation failure → Regulatory fine risk\n→ SPL-003: Oil spill in loading bay → Soil contamination liability\n→ WST-005: Hazardous waste storage nearing 90-day limit → Immediate action required",
          disabled: true,
        },
        {
          label: "Overall Tracking Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
          preSelected: "Under Review",
        },
        { label: "Reviewed By", type: "text", placeholder: "EHS/ESG Officer" },
        { label: "Review Date", type: "date", value: "2025-11-26" },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Digital Signatures (Audit-Ready)",
      fields: [
        {
          label: "Prepared By (Waste/Spill Lead)",
          type: "text",
          value: "Amit Sharma",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager / ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-26", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all waste & spill data is accurate and corrective actions are assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const WASTE_SPILL_TRACKING_ESG_MAPPING_STEP_2 = [
  // Main Title
  // Detail Reporting
  {
    heading: "Detail Reporting",
    items: [],
  },

  // Global ESG Reporting Standards
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const BIODIVERSITY_HABITAT_FORM_STEP_1 = {
  title: "Digital Biodiversity & Habitat Capture",
  subtitle: "",
  formTitle: "",
  downloadFileName: "Biodiversity_Habitat_Monitoring_Report",
  downloadFileExtension: "pdf",

  topRightButtons: ["SAVE", "USER ID"],
  bottomButtons: ["NEXT"],
  actionButtons: [],

  sections: [
    // ===================== SECTION 1: MONITORING SETUP =====================
    {
      title: "Biodiversity & Habitat Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "BIO-2025-11-0472",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: "2025-11-26T09:15",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          required: true,
        },

        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Protected Area",
            "Buffer Zone",
            "Construction Site",
            "Wetlands",
            "Forest Patch",
            "River/Coastal Zone",
            "Community Land",
            "Other _________",
          ],
        },

        {
          label: "Geo-Tagging",
          type: "text",
          value: "26.9124° N, 75.7873° E (Auto-captured with map)",
          disabled: true,
        },

        {
          label: "Monitoring Team",
          type: "text",
          value:
            "Dr. Neha Singh (Ecologist), Rahul Meena (EHS), Local Tribal Guide",
        },

        {
          label: "Departments Involved",
          type: "checkbox",
          options: ["EHS", "Operations", "CSR", "Contractors", "Community"],
        },

        {
          label: "Monitoring Objectives",
          type: "checkbox",
          options: [
            "Baseline Survey (Pre-Construction)",
            "Regulatory Compliance (e.g., IFC PS6, CBD, National Law)",
            "ESG Reporting (GRI 304, SASB, TNFD)",
            "Offset / Conservation Plan Tracking",
            "Incident / Habitat Disturbance Investigation",
            "Other: _________",
          ],
        },
      ],
    },

    // ===================== SECTION 2: BIODIVERSITY ELEMENTS =====================
    {
      title: "Biodiversity Elements to Monitor (User Input + AI Suggestion)",
      fields: [
        {
          label: "Flora (Plants)",
          type: "info",
          value:
            "AI auto-cross-checks with IUCN Red List & National Red Data Book",
        },
        {
          label: "Trees (Species)",
          type: "text",
          placeholder: "e.g., Neem, Peepal, Acacia",
        },
        {
          label: "Shrubs (Species)",
          type: "text",
          placeholder: "e.g., Lantana, Prosopis",
        },
        {
          label: "Ground Cover (Species)",
          type: "text",
          placeholder: "e.g., Grasses, Herbs",
        },
        {
          label: "Endemic / Rare Species",
          type: "text",
          placeholder: "e.g., Great Indian Bustard habitat indicator",
        },

        {
          label: "Fauna (Animals)",
          type: "info",
          value:
            "AI auto-identifies from photos/videos (Bird call ID, mammal tracking)",
        },
        {
          label: "Birds (Species + Count)",
          type: "text",
          placeholder:
            "e.g., Peacock (12), Sparrow (45), Migratory ducks observed",
        },
        {
          label: "Mammals",
          type: "text",
          placeholder: "e.g., Blackbuck (8), Jackal (3)",
        },
        {
          label: "Amphibians / Reptiles",
          type: "text",
          placeholder: "e.g., Indian Bullfrog, Russell’s Viper",
        },
        {
          label: "Fish / Insects",
          type: "text",
          placeholder: "e.g., Rohu, Butterflies (diverse)",
        },

        {
          label: "Habitats (Ecosystem Types)",
          type: "info",
          value: "AI overlays satellite/drone data for change detection",
        },
        {
          label: "Forest",
          type: "text",
          placeholder: "Intact / Fragmented / Degraded",
        },
        {
          label: "Wetland",
          type: "text",
          placeholder: "Seasonal / Permanent / Polluted",
        },
        {
          label: "Grassland",
          type: "text",
          placeholder: "Natural / Overgrazed",
        },
        {
          label: "Marine/Coastal (if applicable)",
          type: "text",
          placeholder: "Mangrove health, Coral status",
        },
        {
          label: "Agricultural / Urban",
          type: "text",
          placeholder: "Monoculture / Green belts",
        },
      ],
    },

    // ===================== SECTION 3: SPECIES STATUS & PARAMETERS =====================
    {
      title: "Species Status & Key Indicators",
      fields: [
        {
          label: "Species Richness & Diversity",
          type: "text",
          placeholder: "e.g., Shannon Index: 3.2 (High), 48 species recorded",
        },
        {
          label: "Habitat Condition",
          type: "text",
          placeholder: "Healthy / Moderately degraded / Highly fragmented",
        },
        {
          label: "Human/Industrial Disturbance Observed",
          type: "textarea",
          rows: 3,
          placeholder:
            "Construction noise, vehicle movement, waste dumping, light pollution",
        },
        {
          label: "Invasive Species Presence",
          type: "text",
          placeholder: "e.g., Lantana camara dominant in 40% area",
        },
        {
          label: "Evidence of Poaching / Habitat Clearance",
          type: "text",
          placeholder: "e.g., Tree felling marks, snares found",
        },
        {
          label: "Migratory Species Presence",
          type: "text",
          placeholder:
            "e.g., Demoiselle Cranes (seasonal), Amur Falcons passing",
        },

        {
          label: "AI Conservation Insights",
          type: "info",
          value:
            "⚡ Great Indian Bustard (CR) habitat confirmed → Immediate No-Go Zone recommended\n⚡ 6% forest cover loss detected vs Q3 2025 (Satellite AI)\n⚡ Lantana invasion increasing → Biological control advised",
        },
      ],
    },

    // ===================== SECTION 4: OBSERVATIONS & FIELD NOTES =====================
    {
      title: "Observations / Field Notes",
      fields: [
        {
          label: "Habitat Condition Notes",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Soil erosion near construction boundary, waterlogging in low-lying areas",
        },
        {
          label: "Disturbance Events",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Heavy machinery movement scared wildlife, night lighting affecting nocturnal species",
        },
        {
          label: "Community Feedback",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Locals reported reduced peacock sightings, request for water pond restoration",
        },
      ],
    },

    // ===================== SECTION 5: EVIDENCE & ATTACHMENTS =====================
    {
      title: "Evidence & Attachments + AI Analysis",
      fields: [
        {
          label: "Upload Geo-Tagged Photos / Videos",
          type: "file",
          accept: "image/*,video/*",
          multiple: true,
        },
        {
          label: "Upload Drone / Satellite Imagery",
          type: "file",
          accept: ".jpg,.png,.tif,.pdf",
          multiple: true,
          note: "AI auto-detects vegetation index (NDVI) & habitat change",
        },
        {
          label: "Upload Field Survey Checklists",
          type: "file",
          accept: ".pdf,.docx",
          multiple: true,
        },

        {
          label: "AI Auto-Comparison Report",
          type: "info",
          value:
            "Forest patch reduced by 6% vs last quarter\nGrassland NDVI dropped from 0.68 → 0.51\n3 new invasive hotspots detected",
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const BIODIVERSITY_HABITAT_MONITORING_STEP_2 = {
  title: "Smart AI-Enabled Biodiversity & Habitat Monitoring Form",
  subtitle: "",
  formTitle: "Biodiversity & Habitat Monitoring Report",
  downloadFileName: "Biodiversity_Habitat_Monitoring_Log",
  downloadFileExtension: "pdf",

  sections: [
    // ========== BASIC INFO ==========
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "BIO-2025-11-2519",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: "2025-11-26T08:30",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          required: true,
        },

        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Protected Area",
            "Buffer Zone",
            "Construction Site",
            "Wetlands",
            "Forest Patch",
            "River/Coastal Zone",
            "Community Land",
            "Other _________",
          ],
        },

        {
          label: "Geo-Tagging",
          type: "text",
          value: "26.9124° N, 75.7873° E (Map overlay)",
          disabled: true,
        },

        {
          label: "Monitoring Team",
          type: "text",
          value:
            "Dr. Priya Verma (Ecologist), Anil Saini (EHS), Local Community Rep",
        },
      ],
    },

    // ========== MAIN TABLE — BIODIVERSITY & HABITAT RESULTS ==========
    {
      title: "Biodiversity & Habitat Monitoring Results Table",
      type: "table",
      addRowLabel: "+ Add New Monitoring Element",

      fields: [
        { label: "Element Monitored", type: "text", width: "14%" },
        { label: "Standard / Benchmark", type: "text", width: "14%" },
        { label: "Method / Tool Used", type: "text", width: "12%" },
        { label: "Observed Value", type: "text", width: "12%" },
        {
          label: "AI Analysis / Index",
          type: "text",
          disabled: true,
          width: "12%",
        },
        {
          label: "Compliance Status",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Action",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "select",
          options: [
            "Immediate",
            "1 Week",
            "2 Weeks",
            "1 Month",
            "3 Months",
            "Ongoing",
          ],
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "8%",
        },
      ],

      preFilledRows: [
        {
          "Element Monitored": "Bird Species Count",
          "Standard / Benchmark": "Baseline = 25 species",
          "Method / Tool Used": "Field Survey (Binoculars, Transect)",
          "Observed Value": "19 species",
          "AI Analysis / Index": "Decline -24%",
          "Compliance Status": "Warning",
          "AI Suggested Action":
            "Restore nesting zones, reduce night lighting, noise barriers during breeding season",
          "Responsible Person": "Ecologist",
          Timeline: "1 Month",
          Status: "Open",
        },
        {
          "Element Monitored": "Wetland Condition",
          "Standard / Benchmark": "IFC PS6 / Wildlife Protection Act",
          "Method / Tool Used": "Drone + Satellite Mapping",
          "Observed Value": "Reduced area by 10%",
          "AI Analysis / Index": "Encroachment confirmed (AI overlay)",
          "Compliance Status": "Non-Compliant",
          "AI Suggested Action":
            "Immediate stop-work near wetland, restore 50m buffer, replant native species",
          "Responsible Person": "EHS Officer",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          "Element Monitored": "Invasive Plant (Lantana)",
          "Standard / Benchmark": "IUCN / State Biodiversity Board",
          "Method / Tool Used": "Quadrat Survey + Drone AI",
          "Observed Value": "18% ground cover",
          "AI Analysis / Index": "Increasing trend (+5% vs last quarter)",
          "Compliance Status": "Risk Identified",
          "AI Suggested Action":
            "Manual removal + biological control, weekly monitoring, community awareness",
          "Responsible Person": "Contractor + Ecologist",
          Timeline: "Ongoing",
          Status: "Open",
        },
        {
          "Element Monitored": "Great Indian Bustard Sightings",
          "Standard / Benchmark": "Schedule I - WPA 1972 (CR - IUCN)",
          "Method / Tool Used": "Camera Trap + Field Observation",
          "Observed Value": "2 individuals (near turbine zone)",
          "AI Analysis / Index": "High collision risk detected",
          "Compliance Status": "Critical",
          "AI Suggested Action":
            "Shut down turbines in flight path, install bird diverters, declare No-Go zone",
          "Responsible Person": "Project Head + Wildlife Dept",
          Timeline: "Immediate",
          Status: "Open",
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 5,
          value:
            "→ BIO-001: Wetland encroachment → IFC PS6 violation + Community opposition risk\n→ BIO-002: GIB presence near turbines → Schedule I species threat → Project delay possible\n→ BIO-003: Invasive spread → Long-term biodiversity loss → TNFD & GRI 304 material risk\n→ BIO-004: Bird diversity decline → ESG rating downgrade risk",
          disabled: true,
        },
        {
          label: "Overall Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "Ecologist / ESG Officer",
        },
        { label: "Review Date", type: "date", value: "2025-11-26" },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Digital Signatures (Audit-Ready)",
      fields: [
        {
          label: "Prepared By (Monitoring Team Lead)",
          type: "text",
          value: "Dr. Priya Verma",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Corporate ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-26", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all biodiversity data is accurate and conservation actions are assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const BIODIVERSITY_HABITAT_ESG_MAPPING_STEP_3 = [
  { heading: "Auto-Synced to ESG Vision Dashboard", items: [] },
  { heading: "Detail Reporting", items: [] },

  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific ESG Compliance
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier Selection & Compliance
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future Development
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const LAND_USE_SOIL_DISTURBANCE_FORM_STEP_1 = {
  title: "Digital Land Use & Soil Disturbance Capture (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Land Use & Soil Disturbance Monitoring Report",
  downloadFileName: "Land_Use_Soil_Disturbance_Monitoring_Log",
  downloadFileExtension: "pdf",

  notes: [
    "Parameters to Monitor (User + AI Hybrid): Excavation depth, slope stability, visible erosion, gully formation, vegetation loss, soil quality, biodiversity disturbance, community land impacts, contamination checks.",
    "AI Suggestions: Auto-flags areas of significant disturbance vs baseline maps, predicts risk of erosion/flooding, detects illegal clearing from drone/satellite imagery.",
  ],

  sections: [
    // ========== BASIC INFO ==========
    {
      title: "Monitoring Setup Information",
      helperText:
        "Auto capture Monitoring ID & coordinates. Multi-select applicable land types. Team should include EHS, soil experts, ecologists, contractors, and community representatives.",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "Auto-generated unique ID",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured from system clock + timezone",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter project or facility name",
          required: true,
        },
        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Construction Zone",
            "Agricultural Land",
            "Wetland",
            "Forest Area",
            "Industrial Zone",
            "Community Land",
            "Mine/Quarry",
            "Other _________",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          value: "GPS auto-captured with map overlay",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          placeholder:
            "EHS Officer, Soil Scientist, Ecologist, Contractor, Community Rep",
        },
        {
          label: "Departments Involved",
          type: "checkbox",
          options: [
            "EHS",
            "Operations",
            "Engineering",
            "Contractors",
            "CSR",
            "Community",
          ],
        },
        {
          title: "Monitoring Objectives",
          type: "checkbox",
          options: [
            "Regulatory Compliance (Environmental Permits, IFC PS6, ISO 14001)",
            "ESG Reporting (GRI 304, SASB, TNFD, CDP Land Use Indicators)",
            "Construction/Project Impact Tracking",
            "Rehabilitation/Restoration Monitoring",
            "Community Engagement & Land Rights",
            "Incident Investigation (erosion, illegal clearing, contamination)",
            "Other: _________",
          ],
        },
      ],
    },

    // ========== PARAMETERS ==========
    {
      title: "Parameters to Monitor (User Input + AI Suggestion)",
      helperText:
        "Enter values manually. AI can auto-suggest based on uploaded imagery and project context.",
      fields: [
        {
          label: "Soil Disturbance / Erosion Indicators",
          type: "textarea",
          placeholder:
            "Excavation depth, slope stability, visible erosion, gully formation",
          rows: 2,
        },
        {
          label: "Land Cover Change (% vegetation loss)",
          type: "text",
          placeholder: "AI auto-detect if connected",
        },
        {
          label: "Soil Quality",
          type: "textarea",
          placeholder: "pH, organic matter, compaction, moisture, heavy metals",
          rows: 2,
        },
        {
          label: "Biodiversity Impact",
          type: "textarea",
          placeholder: "Disturbance to flora/fauna habitat",
          rows: 2,
        },
        {
          label: "Community Land Use",
          type: "textarea",
          placeholder:
            "Traditional use, grazing, agriculture, displacement impacts",
          rows: 2,
        },
        {
          label: "Pollution Indicators",
          type: "textarea",
          placeholder:
            "Contamination by oil spills, chemicals, construction debris",
          rows: 2,
        },
        {
          label: "AI Suggestions (auto risk detection)",
          type: "textarea",
          rows: 3,
          value:
            "⚡ AI flags significant disturbance areas, predicts erosion/flooding, detects illegal clearing.",
          disabled: true,
        },
      ],
    },

    // ========== FIELD LOGS ==========
    {
      title: "Field Logs (Manual User Input)",
      subtitle:
        "User measurement + AI auto-analysis. Evidence files should be geo-tagged.",
      type: "table",
      addRowLabel: "+ Add New Field Record",
      fields: [
        { label: "Parameter", type: "text", width: "14%" },
        { label: "Standard / Benchmark (if any)", type: "text", width: "15%" },
        { label: "Measured Value (User)", type: "text", width: "10%" },
        { label: "Unit", type: "text", width: "8%" },
        { label: "Method / Equipment", type: "text", width: "12%" },
        { label: "Evidence Upload", type: "file", width: "12%" },
        { label: "Remarks", type: "textarea", rows: 2, width: "18%" },
      ],
      preFilledRows: [
        {
          Parameter: "Excavation Depth",
          "Standard / Benchmark (if any)": "Design Plan (≤ 3m)",
          "Measured Value (User)": "5",
          Unit: "m",
          "Method/Equipment": "GPS/Survey",
          "Evidence Upload": "",
          Remarks: "Over-excavation observed",
        },
        {
          Parameter: "Vegetation Cover",
          "Standard / Benchmark (if any)": "IFC PS6: No net loss",
          "Measured Value (User)": "40",
          Unit: "%",
          "Method/Equipment": "Drone survey",
          "Evidence Upload": "",
          Remarks: "15% cleared illegally",
        },
      ],
    },

    // ========== FIELD OBSERVATIONS ==========
    {
      title: "Observations / Field Notes",
      helperText:
        "Describe visible land disturbance, cracks, soil damage, and community concerns.",
      fields: [
        { label: "Soil condition", type: "textarea", rows: 2 },
        { label: "Visible erosion or cracks", type: "textarea", rows: 2 },
        { label: "Waste dumping observed", type: "textarea", rows: 2 },
        {
          label: "Community concerns (land access, grazing)",
          type: "textarea",
          rows: 2,
        },
      ],
    },

    // ========== EVIDENCE & ATTACHMENTS ==========
    {
      title: "Evidence & Attachments",
      subtitle:
        "AI auto-analyzes uploaded imagery and reports vegetation cover change.",
      fields: [
        {
          label: "Upload geo-tagged photos/videos",
          type: "file",
          accept: "image/*,video/*",
          multiple: true,
        },
        {
          label: "Upload drone/satellite imagery",
          type: "file",
          accept: ".jpg,.png,.tif,.pdf",
          multiple: true,
          note: "AI auto-analyzes vegetation cover & land-use change",
        },
        {
          label: "Upload survey/soil lab reports",
          type: "file",
          accept: ".pdf,.xlsx",
          multiple: true,
        },
        {
          label: "AI auto-generated land-use change map",
          type: "info",
          value: "Generated after file uploads",
        },
      ],
    },
    // {
    //   title: "Evidence & Attachments",
    //   subtitle: "AI auto-analyzes uploaded imagery and reports vegetation cover change.",
    //   fields: [
    //     { label: "Upload geo-tagged photos/videos", type: "file", accept: "image/*,video/*", multiple: true },
    //     { label: "Upload drone/satellite imagery", type: "file", accept: ".jpg,.png,.tif,.pdf", multiple: true, note: "AI auto-analyzes vegetation cover & land-use change" },
    //     { label: "Upload survey/soil lab reports", type: "file", accept: ".pdf,.xlsx", multiple: true },
    //     { label: "AI auto-generated land-use change map", type: "info", value: "Generated after file uploads" }
    //   ]
    // }
  ],

  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const LAND_USE_SOIL_DISTURBANCE_FORM_STEP_2 = {
  title: "Smart AI-Enabled Biodiversity & Habitat Monitoring Form",
  subtitle:
    "AI-Powered Species Tracking, Habitat Assessment & Conservation Compliance",
  formTitle: "Biodiversity & Habitat Monitoring Report",
  downloadFileName: "Biodiversity_Habitat_Monitoring_Log",
  downloadFileExtension: "pdf",

  notes: [
    "Monitoring includes species tracking, habitat assessment, land-use change detection, and AI-assisted compliance verification.",
    "AI Suggestions: Auto-flags deviations from standard, predicts biodiversity risk, and recommends corrective actions.",
  ],

  sections: [
    // ========== BASIC INFO ==========
    {
      title: "Monitoring Setup Information",
      helperText:
        "Auto-capture Monitoring ID & coordinates. Multi-select applicable land types. Team includes EHS, ecologists, soil scientists, contractors, and community representatives.",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "Auto-generated unique ID",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured from system clock + timezone",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "Enter project or facility name",
          required: true,
        },
        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Construction Zone",
            "Agricultural Land",
            "Wetland",
            "Forest Area",
            "Industrial Zone",
            "Community Land",
            "Mine/Quarry",
            "Other _________",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          value: "GPS auto-captured with map overlay",
          disabled: true,
        },
        {
          label: "Monitoring Team",
          type: "text",
          placeholder:
            "EHS Officer, Soil Scientist, Ecologist, Contractor, Community Rep",
        },
      ],
    },

    // ========== MONITORING RESULTS TABLE ==========
    {
      title: "Monitoring Results Table",
      subtitle: "User + AI Hybrid measurement. Evidence files geo-tagged.",
      type: "table",
      addRowLabel: "+ Add New Monitoring Parameter",
      fields: [
        { label: "Parameter / Element Monitored", type: "text", width: "14%" },
        { label: "Standard / Benchmark", type: "text", width: "14%" },
        { label: "Method / Equipment", type: "text", width: "12%" },
        { label: "Measured Value (User/AI)", type: "text", width: "12%" },
        {
          label: "Compliance Status (AI Auto-Check)",
          type: "text",
          disabled: true,
          width: "12%",
        },
        { label: "Variance from Standard", type: "text", width: "10%" },
        {
          label: "AI Suggested Action",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "select",
          options: [
            "Immediate",
            "1 Week",
            "2 Weeks",
            "1 Month",
            "2 Months",
            "3 Months",
            "Ongoing",
          ],
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "8%",
        },
      ],
      preFilledRows: [
        {
          "Parameter / Element Monitored": "Excavation Depth",
          "Standard / Benchmark": "≤ 3m (Design Plan)",
          "Method / Equipment": "GPS/Survey",
          "Measured Value (User/AI)": "5m",
          "Compliance Status (AI Auto-Check)": "❌ Non-Compliant",
          "Variance from Standard": "+2m",
          "AI Suggested Action": "Reinstate slope protection, re-fill excess",
          "Responsible Person": "Site Engineer",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          "Parameter / Element Monitored": "Vegetation Cover",
          "Standard / Benchmark": "IFC PS6 – No net loss",
          "Method / Equipment": "Drone Image",
          "Measured Value (User/AI)": "40%",
          "Compliance Status (AI Auto-Check)": "❌ Non-Compliant",
          "Variance from Standard": "-15%",
          "AI Suggested Action": "Replant trees, enforce buffer zone",
          "Responsible Person": "EHS Officer",
          Timeline: "2 Months",
          Status: "Open",
        },
        {
          "Parameter / Element Monitored": "Soil pH",
          "Standard / Benchmark": "6.0–7.5",
          "Method / Equipment": "Soil Test",
          "Measured Value (User/AI)": "4.8",
          "Compliance Status (AI Auto-Check)": "❌ Non-Compliant",
          "Variance from Standard": "-1.2",
          "AI Suggested Action": "Apply lime, monitor quarterly",
          "Responsible Person": "Agronomist",
          Timeline: "1 Month",
          Status: "Open",
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 5,
          value:
            "→ Land clearing → biodiversity loss risk\n→ Wetland encroachment → IFC PS6 violation + Community opposition risk\n→ Soil over-excavation → erosion risk → Project delay",
          disabled: true,
        },
        {
          label: "Overall Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "EHS / Soil Scientist / ESG Officer",
        },
        { label: "Review Date", type: "date", value: "2025-11-26" },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Digital Signatures (Audit-Ready)",
      fields: [
        {
          label: "Prepared By (Monitoring Lead)",
          type: "text",
          placeholder: "Enter name",
          required: true,
        },
        {
          label: "Verified By (EHS / Soil Scientist / ESG Officer)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager / ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-26", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all monitoring data is accurate and corrective actions are assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const LAND_USE_SOIL_DISTURBANCE_REPORT_STEP_2 = {
  title: "Smart AI-Enabled Land Use & Soil Disturbance Report",
  subtitle: "AI-Powered Land Clearance, Excavation & Soil Health Monitoring",
  formTitle: "Land Use & Soil Disturbance Monitoring Report",
  downloadFileName: "Land_Use_Soil_Disturbance_Log",
  downloadFileExtension: "pdf",

  sections: [
    // ========== BASIC INFO ==========
    {
      title: "Monitoring Setup Information",
      fields: [
        {
          label: "Monitoring ID",
          type: "text",
          value: "LAND-2025-11-2701",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: "2025-11-27T09:00",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          required: true,
        },

        {
          label: "Monitoring Location(s)",
          type: "checkbox",
          options: [
            "Construction Zone",
            "Agricultural Land",
            "Wetland",
            "Forest Area",
            "Industrial Zone",
            "Community Land",
            "Mine/Quarry",
            "Other _________",
          ],
        },

        {
          label: "Geo-Tagging",
          type: "text",
          value: "26.9124° N, 75.7873° E (Map overlay)",
          disabled: true,
        },

        {
          label: "Monitoring Team",
          type: "text",
          value:
            "Anil Saini (EHS Officer), Dr. Rajesh Meena (Soil Scientist), Site Contractor, Community Rep",
        },
      ],
    },

    // ========== MAIN TABLE — LAND USE & SOIL RESULTS ==========
    {
      title: "Land Use & Soil Disturbance Monitoring Results Table",
      type: "table",
      addRowLabel: "+ Add New Monitoring Parameter",

      fields: [
        { label: "Parameter", type: "text", width: "14%" },
        { label: "Standard / Benchmark", type: "text", width: "14%" },
        { label: "Method / Equipment", type: "text", width: "12%" },
        { label: "Measured Value", type: "text", width: "10%" },
        {
          label: "Compliance Status",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "Variance from Standard",
          type: "text",
          disabled: true,
          width: "10%",
        },
        {
          label: "AI Suggested Action",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Timeline",
          type: "select",
          options: [
            "Immediate",
            "1 Week",
            "2 Weeks",
            "1 Month",
            "3 Months",
            "Ongoing",
          ],
          width: "10%",
        },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "8%",
        },
      ],

      preFilledRows: [
        {
          Parameter: "Excavation Depth",
          "Standard / Benchmark": "≤ 3m (Design Plan)",
          "Method / Equipment": "GPS / Total Station Survey",
          "Measured Value": "5m",
          "Compliance Status": "Non-Compliant",
          "Variance from Standard": "+2m",
          "AI Suggested Action":
            "Reinstate slope protection immediately, re-fill excess depth, update excavation permit",
          "Responsible Person": "Site Engineer",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          Parameter: "Vegetation Cover After Clearing",
          "Standard / Benchmark": "IFC PS6 – No net loss policy",
          "Method / Equipment": "Drone Imagery + NDVI Analysis",
          "Measured Value": "40%",
          "Compliance Status": "Non-Compliant",
          "Variance from Standard": "-15% from baseline",
          "AI Suggested Action":
            "Immediate replanting of native species, enforce 30m buffer zone, compensatory afforestation plan",
          "Responsible Person": "EHS Officer",
          Timeline: "2 Months",
          Status: "Open",
        },
        {
          Parameter: "Soil pH",
          "Standard / Benchmark": "6.0 – 7.5 (Suitable for native vegetation)",
          "Method / Equipment": "Field Soil Test Kit / Lab Analysis",
          "Measured Value": "4.8",
          "Compliance Status": "Non-Compliant",
          "Variance from Standard": "-1.2",
          "AI Suggested Action":
            "Apply agricultural lime @ 2 tons/ha, re-test after 30 days, restrict heavy machinery on acidic zones",
          "Responsible Person": "Agronomist / Soil Scientist",
          Timeline: "1 Month",
          Status: "Open",
        },
        {
          Parameter: "Topsoil Stockpile Management",
          "Standard / Benchmark": "Stockpile height ≤ 2m, covered, seeded",
          "Method / Equipment": "Visual + Drone Survey",
          "Measured Value": "Height 4.2m, uncovered",
          "Compliance Status": "Non-Compliant",
          "Variance from Standard": "Height +2.2m, no cover",
          "AI Suggested Action":
            "Reduce stockpile height, cover with geotextile/tarpaulin, seed with grass to prevent erosion",
          "Responsible Person": "Contractor + EHS",
          Timeline: "1 Week",
          Status: "Open",
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 5,
          value:
            "→ LAND-001: Excess excavation depth → Slope instability & safety risk\n→ LAND-002: Vegetation loss → Linked to BIO-001 (biodiversity decline) & erosion risk\n→ LAND-003: Soil acidification → Reduced rehabilitation success rate → TNFD nature-related risk\n→ LAND-004: Poor topsoil management → Long-term land productivity loss",
          disabled: true,
        },
        {
          label: "Overall Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "EHS Officer / Soil Scientist / ESG Officer",
        },
        { label: "Review Date", type: "date", value: "2025-11-27" },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Digital Signatures (Audit-Ready)",
      fields: [
        {
          label: "Prepared By (Monitoring Lead)",
          type: "text",
          value: "Anil Saini",
          required: true,
        },
        {
          label: "Verified By (EHS / Soil Scientist)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager / ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-27", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all land use & soil data is accurate and corrective actions are assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const LAND_USE_SOIL_DISTURBANCE_STEP_3 = [
  {
    heading: "Detail Reporting",
    items: [],
  },

  // Global ESG Reporting Standards
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific ESG Compliance
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier Selection & Compliance
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future Development
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const STAKEHOLDER_MEETING_CAPTURE_FORM_STEP_1 = {
  title: "Digital Stakeholder Meeting Capture & Setup",
  subtitle: "",
  formTitle: "Stakeholder Engagement & Meeting Minutes",
  downloadFileName: "Stakeholder_Meeting_Minutes",
  downloadFileExtension: "pdf",

  notes: [
    "• AI Auto-Summarization: Automatically categorizes concerns (Environment, Social, Governance, Safety, Livelihood).",
    "• AI Trend Detection: Flags recurring issues from past meetings (e.g., 'Wastewater complaint raised 4th time').",
    "• All evidence is geo-tagged & audit-ready for GRI 413, IFC PS1, ESRS E4/S1 compliance.",
  ],

  sections: [
    // ========== MEETING SETUP INFORMATION ==========
    {
      title: "Meeting Setup Information (User + AI Support)",
      helperText:
        "Auto-generated ID & timestamp. Select all applicable groups.",
      fields: [
        {
          label: "Meeting ID (Auto-generated unique ID)",
          type: "text",
          value: "STK-2025-11-2801",
          disabled: true,
        },
        {
          label: "Date & Time (Auto-captured system clock + timezone)",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Project / Facility Name",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Meeting Location",
          type: "text",
          placeholder:
            "Physical / Virtual (Zoom, Teams, On-site, Community Hall, etc.)",
        },

        {
          label: "Stakeholder Group(s) Engaged – Multi-select",
          type: "checkbox",
          options: [
            "Local Community",
            "Employees",
            "Contractors",
            "Suppliers",
            "Regulators",
            "NGOs",
            "Investors",
            "Other _________",
          ],
          required: true,
        },

        {
          label: "Departments Represented",
          type: "checkbox",
          options: [
            "Operations",
            "EHS",
            "HR",
            "CSR",
            "Procurement",
            "Community",
            "Other _________",
          ],
        },

        {
          label: "Meeting Purpose / Objectives",
          type: "checkbox",
          options: [
            "Consultation & Engagement",
            "Regulatory/Permit Review",
            "ESG Performance Disclosure",
            "Conflict Resolution / Grievance Handling",
            "Project Updates",
            "Other: ________",
          ],
          required: true,
        },

        {
          label: "Agenda Items (User Input)",
          type: "textarea",
          rows: 5,
          placeholder:
            "List agenda topics.\nAI can suggest based on previous meetings & ESG priorities.\nExample: Discussion on wastewater discharge...",
          note: "AI will suggest recurring/high-priority topics from previous engagements",
        },
      ],
    },

    // ========== MANUAL INPUTS DURING MEETING ==========
    {
      title: "Manual User Inputs During Meeting",
      subtitle:
        "Capture real-time discussion. AI auto-summarizes & categorizes concerns.",
      type: "table",
      addRowLabel: "+ Add New Discussion Point",

      fields: [
        { label: "Agenda Item", type: "text", width: "18%" },
        {
          label: "Stakeholder Concern / Discussion Point",
          type: "text",
          width: "24%",
        },
        {
          label: "Notes (User Input)",
          type: "textarea",
          rows: 2,
          width: "28%",
        },
        { label: "Evidence / Attachments", type: "file", width: "14%" },
        {
          label: "AI Auto-Summary (Optional)",
          type: "textarea",
          rows: 2,
          disabled: true,
          width: "16%",
        },
      ],

      preFilledRows: [
        {
          "Agenda Item": "Wastewater discharge",
          "Stakeholder Concern / Discussion Point":
            "Local community raised odor complaints",
          "Notes (User Input)": "Strong odor near discharge outlet",
          "Evidence / Attachments": "[Attach complaint letter / photo]",
          "AI Auto-Summary (Optional)":
            "Community perceives untreated discharge; reputational risk.",
        },
      ],
    },

    // ========== EVIDENCE & ATTACHMENTS + AI FEATURES (FULLY UPDATED) ==========
    {
      title: "Evidence, Attachments & AI-Powered Insights",
      subtitle:
        "Upload files + AI analyzes sentiment, trends & compliance gaps",
      fields: [
        {
          label: "Upload MoM draft (Word, PDF, scanned copy)",
          type: "file",
          accept: ".pdf,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload stakeholder presentations",
          type: "file",
          accept: ".pdf,.pptx",
          multiple: true,
        },
        {
          label: "Upload geo-tagged photos of meeting venue",
          type: "file",
          accept: "image/*",
          multiple: true,
        },
        {
          label: "Upload complaint records / feedback forms",
          type: "file",
          accept: ".pdf,.jpg,.xlsx",
          multiple: true,
        },

        // YE TUMHARA MISSING AI FEATURES WALA PART — AB BILKUL CLEAR & BOLD!

        {
          subtitle: "AI Features:",
          type: "textarea",
          label: "Auto-summarize stakeholder concerns by category ",
          rows: 3,
          placeholder: "Environment, Social, Governance, Safety.",
          disabled: true,
        },

        {
          type: "textarea",
          label: "Compare with past meetings ",
          rows: 3,
          placeholder:
            "Issue on wastewater raised repeatedly in last 3 meetings",
          disabled: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const STAKEHOLDER_MEETING_CAPTURE_FORM_STEP_2 = {
  title: "Smart AI-Enabled Stakeholder Meeting Report",
  subtitle: "",
  formTitle: "Stakeholder Engagement & Meeting Minutes",
  downloadFileName: "Stakeholder_Meeting_Minutes",
  downloadFileExtension: "pdf",

  notes: [
    "AI Auto-Summarization: Automatically categorizes concerns (Environment, Social, Governance, Safety, Livelihood).",
    "AI Trend Detection: Flags recurring issues from past meetings.",
    "All evidence is geo-tagged & audit-ready for GRI 413, IFC PS1, ESRS compliance.",
  ],

  sections: [
    // ========== MEETING SUMMARY (AI Structured Output) ==========
    {
      title: "Meeting Summary (AI Structured Output)",
      fields: [
        {
          label: "Meeting ID",
          type: "text",
          value: "STK-2025-11-2801",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Project / Facility",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
        {
          label: "Stakeholder Groups",
          type: "text",
          value: "Local Community, Regulators",
          disabled: true,
        },
        {
          label: "Purpose",
          type: "text",
          value:
            "Consultation & Engagement, Conflict Resolution / Grievance Handling",
          disabled: true,
        },
      ],
    },

    // ========== DISCUSSION & ACTION TRACKING ==========
    {
      title: "Discussion & Action Tracking",
      type: "table",
      addRowLabel: "+ Add Action Item",

      fields: [
        { label: "Agenda Item", type: "text", width: "16%" },
        { label: "Stakeholder Concern", type: "text", width: "20%" },
        {
          label: "AI Risk/Materiality Classification",
          type: "text",
          disabled: true,
          width: "18%",
        },
        { label: "Agreed Actions", type: "textarea", rows: 2, width: "20%" },
        { label: "Responsible Person", type: "text", width: "12%" },
        { label: "Timeline", type: "text", width: "10%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],

      preFilledRows: [
        {
          "Agenda Item": "Wastewater discharge",
          "Stakeholder Concern": "Odor near outlet",
          "AI Risk/Materiality Classification":
            "High (Community Impact, Compliance Risk)",
          "Agreed Actions":
            "Conduct water quality test, share results with community",
          "Responsible Person": "Utility Engineer",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Agenda Item": "Local employment",
          "Stakeholder Concern": "Requests for more local hiring",
          "AI Risk/Materiality Classification": "Medium (Social Inclusion)",
          "Agreed Actions": "HR to review hiring pipeline",
          "Responsible Person": "HR Manager",
          Timeline: "1 Month",
          Status: "Open",
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "textarea",
          rows: 4,
          value:
            "→ Odor complaints → Linked to Water Discharge Risk (ENV-2025-012)\n→ Local hiring demand → Linked to Social Inclusion & SDG 8",
          disabled: true,
        },
        {
          label: "Overall Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "CSR/ESG Officer / Community Relations Lead",
        },
        {
          label: "Review Date",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
        },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Signatures (Audit Ready)",
      fields: [
        {
          label: "Prepared By (Meeting Recorder)",
          type: "text",
          value: "Rahul Sharma",
          required: true,
        },
        {
          label: "Verified By (CSR/ESG Officer)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager/Corporate ESG Lead)",
          type: "text",
          placeholder: "____________________",
          required: true,
        },
        {
          label: "Date",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
          disabled: true,
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all stakeholder concerns are accurately recorded and actions assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const STAKEHOLDER_MEETING_CAPTURE_FORM_STEP_3 = [
  {
    heading: "Detail Reporting",
    items: [],
  },
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific ESG Compliance
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier Selection & Compliance
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future Development
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" }, // ← Yeh pehle miss tha, ab add kar diya
    ],
  },
];

export const GRIEVANCE_CAPTURE_FORM_STEP_1 = {
  title: "Digital Grievance Capture Form (User + AI Hybrid)",
  subtitle: "",
  formTitle: "",
  downloadFileName: "Grievance_Log",
  downloadFileExtension: "pdf",

  notes: [
    "Fully GDPR-compliant & confidential handling",
    "AI auto-classifies grievance type, severity & links to IFC PS / GRI standards",
    "Auto-syncs to Grievance Register & ESG Vision Dashboard",
  ],

  sections: [
    // ========== GRIEVANCE INTAKE INFORMATION ==========
    {
      title: "Grievance Intake Information",
      helperText: "Auto-generated fields + confidential complainant details",
      fields: [
        {
          label: "Grievance ID",
          type: "text",
          value: "GRV-2025-11-2901",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured (system clock + timezone)",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "e.g., GreenField Solar Park, Rajasthan",
          required: true,
        },

        {
          label: "Complaint Received Via",
          type: "checkbox",
          options: [
            "Community Helpdesk",
            "Hotline",
            "Email",
            "Letter",
            "Stakeholder Meeting",
            "Social Media",
            "Other: _________",
          ],
          required: true,
        },

        {
          label: "Complainant Details (Confidential, GDPR-compliant)",
          type: "info",
          value:
            "Data protected • Access restricted to authorized personnel only",
        },
        {
          label: "Name (optional)",
          type: "text",
          placeholder: "Anonymous if preferred",
        },
        {
          label: "Contact Info (phone/email)",
          type: "text",
          placeholder: "For follow-up only",
        },
        {
          label: "Community Group (if applicable)",
          type: "text",
          placeholder: "e.g., Village Panchayat, Farmers Group",
        },
        {
          label: "Preferred Language",
          type: "text",
          placeholder: "e.g., Hindi, English, Rajasthani",
        },

        {
          label: "Location of Concern",
          type: "text",
          value: "26.9124° N, 75.7873° E (GPS auto-captured with map overlay)",
          disabled: true,
        },
      ],
    },

    // ========== COMPLAINT DESCRIPTION ==========
    {
      title: "Complaint Description (User Input)",
      helperText: "AI assists in classification and tagging",
      fields: [
        {
          label: "Category (AI Suggested)",
          type: "checkbox",
          options: [
            "Environmental (air, water, noise, waste)",
            "Social (employment, land use, community benefits)",
            "Health & Safety (accidents, occupational hazards)",
            "Human Rights (resettlement, indigenous rights, discrimination)",
            "Other: _________",
          ],
          required: true,
        },

        {
          label: "Complaint Details",
          type: "textarea",
          rows: 6,
          placeholder:
            "Describe the issue in detail...\nExample: Strong chemical odor from plant discharge affecting health and livestock since last week...",
          required: true,
        },

        {
          label: "Severity (User Perception)",
          type: "radio",
          options: ["Low", "Medium", "High", "Urgent"],
          inline: true,
          required: true,
        },

        // YEHI MISSING THA — AB ADD KAR DIYA
        {
          label: "Evidence & Attachments",
          type: "checkbox",
          options: [
            "Photos",
            "Videos",
            "Signed letters",
            "Media reports",
            "Other: _________",
          ],
        },

        // File upload bhi rakha hai (real functionality ke liye)
        {
          label: "Upload Evidence Files",
          type: "file",
          accept: "image/*,video/*,.pdf,.docx",
          multiple: true,
          note: "Attach photos, videos, letters, reports etc.",
        },

        {
          label: "AI Auto-Assist",
          type: "info",
          value:
            "• Classifies complaint type (Environment, Social, Governance)\n" +
            "• Tags keywords → “odor”, “dust”, “hiring bias”, etc.\n" +
            "• Links to relevant ESG standards (e.g., IFC PS1, PS4, GRI 413, ESRS S1)",
        },
      ],
    },

    // ========== INITIAL ACKNOWLEDGMENT ==========
    {
      title: "Initial Acknowledgment (User Input)",
      fields: [
        {
          label: "Complaint Received By",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Date Acknowledged to Complainant",
          type: "date",
          required: true,
        },
        {
          label: "Mode of Acknowledgment",
          type: "checkbox",
          options: ["Verbal", "Written", "Digital (SMS/Email)"],
          required: true,
        },
        {
          label: "Acknowledgment Message Sent",
          type: "textarea",
          rows: 3,
          placeholder:
            "Your grievance has been recorded (ID: GRV-2025-11-2901). We will investigate and respond within 7 working days...",
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const GRIEVANCE_REGISTER_STEP_2 = {
  title: "",
  subtitle: "",
  formTitle: "Community Grievance Register",
  downloadFileName: "Community_Grievance_Register",
  downloadFileExtension: "pdf",

  notes: [
    "AI auto-classifies, flags trends & suggests mitigation actions",
    "Fully audit-ready for IFC PS1, GRI 413, ESRS S1/S2 compliance",
    "Auto-syncs with Risk Register & ESG Vision Dashboard",
  ],

  sections: [
    // ========== GRIEVANCE SUMMARY ==========
    {
      title: "",
      fields: [
        {
          label: "Grievance ID – Auto-generated unique ID",
          type: "text",
          value: "G-2025-001",
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured (system clock + timezone)",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
      ],
    },

    // ========== COMMUNITY COMPLAINT REGISTER TABLE ==========
    {
      title: "Community Complaint Register",
      type: "table",
      addRowLabel: "+ Add New Grievance",
      fields: [
        { label: "Grievance ID", type: "text", width: "10%" },
        { label: "Category", type: "text", width: "14%" },
        { label: "Complaint Means", type: "text", width: "14%" },
        { label: "Complaint Summary", type: "textarea", rows: 2, width: "18%" },
        {
          label: "AI Risk Classification",
          type: "text",
          disabled: true,
          width: "14%",
        },
        { label: "Assigned Department", type: "text", width: "10%" },
        { label: "Action Required", type: "textarea", rows: 2, width: "16%" },
        { label: "Responsible Person", type: "text", width: "10%" },
        { label: "Timeline", type: "text", width: "8%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
      preFilledRows: [
        {
          "Grievance ID": "G-2025-001",
          Category: "Environmental – Water",
          "Complaint Means": "Hotline, Email, Social Media etc.",
          "Complaint Summary": "Odor near wastewater discharge point",
          "AI Risk Classification": "High (Compliance + Community Impact)",
          "Assigned Department": "Utilities",
          "Action Required": "Test effluent, share report with community",
          "Responsible Person": "EHS Officer",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Grievance ID": "G-2025-002",
          Category: "Social – Employment",
          "Complaint Means": "Hotline, Email, Social Media etc.",
          "Complaint Summary": "Request for more local hiring",
          "AI Risk Classification": "Medium (Social License Risk)",
          "Assigned Department": "HR",
          "Action Required": "Review hiring pipeline & disclose ratios",
          "Responsible Person": "HR Manager",
          Timeline: "1 Month",
          Status: "Open",
        },
      ],
    },

    {
      title: "AI-Enabled Features ",
      fields: [
        {
          label: "Compliance Check (AI Auto-Flag)",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "Trend Analysis (AI Detected)",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "Risk Linkage (Auto Cross-Referenced)",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
        {
          label: "Community Feedback Loop (AI Reminder)",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
          required: true,
        },
        {
          label: "Reviewed By – CSR/ESG Officer / Community Relations Lead",
          type: "text",
          placeholder: "Enter name",
          required: true,
        },
        {
          label: "Review Date",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
          required: true,
        },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Signatures (Audit Ready)",
      fields: [
        {
          label: "Logged By (Grievance Officer)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Verified By (ESG/CSR Lead)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager / ESG Director)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Date",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
          disabled: true,
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all grievances are accurately recorded, actions assigned and follow-up scheduled",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const GRIEVANCE_REGISTER_STEP_3 = [
  // Main Title - Premium Banner Style

  // Detail Reporting
  {
    heading: "Detail Reporting",
    type: "checkbox",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  // Global ESG Reporting Standards
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    type: "checkbox",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    type: "checkbox",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    type: "checkbox",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // Industrial & Country-Specific ESG Compliance
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    type: "checkbox",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // Data Analytics
  {
    heading: "Data Analytics",
    type: "checkbox",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // Supplier Selection & Compliance
  {
    heading: "Supplier Selection & Compliance",
    type: "checkbox",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // Capacity & Future Development
  {
    heading: "Capacity & Future Development",
    type: "checkbox",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const TRAINING_TOOLBOX_TALK_CAPTURE_FORM_STEP_1 = {
  title: "Digital Training / Toolbox Talk Capture (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Training & Toolbox Talk Register",
  downloadFileName: "Training_Toolbox_Talk_Log",
  downloadFileExtension: "pdf",

  notes: [
    "Fully compliant with ISO 45001, IFC PS2, GRI 403, ESRS S2",
    "AI suggests topics based on incident trends, seasonal risks & audit gaps",
    "Auto-syncs to Training Matrix, Risk Register & ESG Vision Dashboard",
  ],

  sections: [
    // ===================== 1. TRAINING SETUP =====================
    {
      title: "Training / Toolbox Talk Setup Information",
      helperText: "Auto-generated + real-time geo-tagging",
      fields: [
        {
          label: "Session ID – Auto-generated unique ID",
          type: "text",
          value: `TT-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-01`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured (system clock + timezone)",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
        {
          label: "Location / Work Area",
          type: "text",
          placeholder: "e.g., Substation Area, Turbine Zone, Admin Block",
          required: true,
        },
        {
          label: "Geo-Tagging – GPS auto-captured with map overlay",
          type: "text",
          value:
            "26.9124° N, 75.7873° E (Jaipur, Rajasthan) → Verified within site",
          disabled: true,
        },
        {
          label: "Trainer / Facilitator",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Departments / Participants Covered",
          type: "checkbox",
          options: [
            "Operations",
            "Maintenance",
            "EHS",
            "Contractors",
            "Visitors",
            "Other: _______",
          ],
          required: true,
        },
      ],
    },

    // ===================== 2. SESSION TYPE & TOPICS =====================
    {
      title: "Session Type (multi-select)",
      fields: [
        {
          label: "Session Type (multi-select)",
          type: "checkbox",
          options: [
            "Induction Training",
            "Refresher Training",
            "Daily Toolbox Talk",
            "Safety Drill",
            "Specialized Skill Training",
            "Community Awareness Training",
            "Other: _________",
          ],
          required: true,
        },

        {
          label: "Core Safety & Environment Topics",
          type: "checkbox",
          options: [
            "PPE Usage",
            "Emergency Response & Evacuation",
            "Fire Safety",
            "Waste Handling",
            "Hazardous Chemical Safety",
            "Working at Height / Confined Space",
            "Driving & Transport Safety",
            "Biodiversity & Cultural Sensitivity",
            "Other: ___________________________",
          ],
          required: true,
        },

        // PREMIUM AI SUGGESTION BOX (BLUE)
        {
          label: "",
          type: "info",
          value:
            "AI Topic Suggestion Engine Active\n\n" +
            "• Recent incident trend: 3 near-miss falls in last 30 days → Recommending “Working at Height”\n" +
            "• Monsoon season detected → Adding “Slips, Trips & Falls”\n" +
            "• Recent audit finding: Chemical storage non-compliance → Suggesting “Hazardous Chemical Safety”\n" +
            "• High dust levels reported → Adding “Respiratory Protection”\n" +
            "• New contractors onboarded → Mandatory “Site Induction” flagged",
          sx: {
            background: "linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%)",
            border: "4px solid #02462E",
            borderRadius: "20px",
            padding: "28px 32px",
            fontFamily: "DM Sans",
            fontSize: "16px",
            fontWeight: "600",
            color: "#1a1a1a",
            lineHeight: "2.1",
            whiteSpace: "pre-line",
            boxShadow: "0 10px 30px rgba(53, 65, 165, 0.2)",
            margin: "24px 0",
          },
        },
      ],
    },

    // ===================== 3. ATTENDANCE & DELIVERY =====================
    {
      title: "Attendance & Delivery Method",
      fields: [
        {
          label: "Number of Participants",
          type: "text",
          placeholder: "e.g., 28",
          required: true,
        },
        {
          label: "Participant List Upload",
          type: "file",
          accept: ".pdf,.xlsx,.csv,image/*",
          multiple: true,
          note: "Attach signed attendance sheet, biometric report, or photo register",
        },
        {
          label: "Roles Represented",
          type: "checkbox",
          options: ["Worker", "Supervisor", "Manager", "Contractor", "Visitor"],
          required: true,
        },
        {
          label: "Delivery Method",
          type: "radio",
          options: [
            "In-person (classroom / site)",
            "Virtual (Teams/Zoom/Webinar)",
            "Practical Demonstration (field)",
            "Drill / Mock Exercise",
          ],
          inline: true,
          required: true,
        },
      ],
    },

    // ===================== 4. EVIDENCE & AI VERIFICATION =====================
    {
      title: "Evidence & Attachments + AI Verification",
      fields: [
        {
          label: "Evidence & Attachments",
          type: "checkbox",
          options: [
            "Upload photos of session",
            "Upload signed attendance sheet / register",
            "Upload training materials / slides / handouts",
            "Upload video clip / recording",
          ],
        },
        {
          label: "Upload Files",
          type: "file",
          accept: "image/*,video/*,.pdf,.ppt,.pptx,.doc,.docx",
          multiple: true,
          note: "Mandatory: At least 1 photo + attendance proof",
        },

        // GREEN AI VERIFICATION BOX
        {
          label: "",
          type: "info",
          value:
            "AI Compliance Check Complete\n\n" +
            "Attendance sheet detected & verified\n" +
            "Minimum 3 session photos uploaded\n" +
            "Training content matches selected topics\n" +
            "Geo-location confirmed within site boundary\n" +
            "All mandatory fields completed → Ready for approval",
          sx: {
            background: "linear-gradient(135deg, #e8f5e8 0%, #dcedc8 100%)",
            border: "4px solid #4caf50",
            borderRadius: "20px",
            padding: "28px 32px",
            fontFamily: "DM Sans",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#0d6e0d",
            lineHeight: "2.1",
            whiteSpace: "pre-line",
            boxShadow: "0 10px 30px rgba(76, 175, 80, 0.2)",
            margin: "24px 0",
          },
        },
      ],
    },

    // ===================== 5. OBSERVATIONS & FEEDBACK =====================
    {
      title: "Observations / Feedback",
      fields: [
        {
          label: "Trainer Notes",
          type: "textarea",
          rows: 4,
          placeholder:
            "Key takeaways, participant engagement level, any concerns raised...",
        },
        {
          label: "Participant Feedback",
          type: "textarea",
          rows: 4,
          placeholder: "Was the session useful? Any suggestions?",
        },
        {
          label: "Improvement Suggestions",
          type: "textarea",
          rows: 4,
          placeholder: "For future sessions...",
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm this training session was conducted as recorded with full participation and evidence",
          ],
          required: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const TRAINING_TOOLBOX_TALK_LOG_STEP_2 = {
  title: "Smart AI-Enabled Training & Toolbox Talk Log",
  subtitle: "",
  formTitle: "Training & Toolbox Talk Register",
  downloadFileName: "Training_Toolbox_Talk_Log",
  downloadFileExtension: "pdf",

  notes: [
    "AI validates attendance, flags gaps & links to incident trends",
    "Fully audit-ready for ISO 45001, IFC PS2, GRI 403, ESRS S2",
    "Auto-syncs with Training Matrix, Incident Register & ESG Vision Dashboard",
  ],

  sections: [
    // ========== SESSION SUMMARY ==========
    {
      title: "",
      fields: [
        {
          label: "Session ID ",
          type: "text",
          value: "TRAIN-LOG-2025-11",
          disabled: true,
        },
        {
          label: "Date Range Covered",
          type: "text",
          value: "01 Nov 2025 – 27 Nov 2025",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
        {
          label: "Location / Work Area",
          type: "text",
          placeholder: "e.g., Substation Area, Turbine Zone, Admin Block",
          required: true,
        },
      ],
    },

    // ========== MAIN TRAINING LOG TABLE ==========
    {
      title: "Training & Toolbox Talk Register",
      type: "table",
      addRowLabel: "+ Add New Training Session",
      fields: [
        { label: "Session ID", type: "text", width: "10%" },
        { label: "Date", type: "date", width: "10%" },
        { label: "Type", type: "text", width: "14%" },
        { label: "Topics", type: "text", width: "18%" },
        { label: "Participants", type: "text", width: "8%" },
        {
          label: "Compliance Status",
          type: "text",
          disabled: true,
          width: "10%",
        },
        { label: "AI Insights", type: "text", disabled: true, width: "20%" },
        { label: "Responsible Person", type: "text", width: "12%" },
        { label: "Timeline", type: "text", width: "8%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
      preFilledRows: [
        {
          "Session ID": "TBT-2025-047",
          Date: "2025-11-26",
          Type: "Daily Toolbox Talk",
          Topics: "PPE Usage, Fall Protection, Heat Stress",
          Participants: "32",
          "Compliance Status": "Compliant",
          "AI Insights":
            "3 near-miss falls last week → Reinforced Working at Height\nAttendance validated via photo + biometric",
          "Responsible Person": "HSE Supervisor - Rajesh Kumar",
          Timeline: "Daily",
          Status: "Closed",
        },
        {
          "Session ID": "TRN-2025-018",
          Date: "2025-11-20",
          Type: "Induction Training",
          Topics: "Site Safety Rules, Emergency Evacuation, Fire Safety",
          Participants: "18",
          "Compliance Status": "Compliant",
          "AI Insights":
            "12 new joiners completed induction\nAll contractors covered → No gap detected",
          "Responsible Person": "HR + EHS Team",
          Timeline: "As per onboarding",
          Status: "Closed",
        },
        {
          "Session ID": "DRILL-2025-003",
          Date: "2025-11-15",
          Type: "Fire Drill",
          Topics: "Mock Fire Evacuation & First Aid",
          Participants: "85",
          "Compliance Status": "Compliant",
          "AI Insights":
            "Evacuation time: 4 min 32 sec (improved from 6 min)\nPost-drill feedback collected",
          "Responsible Person": "Emergency Response Team",
          Timeline: "Quarterly",
          Status: "Closed",
        },
      ],
    },

    {
      title: "AI-Enabled Features ",
      fields: [
        {
          label: "Attendance Validation ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "Compliance Assurance ",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "Trend Analysis ",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
        {
          label: "Risk Linkage ",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
        {
          label: "ESG / Audit Readiness ",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Training Status ",
          type: "radio",
          options: ["Open", "Under Review", "Completed", "Verified"],
          inline: true,
          required: true,
        },
        {
          label: "Reviewed By – EHS/HR Officer / Compliance Lead",
          type: "text",
          placeholder: "Enter name & designation",
          required: true,
        },
        {
          label: "Review Date",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
          required: true,
        },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Signatures (Audit Ready)",
      fields: [
        {
          label: "•	Facilitator / Trainer",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager / HR Lead)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Date",
          type: "date",
          value: new Date().toISOString().slice(0, 10),
          disabled: true,
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all training sessions are accurately recorded, evidence verified, and compliance achieved",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const TRAINING_TOOLBOX_TALK_LOG_STEP_3 = [
  // DETAIL REPORTING
  {
    heading: "Detail Reporting",
    type: "checkbox",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  // GLOBAL ESG REPORTING STANDARDS
  {
    heading: "Global ESG Reporting (Standards Frameworks Compliances)",
    type: "checkbox",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },

      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // CLIMATE CARBON
  {
    heading: "Climate Carbon Compliance",
    type: "checkbox",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance Bond Standards",
      },
      { id: "carbon_credit", label: "Carbon Credit, Offset Emission Trading" },
    ],
  },

  // OPERATIONAL ESG
  {
    heading: "Operational ESG Systems Reporting",
    type: "checkbox",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "ES Legal Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental Social System Management" },
    ],
  },

  // INDUSTRIAL COUNTRY SPECIFIC
  {
    heading: "Industrial Country-Specific ESG Compliance",
    type: "checkbox",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "ES Due Diligence for ESG Compliance" },
    ],
  },

  // DATA ANALYTICS
  {
    heading: "Data Analytics",
    type: "checkbox",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // SUPPLIER
  {
    heading: "Supplier Selection Compliance",
    type: "checkbox",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment Compliance" },
    ],
  },

  // CAPACITY DEVELOPMENT
  {
    heading: "Capacity Future Development",
    type: "checkbox",
    items: [
      { id: "training", label: "Training Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const Contractor_Compliance_Capture_STEP_1 = {
  title: "Digital Contractor Compliance Capture (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Contractor Compliance Report",
  downloadFileName: "Contractor_Compliance_Report",
  downloadFileExtension: "pdf",

  notes: [
    "Fully compliant with IFC PS2, ILO Conventions, ISO 45001, ISO 14001, GRI 408/409, ESRS S1/S2",
    "AI auto-flags expired docs, child labor risk, wage delays & missing evidence",
    "Auto-syncs to Supplier Risk Register, Labor Dashboard & ESG Vision Platform",
  ],

  sections: [
    // ===================== 1. CONTRACTOR SETUP =====================
    {
      title: "Contractor / Subcontractor Setup Information",
      helperText: "Auto-generated + GPS locked",
      fields: [
        {
          label: "Compliance ID – Auto-generated unique ID",
          type: "text",
          value: `CON-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-089`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },

        {
          label: "Contractor / Subcontractor Name",
          type: "text",
          placeholder: "e.g., Shree Construction Ltd., Raj Electricals",
          required: true,
        },
        {
          label: "Contract / PO Reference",
          type: "text",
          placeholder: "e.g., PO-2025-1189, Civil Works Phase-2",
          required: true,
        },
        {
          label: "Work Scope / Activity",
          type: "text",
          placeholder:
            "e.g., Trenching, Welding, Waste Transport, Housekeeping",
          required: true,
        },
        {
          label: "Location(s) of Work",
          type: "checkbox",
          options: ["Site", "Workshop", "Community", "Other _________"],
          required: true,
        },
        {
          label: "Geo-Tagging – GPS auto-captured",
          type: "text",
          value: "26.9124° N, 75.7873° E → Verified inside project boundary",
          disabled: true,
        },
        {
          label: "Contractor Representative (Name/Contact)",
          type: "text",
          placeholder:
            "e.g., Mr. Ramesh Sharma, Site In-charge, +91-98xxxxxxxx",
          required: true,
        },
        {
          label: "Responsible Department",
          type: "checkbox",
          options: [
            "Procurement",
            "EHS",
            "Operations",
            "HR",
            "Community",
            "Other _________",
          ],
          required: true,
        },
        {
          label: "Compliance Objective (multi-select)",
          type: "checkbox",
          options: [
            "Regulatory Compliance",
            "ESG Reporting",
            "Permit / License Verification",
            "Safety & Health Management",
            "Labor & Human Rights (ILO/UNGC alignment)",
            "Environmental Safeguards",
            "Community Safeguards",
            "Other: _________",
          ],
          required: true,
        },
      ],
    },

    // ===================== 2. AI DOCUMENT SUGGESTION (GROUPED CHECKBOXES) =====================
    {
      title: "Compliance Documents Required (User + AI Suggestion)",
      fields: [
        {
          label: "Legal / Contractual",
          type: "checkbox",
          options: [
            "Business License",
            "Tax Registration",
            "Insurance Certificates",
            "Labor Permits",
            "Others___________",
          ],
        },
        {
          label: "EHS Compliance",
          type: "checkbox",
          options: [
            "Safety Plan",
            "Training Records",
            "Equipment Certifications",
            "Waste Management Plan",
            "Chemical Handling Authorization",
            "Others___________",
          ],
        },
        {
          label: "Labor & HR",
          type: "checkbox",
          options: [
            "Worker IDs",
            "Age Verification",
            "Employment Contracts",
            "Wage Records",
            "PPE Issuance Logs",
            "Others___________",
          ],
        },
        {
          label: "Environmental & Community",
          type: "checkbox",
          options: [
            "Spill Prevention Plan",
            "Biodiversity Safeguard",
            "Noise & Dust Control",
            "Community Consent",
            "CSR Obligations",
            "Others___________",
          ],
        },
        // PREMIUM AI SUGGESTION BOX
        {
          label: "",
          type: "info",
          value:
            "AI SUGGESTION ENGINE ACTIVE\n\n" +
            "Contract Type: Civil +150 workers, High-risk activity (Height Work + Chemicals)\n" +
            "Jurisdiction: Rajasthan + IFC Financed\n\n" +
            "MANDATORY DOCUMENTS (Auto-selected above):\n" +
            "• Labor License (Contract Labour Act)\n" +
            "• Work at Height Permit + Training\n" +
            "• Hazardous Waste Authorization\n" +
            "• Worker Insurance (WC Policy)\n" +
            "• No-Child-Labor Declaration\n\n" +
            "Missing Documents: 4 → Contractor flagged as HIGH RISK",
          sx: {
            background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
            border: "5px solid #1565c0",
            borderRadius: "24px",
            padding: "32px 36px",
            fontFamily: "DM Sans",
            fontSize: "16.5px",
            fontWeight: "bold",
            color: "#0d47a1",
            lineHeight: "2.2",
            whiteSpace: "pre-line",
            boxShadow: "0 12px 40px rgba(21, 101, 192, 0.28)",
            margin: "32px 0",
          },
        },
      ],
    },

    // ===================== 3. SELF-DECLARATION TABLE =====================
    {
      title: "Manual User Input – Contractor Compliance Self-Declaration",
      type: "table",
      addRowLabel: "+ Add New Declaration",
      fields: [
        { label: "Compliance Area", type: "text", width: "18%" },
        { label: "Requirement (user/AI input)", type: "text", width: "28%" },
        {
          label: "Contractor Declaration",
          type: "radio",
          options: ["Yes", "No"],
          inline: true,
          width: "12%",
        },
        {
          label: "Evidence Upload",
          type: "file",
          accept: ".pdf,.jpg,.png",
          width: "18%",
        },
        { label: "Remarks", type: "textarea", rows: 2, width: "24%" },
      ],
      preFilledRows: [
        {
          "Compliance Area": "Legal License",
          "Requirement (user/AI input)": "Valid till Dec 2025",
          "Contractor Declaration": "Yes",
          "Evidence Upload": null,
          Remarks: "Verified – License No. RJ/2024/5678",
        },
        {
          "Compliance Area": "PPE Training",
          "Requirement (user/AI input)": "All staff trained on PPE usage",
          "Contractor Declaration": "No",
          "Evidence Upload": null,
          Remarks: "Only 68% trained – Immediate corrective action required",
        },
      ],
    },

    // ===================== 4. ON-SITE VERIFICATION =====================
    {
      title: "Workplace Compliance Checks (On-Site Verification)",
      fields: [
        {
          label: "On-Site Observations",
          type: "checkbox",
          options: [
            "Valid work permits displayed",
            "PPE compliance",
            "Emergency preparedness (fire, spill kits, alarms)",
            "Waste segregation & storage",
            "Equipment certifications available",
            "Worker welfare (water, sanitation, first aid)",
            "Wage and ID verification",
            "No underage or forced labor",
            "Community safety safeguards (traffic, dust, noise)",
          ],
        },
        {
          label: "Non-compliance incidents observed",
          type: "textarea",
          rows: 4,
          placeholder: "List any violations observed during site visit...",
        },
        {
          label: "Worker grievances / community concerns",
          type: "textarea",
          rows: 3,
          placeholder:
            "Any complaints received from workers or nearby community?",
        },
        {
          label: "Site safety observations",
          type: "textarea",
          rows: 4,
          placeholder:
            "General observations about housekeeping, barricading, signage etc.",
        },
      ],
    },

    // ===================== 5. EVIDENCE + AI FINAL CHECK (RED BOX) =====================
    {
      title: "Evidence & Attachments + AI Final Check",
      fields: [
        {
          label: "Upload compliance certificates, insurance, licenses",
          type: "file",
          accept: ".pdf,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload workforce registers / PPE records",
          type: "file",
          accept: ".pdf,.xlsx",
          multiple: true,
        },
        {
          label: "Upload geo-tagged site inspection photos",
          type: "file",
          accept: "image/*",
          multiple: true,
        },
        {
          label: "Upload grievance records / community feedback",
          type: "file",
          accept: ".pdf,.docx,.xlsx",
          multiple: true,
        },
        {
          label: "",
          type: "info",
          value:
            "AI FINAL CHECK COMPLETE\n\n" +
            "Contractor Risk Score: 72/100 → HIGH RISK\n" +
            "• 4 mandatory documents missing\n" +
            "• PPE non-compliance detected in 11 photos\n" +
            "• Labor license expires in 38 days\n" +
            "• Wage payment delay reported by 7 workers\n\n" +
            "ACTION REQUIRED:\n" +
            "• Suspend payment until compliance achieved\n" +
            "• Issue formal notice within 7 days\n" +
            "• Schedule re-audit in 15 days\n" +
            "→ Auto-escalated to: Project Director, Lender Advisor, ESG Head",
          sx: {
            background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
            border: "5px solid #d32f2f",
            borderRadius: "24px",
            padding: "32px 36px",
            fontFamily: "DM Sans",
            fontSize: "17px",
            fontWeight: "bold",
            color: "#b71c1c",
            lineHeight: "2.3",
            whiteSpace: "pre-line",
            boxShadow: "0 15px 45px rgba(211, 47, 47, 0.35)",
            margin: "32px 0",
          },
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all data is verified, evidence uploaded, and AI risk score reviewed",
          ],
          required: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const Contractor_Compliance_Capture_STEP_2 = {
  title: "Smart AI-Enabled Contractor Compliance Log (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Contractor Compliance Log & Scorecard",
  downloadFileName: "Contractor_Compliance_Log_AI_Scorecard",
  downloadFileExtension: "pdf",

  sections: [
    // ===================== 1. BASIC INFO (AUTO + GPS) =====================
    {
      title: "Contractor Compliance Log – Basic Information",
      description: "Auto-generated + GPS + Blockchain timestamped",
      fields: [
        {
          label: "Compliance ID – Auto-generated unique ID",
          type: "text",
          value: `CCL-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-001`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },

        {
          label: "Contractor / Subcontractor Name",
          type: "text",
          placeholder: "e.g., Shree Construction Ltd.",
          required: true,
        },
        {
          label: "Contract / PO Reference",
          type: "text",
          placeholder: "e.g., PO-2025-1189",
          required: true,
        },
        {
          label: "Work Scope / Activity",
          type: "text",
          placeholder: "e.g., Civil Foundation, Electrical Installation",
          required: true,
        },
        {
          label: "Location(s) of Work",
          type: "checkbox",
          options: [
            "Site",
            "Workshop",
            "Community",
            "Other (please specify) _________",
          ],
          required: true,
        },
      ],
    },

    // ===================== 2. COMPLIANCE SUMMARY TABLE (FULLY SUPPORTED) =====================
    {
      title: "Contractor Compliance Summary Table (AI + User Verified)",
      type: "table",
      defaultRows: 4,
      addRowLabel: "+ Add New Compliance Item",
      fields: [
        {
          label: "Compliance Area",
          type: "text",
          width: "15%",
          placeholder: "e.g., Business License",
        },
        {
          label: "Requirement",
          type: "text",
          width: "18%",
          placeholder: "e.g., Valid till Dec 2025",
        },
        {
          label: "Evidence Status (Upload)",
          type: "text",
          width: "14%",
          placeholder: "Attached / Missing / Missing / Pending",
        },
        {
          label: "Compliance Status",
          type: "text",
          width: "12%",
          placeholder: "Compliant / Non-Compliant / Pending",
          disabled: false,
        },
        {
          label: "AI Suggested Action",
          type: "text",
          width: "20%",
          disabled: true,
        },
        {
          label: "Responsible Person",
          type: "text",
          width: "12%",
          placeholder: "e.g., Safety Officer",
        },
        {
          label: "Timeline",
          type: "text",
          width: "9%",
          placeholder: "e.g., 1 Week",
        },
        {
          label: "Status",
          type: "checkbox",
          options: ["Open", "Closed"],
          width: "8%",
        },
      ],
      // Optional: Pre-filled example rows (will appear on load)
      // Remove if you want empty table
      preFilledRows: [
        {
          0: "Business License",
          1: "Valid till Dec 2025",
          2: "Attached",
          3: "Compliant",
          4: "Continue monitoring",
          5: "Procurement Lead",
          6: "Ongoing",
          7: ["Closed"],
        },
        {
          0: "PPE Training",
          1: "All staff trained",
          2: "Missing",
          3: "Non-Compliant",
          4: "Arrange training within 7 days or suspend work",
          5: "Safety Officer",
          6: "1 Week",
          7: ["Open"],
        },
        {
          0: "Wage Records",
          1: "Updated monthly",
          2: "Attached",
          3: "Compliant",
          4: "AI notes → verify with random worker check",
          5: "HR Manager",
          6: "Monthly",
          7: ["Closed"],
        },
        {
          0: "Spill Prevention",
          1: "Plan approved",
          2: "Pending",
          3: "Non-Compliant",
          4: "Submit plan immediately – HIGH RISK",
          5: "Contractor Rep.",
          6: "Immediate",
          7: ["Open"],
        },
      ],
    },

    {
      title: "AI Add-Ons  ",
      fields: [
        {
          label: "AI Auto-Flagging:  ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "AI Scorecard:  ",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "Cross-Linking: ",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
        {
          label: "Predictive Alerts ",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
      ],
    },

    // ===================== 3. AI RISK ENGINE & PREDICTIVE INTELLIGENCE (BIG RED BOX) =====================

    // ===================== 4. VALIDATION & STATUS =====================
    {
      title: "Validation & Monitoring Status",
      fields: [
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          required: true,
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "Name & Designation",
        },
        {
          label: "Review Date",
          type: "date",
          value: new Date().toISOString().split("T")[0],
        },
      ],
    },

    // ===================== 5. CLOSING & SIGNATURES =====================
    {
      title: "Closing & Signatures (Audit-Ready + Blockchain Timestamped)",
      fields: [
        {
          label: "Prepared By (Contractor Representative)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Verified By (EHS/Procurement Officer)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Approved By (Project Manager / ESG Lead)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Final Approval Date",
          type: "date",
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all compliance items verified, evidence uploaded, AI alerts acknowledged, cross-links validated, and log is audit-ready",
          ],
          required: true,
        },
      ],
    },
  ],
};

// File: airQualityStandards.js

export const Contractor_Compliance_Capture_STEP_3 = [
  // 1. Top Banner (isFormSection use karke alag dikhane ke liye)
  {
    isFormSection: true,
    heading: "Auto-Synced to ESG Vision Dashboard",
    fields: [], // empty kyunki sirf heading hai
  },

  // 2. Detail Reporting
  {
    heading: "Detail Reporting",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  // 3. Global ESG Standards
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // 4. Climate & Carbon
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // 5. Operational ESG
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // 6. Industrial & Country-Specific
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // 7. Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // 8. Supplier
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // 9. Capacity & Future
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const Digital_PTW_PPE_Step_1 = {
  title: "Digital PTW & PPE Capture (User + AI Hybrid)",
  subtitle:
    "Real-time Safety Compliance | AI Validation | Blockchain Timestamped",
  formTitle: "Permit-to-Work & PPE Compliance Log",
  downloadFileName: "Digital_PTW_PPE_Log",
  downloadFileExtension: "png",

  sections: [
    // ========= 1. Permit-to-Work Setup Information =========
    {
      title: "Permit-to-Work Setup Information",
      description: "Auto-generated + GPS + AI-assisted",
      fields: [
        {
          label: "Permit ID – Auto-generated unique ID",
          type: "text",
          value: `PTW-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-${String(Math.floor(1000 + Math.random() * 9000)).padStart(
            4,
            "0"
          )}`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured (system clock + timezone)",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Work Description",
          type: "textarea",
          rows: 4,
          placeholder:
            "___________________________ (hot work, confined space, working at height, excavation, lifting, electrical isolation, chemical handling, etc.)",
          required: true,
        },
        {
          label: "Permit Type (multi-select)",
          type: "checkbox",
          required: true,
          options: [
            "Hot Work",
            "Confined Space Entry",
            "Working at Height",
            "Electrical Isolation",
            "Excavation",
            "Lifting/Hoisting",
            "Chemical Handling",
            "Other: ________",
          ],
        },
        {
          label:
            "Location(s) of Work – GPS auto-captured + manual entry for area/zone",
          type: "text",
          placeholder: "e.g., Zone A, Turbine 5, Tank Farm",
          required: true,
        },
        {
          label: "Permit Issuer (Name/Role)",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Permit Holder (Contractor/Supervisor Name/Contact)",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Permit Validity Period – From",
          type: "datetime-local",
          required: true,
        },
        {
          label: "Permit Validity Period – To",
          type: "datetime-local",
          required: true,
        },
        {
          label: "Associated Work Order / Job Reference",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
      ],
    },

    // ========= 2. PPE & Safety Checklist =========
    {
      title: "PPE & Safety Checklist (User Input + AI Validation)",
      fields: [
        {
          type: "checkbox",
          options: [
            "Hard Hat",
            "Safety Glasses / Face Shield",
            "Protective Gloves",
            "Safety Shoes",
            "Respiratory Protection (mask, SCBA, cartridge type)",
            "Hearing Protection",
            "Flame-Resistant Clothing / Overalls",
            "Fall Protection (harness, lifelines)",
            "Chemical-Resistant Suit / Apron",
            "High-Visibility Vest",
            "Other (user-defined): __________________",
          ],
        },
        // AI Support Box – Bilkul Tumhare Design Jaisa
        {
          type: "info",
          value:
            "AI Support:\n" +
            "• Cross-check PPE selection with Permit Type (e.g., Hot Work → goggles, gloves, FR clothing mandatory)\n" +
            "• Alerts: “Confined Space Permit selected but no SCBA ticked.”\n" +
            "• AI can flag expired PPE inspections (harness expiry, SCBA service)",
          sx: {
            background: "linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)",
            border: "4px solid #ff8f00",
            borderRadius: "20px",
            padding: "28px 32px",
            fontSize: "17px",
            fontWeight: "bold",
            color: "#d84315",
            whiteSpace: "pre-line",
            my: 4,
            boxShadow: "0 15px 50px rgba(255, 143, 0, 0.4)",
            lineHeight: "2.4",
            textAlign: "left",
            position: "relative",
            "&::before": {
              content: '"AI Support"',
              position: "absolute",
              top: "-14px",
              left: "24px",
              background: "#ff6f00",
              color: "white",
              padding: "6px 20px",
              borderRadius: "12px",
              fontSize: "15px",
              fontWeight: "900",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
            },
          },
        },
      ],
    },

    {
      title: "AI Support:",
      fields: [
        {
          label: "Cross-check PPE selection with Permit Type ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "Alerts:  ",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "AI can flag expired PPE inspections ",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
      ],
    },

    // ========= 3. Hazards & Controls Table =========
    {
      title: "Hazards & Controls (User Input + AI Assist)",
      description:
        "AI pulls from hazard libraries (OSHA, IFC, ISO 45001) + past site incidents",
      type: "table",
      addRowLabel: "+ Add Hazard",
      defaultRows: 1,
      preFilledRows: [
        {
          "Hazard Identified": "Hot Work sparks",
          "Risk (Impact)": "Fire/Explosion risk",
          "Existing Controls": "Fire extinguisher at site",
          "Additional Controls (AI Suggestion)":
            "Fire watch & spark guards required",
          "Responsible Person": "Supervisor",
          Timeline: "Immediate",
        },
      ],
      fields: [
        { label: "Hazard Identified", type: "text", width: "18%" },
        { label: "Risk (Impact)", type: "text", width: "16%" },
        { label: "Existing Controls", type: "text", width: "18%" },
        {
          label: "Additional Controls (AI Suggestion)",
          type: "text",
          width: "22%",
          disabled: true,
        },
        { label: "Responsible Person", type: "text", width: "14%" },
        { label: "Timeline", type: "text", width: "12%" },
      ],
    },

    // ========= 4. Observations / Field Notes =========
    {
      title: "Observations / Field Notes (User Input)",
      fields: [
        {
          label: "Site readiness checks",
          type: "textarea",
          rows: 4,
          placeholder: "______________________________________",
        },
        {
          label: "Worker briefing conducted?",
          type: "radio",
          options: ["Yes", "No"],
          inline: true,
        },
        {
          label: "Energy isolation verified?",
          type: "radio",
          options: ["Yes", "No", "N/A"],
          inline: true,
        },
        {
          label: "Emergency preparedness (first aid, fire, rescue)",
          type: "textarea",
          rows: 3,
          placeholder: "__________________",
        },
        {
          label: "Community/surrounding impacts",
          type: "textarea",
          rows: 3,
          placeholder: "__________________",
        },
      ],
    },

    // ========= 5. Evidence & Attachments =========
    {
      title: "Evidence & Attachments",
      description: "Mandatory for audit trail | AI auto-flags missing items",
      fields: [
        {
          type: "checkbox",
          options: [
            "Upload signed PTW form (scan/PDF)",
            "Upload workforce PPE inspection photos",
            "Upload geo-tagged site safety photos/videos",
            "Upload tool/equipment certificates",
            "Upload toolbox talk attendance",
          ],
        },
        {
          type: "file",
        },
        {
          type: "info",
          value:
            "AI Check Active:\n" +
            "• Flags if mandatory evidence missing\n" +
            "• e.g., “Confined Space Permit requires gas test results”\n" +
            "• “Hot Work without fire watch photo → BLOCKED”\n" +
            "• All uploads blockchain timestamped",
          sx: {
            background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
            border: "4px solid #f44336",
            borderRadius: "20px",
            padding: "28px 32px",
            fontSize: "17px",
            fontWeight: "bold",
            color: "#c62828",
            whiteSpace: "pre-line",
            my: 4,
            boxShadow: "0 15px 50px rgba(244, 67, 54, 0.4)",
            lineHeight: "2.3",
            "&::before": {
              content: '"AI Check"',
              position: "absolute",
              top: "-14px",
              left: "24px",
              background: "#d32f2f",
              color: "white",
              padding: "6px 20px",
              borderRadius: "12px",
              fontSize: "15px",
              fontWeight: "900",
            },
          },
        },
      ],
    },

    // ========= 6. Signatures & Closure =========
    {
      fields: [
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all hazards identified, controls in place, PPE issued & inspected, evidence uploaded, and work can proceed safely under this permit",
          ],
          required: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const Smart_PTW_PPE_Compliance_Step_2 = {
  title: "Smart AI-Enabled PTW & PPE Compliance Log",
  subtitle: "Real-time AI Validation | Predictive Alerts | IFC/OSHA Ready",
  formTitle: "Permit-to-Work & PPE Compliance Dashboard",
  downloadFileName: "AI_PTW_PPE_Compliance_Report",
  downloadFileExtension: "png",

  sections: [
    // ========= 1. Permit Setup Info =========
    {
      title: "Permit-to-Work Setup Information",
      description: "Auto-generated + GPS + AI-assisted",
      fields: [
        {
          label: "Permit ID – Auto-generated unique ID",
          type: "text",
          value: `PTW-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-${String(Math.floor(1000 + Math.random() * 9000)).padStart(
            4,
            "0"
          )}`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Work Description",
          type: "textarea",
          rows: 3,
          placeholder:
            "___________________________ (hot work, confined space, working at height, etc.)",
          required: true,
        },
        {
          label: "Location(s) of Work – GPS auto-captured + manual entry",
          type: "text",
          placeholder: "e.g., Zone B, Tank 12, Roof Area",
          required: true,
        },
        {
          label: "Permit Issuer (Name/Role)",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Permit Holder (Contractor/Supervisor Name/Contact)",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
        {
          label: "Permit Validity Period – From",
          type: "datetime-local",
          required: true,
        },
        {
          label: "Permit Validity Period – To",
          type: "datetime-local",
          required: true,
        },
        {
          label: "Associated Work Order / Job Reference",
          type: "text",
          placeholder: "___________________________",
          required: true,
        },
      ],
    },

    // ========= 2. AI-Powered PTW & PPE Compliance Table (3 Real Examples) =========
    {
      title: "Permit & PPE Compliance Table",
      type: "table",
      addRowLabel: "+ Add Permit Entry",
      defaultRows: 0,
      preFilledRows: [
        {
          "Permit ID": "PTW-2025-001",
          "Work Activity": "Hot Work (cutting pipes)",
          "PPE Required": "Gloves, Goggles, FR Clothing",
          "PPE Compliance (AI Auto-Check)":
            "Non-Compliant (No FR Clothing in use)",
          "Key Hazards & Controls": "Sparks → Fire Watch + Extinguisher",
          "Responsible Person": "Safety Officer",
          Status: "Open",
        },
        {
          "Permit ID": "PTW-2025-002",
          "Work Activity": "Confined Space (Tank Cleaning)",
          "PPE Required": "SCBA, Gas Detector, Harness",
          "PPE Compliance (AI Auto-Check)": "Compliant",
          "Key Hazards & Controls": "Toxic gases → Continuous monitoring",
          "Responsible Person": "Contractor Supervisor",
          Status: "Open",
        },
        {
          "Permit ID": "PTW-2025-003",
          "Work Activity": "Working at Height (Scaffold)",
          "PPE Required": "Harness, Helmet, Shoes",
          "PPE Compliance (AI Auto-Check)": "Compliant",
          "Key Hazards & Controls": "Fall risk → Double lanyard system",
          "Responsible Person": "Site Supervisor",
          Status: "Closed",
        },
      ],
      fields: [
        { label: "Permit ID", type: "text", width: "12%" },
        { label: "Work Activity", type: "text", width: "18%" },
        { label: "PPE Required", type: "text", width: "20%" },
        {
          label: "PPE Compliance (AI Auto-Check)",
          type: "text",
          disabled: true,
          width: "18%",
        },
        { label: "Key Hazards & Controls", type: "text", width: "20%" },
        { label: "Responsible Person", type: "text", width: "12%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
    },

    {
      title: "AI Support:",
      fields: [
        {
          label: "AI Auto-Validation: ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "AI Predictive Alerts:",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "Cross-Linked Risks: ",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
        {
          label: "AI Scorecard: ",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
      ],
    },

    // ========= 4. Validation & Status =========
    {
      title: "Validation & Status",
      fields: [
        {
          label:
            "Cross-Linked Risks – AI links open permits to site risk register",
          type: "textarea",
          rows: 4,
          value:
            "PTW-2025-001 → Risk ID: FIR-112 (Fire Risk)\nPTW-2025-002 → Risk ID: CON-089 (Confined Space Risk)",
          disabled: true,
        },
        {
          label: "Permit & PPE Status",
          type: "radio",
          options: ["Open", "Under Review", "Closed", "Verified"],
          inline: true,
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "EHS Officer / Site Manager / Compliance Lead",
        },
        { label: "Review Date", type: "date" },
      ],
    },

    // ========= 5. Closing & Signatures =========
    {
      title: "Closing & Signatures (Audit-Ready)",
      fields: [
        {
          label: "Permit Issuer (EHS/Supervisor)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Permit Holder (Contractor/Site Lead)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Verified By (Safety/Compliance Officer)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        { label: "Date", type: "date", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all PTW data is accurate, AI checks passed, and compliance is verified",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const Smart_PTW_PPE_Compliance_Step_3 = [
  // 1. Big Beautiful Top Banner (Exactly as in your design)
  {
    isFormSection: true,
    heading: "",
    fields: [],
  },

  // 2. Detail Reporting
  {
    heading: "Detail Reporting",
    items: [],
  },

  // 3. Global ESG Reporting Standards
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  // 4. Climate & Carbon Compliance
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  // 5. Operational ESG Systems & Reporting
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  // 6. Industrial & Country-Specific
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  // 7. Data Analytics
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  // 8. Supplier
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  // 9. Capacity & Future
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const INCIDENT_NEAR_MISS_CAPTURE_FORM_STEP_1 = {
  title: "Digital Incident & Near-Miss Capture (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Incident / Near-Miss Report",
  downloadFileName: "Incident_NearMiss_Log",
  downloadFileExtension: "pdf",

  notes: [
    "Fully confidential & GDPR-compliant",
    "AI auto-classifies incident type, severity & detects hazards from photos/videos",
    "Auto-syncs to Incident Register, EHS Dashboard & regulatory reporting module",
  ],

  sections: [
    // ========== INCIDENT / NEAR-MISS SETUP INFORMATION ==========
    {
      title: "Incident / Near-Miss Setup Information",
      helperText: "Auto-generated fields + reporter details",
      fields: [
        {
          label: "Report ID",
          type: "text",
          value: "INC-2025-11-29001",
          disabled: true,
        },
        {
          label: "Date & Time of Event",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured (system clock + timezone)",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "e.g., GreenField Solar Park, Rajasthan",
          required: true,
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          value: "26.9124° N, 75.7873° E (GPS auto-captured with map overlay)",
          disabled: true,
        },
        {
          label: "Reported By (Name & Role)",
          type: "text",
          placeholder: "e.g., Rajesh Kumar, Site Supervisor",
          required: true,
        },
        {
          label: "Witness(es)",
          type: "text",
          placeholder: "Name(s) and contact (optional)",
        },
      ],
    },

    // ========== EVENT CLASSIFICATION ==========
    {
      title: "Event Classification",
      helperText: "AI assists with classification and severity scoring",
      fields: [
        {
          label: "Type of Event",
          type: "radio",
          options: [
            "Incident (actual injury/damage)",
            "Near-Miss (no injury, but potential for harm)",
            "Unsafe Act / Condition",
          ],
          required: true,
          inline: true,
        },
        {
          label: "Category",
          type: "checkbox",
          options: [
            "Safety",
            "Environmental",
            "Health",
            "Security",
            "Property Damage",
            "Other: _________",
          ],
          required: true,
        },
        {
          label: "Severity / Potential Severity",
          type: "radio",
          options: ["Minor", "Moderate", "Major", "Critical"],
          inline: true,
          required: true,
          note: "AI auto-suggests based on description & evidence",
        },
        {
          label:
            "AI auto-suggests based on event description, photo/video evidence, and risk database.",
          type: "info",
          value:
            "• Detects hazards in uploaded media (PPE missing, spill, fire risk, etc.)\n" +
            "• Suggests severity using historical risk matrix\n" +
            "• Tags keywords: fall, spill, electrocution, chemical exposure, etc.",
        },
      ],
    },

    // ========== EVENT DESCRIPTION & EVIDENCE ==========
    {
      title: "Event Description & Evidence",
      helperText: "Describe what happened — AI will help rephrase and tag",
      fields: [
        {
          label: "Description of Event / Condition",
          type: "textarea",
          rows: 6,
          placeholder:
            "Provide a clear description of what happened, sequence of events, who was involved...\n" +
            "Example: Worker slipped on oil spill near transformer area, no injury but could have been serious...",
          required: true,
        },
        {
          label: "Immediate Cause(s)",
          type: "textarea",
          rows: 3,
          placeholder: "e.g., Oil spill not cleaned, no warning signs",
        },
        {
          label: "Underlying / Root Cause(s) (if known)",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Poor housekeeping, lack of training, faulty equipment",
        },
        {
          label: "Evidence & Attachments",
          type: "checkbox",
          options: [
            "Photo(s)",
            "Video(s)",
            "Witness Statement(s)",
            "Equipment Logs",
            "Other: _________",
          ],
        },
        {
          label: "Upload Evidence Files",
          type: "file",
          accept: "image/*,video/*,.pdf,.docx,.xlsx",
          multiple: true,
          note: "Photos, videos, statements, logs, etc. — AI will analyze for hazards",
        },
        {
          label: "AI Media Analysis",
          type: "info",
          value:
            "• Automatically detects missing PPE, spills, unsafe positioning, fire risks, etc.\n" +
            "• Flags potential ESG non-compliances (e.g., unreported spill → IFC PS3)",
        },
      ],
    },

    // ========== IMMEDIATE ACTIONS & NOTIFICATIONS ==========
    {
      title: "Immediate Actions & Notifications",
      fields: [
        {
          label: "Immediate Action Taken",
          type: "textarea",
          rows: 4,
          placeholder:
            "e.g., Area cordoned off, spill cleaned, injured worker sent to clinic...",
          required: true,
        },
        {
          label: "Emergency Response Triggered?",
          type: "radio",
          options: ["Yes", "No"],
          inline: true,
          required: true,
        },
        {
          label: "First Aid / Medical Treatment Given?",
          type: "radio",
          options: ["Yes", "No"],
          inline: true,
          required: true,
        },
        {
          label: "Notified Parties",
          type: "checkbox",
          options: [
            "Supervisor",
            "EHS",
            "HR",
            "Community",
            "Regulatory Authority",
            "Other: _________",
          ],
          required: true,
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const INCIDENT_NEAR_MISS_CAPTURE_FORM_STEP_2 = {
  title: "Smart AI-Enabled Incident & Near-Miss Register",
  subtitle:
    "AI-Powered Incident Tracking, Root Cause Analysis & Corrective Actions",
  formTitle: "Incident & Near-Miss Register",
  downloadFileName: "Incident_NearMiss_Register",
  downloadFileExtension: "pdf",

  notes: [
    "AI auto-classifies severity, suggests root causes & preventive actions",
    "Full audit trail for OSHA, ISO 45001, IFC PS2/PS3, GRI 403 compliance",
    "Auto-syncs with Risk Register, CAPA Log & EHS Dashboard",
  ],

  sections: [
    // ========== INCIDENT REGISTER SUMMARY ==========
    {
      title: "Incident Register Summary",
      fields: [
        {
          label: "Report ID – Auto-generated unique ID",
          type: "text",
          value: "INC-2025-11001",
          disabled: true,
        },
        {
          label: "Date & Time of Event – Auto-captured",
          type: "datetime-local",
          value: "2025-11-28T12:00",
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
        {
          label: "Location (Geo-Tagged)",
          type: "text",
          value: "26.9124° N, 75.7873° E (GPS auto-captured with map overlay)",
          disabled: true,
        },
        {
          label: "Reported By (Name/Role)",
          type: "text",
          value: "Rajesh Kumar – Site Supervisor",
          disabled: true,
        },
      ],
    },

    // ========== INCIDENT & NEAR-MISS RECORD TABLE ==========
    {
      title: "Incident & Near-Miss Record Table",
      type: "table",
      addRowLabel: "+ Add New Incident / Near-Miss",
      fields: [
        { label: "Event ID", type: "text", width: "9%" },
        { label: "Type", type: "text", width: "10%" },
        { label: "Category", type: "text", width: "10%" },
        {
          label: "Description (AI Rephrased)",
          type: "textarea",
          rows: 2,
          width: "20%",
        },
        {
          label: "Severity (AI Scored)",
          type: "text",
          disabled: true,
          width: "10%",
        },
        { label: "Immediate Action", type: "textarea", rows: 2, width: "15%" },
        {
          label: "Root Cause (AI Optional)",
          type: "textarea",
          rows: 2,
          width: "15%",
        },
        { label: "Responsible Person", type: "text", width: "10%" },
        { label: "Timeline", type: "text", width: "8%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
      preFilledRows: [
        {
          "Event ID": "Example-01",
          Type: "Incident",
          Category: "Safety",
          "Description (AI Rephrased)":
            "Worker slipped on wet floor near pump station",
          "Severity (AI Scored)": "Moderate",
          "Immediate Action": "Area barricaded, first aid provided",
          "Root Cause (AI Optional)": "Poor housekeeping, inadequate signage",
          "Responsible Person": "Supervisor",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          "Event ID": "Example-02",
          Type: "Near-Miss",
          Category: "Environmental",
          "Description (AI Rephrased)":
            "Spill observed but contained before reaching drain",
          "Severity (AI Scored)": "Minor",
          "Immediate Action": "Spill kit applied",
          "Root Cause (AI Optional)": "Lack of secondary containment",
          "Responsible Person": "EHS Officer",
          Timeline: "1 Week",
          Status: "Open",
        },
      ],
    },

    {
      title: "AI Features",
      fields: [
        {
          label: "AI Auto-Classification: ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "AI Root Cause Suggestion: ",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "AI Suggested Corrective Actions: ",
          type: "textarea",
          value:
            "Linked to Risk Register:\n• Regulatory Penalty Risk → HIGH\n• Reputational Damage → MEDIUM-HIGH\n• Social License to Operate → At Risk",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#fce4ec",
            fontWeight: "500",
            color: "#c2185b",
          },
        },
        {
          label: "Trend Analysis: ",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
        {
          label: "•	Predictive Alerts: ",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
      ],
    },

    // ========== VALIDATION & STATUS ==========
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks",
          type: "textarea",
          value:
            "Follow-up with complainant due by: 10-Dec-2025\nResponsible: Mr. Rajesh Sharma (Community Officer)\nPrevious action status: Site visit completed, report pending",
          rows: 4,
          disabled: true,
          style: {
            backgroundColor: "#e8f5e8",
            fontWeight: "500",
            color: "#2e7d32",
          },
        },
        {
          label: "Investigation Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          inline: true,
          required: true,
        },
        {
          label: "Reviewed By: Supervisor / EHS / Compliance Officer",
          type: "text",
          placeholder: "Enter name and designation",
          required: true,
        },
        {
          label: "Review Date",
          type: "date",
          value: "2025-11-28",
          required: true,
        },
      ],
    },

    // ========== CLOSING & SIGNATURES ==========
    {
      title: "Closing & Signatures (Audit Ready)",
      fields: [
        {
          label: "Reported By",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        {
          label: "Approved By (Project Manager / Compliance Lead)",
          type: "text",
          placeholder: "__________________",
          required: true,
        },
        { label: "Date", type: "date", value: "2025-11-28", disabled: true },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all incidents are accurately recorded, investigated, and corrective actions assigned",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const INCIDENT_NEAR_MISS_CAPTURE_FORM_STEP_3 = [
  {
    heading: "Detail Reporting",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD " },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const EMERGENCY_DRILL_CAPTURE_FORM_STEP_1 = {
  title: "Digital Emergency Drill Capture (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Emergency Drill Report",
  downloadFileName: "Emergency_Drill_Report",
  downloadFileExtension: "pdf",

  topRightButtons: ["SAVE", "USER ID"],
  bottomButtons: ["NEXT"],

  sections: [
    // ===================== SECTION 1: DRILL SETUP INFORMATION =====================
    {
      title: "Drill Setup Information",
      fields: [
        {
          label: "Drill ID",
          type: "text",
          value: "DRILL-2025-11001",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured (system clock + timezone)",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "e.g., GreenField Solar Park, Rajasthan",
          required: true,
        },
        {
          label: "Drill Type (multi-select)",
          type: "checkbox",
          options: [
            "Fire Evacuation",
            "Chemical Spill",
            "Medical Emergency",
            "Earthquake / Natural Disaster",
            "Security / Terror Threat",
            "Rescue / Confined Space",
            "Other: ___________",
          ],
          required: true,
        },
        {
          label: "Drill Location(s)",
          type: "checkbox",
          options: [
            "Office",
            "Plant",
            "Construction Site",
            "Community Area",
            "Other _________",
          ],
        },
        {
          label: "Geo-Tagging",
          type: "text",
          value: "26.9124° N, 75.7873° E (GPS auto-captured with map overlay)",
          disabled: true,
        },
        {
          label: "Drill Coordinator (Lead)",
          type: "text",
          placeholder: "Name & Designation",
          required: true,
        },
        {
          label: "Participants",
          type: "text",
          placeholder:
            "Total number & roles (workers, contractors, ERT, community etc.)",
          required: true,
        },
        {
          label: "Departments Covered",
          type: "checkbox",
          options: [
            "EHS",
            "Operations",
            "HR",
            "Contractors",
            "Security",
            "Community",
            "Other _________",
          ],
        },
        {
          label: "Drill Objective(s)",
          type: "checkbox",
          options: [
            "Compliance with regulation",
            "Training / Awareness",
            "Testing Response Plan",
            "ESG / Corporate Reporting",
            "Community Engagement",
            "Other _________",
          ],
        },
        {
          label: "Applicable Standards / Frameworks",
          type: "text",
          value: "OSHA • NFPA • ISO 22301 • IFC PS4 • Local Regulations",
          disabled: true,
          note: "AI auto-links based on drill type & location",
        },
      ],
    },

    // ===================== SECTION 2: DRILL PLAN (MANUAL INPUT) =====================
    {
      title: "Manual User Input – Drill Plan",
      fields: [
        {
          label: "Scenario Description",
          type: "textarea",
          rows: 5,
          placeholder:
            "e.g., Sudden fire breakout in transformer yard during peak load hours with smoke spreading to admin block...",
          required: true,
        },
        {
          label: "Planned Sequence / Steps",
          type: "textarea",
          rows: 6,
          placeholder:
            "1. Alarm activation\n2. Announcement via PA system\n3. Floor wardens guide evacuation\n4. Headcount at muster point\n5. Mock rescue operation\n6. All clear signal",
        },
        {
          label: "Resources to be Tested",
          type: "checkbox",
          options: [
            "Fire alarms",
            "sirens",
            "Evacuation routes",
            "Muster points",
            "Spill  kits",
            "First aid ",
            "Emergency comms",
          ],
        },
        {
          label: "Key Risk Areas / Hazards",
          type: "textarea",
          rows: 4,
          placeholder:
            "e.g., Narrow staircase near canteen, blocked emergency exit in warehouse, poor lighting in basement parking...",
        },
      ],
    },

    // ===================== SECTION 3: EVIDENCE & ATTACHMENTS =====================
    {
      title: "Evidence & Attachments",
      fields: [
        {
          label: "Upload Drill Notification / Circular",
          type: "file",
          accept: ".pdf,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload Geo-Tagged Photos / Videos of Drill",
          type: "file",
          accept: "image/*,video/*",
          multiple: true,
          note: "AI analyzes evacuation flow, PPE usage, response time",
        },
        {
          label: "Upload Attendance Register / Muster Roll",
          type: "file",
          accept: ".pdf,.xlsx,.csv",
          multiple: true,
        },
        {
          label: "Upload Floor Plan / Evacuation Map",
          type: "file",
          accept: "image/*,.pdf",
          multiple: true,
        },
        {
          label:
            "AI Cross-Check: Alerts if muster roll vs participant count mismatch.",
          type: "info",
          value:
            "Headcount mismatch: Muster roll = 142, AI counted 137 people in photos\n" +
            "Evacuation time: 7 min 18 sec (Target: < 6 min)\n" +
            "Congestion detected at Exit Gate 2 → Recommend alternative route\n" +
            "Missing helmets detected in 18% participants",
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const EMERGENCY_DRILL_CAPTURE_FORM_STEP_2 = {
  title: "Smart AI-Enabled Emergency Drill Tracker Log",
  subtitle: "",
  formTitle: "",
  downloadFileName: "Emergency_Drill_Tracker_AI_Scorecard",
  downloadFileExtension: "pdf",

  sections: [
    // ===================== 1. BASIC DRILL INFO =====================
    {
      title: "",
      description: "Auto-generated + GPS + Blockchain timestamped",
      fields: [
        {
          label: "Drill ID – Auto-generated unique ID",
          type: "text",
          value: `DRILL-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-001`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
      ],
    },

    // ===================== 2. DRILL RESULTS TABLE (100% WORKING) =====================
    {
      title: "Drill Results Table",
      type: "table",
      addRowLabel: "+ Add New Drill Scenario",
      fields: [
        { label: "Drill Scenario", type: "text", width: "14%" },
        { label: "Planned vs Actual Time", type: "text", width: "16%" },
        { label: "No. of Participants", type: "text", width: "10%" },
        { label: "Compliance Benchmark", type: "text", width: "12%" },
        { label: "Issues Observed", type: "textarea", rows: 3, width: "16%" },
        {
          label: "AI Suggested Improvements",
          type: "text",
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "10%" },
        { label: "Timeline", type: "text", width: "8%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "10%",
        },
      ],
      preFilledRows: [
        {
          "Drill Scenario": "Fire Evacuation",
          "Planned vs Actual Time": "Planned: 5 min / Actual: 8 min",
          "No. of Participants": "120 workers",
          "Compliance Benchmark": "NFPA ≤ 5 min",
          "Issues Observed":
            "Delay in staircase evacuation\nCongestion at Gate 2",
          "AI Suggested Improvements":
            "Install illuminated exit signs, conduct refresher drill",
          "Responsible Person": "EHS Lead",
          Timeline: "2 Weeks",
          Status: "Open",
        },
        {
          "Drill Scenario": "Chemical Spill",
          "Planned vs Actual Time": "Planned: 7 min / Actual: 6 min",
          "No. of Participants": "35 staff",
          "Compliance Benchmark": "OSHA HazCom",
          "Issues Observed":
            "Spill kit not fully stocked\nSome responders without gloves",
          "AI Suggested Improvements":
            "AI: Auto-reminder for monthly spill kit inspection",
          "Responsible Person": "Utility Supervisor",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          "Drill Scenario": "Medical Emergency",
          "Planned vs Actual Time": "Planned: 10 min / Actual: 9 min",
          "No. of Participants": "15 responders",
          "Compliance Benchmark": "IFC PS4",
          "Issues Observed":
            "First aid kit expired supplies\nDelayed ambulance mock call",
          "AI Suggested Improvements": "Replace kits, schedule AI reminders",
          "Responsible Person": "Site Nurse",
          Timeline: "1 Week",
          Status: "Open",
        },
      ],
    },

    // ===================== 4. VALIDATION & STATUS =====================
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "Drill Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          required: true,
          note: "AI can auto-update to 'Verified' once all corrective actions are closed",
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "Supervisor / EHS-ESG Officer / Compliance Lead",
        },
        {
          label: "Review Date",
          type: "date",
          value: new Date().toISOString().split("T")[0],
        },
      ],
    },

    // ===================== 5. CLOSING & SIGNATURES =====================
    {
      title: "Closing & Signatures (Audit-Ready + Blockchain Timestamped)",
      fields: [
        {
          label: "Prepared By (Drill Coordinator)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Approved By (Project Manager / Corporate ESG Lead)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Final Approval Date",
          type: "date",
          value: new Date().toISOString().split("T")[0],
        },
      ],
    },

    {
      title: "AI Insights Add-On",
      fields: [
        {
          label: "	Predictive analytics  ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "	Benchmark comparison  ",
          type: "textarea",
          value:
            "This is the 3rd wastewater-related complaint in last 2 months\n→ Recurring issue flagged",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff8e1",
            fontWeight: "500",
            color: "#f57f17",
          },
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all drill results verified, AI insights & cross-linked risks acknowledged, corrective actions assigned and tracked, and this log is fully audit-ready with blockchain timestamp",
          ],
          required: true,
        },
      ],
    },
  ],
};

// FILE: forms/emergencyDrillStandards.js
export const EMERGENCY_DRILL_CAPTURE_FORM_STEP_3 = [
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" },
    ],
  },
];

export const EQUIPMENT_INSPECTION_CAPTURE_FORM_STEP_1 = {
  title: "Digital Asset & Equipment Inspection Capture (User + AI Hybrid)",
  subtitle: "",
  formTitle: "Equipment Inspection Report",
  downloadFileName: "Equipment_Inspection_Report_AI_Scorecard",
  downloadFileExtension: "pdf",

  topRightButtons: ["SAVE", "USER ID"],
  bottomButtons: ["NEXT"],

  sections: [
    // ===================== SECTION 1: INSPECTION SETUP INFORMATION =====================
    {
      title: "Inspection Setup Information",
      description: "Auto-generated + GPS + Blockchain timestamped",
      fields: [
        {
          label: "Inspection ID – Auto-generated unique ID",
          type: "text",
          value: `INSP-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-001`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
          note: "Auto-captured (system clock + timezone)",
        },
        {
          label: "Facility / Project Name",
          type: "text",
          placeholder: "e.g., GreenField Solar Park, Rajasthan",
          required: true,
        },
        {
          label: "Equipment / Asset Type (Multi-select)",
          type: "checkbox",
          options: [
            "Vehicles",
            "Cranes",
            "Lifts",
            "Generators",
            "Compressors",
            "Electrical Panels",
            "Fire Equipment",
            "PPE",
            "Tools",
            "Other _________",
          ],
          required: true,
        },
        {
          label: "Equipment ID / Tag Number",
          type: "text",
          placeholder: "e.g., CR-001, GEN-045, FE-118",
          required: true,
          note: "Linked to central asset register",
        },
        {
          label: "Location of Asset",
          type: "text",
          value:
            "26.9124° N, 75.7873° E – Workshop Yard (GPS auto-captured + map overlay)",
          disabled: true,
        },
        {
          label: "Inspection Team",
          type: "text",
          placeholder:
            "Names / Roles (Maintenance Engineer, EHS Officer, Operator, Contractor etc.)",
          required: true,
        },
        {
          label: "Department(s) Responsible",
          type: "checkbox",
          options: [
            "Maintenance",
            "Operations",
            "EHS",
            "Contractor",
            "Utilities",
            "Other: _________",
          ],
        },
        {
          label: "Inspection Objectives",
          type: "checkbox",
          options: [
            "Preventive Maintenance",
            "Regulatory Compliance (e.g., OSHA, Factory Act, ISO)",
            "ESG Reporting (ESG Vision dashboard linkage)",
            "Safety Assurance",
            "Reliability / Uptime",
            "Community / Environmental Protection",
            "Other: _________",
          ],
          required: true,
        },
      ],
    },

    // ===================== SECTION 2: PRE-INSPECTION DATA (USER MANUAL INPUT) =====================
    {
      title: "User Manual Input – Pre-Inspection Data",
      fields: [
        {
          label: "Last Inspection Date",
          type: "date",
          value: "2025-08-15",
        },
        {
          label: "Last Service / Maintenance Log Reference",
          type: "text",
          placeholder: "e.g., SRV-2025-0892",
        },
        {
          label: "Running Hours / Meter Reading",
          type: "text",
          placeholder: "e.g., 12,450 hrs",
        },
        {
          label: "Manufacturer / Model",
          type: "text",
          placeholder: "e.g., Caterpillar / C15 (500 kVA)",
        },
        {
          label: "Criticality Level",
          type: "radio",
          options: ["Low", "Medium", "High"],
          note: "AI Suggestion: High (Backup Generator – Critical for emergency power)",
        },
        {
          label: "Known Issues from Past Records",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Frequent oil leakage from valve cover, battery terminal corrosion reported in June 2025...",
        },
      ],
    },

    // ===================== SECTION 3: OBSERVATIONS / FIELD NOTES =====================
    {
      title: "Observations / Field Notes (User Input)",
      fields: [
        {
          label: "Visible Defects",
          type: "textarea",
          rows: 4,
          placeholder:
            "Corrosion, cracks, leakage, wear & tear, loose bolts, damaged wiring...",
        },
        {
          label: "Abnormal Sound, Vibration or Smell",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., High-pitched whining from alternator, excessive vibration at 1800 RPM...",
        },
        {
          label: "Safety Guard / Machine Protection Status",
          type: "textarea",
          rows: 3,
          placeholder:
            "Missing guard on pulley, broken emergency stop button, no lockout-tagout applied...",
        },
        {
          label: "Operational Readiness Checks",
          type: "textarea",
          rows: 4,
          placeholder:
            "Fuel level, battery charge, oil level, calibration status, hydraulic pressure...",
        },
        {
          label: "Spare Parts Availability / Stockouts",
          type: "textarea",
          rows: 3,
          placeholder:
            "e.g., Oil filter out of stock, V-belt lead time 12 days...",
        },
      ],
    },

    // ===================== SECTION 4: EVIDENCE & ATTACHMENTS + AI ALERT =====================
    {
      title: "Evidence & Attachments + AI Real-Time Analysis",
      fields: [
        {
          label: "Upload Geo-Tagged Inspection Photos",
          type: "file",
          accept: "image/*",
          multiple: true,
          note: "AI auto-detects: corrosion, missing labels, unsafe conditions, PPE non-use",
        },
        {
          label: "Upload Calibration / Service Certificates",
          type: "file",
          accept: ".pdf,.docx,.jpg,.png",
          multiple: true,
        },
        {
          label: "Upload Maintenance Log Extracts",
          type: "file",
          accept: ".pdf,.xlsx",
          multiple: true,
        },
        {
          label: "Upload Vibration / Oil Analysis Reports",
          type: "file",
          accept: ".pdf,.csv",
          multiple: true,
        },
        {
          label: "AI Real-Time Risk Alert Engine",
          type: "info",
          value: `AI INSPECTION ANALYSIS ACTIVE – CRITICAL ALERTS

FIRE EXTINGUISHER #FE-118 EXPIRED (Last serviced: Mar 2024 → Overdue by 8 months)
→ Immediate replacement required | Regulatory violation risk (OSHA / IFC PS2)

CORROSION DETECTED on generator base frame (Severity: HIGH)
→ Recommend sandblasting + anti-corrosive coating within 7 days

OIL LEAKAGE confirmed in 4 photos → Potential soil contamination risk
→ ESG Impact: Environmental Non-Compliance Alert

PPE VIOLATION: Inspector not wearing safety helmet in 3 images

AUTOMATED ACTIONS:
• Work permit blocked until fire extinguisher replaced
• Escalated to: Maintenance Head, EHS Manager, ESG Lead
• Auto-linked to Risk Register #RR-2025-201 (Critical Equipment Failure)
• Blockchain-verified timestamp applied`,
          sx: {
            background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
            border: "7px solid #d32f2f",
            borderRadius: "32px",
            padding: "48px 50px",
            fontFamily: "DM Sans",
            fontSize: "19.5px",
            fontWeight: "bold",
            color: "#b71c1c",
            lineHeight: "2.8",
            whiteSpace: "pre-line",
            boxShadow: "0 25px 80px rgba(211, 47, 47, 0.6)",
            margin: "60px 0",
            textAlign: "center",
          },
        },
      ],
    },
  ],
  extraBottomActions: [
    {
      type: "addNext",
      label: "Add for Next Value",
      buttonText: "Add for Next Value: Click here to Add",
      helperText: "Add another air quality monitoring session / location",
    },
  ],
};

export const EQUIPMENT_INSPECTION_CAPTURE_FORM_STEP_2 = {
  title: "Smart AI-Enabled Asset & Equipment Inspection Tracker",
  subtitle:
    "",
  formTitle: "Equipment Inspection Log & AI Compliance Scorecard",
  downloadFileName: "Equipment_Inspection_AI_Scorecard",
  downloadFileExtension: "pdf",

  sections: [
    // ===================== 1. BASIC INSPECTION INFO =====================
    {
      title: "Inspection – Basic Information",
      description: "Auto-generated + GPS + Blockchain timestamped",
      fields: [
        {
          label: "Inspection ID – Auto-generated unique ID",
          type: "text",
          value: `INSP-${new Date().getFullYear()}-${String(
            new Date().getMonth() + 1
          ).padStart(2, "0")}${String(new Date().getDate()).padStart(
            2,
            "0"
          )}-001`,
          disabled: true,
        },
        {
          label: "Date & Time – Auto-captured",
          type: "datetime-local",
          value: new Date().toISOString().slice(0, 16),
          disabled: true,
        },
        {
          label: "Facility / Project Name",
          type: "text",
          value: "GreenField Solar Park, Rajasthan",
          disabled: true,
        },
        {
          label: "Location of Asset",
          type: "text",
          value: "Workshop Yard – Block C (GPS: 26.9124° N, 75.7873° E)",
          disabled: true,
        },
        {
          label: "Inspection Team",
          type: "text",
          value:
            "Rajesh Kumar (EHS), Anil Sharma (Maintenance), Contractor Rep",
          disabled: true,
        },
      ],
    },

    // ===================== 2. EQUIPMENT INSPECTION RESULTS TABLE =====================
    {
      title: "Smart AI-Enabled Asset & Equipment Inspection Form",
      type: "table",
      addRowLabel: "+ Add New Equipment / Asset",
      fields: [
        { label: "Equipment / Asset", type: "text", width: "14%" },
        { label: "ID / Tag", type: "text", width: "10%" },
        { label: "Standard / Benchmark", type: "text", width: "14%" },
        {
          label: "Condition Observed (User + AI)",
          type: "textarea",
          rows: 3,
          width: "18%",
        },
        {
          label: "Compliance Status (AI Auto-Check)",
          type: "text",
          disabled: true,
          width: "12%",
        },
        { label: "Risk Rating", type: "text", disabled: true, width: "8%" },
        {
          label: "AI Suggested Action",
          type: "text",
          disabled: true,
          width: "18%",
        },
        { label: "Responsible Person", type: "text", width: "10%" },
        { label: "Timeline", type: "text", width: "8%" },
        {
          label: "Status",
          type: "radio",
          options: ["Open", "Closed"],
          inline: true,
          width: "8%",
        },
      ],
      preFilledRows: [
        {
          "Equipment / Asset": "Fire Extinguisher",
          "ID / Tag": "FE-202",
          "Standard / Benchmark": "Validity ≤ 12 months",
          "Condition Observed (User + AI)":
            "Pressure gauge in red zone\nTag expired since Mar 2025\nAI detected rust on base",
          "Compliance Status (AI Auto-Check)": "Non-Compliant",
          "Risk Rating": "High",
          "AI Suggested Action":
            "Immediate replacement required\nBlock area access until fixed\nRegulatory violation alert (OSHA/IFC PS2)",
          "Responsible Person": "EHS Officer",
          Timeline: "Immediate",
          Status: "Open",
        },
        {
          "Equipment / Asset": "Crane",
          "ID / Tag": "CR-115",
          "Standard / Benchmark": "OSHA load test valid",
          "Condition Observed (User + AI)":
            "No valid load test certificate\nWire rope fraying detected in 3 locations\nAI flagged missing safety latch",
          "Compliance Status (AI Auto-Check)": "Non-Compliant",
          "Risk Rating": "Critical",
          "AI Suggested Action":
            "Crane operation suspended\nArrange third-party inspection within 3 days\nAuto-escalated to Plant Manager",
          "Responsible Person": "Contractor Lead",
          Timeline: "1 Week",
          Status: "Open",
        },
        {
          "Equipment / Asset": "Generator",
          "ID / Tag": "GEN-301",
          "Standard / Benchmark": "Noise ≤ 85 dB",
          "Condition Observed (User + AI)":
            "Normal operation\nOil level optimal\nAI confirmed no leaks",
          "Compliance Status (AI Auto-Check)": "Compliant",
          "Risk Rating": "Low",
          "AI Suggested Action":
            "Continue monthly monitoring\nNext service due: 15 Dec 2025",
          "Responsible Person": "Maintenance Engineer",
          Timeline: "Ongoing",
          Status: "Closed",
        },
        {
          "Equipment / Asset": "PPE Kit",
          "ID / Tag": "PPE-K12",
          "Standard / Benchmark": "ISO 20345",
          "Condition Observed (User + AI)":
            "12 helmets cracked\n6 safety shoes sole detached\nAI counted 18 damaged items",
          "Compliance Status (AI Auto-Check)": "Non-Compliant",
          "Risk Rating": "Medium",
          "AI Suggested Action":
            "Replace all damaged PPE immediately\nAuto-generated PR in system",
          "Responsible Person": "Procurement",
          Timeline: "2 Days",
          Status: "Open",
        },
      ],
    },

    // ===================== 4. VALIDATION & STATUS =====================
    {
      title: "Validation & Status",
      fields: [
        {
          label: "Cross-Linked Risks  ",
          type: "textarea",
          value:
            "Effluent discharge exceeds permitted BOD limit → Potential violation of CPCB standards",
          rows: 3,
          disabled: true,
          style: {
            backgroundColor: "#fff3e0",
            fontWeight: "500",
            color: "#ef6c00",
          },
        },
        {
          label: "Inspection Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          required: true,
          note: "AI auto-updates to 'Verified' when all critical actions are closed",
        },
        {
          label: "Reviewed By",
          type: "text",
          placeholder: "Maintenance Manager / EHS Officer / Compliance Lead",
        },
        {
          label: "Review Date",
          type: "date",
          value: new Date().toISOString().split("T")[0],
        },
      ],
    },

    // ===================== 5. CLOSING & SIGNATURES =====================
    {
      title: "Closing & Signatures (Audit-Ready)",
      fields: [
        {
          label: "Prepared By (Inspection Lead)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Verified By (EHS/ESG Officer)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Approved By (Plant/Project Manager)",
          type: "text",
          placeholder: "Name, Designation, Signature",
        },
        {
          label: "Final Approval Date",
          type: "date",
          value: new Date().toISOString().split("T")[0],
        },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: [
            "I confirm all equipment inspected, AI risk alerts acknowledged, corrective actions assigned, cross-linked risks validated, and this log is fully audit-ready",
          ],
          required: true,
        },
      ],
    },
  ],
};

export const EQUIPMENT_INSPECTION_STANDARDS_SELECTION_STEP_3 = [
  // DETAIL REPORTING – AB SABSE UPAR DIKHEGA
  {
    heading: "Detail Reporting",
    items: [{ id: "detail_reporting", label: "Detail Reporting" }],
  },

  // GLOBAL ESG REPORTING
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" },
    ],
  },

  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      {
        id: "sustainable_finance",
        label: "Sustainable Finance & Bond Standards",
      },
      {
        id: "carbon_credit",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },

  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" },
    ],
  },

  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" },
    ],
  },

  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" },
    ],
  },

  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" },
    ],
  },

  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" }, // FIXED – ab sahi hai!
    ],
  },
];
